// 甲子
export const jiazi = [
  '甲子',
  '乙丑',
  '丙寅',
  '丁卯',
  '戊辰',
  '己巳',
  '庚午',
  '辛未',
  '壬申',
  '癸酉',
  '甲戌',
  '乙亥',
  '丙子',
  '丁丑',
  '戊寅',
  '己卯',
  '庚辰',
  '辛巳',
  '壬午',
  '癸未',
  '甲申',
  '乙酉',
  '丙戌',
  '丁亥',
  '戊子',
  '己丑',
  '庚寅',
  '辛卯',
  '壬辰',
  '癸巳',
  '甲午',
  '乙未',
  '丙申',
  '丁酉',
  '戊戌',
  '己亥',
  '庚子',
  '辛丑',
  '壬寅',
  '癸卯',
  '甲辰',
  '乙巳',
  '丙午',
  '丁未',
  '戊申',
  '己酉',
  '庚戌',
  '辛亥',
  '壬子',
  '癸丑',
  '甲寅',
  '乙卯',
  '丙辰',
  '丁巳',
  '戊午',
  '己未',
  '庚申',
  '辛酉',
  '壬戌',
  '癸亥',
]

// 古籍列表
export const bookList = [
  {
    id: 1,
    name: '穷通宝鉴',
  },
  {
    id: 2,
    name: '滴天髓',
  },
  {
    id: 3,
    name: '三命通会',
    noVipContent:
      '该书是传统命理四大作之一，作者明朝进士万明英。\n全书共十二卷，前九卷分列了十天干，每天干以日为主，以月为核心时为辅，定人吉凶。古籍智能推荐，将书中的书中相关论述，匹配命盘的月日时配置，为批命提供思路和取用神参考。',
  },
  {
    id: 4,
    name: '八字提要',
    noVipContent:
      '作者命理学大家韦千里。作者基于实地命理经验的立论与观点，以月令、日干和时柱的配合，进行命局特点和喜用的批算，准确率颇高。\n古籍智能推荐，将其书内一千四百四十条分析，与命盘进行匹配，条目信息简明，且上手简单操作性强。',
  },
  {
    id: 5,
    name: '子平真诠',
    noVipContent:
      '传统命理四大作之一，作者清朝进士沈孝瞻。\n该书更重视理论思路的阐述，让命理学走向了更加有核心、有重点、有条理的分析方法上。是传统子平命理学中分量最少，但是理论最为精辟的著作。\n古籍智能推荐，根据命盘特征，匹配将该书对于格局和格局取运的论述，是了解八字格局和行运成败的绝佳文本。',
  },
  {
    id: 6,
    name: '渊海子平',
    noVipContent:
      '该书由宋代徐大升依据徐子平先师论命成果而编著，是八字命理学的宗祖之作，在命理发展史上具有划时代的意义。故当今算命书又被称为“子平术”。\n古籍智能推荐，根据命盘特征，匹配该书对于格局、干支、诗诀的文本，是您断命不可错过的经典教材。',
  },
  {
    id: 7,
    name: '天元咸巫',
    noVipContent:
      '该书刊载于《古今图书集成》艺术典之中，该书是以日和时统计来定吉凶，进行归类八字的索引档案。\n古籍智能推荐，省去人工索引的工作，自动推送匹配条目。条目信息简明，且上手操作性强。',
  },
  {
    id: 8,
    name: '神峰通考',
    noVipContent:
      '作者明朝神峰子张楠。书中《十天干体象全编论》和《十二支咏》，对干支特性进行了经典的论述；后三卷而用非常直白的语言对许多子平经典古歌赋进行了注解。\n古籍智能推荐，将书中对干支的精妙注解，匹配命盘上的相应五行，是辅助命盘研究的绝佳材料。',
  },
  {
    id: 9,
    name: '千里命稿',
    noVipContent:
      '作者民国韦千里，韦千里在民国与袁树珊被合并誉为“南袁北韦”，该书是他主讲的命学培训班的讲义。\n该书语言简练、述理清晰，尤其是对格局、五行、六神的性质讲解，可以说是此书的精华。\n智能古籍推荐，根据命盘格局，匹配该书对于格局成、败、过、不及、用神等描述，是您把握格局真义的绝佳文本！',
  },
  {
    id: 10,
    name: '五行精纪',
    noVipContent:
      '《五行精纪》作者廖中，南宋人。\n该书以年柱干支来推算富贵贫贱，用纳音，重神煞，讲格局。它引用了当时流行的50多种算命文献，是南宋朝代算命学的一部集大成作。 \n智能古籍推荐，根据命盘特征，匹配该书对纳音、天干、五行、节气的论述，为大家断命提供参考！',
  },
  {
    id: 11,
    name: '李虚中命书',
    noVipContent:
      '《李虚中命书》传为鬼谷子撰，唐李虚中注。后世传星命之学者，皆以虚中为祖。\n该书在中国命理学上有很重要的地位，是把五行学、阴阳学、星命学整合而成的重要著作，是向八字命理学迈进的主要里程碑。\n智能古籍推荐，根据命盘特征，匹配该书的六十甲子解析，为大家断命提供参考！',
  },
]

// 排盘关键词详情列表
export const ShiShenTips = [
  {
    name: '正财',
    tip: '正财心性\n为喜：勤俭持家、脚踏实地、感情专一、守本分、不惹事、情绪感知能力强、注重细节、现实主义、善理财\n为忌：抠门、保守、小气、缺乏进取、过于计较和敏感\n\n正财取象\n为喜：钱财、事业、富裕、健康\n为忌：破财、贫困、疾病、婚灾',
    gujue: '日主克、耗日主者为财星，异性为正财。',
    shishen:
      '偏正财之能力：生官杀，泄伤食，制枭，坏印\n\n生官杀：日干强，有财生官杀，喜官杀旺则成功。日干弱，有财生官杀，喜印生比劫以制之。\n\n泄伤食：日干强，伤食重，有财泄伤食，喜财旺生发。日干弱，伤食轻，有财泄伤食，喜比劫以制财。\n\n制枭：日干强，不须枭神生身，喜财来制枭。日干弱，有财星制枭，喜比劫以解之。\n\n坏印：日干强，不劳印绶再助身，喜伤食生财，助财破印。日干弱，有财坏印，喜比劫克去财星以存印。',
  },
  {
    name: '偏财',
    tip: '偏财心性\n为喜：热情、大方、豁达、情商高、重情重义、善于交际、处事灵活、拿得起放得下\n为忌：欲望强、不克制、放纵情欲、风流、用心不专、不负责任、拜金主义\n\n偏财取象\n为喜：财运好、事业成功、生活富裕、多才多艺\n为忌：破财、贫困、疾病、婚灾、玩世不恭、铺张浪费',
    gujue: '日主克、耗日主者为财星，同性为偏财。',
    shishen:
      '偏正财之能力：生官杀，泄伤食，制枭，坏印\n\n生官杀：日干强，有财生官杀，喜官杀旺则成功。日干弱，有财生官杀，喜印生比劫以制之。\n\n泄伤食：日干强，伤食重，有财泄伤食，喜财旺生发。日干弱，伤食轻，有财泄伤食，喜比劫以制财。\n\n制枭：日干强，不须枭神生身，喜财来制枭。日干弱，有财星制枭，喜比劫以解之。\n\n坏印：日干强，不劳印绶再助身，喜伤食生财，助财破印。日干弱，有财坏印，喜比劫克去财星以存印。',
  },
  {
    name: '正印',
    tip: '正印心性\n为喜：仁慈、心地善良、安静平和、有同情心、有爱心、有修养、有智慧、注重内涵、有精神追求\n为忌：懒惰、行动力差、依赖性强、不思进取、优柔寡断、抑郁\n\n正印取象\n为喜：学历、荣誉、证书、靠山、贵人、房子、地位\n为忌：休学、失业、名声损毁、贫穷、懒惰',
    gujue: '生日主、扶日主者为印星，异性-正印。',
    shishen:
      '偏正印之能力：生身，泄官杀，御伤，挫食\n\n生身：日干弱，有印绶生身，最喜官星生印。日干强，又有印绶生身，即喜财以制之。\n\n泄官杀：日干弱，官杀强，有印绶泄官杀。喜印身两旺。日干强，官杀弱，又有印绶泄官杀，喜堸扶官杀。\n\n御伤：日干弱，伤官强，有印绶驾御伤官。喜印旺御伤助身。日干强，伤官弱，又有印绶驾御伤官。喜 财旺克印以制之。\n\n挫食：日干弱，食神强，有印绶合食，喜印旺助身去食。日干强，食神弱，又有印之挫食，喜财旺克印以制之。',
  },
  {
    name: '偏印',
    tip: '偏印心性\n为喜：精明、领悟力强、善于观察、警觉性高、创造力强、好钻研、思想独特、喜怒不形于色、看透本质、天生的心理学家\n为忌：孤独、不合群、心机重、内向多疑、旁门左道、想事情总往坏处想、钻牛角尖、缺少人情味\n\n偏印取象\n为喜：偏业、学术、荣誉、思想成就、宗教、哲学、地位\n为忌：病灾、休学、失业、心理问题、偏印夺食会导致伤克子女',
    gujue: '生日主、扶日主者为印星，同性-偏印。',
    shishen:
      '偏正印之能力：生身，泄官杀，御伤，挫食\n\n生身：日干弱，有印绶生身，最喜官星生印。日干强，又有印绶生身，即喜财以制之。\n\n泄官杀：日干弱，官杀强，有印绶泄官杀。喜印身两旺。日干强，官杀弱，又有印绶泄官杀，喜堸扶官杀。\n\n御伤：日干弱，伤官强，有印绶驾御伤官。喜印旺御伤助身。日干强，伤官弱，又有印绶驾御伤官。喜 财旺克印以制之。\n\n挫食：日干弱，食神强，有印绶合食，喜印旺助身去食。日干强，食神弱，又有印之挫食，喜财旺克印以制之。',
  },
  {
    name: '食神',
    tip: '食神心性\n为喜：温和斯文，思维细腻，宽容、善良、乐于奉献、人缘好、有福气、人文情怀\n为忌：爱幻想、想得多做得少、自尊心强、多情纵欲、纵情人间烟火、好逸恶劳\n\n食神取象\n为喜：平安、福气、口福、多才多艺、生活富裕\n为忌：贫困、劳累、疾病、抑郁',
    gujue: '日主生、泄日主者为食伤。同性-食神。',
    shishen:
      '食神之能力：泄身，生财，制杀，损官\n\n泄身：日干强，爱食神，既见食，喜财以流通之。日干弱，怕食神，既见食，喜印以合制之。\n\n生财：身强财弱，爱食神，既见食，喜财多生发。身弱财强，怕食神，既见食，喜印助身旺。\n\n制杀：杀重身轻，爱食神，既见食，喜比劫食伤生助。身强杀浅，怕食神，既见食，喜见财以和解之。\n\n损官：官多身弱，爱食神，既见食，喜比劫食伤生助。身重官轻，怕食神，既见食，喜见财以和解之。',
  },
  {
    name: '伤官',
    tip: '伤官心性\n为喜：聪明、悟性高、表现欲强、才华横溢、创新能力极强、追求完美、向往自由、个人魅力\n为忌：恃才傲物、争强好胜、不服管束、爱出风头、三分钟热度、自律性差、多情纵欲\n\n伤官取象\n为喜：才华横溢、升职创业、技术成果、商业头脑\n为忌：失业、降职、官灾、退学、疾病、官非纠纷',
    gujue: '日主生、泄日主者为食伤。异性-伤官。',
    shishen:
      '伤官之能力：泄身，生财，敌杀，损官\n\n泄身：日干强，受伤官，既见伤，喜见财以流通之。日干弱。怕伤官。既见伤，喜印绶以制伏之。\n生财：身强则弱，爱伤官，既见伤，喜财多以生发之。身弱财多，所伤官，既见伤，喜印绶以制之。\n敌杀：杀重身轻，爱伤官，既见伤，喜比劫食伤以生助之。身强杀浅，怕伤官，即见伤，喜见财以和解之。\n损官：官重身轻，爱伤官，既见伤，喜比劫食神以生助之。身强官弱，怕伤官，既见伤，喜见财以和解之。',
  },
  {
    name: '比肩',
    tip: '比肩心性\n为喜：刚健、果断、有毅力、不服输、勤奋努力、执行力强、自我意识强\n为忌：爱面子、自尊心强、据理力争、虚荣、死板、多疑、信口开河\n\n比肩取象\n为喜：得同辈帮助、竞争中取得名利、身体精力\n为忌：竞争、破财、官非口舌、病灾、婚灾',
    gujue: '同日主、助日主者为比劫。同性-比肩。',
    shishen:
      '比劫禄刃之能力：帮身，任官杀，代泄，夺财\n\n帮身：日干弱，有比劫禄刃帮身，喜身旺生发。日干弱，有比劫禄刃帮身，喜官杀以制之。\n\n任官杀：日干弱，有比劫禄刃敌官杀，喜身杀两相停。（停者，平均也）日干强，又有比劫禄刃敌官杀，喜财量生官杀。\n\n代泄：日干弱，伤食多，有比劫禄刃代为受泄，喜印制伤食而生身。日干强，又有比劫禄刃代受伤食之泄，喜财官两旺。\n\n制财：日干弱，有比劫禄刃制财，喜印生身。日干强，又有比劫禄刃制财，喜官杀制之。',
  },
  {
    name: '劫财',
    tip: '劫财心性\n为喜：自信、豪爽大方、热情直率、不怕困难、勇于竞争、口才好、朋友兄弟多\n为忌：冲动、霸道、争斗、自我、说话直、不顾他人感受\n\n劫财取象\n为喜：意志坚强、功成名就、事业有成、竞争得利\n为忌：打架斗殴、官非惹祸、克妻克父、贫困、病灾',
    gujue: '同日主、助日主者为比劫。异性-劫财。',
    shishen:
      '比劫禄刃之能力：帮身，任官杀，代泄，夺财\n\n帮身：日干弱，有比劫禄刃帮身，喜身旺生发。日干旺，有比劫禄刃帮身，喜官杀以制之。\n\n任官杀：日干弱，有比劫禄刃敌官杀，喜身杀两相停。（停者，平均也）日干强，又有比劫禄刃敌官杀，喜财量生官杀。\n\n代泄：日干弱，伤食多，有比劫禄刃代为受泄，喜印制伤食而生身。日干强，又有比劫禄刃代受伤食之泄，喜财官两旺。\n\n制财：日干弱，有比劫禄刃制财，喜印生身。日干强，又有比劫禄刃制财，喜官杀制之。',
  },
  {
    name: '正官',
    tip: '正官心性\n为喜：自律、做事稳健、善于思考、有管理能力、遵守规矩、为人公道、责任心强、利于仕途公职发展。\n为忌：容易悲观、多虑、虚伪、不善变通、胆小怕事、意志不坚\n\n正官取象\n为喜：工作、名声、地位、事业\n为忌：官非、压力、疾病、贫困',
    gujue: '克日主，抑日主者为官杀。异性-正官。',
    shishen:
      '正官之能力：引财，生印，拘身，制劫\n\n引财：身强财弱爱正官，既见官，喜财旺以生之。财多身弱怕正官，既见官，喜印旺以泄之。\n\n生印：身强印弱爱正官，既见官，喜官旺生印身弱印强怕正官，既见官，喜食财以两制之。\n\n拘身：日干强，爱正官，既见官，喜财旺以生之。日干弱，怕正官，既见官，喜印旺以解之。\n\n制劫：身强有劫，爱正官，即见官，喜财旺以生之。身弱赖劫，怕正官，既见官，喜印以生身。',
  },
  {
    name: '七杀',
    tip: '七杀心性\n为喜：有魄力、机警伶俐、目标感强、思维缜密、敢想敢干、善于权谋、做事有手段、务实主义\n为忌：多疑多虑、胆大妄为、走捷径、冲动、好斗、七杀克身太重可能反过来胆小懦弱\n\n七杀取象\n为喜：名声、权力、地位、影响力、事业\n为忌：小人、伤灾、黑社会、被人欺、牢狱、贫贱',
    gujue: '克日主，抑日主者为官杀。同性-偏官。',
    shishen:
      '七杀之能力：耗财，生印，攻身，制劫\n\n耗财：身弱印轻财重，爱七杀，既见杀，喜印比之帮身。身强印重财轻，怕七杀，既见杀，喜伤食以制煞生财。\n\n生印：身印并衰，爱七杀，既见杀，喜杀重生印。日弱印强性七杀，既见杀，喜食财以两制之。\n\n攻身：日干强。爱七杀，既见杀，喜财旺以生之。日干弱，怕七杀，既见杀，喜印旺以解之。\n\n制劫：身强有劫，爱七杀，既见杀，喜财旺以生之。身弱赖劫，怕七杀，既见杀，喜食伤以制之。',
  },
]
export const ZhangShengTips = [
  {
    name: '长生',
    shijue:
      '长生管取命长荣，时日重临主性灵；\n更得吉时相会遇，少年及第入王庭。\n长生若也得相逢，生下须招祖业隆；\n父母妻儿无克陷，安然享福保初终。\n\n                          ——《渊海子平》',
    chafa:
      '以日干查四地支\n\n甲日见亥、乙日见午、丙日见寅、丁日见酉、戊日见寅、己日见酉、庚日见巳、辛日见子、壬日见申、癸日见卯。',
  },
  {
    name: '沐浴',
    shijue:
      '沐浴凶神切忌之，多成多败少人知；\n男人值此应孤独，女命逢之定别离。\n沐浴那堪吉位逢，更兼引从在其中；\n读书必定登科甲，莫比诸神例作凶。\n桃花沐浴不堪闻，叔伯姑姨合共婚；\n日月时胎如犯此，定知无义乱人伦。\n咸池无禄号桃花，酒色多因败坏家；\n更被凶神来克破，瘠羸病死莫咨嗟。\n女命若还逢沐浴，破败两三家不足；\n父母离乡寿不长，头男长女须防哭。\n\n                          ——《渊海子平》',
    chafa:
      '以日干查四地支\n\n甲日见子。乙日见巳。丙日见卯。丁日见申。戊日见卯。己日见申。庚日见午。辛日见亥。壬日见酉。癸日见寅。',
  },
  {
    name: '冠带',
    shijue:
      '命逢冠带少人知，初主贫寒中主宜；\n更得贵人加本位，功成名遂又何疑。\n人命若还逢冠带，兄弟妻孥无陷害；\n因何接祖绍箕裘，只为胎中有冠盖。\n\n                          ——《渊海子平》',
    chafa:
      '以日干查四地支\n\n甲日见丑。乙日见辰。丙日见辰。丁日见未。戊日见辰。己日见未。庚日见未。辛日见戌。壬日见戌。癸日见丑。',
  },
  {
    name: '临官',
    shijue:
      '临官帝旺最为奇，禄贵同宫仔细推；\n若不状元登上第，直须黄甲脱麻衣。\n\n                          ——《渊海子平》',
    chafa:
      '以日干查四地支\n\n甲日见寅。乙日见卯。丙日见巳。丁日见午。戊日见巳。己日见午。庚日见申。辛日见酉。壬日见亥。癸日见子。',
  },
  {
    name: '帝旺',
    shijue:
      '临官帝旺两相逢，业绍箕裘显祖宗；\n失位纵然居世上，也须名姓达天聪。\n\n                          ——《渊海子平》',
    chafa:
      '以日干查四地支\n\n甲日见卯。乙日见寅。丙日见午。丁日见巳。戊日见午。己日见巳。庚日见酉。辛日见申。壬日见子。癸日见亥。',
  },
  {
    name: '衰',
    shijue:
      '纳音衰病死重逢，成败之中见吉凶；\n若得吉神来救助，变灾为福始亨通。\n衰病两逢兼值死，世人至老无妻子；\n不惟衣食不丰隆，灾病绵绵终损己。\n\n                          ——《渊海子平》',
    chafa:
      '以日干查四地支\n\n甲日见辰。乙日见丑。丙日见未。丁日见辰。戊日见未。己日见辰。庚日见戌。辛日见未。壬日见丑。癸日见戌。',
  },
  {
    name: '病',
    shijue:
      '纳音衰病死重逢，成败之中见吉凶；\n若得吉神来救助，变灾为福始亨通。\n衰病两逢兼值死，世人至老无妻子；\n不惟衣食不丰隆，灾病绵绵终损己。\n\n                          ——《渊海子平》',
    chafa:
      '以日干查四地支\n\n甲日见巳。乙日见子。丙日见申。丁日见卯。戊日见申。己日见卯。庚日见亥。辛日见午。壬日见寅。癸日见酉。',
  },
  {
    name: '死',
    shijue:
      '纳音衰病死重逢，成败之中见吉凶；\n若得吉神来救助，变灾为福始亨通。\n衰病两逢兼值死，世人至老无妻子；\n不惟衣食不丰隆，灾病绵绵终损己。\n\n                          ——《渊海子平》\n',
    chafa:
      '以日干查四地支\n\n甲日见午。乙日见亥。丙日见酉。丁日见寅。戊日见酉。己日见寅。庚日见子。辛日见巳。壬日见卯。癸日见申。',
  },
  {
    name: '墓',
    shijue:
      '墓库原来是葬神，一为正印细推论；\n相生相顺无相克，富贵之中次第分。\n人命若还逢墓库，积谷堆财难计数；\n悭贪不使一文钱，至老人呼守钱虏。\n\n                          ——《渊海子平》',
    chafa:
      '以日干查四地支\n\n甲日见未。乙日见戌。丙日见戌。丁日见丑。戊日见戌。己日见丑。庚日见丑。辛日见辰。壬日见辰。癸日见未。',
  },
  {
    name: '绝',
    shijue:
      '绝中逢旺少人知，却去当生命里推；\n反本还元宜细辩，忽然迍否莫猜疑。\n胎神一位难为绝，克陷妻孥家道劣；\n不惟朝暮走忙忙，羊狠狼贪无以别。\n\n                          ——《渊海子平》',
    chafa:
      '以日干查四地支\n\n甲日见申。乙日见酉。丙日见亥。丁日见子。戊日见亥。己日见子。庚日见寅。辛日见卯。壬日见巳。癸日见午。',
  },
  {
    name: '胎',
    shijue:
      '绝中逢旺少人知，却去当生命里推；\n反本还元宜细辩，忽然迍否莫猜疑。\n胎神一位难为绝，克陷妻孥家道劣；\n不惟朝暮走忙忙，羊狠狼贪无以别。\n\n                          ——《渊海子平》',
    chafa:
      '以日干查四地支\n\n甲日见酉。乙日见申。丙日见子。丁日见亥。戊日见子。己日见亥。庚日见卯。辛日见寅。壬日见午。癸日见巳。',
  },
  {
    name: '养',
    shijue:
      '胎养须宜细审详，半凶半吉两相当；\n贵神相会应为福，恶杀重逢见祸殃。\n\n                          ——《渊海子平》',
    chafa:
      '以日干查四地支\n\n甲日见戌。乙日见未。丙日见丑。丁日见戌。戊日见丑。己日见戌。庚日见辰。辛日见丑。壬日见未。癸日见辰。',
  },
]
export const NaYinTips = [
  {
    name: '海中金',
    tip: '性情：深藏不露，有城府\n(主看日柱、年柱)',
    book1:
      '[原文]\n甲子、乙丑。以子为水，又为湖，又为水旺之地，兼金死于子、墓于丑，水旺而金死、墓，故曰海中之金，又曰气在包藏，使极则沉潜。\n\n[今译]\n甲子、乙丑。子的五行属于水，又比喻为湖，是水的旺盛之地。且金死于子、墓库于丑，因此在水旺之地，金就处于死和墓的能量状态，所以把甲子、乙丑称为海中金。又因为甲子、乙丑的能量处于极度包藏状态，因此金就潜入海底。',
    book2:
      '[原文]\n甲子金，为宝物，喜金木旺地。\n进神喜，福星，平头，悬针，破字。\n\n乙丑金，为顽矿，喜火及南方日时。\n福星，华盖，正印。 \n\n[今译]\n甲子金，属于宝贵之物，喜金和木旺之地。\n常带的吉神煞：进神、福星；常带的凶神煞：平头、悬针、破字。\n\n乙丑金，属于质地坚硬的金矿，喜爱火来锻炼，以及南方日时。\n其中包含的神煞有福星、华盖、正印等。 \n\n[原文]\n海中金者，宝藏龙宫，珠孕蛟宝，出现虽假于空冲，成器无借乎火力，故东方朔以蛤蚌名之，良有理也。妙选有珠藏渊海格，以甲子见癸亥，是不用火；逢空有蚌珠照月格，以甲子见己未，是欲合化互贵。盖以海金无形，非空冲则不能出现，而乙丑金库，非旺火则不能陶铸故也。如甲子见戊寅、庚午，是土生金，乙丑见丙寅、丁卯，是火制金。又天干逢三奇，此等格局，无有不贵。',
    book3:
      '[原文]\n甲子天官藏，是子旺母衰之金，溺于水下而韬光须假火革，有旺盛之气，方可以扬名显用。（命入贵格，明暗取官。）\n\n乙丑禄官承，乃库墓守财之金，不嫌鬼旺之方，喜见禄财之地，水土砥砺，\n忽然有气，亦可以为器成材。（平和贵格，不须禄到。）',
  },
  {
    name: '炉中火',
    tip: '性情：待人热情、积极向上\n(主看日柱、年柱)',
    book1:
      '[原文]\n丙寅、丁卯。以寅为三阳，卯为四阴，火既得位，又得寅卯之木以生之，此时天地开炉，万物始生，故曰炉中火，天地为炉，阴阳为炭。\n\n[今译]\n丙寅、丁卯。 寅属阳，在地支中排行第三，故被称为三阳。卯属阴，在地支中排行第四，故被称为四阴。丙火和丁火得到了正位，并且还得到寅  木和卯木的生扶。此时，天地就像刚刚生火的大炉，万物开始生长，所以将丙寅、丁卯称为炉中火。天地就像用于大火炉，阴阳之气就提供燃料的炭。',
    book2:
      '[原文]\n丙寅火，为炉炭，喜冬及木。\n福星，禄刑，平头，聋哑。\n\n丁卯火，为炉烟，喜巽地及秋冬。\n平头，截路，悬针。\n\n[今译]\n丙寅火，属于炉中炭火，喜爱冬季和木。\n其中包含的神煞有福星、禄、刑、平头、聋哑等。\n\n丁卯火，属于炉中烟火，喜爱巽地和秋冬。\n其中包含的神煞有平头、截路、悬针。\n\n[原文]  \n炉中火者，天地为炉，阴阳为炭，腾光辉于宇宙，成陶冶于乾坤。此火炎上，喜得木生，唯平地之木为上，以丙寅见己亥，谓之天乙贵，见戊戌，谓之归库，故吉，丁卯次之。然丙寅火自生，无木庶几，丁卯火自败，若无木则凶，且此火以金为用，更得金来，方应化机，但丁卯无木而更遇金，主劳苦之命。夫寅见木多火炎而无水制，主天，卯见三四木不妨，如庚寅辛卯就位相生，壬午癸未化为真火，寅见之多主凶暴或疾天。',
    book3:
      '[原文]\n丙寅禄地元，是子母相承之火，先烟后焰 抽其明而三进，喜木为助，嫌水陵迟，五行相养，虽在死方，亦可光耿。（命入责格，不用干禄。）\n\n丁卯贵禄奇，乃本旺禄休之火，惟欲阴旺，恶处盛阳，若火木相资，连于艮震之方，必能变鼎味而成享礼也。（欲逢官鬼，始得贵奇。）',
  },
  {
    name: '大林木',
    tip: '性情：团队精神、仁义好善\n(主看日柱、年柱)',
    book1:
      '[原文]\n戊辰、己巳。以辰为原野，巳为六阴，木至六阴则枝藏叶茂，以茂盛之大林木而生原野之间，故曰大林木，声播九天，阴生万顷。\n\n[今译]\n戊辰、己巳。辰包藏着木，因此称之为原野。已属阴，在地支中排行第六，故被称之为六阴。木在六阴之地，树木葱郁枝繁叶茂，就像茂盛的大树生长在原野之中，因此将戊辰、己巳称为大林木。其声音可以传播到天空的高处，阴气足以滋养万倾林木。',
    book2:
      '[原文]\n戊辰木，山林山野处不材之木，喜水。\n禄库，华盖，水禄马库，棒杖，伏神，平\n头。\n\n己巳木，山头花草，喜春及秋。\n禄库，八专，阙字，曲脚。 \n\n[今译]\n戊辰木，属于山野之间不成材之木，喜爱水的滋润。\n其中包含的吉神有禄库，华盖、水禄马库，凶煞则有棒杖、伏神、平头。\n\n己已木，属于山头上的花草，喜爱春秋二季。\n包含的吉神有禄库，凶煞则有八专、阙字、曲脚等。\n\n\n[原文]  \n大林木者，枝干撼风，柯条撑月，耸壑昂霄之德，凌云蔽日之功。此木生居东南，春夏之交，长养成林，金假艮土为源，癸丑为山，三命无破陷，最为福厚权贵，戊辰为上，己已次之。土遇路傍，为负载，戊辰见辛未为贵，己见庚午为禄，主福；壁、屋二土，再得剑金，则大林之木取为栋梁，成格最吉，无此乃山间茂林之木也。',
    book3:
      '[原文]\n戊辰神头禄，乃华实兼荣之木，爱乎水土，忌见火金，有所养于金，乃英实之命也。（相乘可贵，不畏鬼临。）\n\n已已地奇备，乃气胜体刚之木，生逢对旺干鬼相加，或木来比助，金伐以成为栋梁之材，皆得终美。（贵无鬼官，须见角音。）',
  },
  {
    name: '路旁土',
    tip: '性情：迎合权贵、不走寻常路\n(主看日柱、年柱)',
    book1:
      '[原文]\n庚午、辛未。以未中之木，生午火之旺火，则土旺于斯而受刑。土之所生未能育物，犹路旁土也，壮以及时，乘厚戴木，多不喜木。\n\n[今译]\n庚午、辛未。用未中乙木，生助午中藏的旺盛丁火，火势旺盛，土就会受刑。火生土，旺火所生之土是焦土，因此不能滋养万物，就像路边的土一样无用。处于壮年就应当赶紧做一些以后做不了的事情，在厚土上种植树木，一旦多了就不再是好事。',
    book2:
      '[原文]\n庚午土，路傍乾土，喜水及春。\n福星，官贵，截路，棒杖，悬针。\n\n辛未土，含万宝，待秋成，喜秋及火。\n华盖，悬针，破字。 \n\n[今译]\n庚午土，属于路边的燥土，喜爱水和春季。\n包含的吉神有福星、官贵，凶煞有截路空亡、棒杖、悬针。\n\n辛未土，此土包含万种宝物，秋成之后就显现出来，喜爱秋季和火。其中凶煞有华盖、悬针、破字等。\n\n[原文]\n路旁土者，大地连途，平田万顷，禾稼赖以资生，草木由之畅茂。此乃火暖土温，长养万物之土也，故须假水为先，乃灌溉滋润之。论次第尤宜水化为妙，更得金来相助，则禾稼成实。',
    book3:
      '[原文]\n庚午天禄承，是含辉始育之土，气数未备，惟喜旺方，得数已完尚嫌水重，若独禄会命旺身绝，岂是贵地。（禄鬼自处，不假官鬼。）\n\n辛未禄自藏，乃自本立形之土，有火相助，得木相乘，水轻木重亦可以小康若败而乘禄多方为厚载之福。（喜见干连，不畏木重。）',
  },
  {
    name: '剑锋金',
    tip: '性情：锋芒毕露、一针见血\n(主看日柱、年柱)',
    book1:
      '[原文]\n壬申、癸酉。以申酉金之正位，兼临官申、帝旺酉，金既生旺，旺则诚刚，刚则无逾于剑峰，故曰剑峰金。虹光射斗牛，白刃凝霜雪。\n\n[今译]\n壬申、癸酉。申金和酉金都得到了正位，加上金临官于申，帝旺于酉，金处于生旺的状态，着实刚强。刚强的事物难以超越剑锋，所以将他们称为剑锋金。它的虹光足以射落天上的斗宿牛宿，白刃透出寒光，就像凝结了一层霜雪。',
    book2:
      '[原文]\n壬申金，戈戟，大喜子午卯酉。\n平头，大败，妨害，聋哑，破字，悬针。\n\n癸酉金，金之椎凿，喜木及寅卯。\n伏神，破字，聋哑。\n\n[今译]\n壬申金，属于剑戟之器，喜爱子午卯酉。\n其中的凶煞有平头、大败、妨害、聋哑、破字、悬针等。\n\n癸酉金，属于金制成的椎凿，喜爱木和寅卯。\n其中的凶煞有伏神、破字、聋哑等。\n\n[原文]  \n剑锋金者，白帝司权，刚由百炼，红光射于斗牛，白刃凝于霜雪。此金造化，非水不能生，大溪、海水，日时相逢为上格；井泉、涧下，有霹雳助或得乙卯之雷方好，若无雷霹，亦金白水清格也。秋生更吉，日时遇长流，在壬辰为宝剑，化为青龙，癸巳亦得此剑，不能通变。',
    book3:
      '[原文]\n壬申地天禄，乃自任权制之金，刚而有断，爱土木而嫌火重，虽居财旺身衰，木县，喜亦主清华之贵。（真假财官、贵之为贵。） \n\n癸酉贵符印，乃刚锐利用之金，不嫌绝败，惟畏鬼多，若平易而不相刑，当有自然之材器。（庚辛无鬼，不假官鬼。）',
  },
  {
    name: '山头火',
    tip: '性情：激情奔放、疯狂热烈\n(主看日柱、年柱)',
    book1:
      '[原文]\n甲戍、乙亥。以戍亥为天门，火照天门，其光至高，故曰山头火也，天际斜晖，山头落日散绮，因此返照舒霞，木白金光。\n\n[今译]\n甲戍、乙亥。甲乙属木，木生火，戌是天门，木所生之火映照天门，火光极高，所以将甲戌、乙亥称为山头火。傍晚，夕阳西下，太阳斜在天际散发余晖，日落山头，反射的霞光照亮天地，木金闪烁光芒。',
    book2:
      '[原文]\n甲戌火，火所宿处，喜春及夏。\n正印，华盖，平头，悬针，破字，棒杖。\n\n乙亥火，火之热气，喜土及夏。\n天德，曲脚。\n\n[今译]\n甲戌火，属于火的归宿之地，喜爱春夏季节。\n其中的吉神有正印、华盖，凶煞有平头、悬针、破字、棒杖等。 \n\n乙亥火，属于火烧热气，喜爱土和夏季。\n其中包含的吉神有天德贵人，凶煞有曲脚。\n\n[原文]  \n山头火者，野焚燎原，延烧极目，依稀天际斜晖，仿佛山头落日，此乃九月烧荒，衰草尽烬之火也。大概宜山木与风木，喜大林、松柏，以辰已有风，寅卵归禄更得癸丑为山上木，主贵。无山则木无所依，火无所见，纵有风亦不光显，余木无用，只以禄马看。',
    book3:
      '[原文]\n甲戌禄临官，乃墓成息用之火，不求壮旺，欲物平资，福禄可以高厚。（入格可贵，干不官必官。）\n\n乙亥地禄承 为气散游魂之火，生于木火，荣方上下，不逢相制，仅而成达，多助尤崇。（真官相制，得贵亦崇。）',
  },
  {
    name: '涧下水',
    tip: '性情：循规蹈矩、温文尔雅\n(主看日柱、年柱)',
    book1:
      '[原文]\n丙子、丁丑。以水旺于子衰于丑，旺而反衰则不能成江河，故曰涧下水，出环细浪，雪涌飞淌，汇流三峡之倾澜，望下寻之倒。\n\n[今译]\n丙子、丁丑。水旺于子，衰于丑，水行经子丑位，气势会由旺盛转为衰败，因此不能被当做江河，只能称为涧下水。涧下之水环绕山涧，翻涌出细细的波浪，化作雪一样的浪花急速流淌，最后汇为三峡之水，经过涧壑，奔流而倾倒。',
    book2:
      '[原文]\n丙子水，江湖，喜木及土。\n福星，官贵，平头，聋哑，交神，飞刃。\n\n丁丑水，水之不流清彻处，喜金及夏。\n华盖，退神，平头，飞刃，阙字。\n\n\n[今译]\n丙子水，属于江湖之水，喜爱木和土。\n其中的吉神有福星、官贵，凶煞有平头聋哑、交神、飞刃。\n\n丁丑水，属于不流动且清澈的水，喜爱金和夏。\n包含的神煞有华盖、退神、平头飞刃、阙字。 \n\n\n[原文]\n涧下水者，山环细浪，雪涌飞湍，相连南北之流，对峙坎离之脉。此水清澄，喜见金养，沙中、剑锋二金最宜。钗钏庚戌丁丑不宜，以丑戌相刑，辛亥见丙子则丙辛化水，尤贵；余金以禄贵参之，取其资生，恶其冲破。见木一位不妨，二三则主劳苦，亦以贵人禄马参之。',
    book3:
      '[原文]\n丙子天禄承，乃深沉停会之水，若会源得生，用制于东南，为出常之器。（自有真官，佳期禄会。）\n\n丁丑禄自守、乃渐下欲流之水，得水土相乘，经于败地，源脉不断，可升而\n济物，功德昭著也。（丑有癸藏，不明见官。）',
  },
  {
    name: '城头土',
    tip: '性情：固执坚持，不善变通\n(主看日柱、年柱)',
    book1:
      '[原文]戊寅、己卯。以天干戊、己属土，寅为艮山，土积为山，故曰城土也，天京玉垒，帝里金城，龙蟠千时之形，虎踞四维之势也。\n\n[今译]\n戊寅、己卯。戊己属土，寅属于艮山，土堆积而成山，因而将戊寅、己卯称为城头土。皇帝居住的京城，用金玉堆垒筑成，展现出龙蟠千里的形状，虎踞四方的气势。',
    book2:
      '[原文]\n戊寅土，堤阜城郭，喜木及火。\n伏神，棒杖。聋哑。\n\n己卯土，破堤败城，喜申酉及火。\n进神，短天，九丑，阏字，曲脚，悬针。\n\n[今译]\n戊寅土，属于堤岸和城墙类型的土，喜爱木和火。\n可能包含的凶煞有伏神、棒杖、聋哑。\n\n己卯土，属于残缺的堤岸和破败的城墙的土，喜爱申酉和火。\n可能包含的吉神有进神，凶煞有短夭、九丑、阙字、曲脚、悬针等。\n\n[原文]\n城头土者，天京玉垒，帝里金城，龙盘千里之形，虎踞四维之势。此土有成有未成，作两般论。凡遇见路傍，为已成之土不必用火；若无路傍，为未成之土，必须用火；大都城土皆须资木，杨柳癸未最佳，壬午则忌；桑拓癸丑为上，壬子次之。',
    book3:
      '[原文]\n戊寅地官承，乃生体安和之土，若资之以火土，俱盛金旺之荣，虽多反制  尚可高崇，为不常之用。（得官不旺，责出自然。）  \n\n己卯地官承，为鬼旺体坚之土，生于金重木多，而见财重，乃富贵长远。（得官不旺，贵出自然。）',
  },
  {
    name: '白蜡金',
    tip: '性情：注重细节，谨慎细微\n(主看日柱、年柱)',
    book1:
      '[原文]\n庚辰、辛巳。以金养于辰而生于巳，形质初成，未能坚利，故曰白蜡金，气渐发生，交栖日月之光，凝阴阳之气。\n\n[今译]\n庚辰、辛巳。辰属土，已属火，金养于辰，长生于巳，金经过土的滋养、火的冶炼，形状和质地初步形成，但是还不够坚硬和锐利。因此，将庚辰、辛巳称为白蜡金。金气渐渐萌发，日光和月光交相辉映，阴阳之气可以凝结。',
    book2:
      '[原文]\n庚辰金，锡蜡，喜秋及微木。\n华盖，大败，棒杖，平头。\n\n辛已金，金之生者，杂沙石，喜火及秋。\n天德，福星，官贵，截路，大败，悬针，曲\n脚。\n\n[今译]\n庚辰金，为锡蜡之金，喜爱秋和幼小的木。\n可能包含的神煞有华盖、十恶大败、棒杖，平头等。 \n\n辛已金，为杂有沙石的金粒，喜火和秋。\n其中包含的吉神有天德贵人、福星、官贵等，凶煞有截路空亡、大败、悬针、曲脚。 \n\n[原文]\n白蜡金者，昆山片玉，洛浦遗金，交栖日月之光凝聚阴阳之气，形明体洁，乃金之正色也。此金唯喜火炼，须炉中炎火。然庚辰见之，若无水济，主贫天，辛巳却以贵论，缘已是金生之地，见丙寅化水逢贵故也；山下火生，早主荣贵，亦须木助方得。',
    book3:
      '[原文]\n庚辰禄暗会，乃显光之金，而未成材，金刚土重，得期相会，无炎火之官，乃大臣之制。（不假禄合，禄千克期。）\n\n辛巳地官承、为资始之金，身坚而体柔；欲平火之制，若金助土成，则为光大之器。（丙官在下，务责于禄。）',
  },
  {
    name: '杨柳木',
    tip: '性情：善变通，随风倒，八面玲珑\n(主看日柱、年柱)',
    book1:
      '[原文]\n壬午、癸未。以木死于午墓于未，木既死墓，唯得天干壬癸之水以生之，终是柔木，故曰杨柳木，万缕不蚕之丝，千条不了之线。\n\n[今译]\n壬午、癸未。木死于午，墓库于未。木处于死墓的状态 即使能得到天干壬水和癸水的生助，但还是性质柔弱的木，因此将壬午、癸未称为杨柳木，杨柳的枝叶就像千丝万缕的丝线。',
    book2:
      '[原文]\n壬午木，杨柳干节，喜春夏。\n官贵，九丑，飞刃、平头、聋哑，悬针。\n\n癸未木，杨柳根，喜冬及水，亦宜春。\n正印，华盖，短天，伏神，飞刃，破字。\n\n[今译]\n壬午木，为杨柳干枝，喜爱春夏。\n其中的吉神有官贵，凶煞则有九丑、飞刃、平头、聋哑、悬针等。\n\n癸未木，为杨柳之根，喜爱冬和水，也喜欢春季。\n其中包含的吉神有正印、华盖，凶煞有短夭，伏神、飞刃、破字。\n\n[原文]\n杨柳木者，隋堤袅娜，汉苑轻盈，万缕不蚕之丝，千条不针之带，午未木之死墓，壬癸木之滋润。此木根基唯喜沙土，见艮山则依倚摇金，遇寅卯则东方得地。',
    book3:
      '[原文]\n壬午天官合，乃化薪之木，畏在火强，得水资之，或处身旺而逢土，亦可富贵。若独见金制，在死败之乡，非长久之命。（丁壬德合，寄任旺官。）\n\n癸未禄自备。为伐根之木，气败而体柔，不嫌金制，喜水之荣，及会元而借生主，乃重器成德之材。（癸在巳中，喜逢甲乙。）',
  },
  {
    name: '泉中水',
    tip: '性情：心胸宽广、为人坦荡\n(主看日柱、年柱)',
    book1:
      '[原文]\n甲申、乙酉。金既临官在申，帝旺在酉，旺则生自以火，然方生之际方量未兴，故曰井泉水也。气息在静，过而不竭，出而不穷。\n\n[今译]\n甲申、乙酉。金在申是临官的状态，在酉是帝旺的状态，金生水需要借助火，但是在火初生之际，力量未足，所以把甲申、乙酉称之为井泉水。井泉水的气息主静，出水不会衰竭。',
    book2:
      '[原文]\n甲申水，甘井，喜春及夏。\n破禄马，截路，平头，破字，悬针。\n\n乙酉水，阴壑水，喜东方及南。\n破禄，短天九丑，曲脚，破字，聋哑。\n\n[今译]\n甲申水。为甘甜的井水，喜爱春和夏。其中的神煞有冲破禄马、截路空亡、平头、破字、悬针等。\n乙酉水，为阴沟之水，喜爱东方和南方。其中可能会有伤克，神煞有禄、短天、九丑、曲脚、破字、聋哑等。\n\n[原文]\n井泉水者，寒泉清冽，取养不穷，八家凿之以同饮，万民资之以生活。此水生于金而出于木，故喜见金为福，沙中有土，性与之最宜，钗钏清秀次之，蜡金与钗金相冲，故不宜再见；剑锋申酉太旺，恐有泛滥之灾；海金无取，乙丑为艮，山下出泉，亦吉。',
    book3:
      '[原文]\n甲申地禄生，乃源泉之水，务有资助流长而无鬼，则为运广之渊，可享高厚之福。（禄始生，要干生旺而无官。）  \n\n乙酉贵还命，乃母旺进趋之水，若资以金，济用以火，自干东而震北，亦超卓辅弼之用。\n（干之无官，会合而责。）',
  },
  {
    name: '屋上土',
    tip: '性情：诚实守信、喜欢表现、好高骛远\n(主看日柱、年柱)',
    book1:
      '[原文]\n丙戌、丁亥。以丙丁属火，戍亥为天门，火既炎上，则土非在下而生，故曰屋上土。\n\n[今译]\n丙戌、丁亥。丙丁属于火，戌亥是天门，所以配合起来，这里的火属于天上的火，因而火生的土，并不是生在下面，土则成为屋上土（实际上是屋顶的砖瓦）。',
    book2:
      '[原文]\n丙戌土，堆阜，喜春夏及水。\n天德，华盖，平头，聋哑。\n\n丁亥土，平原，喜火及木。\n天乙，福星，官贵，德合，平头。\n\n[今译]\n丙戌土，为堆积之土，喜爱春夏和水。\n其中的吉神有天德贵人、华盖，凶煞有平头、聋哑。 \n\n丁亥土，为平原之土，喜爱火和木。\n其中的吉神有天乙贵人、福星、官贵、德合，凶煞有平头。  \n  \n[原文]  \n屋上土者，埏埴为林，水火既济，盖蔽雪霜之积，震凌风雨之功，此土瓦也。非木无以架之，故以木为根基，平地为上，大林次之，余取天干化木，亦吉，只怕冲破。',
    book3:
      '[原文]\n丙戌禄德合，乃禄资支附坚固，火钟之土，若资之以木，光耀不群，盖本重  不须旺也。\n（自有卒符，不畏偏。）\n\n丁亥地贵符，乃福壮临官之土，若润之以水，丽泽以金，处魁罡坤艮之方，可以显功遂名。\n（贵守官藏，真鬼德旺。）',
  },
  {
    name: '霹雳火',
    tip: '性情：雷厉风行、脾气急\n(主看日柱、年柱)',
    book1:
      '[原文]\n戊子、己丑。丑属土，子属水，水居正位而纳音乃火，水中之火非龙神则无，故曰霹雳火，电击金蛇之势，云驰铁骑之奔，变化之象。\n\n[今译]\n戊子、己丑。丑属于土，子属于水，水得到正位，纳音是火。水中的火没有遇到龙则不成立，所以叫做霹雳火。雷电击打金蛇的景象，铁骑在云中驰骋的动作，代表着变化。',
    book2:
      '[原文]\n戊子火，雷也。喜水及春夏，得土而神天。\n伏神，短天，九丑，杖刑，飞刃。\n\n己丑火，电也，喜水及春夏，得地而晦。\n华盖，大败，飞刃，曲脚，阙字。\n\n[今译]\n戊子火，为雷击之火，喜水和春夏，如果又得土相助，则能够为天神。\n其中的吉神有伏神，凶煞有短天、九丑、杖刑、飞刃等。\n\n己丑火，为电闪之火，喜水和春夏，如果得地助则天地晦暗无光。\n其中的吉神有华盖，凶煞有大败、飞刃、曲脚、阙字。\n\n[原文]\n霹雳火者，一缕毫光，九天号令，电掣金蛇之势，云驱铁马之奔。此火须资风水雷方为变化，若五行得值一件，皆主亨通。如日时见大海，癸亥为引凡入圣，已丑为上，戊子次之；见大溪，乙卯为雷火变化，丑为吉，戊子忌之；辰为风运中，遇之尤佳。 ',
    book3:
      '[原文]\n戊子天禄合，乃神龙之火，利于震巽，不畏水刑，支千得官皆可显用，水木盛则尤佳。\n（自有癸财，不必会禄。）\n\n已丑神头禄，乃余光不凡之火，惟期体重，不假奇财，若禄有资而命有成，方入康荣之责局。\n（贵财相会，无禄亦荣。）',
  },
  {
    name: '松柏木',
    tip: '性情：心平气和， 善良仁义\n(主看日柱、年柱)',
    book1:
      '[原文]\n庚寅、辛卯。以木临官在寅，帝旺在卯，木既生旺，则非柔弱之比，故曰松柏木也。积雪凝霜参天覆地，风撼笙簧，再余张旌施。\n\n[今译]庚寅、辛卯。木在寅是临官的状态，在卯的帝旺的状态，木既然是生旺的，远超柔弱的状态，所以叫做松柏木。可以承受雪的积压，和霜的冻寒，风吹来产生笙簧演奏的声音，伸展摇曳。',
    book2:
      '[原文]\n庚寅木，松柏干节，喜秋冬。\n破禄马，相刑，杖刑，聋哑。\n\n辛卯未，松柏之根，喜水土及宜春。\n破禄，交神，九丑，悬针。   \n\n[今译]\n庚寅木，是松柏树的干枝，喜秋冬两季。\n其中的神煞有冲破禄马相刑、杖刑、聋哑等。\n\n辛卯木，是松柏树的根，喜爱水土，最喜春天。可能包含的情况有冲破禄马，吉神有交神，凶煞有九丑、悬针。\n\n[原文]\n松柏木者，泼雪凑霜，参天覆地，风撼笙篁之奏，雨余旌旆之张。此木藏居金申 下，位列正东，乃为极旺，最喜山为根基水为滋润。天河雨露之水可以滋润，涧下丁丑属山，可为根基，丙子不如大溪水，有乙卯为雷，以发荣，却嫌风霹，有损折之凶；大海水有山则吉，癸亥清静无山，亦吉。',
    book3:
      '[原文]\n庚寅地奇备，不避刑冲，宁辞衰败，乃五行坚实之木，若得合柔之气，德相符，必作显扬大用。（禄位生旺，得官鬼成。）\n\n辛卯贵冲命，自旺经制之木，不畏霜雪，气节凌云，可制之以金，损之以火，而逢旺相即成巨室之材。若平易而无金，火生于曲直之会，亦为贵重矣。（禄命相击，不畏官耗。）',
  },
  {
    name: '长流水',
    tip: '性情：喜动不喜静， 喜游玩\n(主看日柱、年柱)',
    book1:
      '[原文]\n壬辰、癸巳。辰为水库，巳为金的长生之地，金则生水，水性已存，以库水而逢生金，泉源终不竭，故曰长流水也。势居东南，贵安静。\n\n[今译]壬辰、癸巳。辰是水的库，巳是金的长生，金可以生水，所以具备水的特性。以辰这一水库，而遇到了巳这一水的长生，水源可以不衰竭，所以叫做长流水。区位在东南，喜欢安静。',
    book2:
      '[原文]\n壬辰水，龙水，喜雷电及春夏。\n正印，天德，水禄马库，退神，平头，聋哑。\n\n癸巳水，水之不息，流入海，喜亥子，乃变化。\n天乙，官贵，德合，伏马，破字，曲脚。\n\n[今译]\n壬辰水，属于蛟龙之水，喜爱雷电和春夏。\n其中的吉神有正印、天德贵人、水禄马库，凶煞有退神、平头、聋哑。\n\n癸巳水，属于奔流不息之水，喜爱亥子水，主变化多端。\n其中的吉神有官贵、德合、天乙贵人，凶煞有伏马、破字、曲脚。\n\n[原文]  \n长流水者，混混无穷，滔滔不竭，就下必纳于东南，顺流自归于辰巳。此水喜金生养，金要白蜡、钗钏，以天干有庚辛真金，地支辰巳就位相生，戌亥为归源之地；剑锋纯是金水，箔金水木居东，皆以吉论；海中，沙中无取。嫌土蹇涸，而土有堤防之用，六土之中，取庚辛丙丁为吉，戊己无用。',
    book3:
      '[原文]\n壬辰禄清洁，乃会贵守成之水，五行不杂，在兑坎之间无物来制，文明清异之资，可享高厚之福。（喜于寅亥，见戌亦清。）\n\n癸巳地带合，乃流远澄清之水，若溢之以水，在火木荣方，方中无土，则有济物惠施之德也。\n（真气得用，官气尤清。）',
  },
  {
    name: '沙中金',
    tip: '性情：高贵典雅、谨慎小心\n(主看日柱、年柱)',
    book1:
      '[原文]\n甲午、乙未。午为火旺之地，火旺则金败，未为火衰之地，火衰败而金冠带，败而方冠带，未能作伐，故曰砂中金也。\n\n[今译]\n甲午、乙未。午是火的旺盛之地，如果火势炙盛，金就必然处于败势。未是火的衰败之地，如果火势衰败，金就会处于冠带，不能起到砍伐的功能，因此将甲午乙未称为砂中金。',
    book2:
      '[原文]\n甲午金，百炼精金，喜木水土。\n进神，德合，平头，破字，悬针。\n\n乙未金，炉炭余金，喜大火及土。\n华盖，截路曲脚，破字。\n\n[今译]\n甲午属金，属于经过千锤百炼的精金，喜水、木和土。\n其中的吉神有进神、德合，凶煞有平头、破字、悬针。\n\n乙未属金，属于炭炉中剩下的金，喜大火和土。\n其中的凶煞有华盖、截路空亡、曲脚、破字等。\n\n[原文]\n沙中金者，刚形布地，宝质藏沙，直教陶洗为珍，必须因人始贵。此金非炉火则不能制，但甲午见丙寅，寅中火生，寅午合局，柱无长生之土则燥，更值木助。主疾天；丙午纳音虽水，而支干纯火，加逢尤凶。山头、山下、覆灯三火既有木生，克制此金，又须清水济之，决主少年荣贵 戊子己丑龙火相逢，子午有交媾之妙，甲己有合化之理，主贵，杂以凡火则不为奇。\n  ',
    book3:
      '[原文]\n甲午天符禄，乃沙汰之金，志大而有节操，或遇火尽之而严，而旺金集之而  刚，不遇丁壬，始可陶镕之宝。（禄神败而食子，欲妻刚而子旺。）\n\n乙未禄印绶，乃强悍刚矿之金，欲金相用，在火盛处，父子相乘，皆为珍宝。（德神当位，喜见印官。）',
  },
  {
    name: '山下火',
    tip: '性情：性格热情、一吐为快\n(主看日柱、年柱)',
    book1:
      '[原文]\n丙申、丁酉。申为地户，酉为日入之门，日至此时而无光亮，故曰山下火。\n\n[今译]\n丙申、丁酉。申是地户，酉是日入之门。申时酉时，这个时候太阳已经落下，藏起自己的光辉，因此将丙申、丁酉称为山下火。酉位于西方 又喜东南方，在东方和南方发出光辉，光辉越来越明亮，喜水而忌火。',
    book2:
      '[原文]\n丙申火，白茅野烧，喜秋冬及木。\n平头，聋哑，大败，破字，悬针。\n\n丁酉火，鬼神之灵响，火无形者，喜辰戌丑未。\n天乙，喜神，平头，破字，聋哑，大败。\n\n[今译]\n丙申属火，属于白茅野烧之火，喜秋冬和木。\n包含的凶煞有平头、聋哑、十恶大败、破字、悬针等。\n\n丁酉属火，属于鬼神的灵火，这样的火没有形态，喜欢见辰、戌、丑、未四季。\n包含的吉神有天乙贵人、喜神，凶煞有平头、破字、聋哑、十恶大败。\n\n[原文]\n山下火者，草间熠耀，花理荧煌，寒林缀叶之光隔幔点衣之彩，方朔以荧火名之，故《妙选》有萤火照水格，遇秋生则贵为卿监，是以此火喜水，地支逢亥子，或纳音水更逢申酉月是也。或以山下之火最喜木与山，更得风来增辉为贵，又不以荧萤火矣。',
    book3:
      '[原文]\n丙申地官承，乃无资之火，金木壮旺而有制，得干生即为厚实，若禄盛而无依，即灰飞而不焰矣。（官在生方，不须癸壬。）\n\n丁酉贵自承。乃平易无为之火，得木旺则大炎见木多则成用，得火助则不清，在火位则常存，人生得此，无不贵豪。（丁连丙 ,见合不清。）',
  },
  {
    name: '平地木',
    tip: '性情：踏实稳健、胆小不惹事\n(主看日柱、年柱)',
    book1:
      '[原文]\n戊戌、己亥。戊为原野，亥为生木之地，夫木生于原野，则非一根一林之比，故曰平地木，惟贵雨露之功，不喜霜雪之积。\n\n[今译]\n戊戌、己亥。戌属土，称之为原野，亥是木的长生之地。生长在原野上的树木，不是一棵树比得上的，因此将戊戌、亥称为平地木。平地木只看重雨露的滋养，不喜欢霜雪的积压。',
    book2:
      '[原文]\n戊戌木，蒿艾之枯者，喜火及春夏。\n华盖，大败，八专，杖刑，截路。\n\n己亥木，蒿艾之茅，喜水及春夏。\n阙字，曲脚。 \n\n[今译]\n戊戌属木，是干枯的蒿艾，喜火和春夏。\n包含的神煞有华盖、十恶大败、八专、杖刑、截路空亡等。\n\n己亥属木，是蒿艾中的茅草，喜水和春夏。\n包含的凶煞有阙字、曲脚。\n\n[原文]\n平地木者，初生萌叶，始发枝条，唯资雨露之功，不喜雪霜之积，此乃地上之茂材，人间之屋木。戊戌为栋，亥为梁，最宜互换见之，须以土为基，土爱路傍，为正格，更逢子午，尤贵，以子午为天地正柱故也屋壁、城头三土以此木相资，中间有升化尤吉。',
    book3:
      '[原文]\n戊戌神头禄，乃不材之木，喜逢水旺乃可资荣，岂厌生成，伐宜金败，真运自然 不嫌禄鬼，方可高崇。（明合暗官，成于旺方。）\n\n己亥地官承，乃粪水育苗之木，水多土而临旺，皆有成就，然逢败绝为殃，亦主富贵荣盛。\n（干支财禄，畏彼官鬼。）',
  },
  {
    name: '壁上土',
    tip: '性情：个性散漫，不合群\n(主看日柱、年柱)',
    book1:
      '[原文]\n庚子、辛丑。丑虽是土家正位，而子则水旺之地，土见水多则为泥也，故曰壁上土也，气屋开塞，物尚包藏，掩形遮体，内外不及。\n\n[今译]\n丑属土，得到了土的正位，而且地支子是水的旺盛之地，土遇到水多，就  会化为泥，因此将庚子、辛丑称为壁上土。土气闭塞，万物还被隐藏着，形状  和体貌也被遮掩着，内在和外在都不完善。',
    book2:
      '[原文]\n庚子土，土中空者，屋宇也，喜木及金。\n木德合，杖刑。\n\n辛丑土，坟墓，喜木及火与春。\n华盖，悬针，阙字。\n\n[今译]\n庚子属土，属于屋宇上的泥土，喜爱木和金。\n与木德相合，包含的凶煞有杖刑。\n\n辛丑属土，属于坟墓之土，喜爱木、火和春季。\n包含的凶煞有华盖、悬针、阙字。\n\n[原文]\n壁上土者，恃栋依梁，兴门立户，却暑御寒之德，遮霜护雪之功。此乃人间壁土，非平地何以为靠。子午，天地正柱逢之尤为吉庆。凡见木皆可为主。庚寅辛卯亦是栋梁，只申酉冲破，子卯相刑，大林有风，若无承载之土，加凡火，主作事难成，贫贱而天。土爱路傍，谓之负载，屋上、城头可以护身，皆吉。',
    book3:
      '【原文】\n庚子天日承，乃气过浮虚之土，得重土相资，水木不刚，即享福寿。（官鬼不刑，表绝自保）\n\n辛壬禄承库，乃气衰就本之土，欲承之以火，制之以木，或重遇木土有刑冲，须假禄元生旺，造化应斯，功名可立。（官鬼不加，禄刚则。）',
  },
  {
    name: '金箔金',
    tip: '性情：爱表现、实在坦诚\n(主看日柱、年柱)',
    book1:
      '[原文]\n壬寅、癸卯。寅卯为木旺之地，木旺则金赢，且金绝于寅，胎于卯，金既无力，故曰金箔金。\n\n[今译]\n寅和卯都是木的旺盛之地，如果木势旺盛，金势就必然羸弱。金绝于寅，  胎于卯，显然缺乏力量，因此将壬寅、癸卯称为金泊金。金在寅上处于绝地，  力量弱得像薄片，因此才有了金泊金的称呼。',
    book2:
      '[原文]\n壬寅金，金之华饰者，喜木及微火。\n截路，平头，聋哑。\n\n癸卯金，环钮铃铎，喜盛火及秋。\n贵人，破字，悬针。\n\n[今译]\n壬寅属金，是用金制的装饰品，喜木和微火。\n包含的凶煞有截路空亡平头、聋哑。  \n\n癸卯属金，是用金制的环钮和铃铛，喜盛火和秋季。\n包含的吉神有贵人，凶煞有破字、悬针。\n\n[原文]\n金箔金者，润色杯盘，增光宫室，打薄须借乎别金，描彩必假乎人力。此金甚微，非木则无所依。木以平地为上，有此不宜见火，有火主天。遇太阳为日间之显，二火相反，不宜同见。山下、山头，有清水助之，亦吉。唯忌炉火，就位相克。此金体薄，不能反源定天，限运同论。',
    book3:
      '[原文]\n壬寅地会义，乃藏用体柔之金，喜土资之以旺，财官不可太刚，若能应此，富贵始得久远。（艮土包命，禄须贵旺。）\n\n癸卯贵会源、乃财旺体弱之金，财命相乘，喜身在生旺之方，或得真官真气，无不配合，贵源莫不易而厚禄也。（贵源多会，不在多逢。）',
  },
  {
    name: '覆灯火',
    tip: '性情：聪慧有灵性、喜神秘\n(主看日柱、年柱)',
    book1:
      '[原文]\n甲辰、乙巳。辰为食时，日之将午，艳阳之势光于天下，故曰覆灯火，金盏摇光，玉台吐艳，照日月不照处，明天下未明时。\n\n[今译]\n辰时是人们就食的时辰。在已时，太阳快要行到天空的中央，阳光灿烂，气势宏大，因此将甲辰、乙已称为覆灯火。灯盏反射出金光，烛光摇曳，灯台散发出光芒，照亮日光和月光照不到的地方，让天地未明的时辰也能得到光明。',
    book2:
      '[原文]\n甲辰火，灯也，喜夜及水，恶昼。\n华盖，大败，平头，破字，悬针。\n\n乙巳火，灯光也，同上，尤喜申酉及秋。\n正禄马，大败，曲脚，阙字。\n\n[今译]\n甲辰属火，属于灯火，喜夜晚和水，畏惧白天。\n包含的神煞有华盖、大败、平头、破库字、悬针等。\n\n乙已属火，属于灯火散发的光，喜夜晚和水，最喜欢申酉金和秋季，不喜白天。包含的吉神有正禄马，凶煞有大败、曲脚、阙字。\n\n[原文]\n覆灯火者，金盏衔光，玉台吐艳，照日月不照之处，明天地未明之时。此火乃人间夜明之火，以木为心，以水为油，遇阴则吉，遇阳则不利。凡日时最忌再见辰巳，地支有冲，恐风吹灯灭，主天。',
    book3:
      '[原文]\n甲辰禄马承，乃始壮之火，欲多生我，或会本源，却无炎光之极，自然超卓，水轻而无土，亦可腾达矣。（甲丙生寅，明我生气。）\n\n乙已地官承，乃进功之火，欲辅助之不息，不必旺极，得木火相乘，虽死败而可贵。（或同音煞丙亦可。）',
  },
  {
    name: '天河水',
    tip: '性情：眼界高、婚姻波折\n(主看日柱、年柱)',
    book1:
      '[原文]\n丙午、丁未。丙丁属火，午为火旺之地，而纳音乃水，水自火出，非银汉而不能有也，故曰天河水，气当升齐，沛然作霖，生旺有济物之功。\n\n[今译]\n丙丁属火，午是火的旺盛之地，但纳音为水，从火中出的水只有银河之水，因此将丙午、丁未称为天河水。元气升高降低，如果充足盛大就会化作甘霖，因此，如果天河水生旺，就能发挥普济万物的作用。',
    book2:
      '[原文]\n丙午火，月轮，喜夜及秋，水旺也。\n喜神，羊刃，交神，平头，聋哑，悬针。\n\n丁未水，火光也，同上。\n华盖，羊刃， 神，八专，平头，破字。\n\n[今译]\n丙午属水，是月光流水，喜夜晚和秋季，因为这时水气最旺。\n包含的吉神有喜神，凶煞有羊刃、交神、平头、聋哑、悬针等。 \n\n丁未属水，是火光，喜爱夜晚和秋季。\n包含的神煞有华盖、羊刃、退神、八专、平头、破字等。\n\n[原文]\n天河水者，乱洒六野，密沛千郊，淋淋泻下银河，细细飞来碧落，此乃天上雨露，发生万物，无不赖之。银河之水，土不能克，故见土不忌，而且有滋润之益；天上之水，地金难生，故见金难益，而亦有涵秀之情；生旺太过则为淫潦，反伤于物，死绝太多则为旱干，又不能生物，要生三秋得时为贵也。',
    book3:
      '[原文]\n丙午神头禄，乃至阴之水，发于阳明蒸气氤氲，何所不及，处金木旺而冲刑禄，得炎而财盛，始可贵矣。（身同官鬼，不避掩冲。）\n\n丁未禄文承，乃禄旺育生之水，宜于水火之中，得五行死败之气，禄千自旺，财贵会于千方 乃富贵显扬之用，惟嫌土在旺乡，即非长久。（喜遇丙丁， 官当用。）',
  },
  {
    name: '大驿土',
    tip: '性情：胸怀博大， 奔波波折\n(主看日柱、年柱)',
    book1:
      '[原文]\n戊申、己酉。申为坤，坤为地，酉为兑，兑为泽，戊己之土加于坤泽之上，非比他浮沉之土，故曰大驿土，气以归息，物当收敛，故云。\n\n[今译]\n申代表八卦中的坤，坤代表大地；酉代表八卦中的兑，兑代表沼泽。戊和己的五行都属土，两者一旦处于大地和沼泽之上，就不再是轻浮薄弱的尘土了，因此将戊申、己酉称为大驿土。元气回归，万物收敛，因此才有了大驿土的称呼。',
    book2:
      '[原文]\n戊申土，秋间田地，喜申酉及火。\n福星，伏马，杖刑，破字，悬针。\n\n己酉土，秋间禾稼，喜申酉及冬。\n退神，截路，九丑，阙字，曲脚，破字，聋哑。\n\n[今译]\n戊申属土，是秋季田地，喜申酉金和火。\n包含的吉神有福星，凶煞有伏马、杖刑、破字、悬针。\n\n巳酉属土，是秋季稻收，喜申酉金和冬季。\n包含的凶煞有退神、截路空亡、九丑、阙字、曲脚、破字、聋哑等。\n\n[原文]\n大驿土者，堂堂大道，坦坦平途，九州无所不通，万国无所不至，此乃位属坤方，德乃厚载，轮天转日，负海乘山之土也。发生万物，以木为基。戊申，长生之土，德厚无疆，见三四木皆能滋生，己酉，自败之土，木多则窃气；大林合中逢冲，主天，别木则吉，更以禄贵参之。',
    book3:
      '[原文]\n戊申地符会，乃柔顺初生之土，喜临四季，得木为荣，独居水火荣方，未得尊高之着。（真官符用，不畏鬼临。）\n\n己酉地贵承，乃子旺母衰之土，喜火土之荣，庆从革之地，或水轻木柔，亦走滋生之德，倘能应此，轩冕非难。（不必正应，要临辛丙。）',
  },
  {
    name: '钗钏金',
    tip: '性情：高贵典雅， 孤芳自赏\n(主看日柱、年柱)',
    book1:
      '[原文]\n庚戌、辛亥。金至戌而衰，至亥而病，金既衰病则诚柔矣，故曰钗钏金，形已成器，华饰光艳乎?生旺者乎?戳体火盛伤形，终不喜。\n\n[今译]金衰于戌，病于亥，金一旦处于衰病的状态，自然就性质柔软，因此将庚戌、辛亥称为钗钏金。金已经被铸成器具的形状，华美的首饰散发出光芒，忌讳生旺，适合隐藏形体，火势旺盛就容易受到毁坏，终究还是不喜欢火势旺盛的状态。',
    book2:
      '[原文]\n庚戌金，刀剑之余，喜微火及木。\n华盖，杖刑。\n\n辛亥金，钟鼎实物，喜木火及土。\n正禄马，悬针。\n\n[今译]\n庚戌属金，是刀剑的锋刃上的金，喜细微之火和木。\n其中神煞有华盖、杖刑。  \n\n辛亥属金，是钟鼎器，喜木火和土。\n包含有吉神正禄马，凶煞悬针。  \n\n[原文]\n钗钏金者，美容首饰，增光腻肌，偎红倚翠之珍，枕玉眠香之宝，此金藏之闺阁，唯宜静水，井涧、溪流，见之皆吉，多见则泛，海水贫夭；天河辛亥见之无妨，丙午真火，庚戌所忌，以午戌凑成火局，有伤此金故也。太阳火日生显耀，覆灯火夜间显耀，故皆宜见，但甲辰乙巳与庚戌辛亥相冲，阴阳交见为妙，戊子己丑与丙午丁未相持，二火忌叠，见之非贫即夭。炉中火庚戌最忌，辛亥见之，丙辛化水，稍吉。山下、山头俱不宜见。若有水济，亦可。柱中有水，此金入于匣中，有福贵方吉。土见砂中，相生相养，更有涧下水助，荣华富贵。',
    book3:
      '[原文]\n庚戌禄符元，乃钝弱成用之金，火轻金重，魁罡相乘，可以体逸，福禄自然，忌木火之极，则命蹇。（旺逢妻鬼，遇鬼反荣。）\n\n辛亥地禄印、乃木旺禄休之金，得平火之革，然后制于克伐，或冲击于金水之中，得以平安守职，富贵优游。（喜于金助，不畏丁鬼。）',
  },
  {
    name: '桑柘木',
    tip: '性情：坚韧不拔， 刚强好胜\n(主看日柱、年柱)',
    book1:
      '[原文]\n壬子、癸丑。子属水而丑属金，水生木而金则伐之，犹桑柘方生而人便以戕伐。故曰桑柘木。\n\n[今译]子属水，丑包藏金，水生助木，金克伐木，就像桑树一开始生长，就会有人去砍伐，因此将壬子、癸丑称为桑柘木 元气盘屈，位于水中，不用刀斧砍伐就能伤害到木。',
    book2:
      '[原文]\n壬子木，伤水多之木，喜火土及夏。\n羊刃，九丑，平头，聋哑。  \n\n癸丑木，伤水少之木，喜金水及秋。\n华盖福星，八专，破字，阙字，羊刃。\n\n[今译]\n壬子属木，属于因为水多而收到伤害之木，喜火土和夏季。\n其中的凶煞有羊刃、九丑、平头、聋哑。 \n\n癸丑属木，属于因为水少而受到伤害之木，喜金水和秋季。\n其中的吉神有华盖、福星，凶煞有八专、破字、阙字、羊刃。\n\n  \n[原文]\n桑柘木者，缯彩镃基，绮罗根本，士民飘飘之袂，圣贤楚楚之衣，此木供蚕为弧，其用甚大。最爱沙土，以为根基，又以辰巳为蚕食之地，不宜刑冲互破，路傍、大驿二土次吉，余土无益。',
    book3:
      '[原文]\n壬子神头禄，乃体柔用刚之木，居旺相而得金，遇贵地而无火，则可以扬名堂当世。（禄旺须官，阴盛畏鬼。）\n\n癸丑禄得源，乃刚柔相济之木，水土承于旺方 则生育利物，金制于生成，皆可以立功立事，惟恐生旺逢火。（禄居北地，畏鬼掩冲。）',
  },
  {
    name: '大溪水',
    tip: '性情：包容大气，不拘小节，奔波\n(主看日柱、年柱)',
    book1:
      '[原文]\n甲寅、乙卯。寅为东旺，卯为正东，水流正东，则其性顺，而川涧池沼俱合而归，故曰大溪水。\n\n[今译]\n寅居于东方，但是只有卯才居于正东。水向正东流去，必然顺畅，川涧水  都汇聚于此，因此将甲寅、乙卯称为大溪水。元气昌盛阳明，水势有源，浩大无边，滔滔不绝地向东流去，因此被称之为大溪水。',
    book2:
      '[原文]\n甲寅水，雨也，喜夏及火。\n正禄马，福神，八专平头，破字，悬针，聋哑。 \n\n乙卯水，露也，喜水及火。\n建禄，喜神，八专，九丑，曲脚，悬针。  \n\n[今译]\n甲寅属水，属于天上的雨水，喜夏季和火。\n其中的吉神有正禄马福神，凶煞有八专、平头、破字、悬针、聋哑。\n\n乙卯属水，属于露水，喜水和火。\n其中的吉神有建禄、喜神，凶煞有八专、九丑、曲脚、悬针等。\n\n[原文]\n大溪水者，惊涛薄岸，骇浪浮天，光涵万里之宽，碧倒千山之影，最喜有归有养，遇坎则为有归，得金则为有养，所嫌者，日月时中，有申酉冲动，或辰巳风吹，主飘流；井泉水净而止，涧下有丑为艮，天河沾润大海朝宗，此四水皆吉；长流有风，独不宜见。',
    book3:
      '[原文]\n甲寅神头禄，乃渊深处静之水，若资之木旺土衰，则为奇特贵异。（庚辛不畏，清在丁壬。）\n\n乙卯神头禄，乃死中受气之水，虽败无妨，或会源于音地，木有不达之者，此二水皆喜土而清 若水多而无土，则为伏寒之气。（癸马为官，胜于戊己。）',
  },
  {
    name: '沙中土',
    tip: '性情：多重性格、不合群\n(主看日柱、年柱)',
    book1:
      '[原文]\n丙辰、丁巳。土库在辰，而绝在巳，而天本丙丁之火至辰为冠带，而临官在巳，土既张绝，得旺火生之而复兴，故曰沙中土。\n\n[今译]\n土墓库于辰，绝于已，丙丁属火，丙丁火冠带于辰，临官于已，土则在辰位和 位上处于墓库和绝，火能生土，旺盛的火又重新生土，因此将丙辰、丁已称为沙中土。此时，土过于疏松，因此不适合储藏元气。',
    book2:
      '[原文]\n丙辰土，堤岸，喜金及木。\n禄库，正印，华盖，截路，平头，聋哑。\n\n丁巳土，土之沮说，喜火及西北。\n禄库，平头，阙字，曲脚。\n\n[今译]\n丙辰属土，属于土筑的堤岸，喜金和木。\n包含的吉神有禄库、正印、华盖，凶煞有截路空亡、平头、聋哑。\n\n丁已属土，属于土中泥沼，喜火和西北金。\n包含的吉神有禄库，凶煞有平头、阙字、曲脚。\n\n[原文]\n沙中土者，浪回所积，波渚而成，龙蛇盘隐之宫，陵谷变迁之地。此土清秀，唯喜清金养之，更得清净之土，主早贵；钗、沙、剑、箔此四金清秀相助，如丙人见辛亥为丙丁入于乾户，号曰驾海长虹，又有星拱北之论，皆贵格也，更得水相涵，尤为上吉。\n',
    book3:
      '[原文]\n丙辰禄自裕，乃发施养生之土，喜于火助，不畏掩冲，夫如是者，自然荣贵（水在库中，无官自裕。）\n\n丁已神头禄，是绝中受气之土，喜逢土助，不畏死败，惟能朝命建元，可以文章妙选。（上下火乘，鬼无害也。）',
  },
  {
    name: '天上火',
    tip: '性情：热情奔放、性子急\n(主看日柱、年柱)',
    book1:
      '[原文]\n戊午、己未。午为火旺之地，未、己之木又复生之，火性炎上，及逢生地，故曰天上火。\n\n[今译]\n午是火的旺盛之地，未中循藏的木还继续生助火势，火的性质是炎上，并且又处于生地，因此将戊午、己未称为天上火。元气一直冲向太阳，火光互相交辉，火焰炎上，发出强光，所以称之为天上火。',
    book2:
      '[原文]\n戊午火，日轮，夏则人畏，冬则人爱，忌戊子、己丑、寅、乙卵。\n伏神，羊刃，九丑，棒杖，悬针。\n\n已未火，日光，忌夜，亦畏四者。\n福星，华盖，羊刃，阙字，曲脚，破字。  \n\n[今译]\n戊午属火，是太阳，夏天人怕，冬天人爱怕见戊子火 己丑火、甲寅水、乙卯水。\n包含的吉神有伏神，凶煞有羊刃九丑、棒杖、悬针等。\n\n己未属火，是太阳的光线，怕夜晚，也怕戊子、 丑、甲寅、乙卯。\n其中的吉神有福星、华盖，凶煞有羊刃，阙字、曲脚、破字。\n\n[原文]\n天上火者，温暖山河，辉光宇宙，阳德丽天之照，阴精离海之明，戊午为太阳则刚，已未为太阴则柔，或以为夏日则刚，冬日则温，诬也。俱要戌亥为天门，卯酉为出入之门，东南为行陆之地则吉。此火见木谓之震折，要日时有风与水方得。大林木有辰，松柏、石榴有卯酉，故唯此三木主贵。',
    book3:
      '[原文]\n戊午天禄备，乃神发离明之火，旺中受绝，喜木助于衰方，忌火乘于巳，旺生之应，此必作魁矣。（真假居壮，水盛不伤。）\n\n己未神头禄，乃成功之火，得季夏之炎阳 守小吉之贵地，生自东北之南有所资附，则能享福厚矣。（甲己扶持，不须更旺。）',
  },
  {
    name: '石榴木',
    tip: '性情：有谋略、有成果\n(主看日柱、年柱)',
    book1:
      '[原文]\n庚申、辛酉。申为七月，酉为八月，此时木则绝矣。惟石榴之木复实，故曰石榴木;气归静肃，物渐成实，木居金生其味，秋果成实矣。\n\n[今译]申代表七月，酉代表八月，此时树木凋零，枝叶残败，只有石榴树还在结果，因此将庚申、辛酉称为石榴木。元气归于宁静安肃，万物逐渐结成果实，石榴树在秋天正好长满果实，因此称之为石榴木。',
    book2:
      '[原文]\n庚申木，榴花，喜夏，不宜秋冬。\n建禄马，八专，杖刑，破字，悬针。\n\n辛酉木，榴子，喜秋及夏。\n建禄，交神，丑，八专，悬针，聋哑。\n\n[今译]\n庚申属木，是石榴花，喜夏季，秋冬不宜。\n包含的吉神有建禄马，凶煞有八专、杖刑、破字、悬针。\n\n辛酉属木，是石榴果，喜秋和夏季。\n包含的吉神有建禄，凶煞有交神、九丑、八专、悬针、聋哑。\n\n[原文]\n\n石榴木者，性辛如姜，花红似火，数颗枝头，累累多子，房内莹莹，干支纯金而 纳音属木，乃木之变者也。可以移盆内而妆做山，故喜成器之土，以为根基，城头为上，屋上次之，然必阴阳交见，则丙辛丁庚互官，戊辛己寅互印，主吉；路、壁、驿、沙四土有山助之，亦吉。',
    book3:
      '[原文]\n庚申神头禄，乃未坚柔末之木，春相夏旺，金重而得火，土重而得水，则为出常之器。（不畏阳官，要官鬼旺。）\n\n辛酉神头禄，乃包秀结英之木，喜于生旺，忌见金多，得土水相乘为物之贵，二者各旺而不得水，亦为奇特之材。（不嫌官鬼，厌甲为财。）',
  },
  {
    name: '大海水',
    tip: '性情：心胸宽广， 宽容忍耐\n(主看日柱、年柱)',
    book1:
      '[原文]\n壬戍、癸亥。水冠带在戍，临官在亥，水则力厚矣。兼亥为江，非他水之比，故曰大海水。势起大门，生旺不泛，死绝不洄。\n\n[今译]\n水冠带于戌，临官于亥，水势厚重。加上亥还被认为是江，远远超过池  水，因此将壬戌、癸亥称为大海水。水势直逼天门，万事都到了终局，水势旺  盛却不至于泛滥，水势衰弱也不至于干涸，因此被称之为大海水。',
    book2:
      '[原文]\n壬戌水，海也，喜春夏及木。\n华盖，退神，平头，聋哑，杖刑。\n\n癸亥水，百川，喜金土火。\n伏马，大败，破字。截路。\n\n[今译]\n壬戌属水，是大海水，喜春夏和木。\n可能包含的神煞有华盖退神、平头、聋哑，杖刑。\n\n癸亥属水，是百川河水，喜金、土、火。\n包含的凶煞有伏马、十恶大败、破字、截路空亡等。\n\n[原文]\n大海水者，总纳百川，汪洋无际，包括乾坤之大，升沉日月之光。此水原有清浊，以两般分论：壬戌有土气为浊，癸亥千支纯水而纳音又水，故清。壬戌人嫌山，以土气太蛊，有金清之方吉，癸亥最喜见山，然后海水之性始安。',
    book3:
      '[原文]\n壬戌禄官顺，乃杳冥之水，喜于死败，要土之击发，则能博施之功及物也。（正气自守，持禄亦荣。）\n\n癸亥神头禄、乃始进成终之水，喜逢贵地，忌在禄乡，三元相反，福庆自然，盖其为用也。大而广，故不可以守常为尚须升而为雨雾，散而为江河，乃为大用也。',
  },
]
export const ShenShaTips = [
  {
    name: '天乙贵人',
    tip: '一生人缘佳，遇事有人解救危难，化险为夷。',
    gujue:
      '“甲戊庚牛羊, 乙己鼠猴乡, 丙丁猪鸡位, 壬癸兔蛇藏, 六辛逢虎马, 此是贵人方。”',
    chafa: `以日/年干查四地支

      人命有天乙贵人，遇事有人帮，临难有人解，是化险为夷最有力的贵人之星。
  天乙贵人：人缘、社交缘、异性缘、长辈缘。一生少病，人缘佳，易有社会地位，很适合从事公关性质的工作。
  
  　　经书有云：『天乙者，乃天上之神，与太乙并列，其神最尊贵，所到之处，危难隐然而避。』由此可知天乙贵人之神通广大，遇吉神则有喜上加喜之庆。逢而为喜，富加且贵，是吉祥之神。凡人命遇之，昌荣有望，达人逢之，功名早显。
  
  　　天乙贵人入命：心性聪明，出入近贵。大运流年见天乙贵人：有生官发财之机，最少亦有吉祥庆事加临。天乙贵人坐旺地：身体健康吉祥富贵，福禄加倍。天乙贵人逢合为忌：多见劳苦，劳苦功高。天乙贵人逢刑冲：多劳累，遇事则贵人去。女命天乙贵人入命、日主自坐二德者：可嫁贵夫。
  
  　　天乙贵人是八字里面最重要、最吉祥的一颗贵人星，八字带天乙贵人吉星的人，无形之中会散发一种贵气，给人亲切好相处的感觉。还可以转危为安，有很多人发生了意外的危难，受到的伤害却很小，经常都是因为八字里面带有天乙贵人这颗贵人吉星。
  
      如为喜用，不冲克刑害，多受器重提携与拥护。如毛爷爷出生的丁酉日。`,
  },
  {
    name: '天德贵人',
    tip: '性格好，主化险为夷，不犯刑律，不遇危难。',
    gujue: `寅月丁。卯月申。辰月壬。巳辛月。午月亥。未月甲。
      申月癸。酉月寅。戌月丙。亥月乙。子月巳。丑月庚。`,
    chafa: `以月支查四柱干支

      天月德助，处世无殃。能把遇到凶险转化为吉祥、顺利，随处保护。
      天地德秀之气，其特点是化解危难。命带天德贵人者有福德，其人心地善良，身体健康，人缘好，在生平之中较不会遇到意外等，纵使逢之也能适时得以化解。
  
      天月二德,乃日月会合照临,有何阴昧敢容其间？子平赋说:" 印绶得同天德,官刑不至, 至老无灾。"凡八字中有天月二德,其人恺悌慈祥,待人至诚仁厚。煞带天月德,明敏果决而仁厚,食伤带天月德,聪明秀慧而仁厚。书云: 素食慈心,印绶逢于天德,良以秉性慈祥故也。二德以天德为重,月德次之,临财官印绶,加一倍福力,日干尤吉。
  
      天德和月德，都是贵人吉星的名称。与其它贵人星有一个最大的不同处，就是天月德比较趋向于一个人个性方面的表现，也就是说天月德谈的是性格。一般来说，八字有天月德入命的人，不但具有贵气的特质，行为处事坦白而无私，也有慈悲心或者同情心。人言积善之家必有余庆，所以天月德也具有遇事化险为夷的功能。`,
  },
  {
    name: '月德贵人',
    tip: '性格好，主化险为夷，不犯刑律，不遇危难。',
    gujue: `寅午戌月生者见丙, 申子辰月生者见壬,亥卯未月生者见甲, 巳酉丑月生者见庚。`,
    chafa: `以月支查四柱干支

      月德贵人同天乙贵人一样，是一颗很好的吉星，命主在命局中逢上带有月德贵人，一生处世无忧，化险为夷，平生很少生病，不犯官刑。但需要注意的是，月德是勤勉敏慧之徳星，虽然命主身带此吉星，也需本身勤勉自助，才能在紧要关头获得帮助。
  
      天月二德,乃日月会合照临,有何阴昧敢容其间？子平赋说:" 印绶得同天德,官刑不至, 至老无灾。"凡八字中有天月二德,其人恺悌慈祥,待人至诚仁厚。煞带天月德,明敏果决而仁厚,食伤带天月德,聪明秀慧而仁厚。书云: 素食慈心,印绶逢于天德,良以秉性慈祥故也。二德以天德为重,月德次之,临财官印绶,加一倍福力,日干尤吉。
  
      天德和月德，都是贵人吉星的名称。与其它贵人星有一个最大的不同处，就是天月德比较趋向于一个人个性方面的表现，也就是说天月德谈的是性格。一般来说，八字有天月德入命的人，不但具有贵气的特质，行为处事坦白而无私，也有慈悲心或者同情心。人言积善之家必有余庆，所以天月德也具有遇事化险为夷的功能。`,
  },
  {
    name: '天德合',
    tip: '性格好，主化险为夷，不犯刑律，不遇危难。（天德的一半效果）',
    gujue:
      '寅月壬。卯月巳。辰月丁。巳月丙。午月寅。未月己。\n申月戊。酉月亥。戌月辛。亥月庚。子月申。丑月乙。',
    chafa:
      '天德与天干五合或地支六合者即为天德合，如正月见丁为天德，壬与丁合，壬即为天德合，类推。\n如没有天德贵人，有天德合也起到天德贵人的作用。',
  },
  {
    name: '月德合',
    tip: '性格好，主化险为夷，不犯刑律，不遇危难。（月德的一半效果）。',
    gujue: '寅午戌见辛，申子辰见丁，巳酉丑见乙，亥卯未见己。',
    chafa:
      '月德合就是与月德相合的天干，如丙火与辛金合，我们就说寅午戌月德合辛，即寅午戌月的辛干。\n月德合凡遇预测之事一般都会达到比较和谐的程度。',
  },
  {
    name: '天赦',
    tip: '化险为夷之神，可解危难，处世无忧，对犯有法律纠纷的人尤为有利。',
    gujue: '春戊寅, 夏甲午, 秋戊申, 冬甲子。',
    chafa:
      '寅卯辰月生戊寅日, 巳午未月生甲午日, 申酉戌月生戊申日, 亥子丑月生甲子日。\n天赦是化险为夷之星，能解人危难。尤其对犯法之人，有宽大处理之可能。纵有过错也可得到宽恕或赦免。',
  },
  {
    name: '禄神',
    tip: '日主得根有利，身体健康，充满信心。',
    gujue: `甲禄寅。乙禄卯。丙禄巳。丁禄午。戊禄巳。
      己禄午。庚禄申。辛禄酉。壬禄亥。癸禄子。`,
    chafa: `以日干查四地支

      身旺见禄，喜见财官。身弱喜禄而逢死绝遭刑冲，又逢吉祥救应，家运可能不太顺利，容易影响到置产、家人之间的关系；同时在求财方面也较为困难。
  
      见年神篇“元禄神”。主身体健康，充满信心，记忆力强，勤劳致富，一生少闲，性刚，容易得罪人。武富、武贵，技术研究方面独具慧眼。
  
      在年月为“建禄”，四柱天干要见财官，“建禄生是月，财官喜透天”也。透财，富。透官，贵。
  
      在时为“归禄”，不喜官星，“日禄归时没官星，号曰青云得路。”主少年发达。“建禄”主长辈之荫，主少年时代幸福。若逢卫破，家运可能不太顺利。身（日主）若太旺，不屑于祖辈留有的家产，不愿坐享现成之福，会自己在外乡创事业。若逢偏印，即破禄而无禄。
  在日为“专禄”（甲寅、乙卯、庚申、辛酉四日），主会享受，爱过阔绰的生活。要有羊刃来保护（因禄柔、刃刚），若被合去则无禄。被冲不利丈夫或者妻子的健康和运势。
  
      “归禄”喜羊刃、身旺、财星。不但不会追求物质享受，反而勤奋努力。逢合变无禄，逢冲，不利子女的健康和运势。“归禄”见食神、财星，多主名利双收。
  
      八字如果有禄有财：丰盈一生。八字如果有禄无财：祖先庇荫。八字若无禄有财：白手起家。大运流年与禄神冲克：可能有意外危险，难聚财，健康上也要注意。
  　　
      女命禄神与桃花同柱：为异性多付出。禄刃同柱：不利钱财与姻缘。
  
  　　禄神在空亡之地：称为『财库落空』，一生做事只怕是有劳无功，虚名虚利。禄神逢冲：叫做破禄，就是一般常听所谓『破财』。大运流年逢之，不可轻言忽视，小心意外事故。
  
  　　八字有禄神入命，予人有财有富之感，一生重视钱财，有金钱观念。精神力超强，脚踏实地，多见努力。企划技术能力强，个性稍见内向，较不善交际，能得人望。`,
  },
  {
    name: '驿马',
    tip: `升迁，调动，走动，迁移，奔波，换工作，出国等。
      贵人驿马多升擢，常人驿马多奔波。`,
    gujue: `申子辰马在寅，寅午戌马在申，巳酉丑马在亥，亥卯未马在巳。`,
    chafa: `以年、日支查余三支

      代表这个人一生走动多、远行、会出远门。一生驿马运重，即使是在一个地方，也经常会忙个不停，这些都是驿马的作用。
  
      驿马坐旺地：利禄亨通。驿马为喜用：心高气爽，动则有喜。四柱财官有力，真好马也。驿马为喜用，自坐财官地：岁运逢财官星，主升迁。驿马为忌且逢冲：是非波动。吉神坐马：有乔迁之喜或顺动之利。凶神坐马：奔走四方，忙于生计。驿马与财星同柱：为喜则财源广进；为忌则奔走四方。驿马与财官、贵人同柱：才是真马。驿马与正官同柱：为喜者风儒雅士，为忌者性格开放。驿马坐七杀，带羊刃或劫煞：小心突发事故。驿马逢冲，带羊刃、元辰、空亡：注意人身意外。驿马见合：有牵制之虑。驿马坐死墓绝、羊刃、劫煞：做事有始无终，飘泊无定。驿马自坐绝地：凶，尤岁运再逢冲。驿马自坐死、绝方：做事少成。桃花坐马：为情爱受难。驿马坐劫煞或羊刃：劳碌奔波，心性多冲动；尤岁运再逢。劫煞坐马：容易有意外危险。马星生财者：有名扬之机。男命，驿马自坐财星：娶他乡富女。女命，驿马与天乙贵人同柱：不利姻缘。女命，驿马坐独官：夫为有用人，儿孙亦同。女命，驿马自同：嫁远乡。
  
  　　驿马逢冲：心猿意马，奔波，忙碌，乃天涯之客。流年驿马逢冲：此年多奔波，有迁异职动之机，并多见出国或远行。驿马冲动，若带羊刃、血支等神煞，应该小心行事。
  　　命带驿马的人比较闲不下来，经常总是把自己弄得很忙，所以古人说『驿马入命，心不安闲』即是此谓。`,
  },
  {
    name: '太极贵人',
    tip: '聪明好学，喜神秘事物（与华盖并用，又临戌亥，在易学方面多有成就。）',
    gujue: `甲乙生人子午中，丙丁鸡兔定亨通，
      戊己两干临四季，庚辛寅亥禄丰隆，
      壬癸巳申偏喜美，值此应当福气钟，
      更须贵格来相扶，候封万户到三公。`,
    chafa: `以日/年干查四地支

      太极者，太初至极之谓。造物之所始，既生不灭，是谓太极。
  　　命中带有太极贵人的八字，可以事职平顺亨通、福禄兼得，事情能够化险为夷，一生多得贵人相助，晚年可以幸福安逸，太极贵人可以说是一颗非常珍贵的吉星。
  
      五行有始有终，造化始终相保，谓之太极。甲乙木生于子，终于午。丙日、丁月出于卯，落于酉，戊己土藏于辰戌丑未四维之库，庚辛金生于寅（垦卦），成于亥（乾卦），壬癸水生于申（坤卦），纳于巳（巽卦），人命逢之，主聪明好学，有钻劲，喜文史哲宗教等科目，为人正直，做事有始有终。如得生旺及有贵格吉星相扶助，主气宇轩昂, 福寿双全, 富贵人间。`,
  },
  {
    name: '将星',
    tip: '权力之星，易掌握权势，有老板或主管之命，具有领导力、威慑力。',
    gujue:
      '子日子。丑日酉。寅日午。卯日卯。辰日子。巳日酉。\n午日午。未日卯。申日子。酉日酉。戌日午。亥日卯。',
    chafa:
      '以年、日支查余支\n\n将星入命：能文能武，一生有权柄威信，具有组织领导能力，会见掌权之机。将星为真格：须正官、七杀有力，或印星有力。将星入命，岁运为财官：大权在握，利禄亨通。将星与亡神同现：才智过人，深具谋略，会是栋梁之才。将星无破：财、官运亨通。将星三合为忌神：奔波多劳。将星逢冲克，权利事职有变动。\n　　将星跟权力地位有关，命带将星的人，给人不可侵犯的感觉，很自然的散发出一种无形、难以言喻的权威感，让人望而生敬。很多做官的人或工商高层主管八字里面大都带有将星，所以也称为将权，八字带有将星，称做将权入命。',
  },
  {
    name: '学堂',
    tip: '模仿力、创作力、想象力、理解力。\n学业出类拔萃，文章声名远播。',
    gujue: `纳音之长生
      金命见巳，辛巳为正；木命见亥，己亥为正；水命见申，甲申为正；土命见申，戊申为正；火命见寅，丙寅为正。`,
    chafa: `查法一：以年纳音查月日时支（禄命法）
      年柱纳音为金命见其他三支有“巳”为学堂，见“辛巳”为正学堂（海中金、剑锋金、沙中金都为纳音金命）；
      年柱纳音为木命见其他三支有“亥”为学堂，见“己亥”为正学堂；
      年柱纳音为水命见其他三支有“申”为学堂，见“甲申”为正学堂；
      年柱纳音为土命见其他三支有“申”为学堂，见“戊申”为正学堂；
      年柱纳音为火命见其他三支有“寅”为学堂，见“丙寅”为正学堂。
      正学堂更能体现学堂的特性
      
      查法二：以日干查四柱（子平法）
      甲见己亥, 乙见壬午, 丙见丙寅, 丁见丁酉, 戊见戊寅, 己见己酉, 庚见辛巳, 辛见甲子, 壬见甲申, 癸见乙卯，以年日干, 查四柱干支。
      
      本软件默认采用第一种禄命法查法
      
      学堂为纳音之长生，命中带之，主人聪明，可得考职功名，文才出众，功名显达。
      
      学堂者, 如人读书在学堂. 故称文星, 主学业功名之事, 凡此星入命, 主登科及第, 学业大展宏图.
      
      学堂又称官贵学堂，八字带学堂的命格，大都饱读诗书，记忆力很好，行为举止无形间给人一种高贵气质的感觉，很多高学历甚至达官显贵之人，八字都有学堂贵星的加临。八字如果见到文昌又有学堂，可以说是一个贵气十足的命格；只要见到其中一位，都很擅长读书，一生当中也都能够化险为夷。`,
  },
  {
    name: '词馆',
    tip: '学业出类拔萃，文章声名远播。',
    gujue: `纳音之临官
    金命见申，壬申为正；木命见寅，庚寅为正；水命见亥，癸亥为正；土命见亥，丁亥为正；火命见巳，乙巳为正。`,
    chafa: `查法一：以年纳音查月日时支（禄命法）
      年柱纳音为金命见其他三支有“申”为词馆，见“壬申”为正词馆（海中金、剑锋金、沙中金都为纳音金命）
      年柱纳音为木命见其他三支有“寅”为词馆，见“庚寅”为正词馆；
      年柱纳音为水命见其他三支有“亥”为词馆，见“癸亥”为正词馆；
      年柱纳音为土命见其他三支有“亥”为词馆，见“丁亥”为正词馆；
      年柱纳音为火命见其他三支有“巳”为词馆，见“乙巳”为正词馆。
      正词馆更能体现学堂的特性
      
      查法二：
      甲干见庚寅，乙干见辛卯；丙干见乙巳，丁干见戊午；戊干见丁巳，己干见庚午；庚干见壬申，辛干见癸酉；壬干见癸亥，癸干见壬戌。
      
      本软件默认采用第一种禄命法查法
      
       
          词馆者, 如今管翰林为词馆(实为今之教育部门), 取其学业精专, 文章出类。
      
          学堂词馆, 主人秀气生发, 聪明智巧, 文章冠世, 一生富贵. 宜生旺不宜克害冲破, 宜天乙贵人吉星相扶为好, 否则, 才难展, 志难伸.
      
          凡学堂词馆，切不要犯空亡及冲破，支干纳音不要见克，方为得用。
      
          《祝胜经》云：“甲辰丙寅，学堂不真；或止富荫，官职卑贫；读书修学，空有虚名。”此言学堂怕落空也。
      
          《三车》云：“学堂无气，惟利师儒。”此言学堂要乘旺也。
      
          《理愚歌》云：“文星聚处人中瑞，声华独冠英雄辈；降生不遇真学堂，才学岂能为拔萃。”此言学堂怕冲破受克也。况人命入格，合造化，又不在学堂词馆而得。`,
  },
  {
    name: '正学堂',
    tip: `模仿力、创作力、想象力、理解力。
    学业出类拔萃，文章声名远播。`,
    gujue: `纳音之长生
      金命见巳，辛巳为正；木命见亥，己亥为正；水命见申，甲申为正；土命见申，戊申为正；火命见寅，丙寅为正。`,
    chafa: `查法一：以年纳音查月日时支（禄命法）
      年柱纳音为金命见其他三支有“巳”为学堂，见“辛巳”为正学堂（海中金、剑锋金、沙中金都为纳音金命）；
      年柱纳音为木命见其他三支有“亥”为学堂，见“己亥”为正学堂；
      年柱纳音为水命见其他三支有“申”为学堂，见“甲申”为正学堂；
      年柱纳音为土命见其他三支有“申”为学堂，见“戊申”为正学堂；
      年柱纳音为火命见其他三支有“寅”为学堂，见“丙寅”为正学堂。
      正学堂更能体现学堂的特性
      
      查法二：以日干查四柱（子平法）
      甲见己亥, 乙见壬午, 丙见丙寅, 丁见丁酉, 戊见戊寅, 己见己酉, 庚见辛巳, 辛见甲子, 壬见甲申, 癸见乙卯，以年日干, 查四柱干支。
      
      本软件默认采用第一种禄命法查法
      
          学堂为纳音之长生，命中带之，主人聪明，可得考职功名，文才出众，功名显达。
      
          学堂者, 如人读书在学堂. 故称文星, 主学业功名之事, 凡此星入命, 主登科及第, 学业大展宏图.
      
          学堂又称官贵学堂，八字带学堂的命格，大都饱读诗书，记忆力很好，行为举止无形间给人一种高贵气质的感觉，很多高学历甚至达官显贵之人，八字都有学堂贵星的加临。八字如果见到文昌又有学堂，可以说是一个贵气十足的命格；只要见到其中一位，都很擅长读书，一生当中也都能够化险为夷。`,
  },
  {
    name: '正词馆',
    tip: `学业出类拔萃，文章声名远播。`,
    gujue: `纳音之临官
      金命见申，壬申为正；木命见寅，庚寅为正；水命见亥，癸亥为正；土命见亥，丁亥为正；火命见巳，乙巳为正。`,
    chafa: `查法一：以年纳音查月日时支（禄命法）
      年柱纳音为金命见其他三支有“申”为词馆，见“壬申”为正词馆（海中金、剑锋金、沙中金都为纳音金命）
      年柱纳音为木命见其他三支有“寅”为词馆，见“庚寅”为正词馆；
      年柱纳音为水命见其他三支有“亥”为词馆，见“癸亥”为正词馆；
      年柱纳音为土命见其他三支有“亥”为词馆，见“丁亥”为正词馆；
      年柱纳音为火命见其他三支有“巳”为词馆，见“乙巳”为正词馆。
      正词馆更能体现学堂的特性
      
      查法二：
      甲干见庚寅，乙干见辛卯；丙干见乙巳，丁干见戊午；戊干见丁巳，己干见庚午；庚干见壬申，辛干见癸酉；壬干见癸亥，癸干见壬戌。
      
      本软件默认采用第一种禄命法查法
      
      
          词馆者, 如今管翰林为词馆(实为今之教育部门), 取其学业精专, 文章出类。
      
          学堂词馆, 主人秀气生发, 聪明智巧, 文章冠世, 一生富贵. 宜生旺不宜克害冲破, 宜天乙贵人吉星相扶为好, 否则, 才难展, 志难伸.
      凡学堂词馆，切不要犯空亡及冲破，支干纳音不要见克，方为得用。
      
          《祝胜经》云：“甲辰丙寅，学堂不真；或止富荫，官职卑贫；读书修学，空有虚名。”此言学堂怕落空也。
      
          《三车》云：“学堂无气，惟利师儒。”此言学堂要乘旺也。
      
          《理愚歌》云：“文星聚处人中瑞，声华独冠英雄辈；降生不遇真学堂，才学岂能为拔萃。”此言学堂怕冲破受克也。况人命入格，合造化，又不在学堂词馆而得。`,
  },
  {
    name: '国印',
    tip: '正直忠信，若生旺得其他吉神辅助，可得掌印之权。',
    gujue:
      '甲见戌, 乙见亥, 丙见丑, 丁见寅,戊见丑, 己见寅, 庚见辰, 辛见巳，壬见未, 癸见申。',
    chafa:
      '以年、日干查四支\n四柱带国印者，主人诚实可靠，严守清规，照章行事，办事公道，为人和悦，礼义仁慈，气质轩昂。如国印逢生旺，有其它吉星相助，不逢冲破克害，不仅可以有掌印之能，可亦为官掌实权。\n\n亦主一生工作，生活环境多动，若流年岁运逢之即主工作变动或家庭搬迁。',
  },
  {
    name: '三奇贵人',
    tip: '胸怀坦荡，博学多才。（与天乙并用，则建功立业，功勋卓著。居空亡，则为隐士高人。）',
    gujue: '天上三奇甲戊庚，地下三奇乙丙丁，人中三奇壬癸辛。',
    chafa:
      '三天干相连（要不相隔而紧连）\n\n凡命遇三奇，主人精神异常，襟怀卓越，好奇尚大，博学多能。\n学艺专精、精力旺盛、脑力灵敏，易成专业技能人才、如工程师、信息家、计算机软件设计、属技能专精之人。\n\n三奇在什么条件下才能真正为奇? 无非是:\n（一）顺布而排. 即，年乙月丙日丁,或月乙日丙时丁。 \n（二）三奇必须得时得地, 不得死绝。\n（三）三奇必有吉星贵人, 如天乙, 天月德贵人扶助。\n（四）带元辰, 桃花, 天罗地网为无用。三奇具有特殊奇材的作用。\n\n带天乙贵人者, 勋业超群。带天月二德者,不犯意外事故。带三合入局者,国家柱石。带官符劫煞者, 器识宏远。带空生旺者,脱尘离俗,不因有钱有势而惑乱，不因武力或权势而胁迫屈服。\n\n三奇必须命局配合得体, 并有其它贵人吉星扶持才有荣华福寿,如果只有三奇无贵地, 命局组合不好, 势必钱财不丰，容易受欺负。即使命局较清粹,若三奇不落贵地而落空亡, 较为孤独, 即是蓬莱三岛客,万里走江山了。',
  },
  {
    name: '文昌贵人',
    tip: '聪明有才华，文笔能力强，利读书考学著书。',
    gujue:
      '甲乙巳午报君知, 丙戊申宫丁己鸡。庚猪辛鼠壬逢虎, 癸人见卯入云梯。\n甲日巳。乙日午。丙日申。丁日酉。戊日申。己日酉。庚日亥。辛日子。壬日寅。癸日卯。',
    chafa:
      '以日、年干查四地支\n文昌多取食神之临官为贵, 为食神建禄之称。文昌入命,主聪明过人,又主化险为夷。气质雅秀,举止温文,男命逢着内涵,女命逢着仪容得体；具有上进心，不与粗俗之辈乱交朋友。\n\n文昌逢合为喜：富加且贵。文昌逢合为忌：多见忙碌，劳苦功高。文昌坐旺地：身体健康，幸福如意，利考试，贵气十足。文昌逢刑冲：劳累辛苦。\n\n文昌入命：心性聪明，出入近贵，气质文雅，好学新知，一生可以近贵利官。',
  },
  {
    name: '华盖',
    tip: '文章、艺术、聪明、孤独，宗教、佛道，浪迹江湖。\n艺术之星，多有文学，音乐，设计方面的天赋，但性情较孤独，具有敏感性质。',
    gujue: '寅午戌见戌,亥卯未见未,申子辰见辰, 巳酉丑见丑。',
    chafa: `以年、日支查余支

      华盖是一颗吉祥之星，有揽护君主威严的职权，所以华盖是权力的象征，也是工作职事变化的代表性，亦是艺术之星。
      华盖临生旺地为喜用，此人才华横溢；
      华盖临（日干）墓地，在日支和时柱为忌，不利子女的健康或运势；若有气，可能为僧道；
      华盖+七杀、桃花，可能成为艺人、巫师；
      华盖+桃花+贵人，会为艺人明星。
      
          华盖是八字忌神，虽然聪明好学，但个性比较有孤僻现象，常见血气方刚，不靠六亲。如果是八字喜神，一生可以自立更生，见解超群，才华有过人之处；可谓气宇不凡，是一个有条件、有能力成就事业的人。
      
      　　双华盖入命：命中多贵人。华盖为八字吉神：一生利官近贵，技艺出众。岁运华盖逢刑冲：事职有动；若岁运不利，小心意外危难。华盖坐空亡、或逢刑冲：工作起伏变动较多。华盖带将星，福气深厚。华盖在空亡、死、绝之地，可修身养性，修习佛理，净化自身。女命，华盖坐日支：形同寡宿。
      
      　　一般都称华盖为孤独之星，如上所言确实如此。有很多方外出家人、在家修道人，甚至九流技术艺业的人，八字里面都带有华盖。`,
  },
  {
    name: '天医',
    tip: '与医学有缘，少病，处死绝之地，则主人体弱，身体健康容易出问题。',
    gujue:
      '正月生见丑, 二月生见寅, 三月生见卯, 四月生见辰,五月生见巳, 六月生见午, 七月生见未, 八月生见申,九月生见酉, 十月生见戌, 十一月生见亥, 十二月生见子。',
    chafa:
      '以月支查其他三支\n\n天医是掌管疾病之事的星神。四柱逢天医,如不旺,又无贵人吉神相扶,不利于身体健康，容易身弱无力。若生旺又有贵人相生助,不仅身体健壮,而且特别适合从事医学、心理学、哲学等。学习力、理解力、观察力、模仿力、好奇心、研究心、直觉观等能力皆强。\n\n宗教、医药、哲学、人文等学说之星。',
  },
  {
    name: '金舆',
    tip: '财帛之星和配偶相关联，会受到配偶之资助，技术之相助。\n与车有缘，拥有私车，交通事故等。',
    gujue: '甲龙乙蛇丙戊羊, 丁己猴歌庚犬方,辛猪壬牛癸逢虎, 凡人遇此福气昌。',
    chafa:
      '以日、年干查四地支\n日坐金舆：能得异性之助；命带金舆：得祖荫。又称金舆禄神，此星入命能得扶助，一生能得富贵。\n女人逢之，幸福安吉、骨肉安泰。\n男人逢之，得贤妻，享妻钱财，荣富显贵。\n\n古代皇族，多带此星。金舆是贵人乘坐的车子。乃禄命之旌旗，三才之节钺。主人性柔、貌美，举止温顺。',
  },
  {
    name: '空亡',
    tip: '空亡入吉神，吉事减半；空亡入凶神，坏事威力减少。',
    gujue:
      '甲子旬在戌亥。甲戌旬在申酉。甲申旬在午未。\n甲午旬在辰巳。甲辰旬在寅卯。甲寅旬在子丑。',
    chafa:
      '以日、年柱，见余三地支\n\n空亡又名“天中”，凡命中所忌之凶星落入空亡则吉，命中所喜之吉星落入空亡则顿失其力，空亡本身并不主吉凶灾祥之事。空亡见三会，三合，六合不作空亡论。吉神空而喜见合，凶星空而忌见合。                   \n\n空亡入命为八字忌神：判断多误，事易差错，人多迷糊，乏主见。多有无心之过错或是意外，一生常见四处奔走。可以说『空亡』是八字里面比劫畏惧见到的神煞。带双空亡：修行出家之人，或见在家居士，多为吃斋人。最怕时柱落空，有孤寡：姻缘迟来，恋情较晚，乃性拗之人。\n\n空亡在年支上, 一是家运可能不太顺利，二是与母亲缘薄。空亡在月支上, 多主无兄弟姐妹, 或兄弟姐妹无靠。时值空亡多拗性,更遇华盖主少子。胎元支落空亡，昏蒙飘零。命中有空亡与咸池, 沐浴多者是艺人。若空亡与贵人,华盖一齐出现,则此人有大智慧,性情恬淡,品德清高,具有追求真理与智慧的超凡入圣之士,每易为世人钦仰与皈依。\n\n伤官与空亡同柱：做事经常遭受阻碍。食神与空亡同柱：注意自身健康。正财与空亡同柱：做事辛苦，财钱不聚。偏财与空亡同柱：横财机会少。正官与空亡同柱：不利公职，威信不足。七杀与空亡同柱：权力难保。空亡与正印同柱：潜心修道之人，一生终见黄袍加身。比肩与空亡同柱：兄弟、朋友相交无情义可言。劫财与空亡同柱：财钱难储，有来去之患。财神、禄神落入空亡之地：一生四处奔波，求财较为困难。女命，食神与空亡同柱：子息少。女命，空亡与正官或七杀同柱：感情多波折。八字喜神入空亡，失其功能。八字忌神入空亡，藏其凶讯。空亡逢合化吉，初凶终吉。空亡逢合化忌，可能对命主不利。空亡逢冲，则空亡去。空亡在喜用之地，则喜神受制。空亡在忌神之地，则助其凶猛。\n\n　　古人说，空亡入命只怕万事成空、心难如愿，有很多人饱读诗书、胸怀大志，却徒劳英雄无用武之地，或则感觉好事不临，却是杂琐不如意事始终不离身，一样的机会、一样的努力以赴，结果反而事与愿违，劳苦心力，空亡入命制喜助凶罢了。是否如此，或吉凶福祸如何，依八字而论定。',
  },
  {
    name: '灾煞',
    tip: '又名白虎煞，主人身意外。有天月吉神相助，多主武权之威。',
    gujue: '申子辰见午, 亥卯未见酉, 寅午戌见子, 巳酉丑见卯。',
    chafa:
      '以年支查余三支\n灾煞也叫“白虎煞”，其性勇猛，冲破将星，谓之灾煞。\n此煞主人身意外，根据所处五行支，在水火，防焚溺，金木，杖刃；土，坠落瘟疫。若与七杀同柱来克身，可能有危难。也主刑律官司。若灾煞是正官、正印的生旺之支，多是武权。',
  },
  {
    name: '劫煞',
    tip: '入喜用支而处生旺则才智过人，可创业绩。反之家运可能不太顺利，难聚财，严重会惹上法律纠纷，事与愿违。',
    gujue: '寅午戌见亥，申子辰见巳，巳酉丑见寅，亥卯未见申。',
    chafa:
      '以年、日支查余三支\n三合局第三个字的下一位\n劫煞主意外危难、健康、刑法上面的问题。为喜具有竞争心，肯求上进，做事有魄力，敢担当。劫煞与贵星同柱：谋事有成。劫煞与天乙贵人、或喜用神同柱：有才能和智谋。劫煞与羊刃同柱：小心意外危险。',
  },
  {
    name: '亡神',
    tip: '临喜用，则善于谋略，胸有城府；临死绝则遇事浮躁，气量较小，脾气阴晴不定，经常任性而为。',
    gujue: '寅午戌见巳, 亥卯未见寅, 巳酉丑见申, 申子辰见亥。',
    chafa:
      '以年、日支查余三支\n三合局中神的前一位  \n亡神若为命局中所喜用的地支，并与吉神同柱，则会沉稳干练，谋略深算，严谨有威，好胜心强。如果恰为命局所忌的地支，又与其它凶煞同柱，则性情中存在着虚伪掩饰的成分，家业容易不顺，影响置业和储蓄；夫妻感情一般，多波折；子女的健康或运势也容易出现问题；自己也经常得罪人，严重的话会有法律纠纷出现。\n\n亡神入命：城府多深，做事疑虑。\n亡神与天乙贵人同现：老谋深算。\n亡神为喜：面有威仪、足智多谋、处事严谨、断事如神，是一个真人不露相的人。\n最怕亡神是命中凶忌之神：其人心性难定、事难如愿、脾气粗俗。\n\n亡神入命为八字凶神的人，做起起事来总感觉无精打采，不利家运，一生难免争纷，严重者可能会惹上法律纠纷，容易涉足酒色场所。不管男命还是女命，夫妻间都容易争吵，子女也会有不省心的情况发生。古人论命特别强调了亡神入命的危害，其实不是没有道理。',
  },
  {
    name: '羊刃',
    tip: '武职之星，主观性、好胜心、倔强、刚烈、勇猛、担当、急躁。',
    gujue:
      '甲日卯。乙日寅。丙日午。丁日巳。戊日午。\n己日巳。庚日酉。辛日申。壬日子。癸日亥。',
    chafa:
      '以日干查四地支\n羊刃+血刃+驿马同柱：人身意外、多惊多险、交通意外事故。\n时刃者, 岁运并临, 可能会有意外危难。\n年刃者，祖上家运可能不太顺利，影响到置产、钱财储蓄、家人之间的关系。\n比如：癸卯 甲子 甲辰 癸酉此一八字出身农家。又如：乙酉 戊寅 庚申 戊寅此男命，年刃栽根，不仅少年丧父，且平生与妻不和。\n\n一般格局中，透出杀神皆要制合，惟刃格大忌制化之。\n羊刃常见于警察、军人。\n羊刃是一种很强硬的气力，但它不一定是凶恶的，必须看八字中的整体组合。\n\n假如一个人的八字很弱，羊刃可以起到很大的匡助作用，比如你贫穷困难时，羊刃就是一个强有力的兄弟，能帮助和支持你；假如八字比较旺，再来羊刃的话就危险了，缺乏适当制约的话，他会与你争夺，劫财。\n\n羊刃是五行过旺之气，通常被认为是凶星。刃，即刀，故亦常与手术、杀伤有关。情绪容易激动，易树敌，生涯充满惊涛骇浪。从事机械、技术之研究，成功的人很多。虽然常碰到困难，但若成功时，所缔造的都是丰功伟业。\n\n羊刃一忌重犯，二忌羊刃逢三合六合于岁运。三忌羊刃跟太岁冲战。羊刃一忌重犯叠遇，犯之必凶所谓“劫财羊刃，切忌时逢，岁运许临，祸患立至”是也。比如原局有子午卯酉四刃，岁运又逢则谓犯重刃，会主求财较为困难，与父亲缘薄，不常往来。夫妻感情多波折。其中尤以午午、酉酉相见大凶，以午酉重叠有相刑之象。\n\n二忌羊刃逢三合六合于岁运。太岁乃凶神羊刃乃凶煞，羊刃三合六合太岁，则小心意外事故。比如甲刃在卯忌亥未戌流岁合之，若命中原犯三合六合，岁运再逢大忌；若原局无此病端则刃合岁灾稍轻。\n\n三忌羊刃跟太岁冲战。经云：“羊刃冲合岁君，勃然祸至”是也。羊刃不可冲犯，犯之大怒凶性发；命中原刃最忌跟太岁冲战，比如甲刃在卯忌见酉年相战，可能会有意外的危难。\n\n羊刃制凶要官杀制化去其暴气方可温顺驯服。甲刃在卯。要庚辛申制合，忌酉冲之；丙刃在午，要见壬癸亥制合，忌子冲之；戊刃在午，要见甲乙寅卯制合，忌子冲亡；庚刃在酉，要丙丁巳午制亡，忌卯冲之；壬刃在子，要戊已戌丑未制之，忌午冲之。刃杀两凶互相制伏，日主从中渔利方善驾驭也。刃杀相见也要力量相等匹配，方为大贵之造。刃重杀柔要补杀，杀重刃轻要补刃，或用食制杀印化杀来助刃平定杀气。\n\n羊刃颇忌伤食之星护卫，则杀官制化之功难于作用；若羊刃与伤食互倚成党，对命主可能会有不利的事情。\n',
  },
  {
    name: '飞刃',
    tip: '人身意外、争端、是非之星，出现在月时两柱最严重。（除非有贵人星化解，最忌刑冲）。',
    gujue:
      '甲羊刃在卯，如果地支见酉，即为飞刃;乙刃在寅,寅申相冲,即为飞刃;丙戊羊刃在午，地支见子，即为飞刃;丁己羊刃在巳,地支见亥，即为飞刃;庚羊刃在酉,地支见卯，即为飞刃;辛羊刃在申, 地支见寅，即为飞刃;壬羊刃在子,地支见午，即为飞刃;癸羊刃在亥，地支见巳，即为飞刃。',
    chafa:
      '以日干查四地支\n羊刃的六冲\n如果原局羊刃，再遇其他支或流年有飞刃，身体健康上容易出问题。',
  },
  {
    name: '血刃',
    tip: '注意身体健康、意外的事故。',
    gujue:
      '寅月丑。卯月未。辰月寅。巳月申。午月卯。未月酉。\n申月辰。酉月戌。戌月巳。亥月亥。子月午。丑月子。',
    chafa: '以月支查四柱干支\n ',
  },
  {
    name: '流霞',
    tip: '男忌酒色，女子在临盆分娩的时候需要注意。',
    gujue:
      '甲日酉。乙日戌。丙日未。丁日申。戊日巳。\n己日午。庚日辰。辛日卯。壬日亥。癸日寅。',
    chafa:
      '以日干查四地支\n\n流霞逢冲：易犯人身意外。男命：酒色。女命：分娩方面的意外。\n　　古人称血煞。轻者可能会有皮肉之伤，健康方面的问题，重者可能会有人身意外。\n命犯血煞，最怕八字凶神带重，大运流年又走在凶煞冲克之地，可能会因为一些事情而受伤或出现人身意外，如果八字有吉神转化，是可以化险为夷的。岁运走在流霞、血支、血刃的流年，不论轻重，或多或少可能会受伤。如果是在不利的流年岁月期间，外出、开车多加小心谨慎，防止意外发生的严重性增加。  \n',
  },
  {
    name: '四废',
    tip: '败多成少。',
    gujue: '春庚申辛酉，夏壬子癸亥，秋甲寅乙卯，冬丙午丁巳。',
    chafa:
      '以日柱见之即是\n\n四废日是在春夏秋冬四个季节中，干支与季节旺气，呈一百八十度的相反的结构。季节为王（朝廷），四废日就像被朝廷刻黜的官吏。以“刻”为“不用”之意引申，四刻日生者，是比较没有个性、事业上面作为不大的人，或者是怀才不遇的人，平凡过其一生。\n\n命局中带“四废”神煞的人，一生之中做事可能会有始无终，需要多注意健康问题。',
  },
  {
    name: '天罗地网',
    tip: '注意健康问题、容易惹上法律纠纷。',
    gujue: '凡纳音火命，见戌亥日为天罗；水土命，见辰巳日为地网，金木二命无之。',
    chafa: `查法一（现代）：以年\日支查余三支
      戌亥为天罗，辰巳为地网；
      戌见亥, 亥见戌为天罗；
      辰见巳, 巳见辰为地网；
      男忌天罗, 女忌地网。
      
      查法二（古代）：以年纳音查日支
      火命人逢戌亥日为天罗, 水土命逢辰巳日为地网. 男忌天罗, 女忌地网.
      
      
      此处采用查法一（现代）
      
      
      天罗地网, 容易惹上法律纠纷, 大运流年遇之,于人不利，若天月二德解救则无忧。
      
      大多命带罗网的人，在人生旅途上所接受的考验、打击较重大，须奋斗挣扎才能出人头地，若命格不高，意志不足就被命运之神俘虏，庸庸碌碌过其一生；有的则甘心落后，误入歧途。
      
      天罗地网逢三刑六害之神，再见魁罡、身强杀重、官杀混杂，伤官见官、财星在偏印皆主会触犯刑律，验率颇高。`,
  },
  {
    name: '天罗',
    tip: '注意健康问题、容易惹上法律纠纷。',
    gujue: '凡纳音火命，见戌亥日为天罗；水土命，见辰巳日为地网，金木二命无之。',
    chafa: `以年纳音查日支

      火命人逢戌亥为天罗, 水土命逢辰巳为地网. 男忌天罗, 女忌地网.
      
      年命纳音为火，即年柱为戊子、己丑、丙寅、丁卯、甲辰、乙巳、戊午、己未、丙申、丁酉、甲戌、乙亥的八字，日支中又出现戌或亥时为天罗。年命纳音为水、土，即年柱为丙子、丁丑、甲寅、乙卯、壬辰、癸巳、丙午、丁未、甲申、乙酉、壬戌、癸亥；庚子、辛丑、戊寅、己卯、丙辰、丁巳、庚午、辛未、戊申、己酉、丙戌、丁亥的八字，日支中又出现辰或巳时为地网。
      
      天罗地网, 容易惹上法律纠纷, 大运流年遇之,于人不利，若天月二德解救则无忧。
      
      大多命带罗网的人，在人生旅途上所接受的考验、打击较重大，须奋斗挣扎才能出人头地，若命格不高，意志不足就被命运之神俘虏，庸庸碌碌过其一生；有的则甘心落后，误入歧途。
      
      天罗地网逢三刑六害之神，再见魁罡、身强杀重、官杀混杂，伤官见官、财星在偏印皆主会触犯刑律，验率颇高。`,
  },
  {
    name: '地网',
    tip: '注意健康问题、容易惹上法律纠纷。',
    gujue: '凡纳音火命，见戌亥日为天罗；水土命，见辰巳日为地网，金木二命无之。',
    chafa: `以年纳音查日支

      火命人逢戌亥为天罗, 水土命逢辰巳为地网. 男忌天罗, 女忌地网.
      
      年命纳音为火，即年柱为戊子、己丑、丙寅、丁卯、甲辰、乙巳、戊午、己未、丙申、丁酉、甲戌、乙亥的八字，日支中又出现戌或亥时为天罗。年命纳音为水、土，即年柱为丙子、丁丑、甲寅、乙卯、壬辰、癸巳、丙午、丁未、甲申、乙酉、壬戌、癸亥；庚子、辛丑、戊寅、己卯、丙辰、丁巳、庚午、辛未、戊申、己酉、丙戌、丁亥的八字，日支中又出现辰或巳时为地网。
      
      天罗地网, 容易惹上法律纠纷, 大运流年遇之,于人不利，若天月二德解救则无忧。
      
      大多命带罗网的人，在人生旅途上所接受的考验、打击较重大，须奋斗挣扎才能出人头地，若命格不高，意志不足就被命运之神俘虏，庸庸碌碌过其一生；有的则甘心落后，误入歧途。
      
      天罗地网逢三刑六害之神，再见魁罡、身强杀重、官杀混杂，伤官见官、财星在偏印皆主会触犯刑律，验率颇高。`,
  },
  {
    name: '桃花',
    tip: '1、代表魅力、社交缘、风流（女人比较忌，桃花喜空亡）\n2、代表鉴赏能力、装饰能力',
    gujue: '申子辰在酉, 寅午戌在卯, 巳酉丑在午, 亥卯未在子。',
    chafa:
      '以年、日支查余三支\n咸池是取日入之义, 指万物暗昧之时"日出扶桑, 入于咸池", 故五行沐浴之地曰咸池，又名桃花。 主要影响一个人的情感,魅力和恋爱, 婚姻生活,附带还有隐秘,阴暗,酒水之类的影响。命带桃花,其人性巧,有同情心,爱风流,多才艺,能艺术,如果八字出现桃花而且处于生旺之地则主其人姿容俊美,如果是男人,则慷慨好交游,喜美色;如果是女人则风情万种, 漂亮诱人。桃花并主聪明,异性缘佳。桃花忌见水,见之则生理欲望比较强。如申子辰人逢癸酉或亥子丑水。时支桃花,时干不宜再见伤官,因为伤官本身已伤害官星(夫星),如再坐桃花, 将导致多夫,及婚姻不美满的情形。\n\n桃花在年月：称为『内桃花』，夫妻恩爱。桃花在日时：称为『外桃花』，夫妻多纷争；尤岁运再逢。时上桃花：桃花强，感情丰富。桃花入命，干见杀星：为人多情、欲望强。桃花与禄神同柱：有异性缘。桃花与羊刃同柱：感情风波，是非多灾。桃花与空亡同柱：人缘有欠缺之忧，一生为情多苦。桃花与元辰同现或桃花逢刑冲：可能会因为钱财女人方面遇到问题。不易犯桃花者：桃花坐空亡；命不带桃花。男命，桃花合禄：一生多有女贵人，多见帮助。男命，桃花与禄神同柱：能得桃花之助力。女命，流年大运见桃花刑冲：不利姻缘。\n\n桃花喜与正官、正印同柱：表示自己有自制能力，不致于滥。喜与食神同柱：表示将欲求转为文学、艺术的才华。忌与七杀同柱：表示容易为欲望犯罪，女性则被迫，坠入风尘。与伤官同柱（欲望强）：表示喜新厌旧、容易自恃才貌、追求时髦，对于感情不太在乎。与劫财同柱：敢爱敢恨、横刀夺爱、争风吃醋。与偏印同柱：生理欲望较强，同性。与比肩同柱：孤芳自赏、独身主义。 \n\n另外，《三命通会刑冲带合》中认为，“干合支刑”也是喜爱喝酒的典型标志。比如甲子见己卯，丙子见辛卯，庚申见乙巳，干合支刑，上合下刑，多犯酒色。\n\n看有无外遇，则看命局中有无劫夺妻或夫之象。',
  },
  {
    name: '孤辰',
    tip: '『男怕孤、女怕寡』\n\n性格孤僻沉默不语、清心寡欲、依恋安逸。\n\n男命逢孤辰,平生感情多波折。女命逢寡宿，姻缘不利。孤寡与驿马并，流浪他乡，与华盖并于日时,恋情较晚，或为僧尼。与空亡并，小的时候能依靠的人较少，一生不太平稳，四处奔走。',
    gujue:
      '亥子丑人, 见寅为孤, 见戌为寡；\n寅卯辰人, 见巳为孤, 见丑为寡；\n巳午未人, 见申为孤, 见辰为寡；\n申酉戌人, 见亥为孤, 见未为寡。',
    chafa:
      '以年支查余三支\n孤辰入命：生性多孤独，孤枕独眠。古人常说『男怕孤、女怕寡』，八字里面孤辰、寡宿同现：常见事与愿违。男命：为人孤独。女命：为人独立。\n\n男命怕孤辰落在财星之地，或日主的死绝之方。女命怕寡宿落在夫星之地，或日主的死绝之方。这现像造成缘份难偕久之憾，难免刑克，内心容易伤感，尤其是孤寡入命又见空亡的八字，一生比较孤单。八字忌孤辰、寡宿同时入命。\n\n　　如果命带孤辰或寡宿，八字又有华盖出现，则是一个非常聪明的孤独之人，往往具有特殊才华，很多艺术家、哲学家、五术家，或是修道者、牧师，多是这种命格。\n\n　　孤辰、寡宿也叫做隔角煞，又叫绝情煞。在年月柱，与六亲缘份淡薄，独立自成之命。在日柱，夫妻男女缘份淡薄。在时柱，与子孙缘分淡薄。\n\n　　命带孤辰、寡宿的人，不具交际能力与手腕，兄弟朋友情谊也显得有始无终，这就是孤寡入命终须寂的道理。所以八字有孤寡的人，其实无须汲汲追求社交或过份接近喧嚣人潮，养性独处反而显得安然自得。古来五术界得以流芳者，大都八字有孤寡、华盖空亡等神煞入命，惟能处静耐寂之人才得以花长时间研究探讨精深命理。\n\n凡人命犯孤寡，主形孤肉露,面无和气。生旺稍可,死绝尤甚。孤寡如有贵神相扶, 不至为害, 甚至"孤辰寡宿带官印,定做丛林领袖"。\n\n孤辰寡宿是印星与财星的墓、绝之位，与丧门、吊客并见，不利父母的健康和运势，做事阻碍较多，伶仃、单寒。入贵格，主入赘。\n\n阳命大运流年忌孤辰，阴命忌寡宿。',
  },
  {
    name: '寡宿',
    tip: '异性缘浅薄，婚缘浅薄延后，夫缘浅薄，独身主义。\n\n男命逢孤辰，平姻缘迟来，恋情较晚。女命逢寡宿姻缘来的较晚。孤寡与驿马并，流浪他乡，与华盖并于日时，孤苦伶仃，或为僧尼。与空亡并，自幼无倚，一生可能不太平顺，容易四处奔走。',
    gujue:
      '亥子丑人,见寅为孤,见戌为寡；\n寅卯辰人,见巳为孤,见丑为寡；\n巳午未人,见申为孤,见辰为寡；\n申酉戌人,见亥为孤，见未为寡。',
    chafa:
      '以年支查余三支\n\n寡宿入命：孤枕独眠，生性多孤独。孤辰、寡宿同现：凡事多见无所谓，乃四大皆空。男命：为人孤僻。女命：为人多孤独，老年比较孤单。\n  孤辰入命：生性多孤独，孤枕独眠。古人常说『男怕孤、女怕寡』，八字里面孤辰、寡宿同现：常见事与愿违。男命：为人孤独。女命：为人独立。\n\n男命怕孤辰落在财星之地，或日主的死绝之方。女命怕寡宿落在夫星之地，或日主的死绝之方。这现像造成缘份难偕久之憾，难免刑克，内心容易伤感，尤其是孤寡入命又见空亡的八字，一生比较孤单。八字忌孤辰、寡宿同时入命。\n\n　　如果命带孤辰或寡宿，八字又有华盖出现，则是一个非常聪明的孤独之人，往往具有特殊才华，很多艺术家、哲学家、五术家，或是修道者、牧师，多是这种命格。\n\n　　孤辰、寡宿也叫做隔角煞，又叫绝情煞。在年月柱，与六亲缘份淡薄，独立自成之命。在日柱，夫妻男女缘份淡薄。在时柱，与子孙缘份淡薄。\n\n　　命带孤辰、寡宿的人，比较不具交际能力与手腕，兄弟朋友情谊也显得有始无终，这就是孤寡入命终须寂的道理。所以八字有孤寡的人，其实无须汲汲追求社交或过份接近喧嚣人潮，养性独处反而显得安然自得。古来五术界得以流芳者，大都八字有孤寡、华盖空亡等神煞入命，惟能处静耐寂之人才得以花长时间研究探讨精深命理。\n\n凡人命犯孤寡, 主形孤肉露, 面无和气。生旺稍可, 死绝尤甚.孤寡如有贵神相扶, 不至为害, 甚至"孤辰寡宿带官印, 定做丛林领袖"。\n\n孤辰寡宿是印星与财星的墓、绝之位，与丧门、吊客并见，不利父母的健康和运势，做事阻碍较多，伶仃、单寒。入贵格，主入赘。\n\n阳命大运流年忌孤辰，阴命忌寡宿。',
  },
  {
    name: '阴差阳错',
    tip: '女不太利于婆婆和妯娌姐妹间的亲情。男不太利于和妻子家的关系，不容易得到外家之助。\n如月日时两重或三重犯此煞，多主二婚之事，常为婚姻烦恼，应注意感情培养。',
    gujue:
      '丙子日。丙午日。丁丑日。丁未日。戊寅日。戊申日。\n辛卯日。辛酉日。壬辰日。壬戌日。癸巳日。癸亥日。',
    chafa:
      '查日柱\n\n行事阴阳颠倒，多有事成反败之虞。好变不好，诸事多见在阴错阳差下，或完成、或结束。\n\n阴差阳错，是太过与不及、男女不和的意思。古说谓“女子逢之，公姑寡合，妯娌不足，夫家冷退。男子逢之，主退外家，亦与妻家是非寡合。其杀，不论男女，月日时两重或三重，犯之重，只日犯之尤重，主不得外家力，纵有妻财，亦成虚花，久后可能会与妻家有矛盾”。 \n\n一般带阴差阳错者可能有同母异父或同父异母的兄弟姐妹，在丧期中成婚、谈亲事时发生不愉快之事，妻子与父母相处的不太融洽，和妻舅感情疏远。做事阻碍较大，容易错失良机。',
  },
  {
    name: '魁罡',
    tip: '聪明机巧，临事果断，有威杀之。\n忌刑冲，刑冲多有人身意外；忌身弱，身弱逢之则钱财不丰，容易遇刑律。',
    gujue: '戊戌日。庚辰日。庚戌日。壬辰日。',
    chafa:
      '查日柱\n魁罡坐命：心性刚强霸气，聪明果断，攻击性，不服输，临事果断。带双魁罡：秉权，好杀，具领导才能。必须身旺，才能任其霸气；身弱，则容易遭意外事故，凡事不要强出头。\n\n辰为天罡, 戌为河魁, 乃阴阳绝灭之地,故名。辰是水库属天罡,戌是火库属地魁,辰戌相见为天冲地击。魁罡格在日柱方能入格,其他三格不算,且不能冲破。魁罡格需日主健旺,也即以财官为喜用,因为魁罡格,具有攻击性且格局雄壮,日主衰弱需印生,与魁罡性格相反, 即不成为魁罡格了。古歌云:"魁罡四日为先,叠叠相逢掌大权,庚戌庚辰怕显官,戊戌壬辰畏财运。主人性格多聪慧,好杀之心断不偏,倘有刑冲兼破害,一贫彻骨受笞鞭。"\n\n身值天罡地魁,财运不佳,强则较显贵,魁罡聚会,发福非常。主为人性格聪明,文章振发,临事果断,秉权好杀。魁罡性严有操持。运行身旺发福百端,一见财官,祸患立至,或带刑杀尤甚。倘日位独处,刑冲克制重临,人际关系可能不太好,刑责不已,求财困难。运临财旺官旺处,主防意外事故,若月令见财官印绶,日主一位,即以财官印食取用,虽难聚财,财官印食得位即无大害。\n\n庚戌, 庚辰二日无官星, 若魁罡重叠有情,主富贵于名,但见财官则不成局,岁运再见财旺之乡,小心意外危险。\n\n柱带魁罡者,虽有领导才能,声宏气壮,且好权术,好胜心强，但婚姻较为不顺。\n\n古人说魁罡入命的八字不要吃牛肉，并且适合修道养性以断其霸气伤人之性。\n\n“为人性格聪明，文章振发，临事果断，秉权好杀。”在现代，“魁罡”有新的诠释：带魁罡的人，人生可能充满惊涛骇浪，命运起伏大，分化较明显，容易碰到不好的事情。若是女性，大多是美人胚子，但是在恋爱和婚姻方面感情较差。法官、教授、艺术家、裁缝、理发业人士，有很多是魁罡日出的。\n\n好坏参半，婚缘不佳财运不济，因在丑和戌把天乙贵人吃掉。具有独立自主精神、精明干练、模仿、组织力皆强，性情属于累积性暴发。',
  },
  {
    name: '孤鸾煞',
    tip: '不利婚姻，或外遇。',
    gujue: '甲寅日。乙巳日。丙午日。丁巳日。\n戊午日。戊申日。辛亥日。壬子日。',
    chafa:
      '查日柱\n又名“呻吟煞”。夫妻多纷争。\n\n男命：婚姻中不太懂的相处，和妻子不和睦，可能会出现外遇事件。\n女命：夫妻感情多一般，正缘来的晚，多为晚婚，注意健康问题。\n\n女命带孤鸾与子女缘分薄，若四柱中见官杀则不适用此条。孤鸾日生的女子不利姻缘，夫妻感情多波折，两人需要面对的问题较多。房事不太和谐，注意外遇风波。',
  },
  {
    name: '红鸾',
    tip: '喜事，结婚爱情喜事。',
    gujue:
      '红鸾年支: 子 丑 寅 卯 辰 巳 午 未 申 酉 戌 亥。\n三地支见: 卯 寅 丑 子 亥 戌 酉 申 未 午 巳 辰。',
    chafa:
      '以年支查余地支\n\n如子年生人见卯为红鸾，见酉为天喜。\n“桃花红鸾天喜合，岁运逢之定结亲”。\n红鸾天喜星，主喜庆之事，岁运逢之，若与桃花同见，年日柱与岁运多合者，若是结婚合适年纪，多有爱情结婚喜事。',
  },
  {
    name: '天喜',
    tip: '喜事，结婚爱情喜事。',
    gujue:
      '天喜年支: 子 丑 寅 卯 辰 巳 午 未 申 酉 戌 亥。\n三地支见: 酉 申 未 午 巳 辰 卯 寅 丑 子 亥 戌。',
    chafa:
      '以年支查余地支\n\n如子年生人见卯为红鸾，见酉为天喜。\n“桃花红鸾天喜合，岁运逢之定结亲”。\n红鸾天喜星，主喜庆之事，岁运逢之，若与桃花同见，年日柱与岁运多合者，适合结婚年纪，多有爱情结婚喜事。',
  },
  {
    name: '勾绞煞',
    tip: '婚姻不顺\n易遭人身意外，也主容易惹上法律纠纷，难聚财。',
    gujue:
      '阳男阴女，命前三辰为勾，命后三辰为绞。\n阴男阳女，命前三辰为绞，命后三辰为勾。\n如甲子年生男，以命前三辰卯为勾，命后三辰酉为绞。\n\n子见卯。丑见辰。寅见巳。卯见午。辰见未。巳见申。\n午见酉。未见戌。申见亥。酉见子。戌见丑。亥见寅。',
    chafa:
      '以年支查余三支\n（桃花的六冲地支）\n\n古人也称破煞，常听人说某人犯破格命，就是犯了勾绞煞的意思。命带勾绞的命，一生之中可能人际关系不太好，不善于与人相处，经常会有无礼相向的事情发生。勾绞犯命，感情方面也多有波折，争吵等现象是常有的事。不只是八字本身带勾绞煞会如此，流年岁运碰到也一样会犯。\n\n勾绞之义为“牵连、羁绊”，不能发挥、受阻碍。一名“爪牙杀”，亦即地支相距90度之刑。\n\n古歌云：“爪牙杀去命三辰，大忌金神羊刃临；夹杀克身无福救，常遭蛇虎伤其身。”    命带勾绞，并带金神、白虎者，可能会有意外危难，被坏人、蛇、虎、牛、马、狗等兽所伤。勾绞入命者，大多心思敏捷，主掌刑法之任，或为将帅，掌生杀大权，若克身，主人身意外。行岁运逢之，主与人不懂得圆融，所以经常的得罪人，严重会惹上法律纠纷。勾绞只带一个灾轻，带两个灾重。命中无七杀者灾轻，有七杀者灾重。',
  },
  {
    name: '红艳煞',
    tip: '有魅力，多情，婚姻不顺。',
    gujue:
      '甲日午。乙日午。丙日寅。丁日未。戊日辰。\n己日辰。庚日戌。辛日酉。壬日子。癸日申。',
    chafa:
      '以日干查四地支\n\n红艳煞是桃花的一种。命见红艳煞不见得有多漂亮，但风流多情，好美色，人命犯之，多数有外遇桃花，男女感情方面他把控的不太好，容易有纠纷。女命见之，难免私情，一谈恋爱可能就会陷入同居生活，如果地支有日干的禄，又带驿马，为生理欲望较强之人。\n\n女命，红艳与正官或正印同柱：乃良妇也。女命，红艳与七杀同柱：易见外遇，不利姻缘。女命，红艳逢冲：须防身体健康的问题。女命，红艳逢合：桃花不断。女命，红艳坐凶煞：多见桃花灾。\n\n红艳入命大都多情善交际、好花钱、一生可能会有酒色之灾。',
  },
  {
    name: '十恶大败',
    tip: '不善理财，家运不太顺利。',
    gujue:
      '甲辰，乙巳，壬申，丙申，丁亥，庚辰，戊戌，癸亥，辛巳，己丑，日柱见着是。',
    chafa: `查日柱

      十败日所生之人由于生不带禄，多数不太会持家，花钱容易大手大脚，仓库金银化为尘。犹如无源之水、无本之木，没有资本很难成事。
      
      在世袭的古代，表示不能承袭宜、父的官职、产业，在古代这情形多发生于犯罪被搜查并没收家产，所以名为“十恶大败”。十恶，是不赦重罪。大败，表示精光、消减 。在现代可能会表示把父辈辛苦创建留下来的产业，自己给吃喝玩乐掉。
      
      生于十恶大败日的人，在庭生时，家运不顺，可能影响到置产、钱财储蓄。或已走过，当然不能得其福荫。`,
  },
  {
    name: '元辰',
    tip: '耗损、人际不算太好，不懂得圆融。\n又名大耗，面凶声浊，不分良善，贪杯贪色，生理欲望较强。',
    gujue:
      '阳男阴女★子年未。丑年申。寅年酉。卯年戌。辰年亥。巳年子。\n　　　　　午年丑。未年寅。申年卯。酉年辰。戌年巳。亥年午。\n阴男阳女★子年巳。丑年午。寅年未。卯年申。辰年酉。巳年戌。\n　　　　　午年亥。未年子。申年丑。酉年寅。戌年卯。亥年辰。',
    chafa:
      '以年支查余三支\n\n又名“毛头星”、“大耗”。元辰是相背而不合之意，若岁、运逢之，如物当风，摇动颠倒，不得安宁，没有内忧，则有外患。若大运逢之于已发之后，将交未交之际，小心意外事故。人命逢之，形貌有陷（头骨凸露、低鼻、大口、眼凶、脑凸、臀高、手脚僵硬、声音沉浊）。若值生旺则外表大方，容易是非不分、个性不易捉摸。死绝则求财困难、不太注意言辞、做事阻碍较大，容易自甘平庸。元辰在日，不利丈夫/妻子的健康或运势。\n元辰与官符并见，会无缘无故受到挫折。\n\n元辰与劫杀并见，男人做事不能注意小节，动招危辱，求财较为困难。女人声音可能比较中性，生理欲望较强，不遵礼法，生子性拗不爱听父母的话。\n\n元辰虽然是凶星，但逢六合则反吉。例如己丑年生阴男，元辰在午，有未合之。《洞元经》云：“元辰遇合而大亨。”八字中原有七杀，岁运再遇七杀，亦与元辰同观。',
  },
  {
    name: '金神',
    tip: '个性刚毅，聪明多才，然人缘较差。\n（弱命喜运行火乡，便为贵命。逢水旺则做事无成，与子女缘薄，做事劳苦）。',
    gujue: '乙丑，己巳，癸酉。',
    chafa:
      '查日柱或时柱\n\n<<相心赋>>云: "金神贵格, 火地奇哉,有刚断明敏之才,无刻薄欺瞒之意。"柱中有火, 不行火乡难发, 原局火无力, 逢火运显贵。"金神入火乡, 富贵天下响", "金神遇火威震边疆".\n金见水则沉,故金神不喜水乡,不利西北：金神喜见财,行财运则发：财运虽美,火乡更妙。\n\n金神之义是取"巳酉丑"金属而名，又为"杀"（破碎）之位。子午卯酉"的"在巳，辰戌丑未"的"在丑，寅申巳亥"的"在酉。"的杀"是破球之星、加上金的刚性，成为"具有较强破坏力"的星宿，人命带之性多威猛强烈，胆大、好胜、常使人敬而远之。刚金要得火炼，因此有"金神入火乡，发如猛虎"之说。也就是金神命格的人，其命中或岁运逢着丙、丁、巳、午时，能有大发展。',
  },
  {
    name: '天转',
    tip: '做事不太平顺。',
    gujue:
      '“春兔夏马天地转，秋鸡冬鼠便为殃;行人在路须忧死，造恶未成先架丧。”\n寅卯辰月见乙卯日，巳午未月见丙午日，申酉戌月见辛酉日，亥子丑月见壬子日。',
    chafa:
      '以月支查日柱\n天转有四日，分别是春季的乙卯日，夏季的丙午日，秋季的辛酉日，冬季的壬子日。\n地转也有四日，分别是春季的辛卯日，夏季的戊午日，秋季的癸酉日，冬季的丙子日。\n\n正所谓“盛极而衰，否极泰来”，事物发展到某种程度就会发生转变。天转地转日为五行能量旺的日子，正处于盛极而衰的状态，会因为能量过盛而带来危险。比如官位高而显赫，几乎与君主平等，如不急流勇退，可能有意外事故；家财万贯，富裕满盈，还执着于钱财，可能会被政府、坏人盯上，家庭容易遭遇不幸。\n\n生于天转地转日的人，如果格局组合不好，没有它柱干支和纳音克制，很容易出现健康问题，少年体弱等情况。成人以后，一生中也往往是祸福相依，经历磨难。需要命主常怀敬畏，多行好事，方能平安顺遂。此外，天转地转日接受上司派遣出行、经商做买卖、建筑、嫁娶等，容易有意外事情发生。',
  },
  {
    name: '地转',
    tip: '做事不太平顺。',
    gujue:
      '“春兔夏马天地转，秋鸡冬鼠便为殃;行人在路须忧死，造恶未成先架丧。”\n寅卯辰月见辛卯日，巳午未月见戊午日，申酉戌月癸酉日，亥子丑月见丙子日。',
    chafa:
      '以月支查日柱\n天转有四日，分别是春季的乙卯日，夏季的丙午日，秋季的辛酉日，冬季的壬子日。\n地转也有四日，分别是春季的辛卯日，夏季的戊午日，秋季的癸酉日，冬季的丙子日。\n\n正所谓“盛极而衰，否极泰来”，事物发展到某种程度就会发生转变。天转地转日为五行能量旺的日子，正处于盛极而衰的状态，会因为能量过盛而带来危险。比如官位高而显赫，几乎与君主平等，如不急流勇退，可能有意外事故；家财万贯，富裕满盈，还执着于钱财，可能会被政府、坏人盯上，家庭容易遭遇不幸。\n\n生于天转地转日的人，如果格局组合不好，没有它柱干支和纳音克制，很容易出现健康问题，少年体弱等情况。成人以后，一生中也往往是祸福相依，经历磨难。需要命主常怀敬畏，多行好事，方能平安顺遂。此外，天转地转日接受上司派遣出行、经商做买卖、建筑、嫁娶等，容易有意外事情发生。',
  },
  {
    name: '丧门',
    tip: '年逢此星，多主丧事、伤病、难聚财。\n避免观丧，探病。',
    gujue: ' ',
    chafa:
      '以年支查余三支\n\n年支 ：子 丑 寅 卯 辰 巳 午 未 申 酉 戌 亥\n丧门 ：寅 卯 辰 巳 午 未 申 酉 戌 亥 子 丑 \n吊客： 戌 亥 子 丑 寅 卯 辰 巳 午 未 申 酉\n披麻： 酉 戌 亥 子 丑 寅 卯 辰 巳 午 未 申 \n\n年支前两位为丧门，比如巳年生人，前两位未就是丧门，后两位卯就是吊客，后三位寅就是批麻。\n披麻、吊客、丧门皆为凶星。如大运、流年遇之，多主人身意外，伤病等事出现，也不容易聚财。',
  },
  {
    name: '吊客',
    tip: '年逢此星，多主丧事、伤病、难聚财。\n避免观丧，探病。',
    gujue: ' ',
    chafa:
      '以年支查余三支\n\n年支 ：子 丑 寅 卯 辰 巳 午 未 申 酉 戌 亥\n丧门 ：寅 卯 辰 巳 午 未 申 酉 戌 亥 子 丑 \n吊客： 戌 亥 子 丑 寅 卯 辰 巳 午 未 申 酉\n披麻： 酉 戌 亥 子 丑 寅 卯 辰 巳 午 未 申 \n\n年支前两位为丧门，比如巳年生人，前两位未就是丧门，后两位卯就是吊客，后三位寅就是批麻。\n披麻、吊客、丧门皆为凶星。如大运、流年遇之，多主人身意外，伤病等事出现。不容易聚财、也要多加注意健康问题，主要作用于流年。',
  },
  {
    name: '披麻',
    tip: '年逢此星，多主丧事、伤病、难聚财。\n避免观丧，探病。',
    gujue: ' ',
    chafa:
      '以年支查余三支\n\n年支 ：子 丑 寅 卯 辰 巳 午 未 申 酉 戌 亥\n丧门 ：寅 卯 辰 巳 午 未 申 酉 戌 亥 子 丑 \n吊客： 戌 亥 子 丑 寅 卯 辰 巳 午 未 申 酉\n披麻： 酉 戌 亥 子 丑 寅 卯 辰 巳 午 未 申 \n\n年支前两位为丧门，比如巳年生人，前两位未就是丧门，后两位卯就是吊客，后三位寅就是批麻。\n披麻、吊客、丧门皆为凶星。如大运、流年遇之，多主人身意外，伤病等事出现。不容易聚财、也要多加注意健康问题，主要作用于流年。',
  },
  {
    name: '十灵日',
    tip: '洞悉宗教之星，直觉敏锐，善于察言观色、领悟力、领会力，善解人意等心性皆强。',
    gujue:
      '“男带十灵好文章，女带十灵好衣裳。”\n甲辰、乙亥、丙辰、丁酉、戊午、庚戌、庚寅、辛亥、壬寅、癸未。',
    chafa:
      '查日柱\n\n十灵者，聪颖性灵，古人招收学习五术（医、卜、星、相、山）的徒弟，会看是否十灵日出生的，一般来说十灵日出生的人对五术方面的知识比较有天赋。好诗书文章、时尚杂论等，男子性灵，女子气质佳长相灵秀，逢此日柱出生的人主灵慧聪明。\n\n《星平会海》云：“五行绝处，即是胎元，生日逢之，名曰‘受气’，八字从了不入格富贵，亦是有余。”通书刊载的十灵日只有癸未日。此日生者容易出名。 ',
  },
  {
    name: '六秀日',
    tip: '聪明秀气。',
    gujue: '丙午 丁未 戊子 戊午 己丑 己未。',
    chafa: '查日柱\n命带六秀聪明多才多艺，相貌俊秀，人缘佳。',
  },
  {
    name: '八专',
    tip: '身体好，生理欲望较强，多情。',
    gujue: '甲寅日。乙卯日。丁未日。戊戌日。己未日。庚申日。辛酉日。癸丑日。',
    chafa:
      '查日柱\n\n此日柱，大抵天干坐禄或冠带，通常是身体比较好的人，生理欲望强，容易因酒、色而招来困扰、失败。\n\n八专坐命：感情多有争端，六亲冷淡，夫妻感情多波折。男命：为忌神，多生理欲望较强，感情多波折。女命：为忌神，不择亲疏多交。\n\n　　八专入命的人，大都比较多情，很容易在平常的相处之中即让自己不知不觉而陷入感情漩涡，很多畸情的发生不见得命带桃花，八专入命的男女也经常会有情事生忧的困扰。古人论命把八专视为桃花的一种，因为命带八专的人容易发生地下恋情。',
  },
  {
    name: '九丑',
    tip: '感情多纷争。',
    gujue:
      '丁酉日。戊子日。戊午日。己卯日。己酉日。辛卯日。辛酉日。壬子日。壬午日。',
    chafa:
      '查日柱\n此煞名“丑”，不是指容貌不好看，相反的，此日生者大多容貌美丽，或很有吸引人的魅力。其所以名“丑”，是指名声方面的风评，因感情的事容易出问题，严重的可能会惹上法律纠纷，名声受损。\n',
  },
  {
    name: '童子煞',
    tip: '时运不济。',
    gujue:
      '春秋寅子贵，冬夏卯未辰；\n金木马卯合，水火鸡犬多；\n土命逢辰巳，童子定不错。',
    chafa:
      '1、命造生在春季或秋季的（以月令算），日支或时支见寅或子的。\n2、命造生在冬季或夏季的（以月令算），日支或时支见卯、未或辰的。\n3、年柱纳音为金或木的，日支或时支见午或卯的。\n4、年柱纳音为水或火的，日支或时支见酉或戌的。\n5、年柱纳音为土命的，日支或时支见辰或巳的。\n犯童子煞的人一般时运不好事业受阻，容易遇到人格有问题的人，遭到嫉妒和排斥，自己有时已经很努力了，但是结果没有意义。前途一片光明有时自己找不到出路，就像被困在陷阱的动物渴望寻找到出路一样。尤其是婚姻感情方面不顺利，晚婚居多。',
  },
  {
    name: '天厨贵人',
    tip: '有口福\n厨艺一流、女命旺夫，但忌刑冲克破空亡',
    gujue:
      ' 甲丙爱行双妃游，乙丁狮子已金牛，\n 戊坐阴阳庚鱼双，二干石禄坐皇州，\n 癸用天喝壬人马，辛到宝瓶禄自由，\n 此是天厨注天禄，令人福禄两优游。',
    chafa: `以年干、日干查余四支

      甲干见巳，乙干见午        
      丙干见巳，丁干见午
      戊干见申，己干见酉
      庚干见亥，辛干见子
      壬干见寅，癸干见卯
      
        天厨又名「食神禄」，比如甲天干的食神丙，丙的禄在巳。先贤陆位亦说:「天厨，宜食禀」，食禀是藏食粮的仓库。
      
        天厨乃食神建禄之宫，食神是人命福星，食神既能得禄，其福必厚，故谓之天厨。
       
        天厨入命的人，如不逢刑冲克破空亡，一生不愁吃穿，食禄不虞匮乏，可以享降天之禄、得天赐之福，古人谓之“衣食无忧，福禄满堂”。八字带有天厨贵人的命，一生大都能够平安吉顺，遇事可以化险为夷、福禄优游。女命逢天厨贵人，有口福，爱美食，爱做饭，且烹饪技术一流，饭菜之香胜于他人，能迅速拉高一家人的幸福指数，因此有旺夫一说。`,
  },
  {
    name: '福星贵人',
    tip: '主平安福气，丰衣足食。',
    gujue:
      '凡甲、丙两干见寅或子，乙、癸两干见卯或丑，戊干见申，己干见未，丁干见亥，庚干见午，辛干见巳，壬干见辰是也。',
    chafa: `以年/日干查地支
 
      出自明代《甲丙相邀入虎乡歌》，甲丙相邀入虎乡，更游鼠穴高强，戊猴己未丁宜亥，乙癸逢牛卯禄昌，庚赶马头辛到巳，壬骑龙背喜非常，此为有福文昌贵，遇者应知受宠光。
       
      人命若带福星。主一生禄禄不缺，格局配合得当，自然多福多寿，金玉满堂。平常人得之，亦主三餐温饱，无忧无虑。此星多主平安福气而不主富贵。
       
      命中带有福星贵人，不但能够遇事不为凶，甚至可以遇难呈祥，化险为夷，一辈子享受悠闲的福气。如果再加上岁运和流年的配合，那自然是一个福禄兴昌、光宗耀祖的命。倘若得不到岁运流年扶持的话，也可以平安的享受快乐的生活，所以说福星贵人是一个很高贵的星。`,
  },
  {
    name: '德秀贵人',
    tip: '主内涵充实，才华出众，遇难呈祥。',
    gujue:
      '寅午戌月, 丙丁为德, 戊癸为秀.申子辰月, 壬癸戊己为德, 丙辛甲己为秀。\n巳酉丑月, 庚辛为德, 乙庚为秀.亥卯未月, 甲乙为德, 丁壬为秀。',
    chafa: `以月令查天干
 
      夫德者，本月生旺之德；秀者，合天地中和之气、五行变化而成者也。又曰；德者，阴阳解凶之神；秀者，天地清秀之气，四时当旺之神。故寅午戌月，丙丁为德，戊癸为秀。申子辰月，壬癸戊己为德，丙辛甲己为秀。巳酉丑月，庚辛为德，乙庚为秀。亥卯未月，甲乙为德，丁壬为秀。凡人命中得此德秀，无破冲克压者，赋性聪明，温厚和气。若遇学堂，更带财官，主贵。冲克减力。
       
      德秀贵人是八字里的一种神煞，古人对德秀贵人的解释是：“德者，本月生旺之德，秀者，合天地中和之气、五行变化而成者也。又曰：德者，阴阳解凶之神；秀者，天地淸秀之气，四时当旺之神”。此种说法表示德秀贵人不仅仅是贵人，还包含了一股文学的淸秀之意。
       
      德秀贵人的女命：
      为人仁慈、敏慧、慈善、温顺、修养高，一生有贵人相助，无险无虑，较为神佛帮助。“德”，就是利物救人、改过迁善。性格温和有相夫教子之美，主人仪容娟秀，对工作和家庭都是和和美美。
       
      德秀贵人的男命：
      德者，性格秉性；秀者，天地清秀之气，四时当旺之神。德秀贵人乃阴阳解厄之神，天在正气所在，故有自救解灾之能。男命带德秀贵人，且无冲破克压者，其人聪明晓事，温厚和气，文业通达，遇事常有贵人相助，总能化险为夷。带财官，主贵。此外，男命德秀贵人多带正气，所以命主很可能多在公、检、法或事业单位工作。`,
  },
  {
    name: '拱禄',
    tip: '主勤奋向上，充满正能量的福气。',
    gujue:
      '拱禄有五日五时:癸亥日癸丑时, 癸丑日癸亥时, 拱子禄；丁巳日丁未时, 己未日己巳时, 拱午禄；戊辰日戊午时, 拱巳禄。',
    chafa:
      '以日柱配合时柱\n《三命通会》云:"凡拱格, 需日时同干,贵与月令通气。运行身旺及贵禄旺地方大好,印绶伤官食神财运大吉。忌行冲破害或羊刃七杀伤了日时,拱不住贵气,大忌填实空亡。譬如器皿, 虚则能容物,实则无用。所以只宜虚拱。完则能盛,破则无用,所以怕见空亡,岁运同。"\n \n《古诗》云:"日时双拱禄中庭,金匮藏珠格清,至贵至高君子命,必须月令看支提,提纲有用提纲重,月令无神用此奇,所拱之位怕填实,又怕伤官在月支。羊刃重重来破格,如无此破贵无疑。"\n \n拱是夹、向的意思；禄是干禄、拱禄，指八字柱中无禄位，日柱和时柱相配合虚拱出禄位。命带拱禄的人，做事特别勤奋好学努力，勤奋向上，且不怕困难挫折，越挫越勇，终形成花好月圆的结果，充满了正能量，很有福分的人。\n \n凡拱格,需日时同干,贵与月令通气. 运行身旺及贵禄旺地方大好,印绶伤官食神财运大吉。忌行冲破害或羊刃七杀伤了日时,拱不住贵气,大忌填实空亡。譬如器皿,虚则能容物,实则无用，所以只宜虚拱。完则能盛,破则无用,所以怕见空亡,岁运同。',
  },
]

export const changSheng12 = [
  /*0*/
  [
    '长生',
    '沐浴',
    '冠带',
    '临官',
    '帝旺',
    '衰',
    '病',
    '死',
    '墓',
    '绝',
    '胎',
    '养',
  ],
  /*甲*/
  ['亥', '子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌'],
  /*乙*/
  ['午', '巳', '辰', '卯', '寅', '丑', '子', '亥', '戌', '酉', '申', '未'],
  /*丙*/
  ['寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥', '子', '丑'],
  /*丁*/
  ['酉', '申', '未', '午', '巳', '辰', '卯', '寅', '丑', '子', '亥', '戌'],
  /*戊*/
  ['寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥', '子', '丑'],
  /*己*/
  ['酉', '申', '未', '午', '巳', '辰', '卯', '寅', '丑', '子', '亥', '戌'],
  /*庚*/
  ['巳', '午', '未', '申', '酉', '戌', '亥', '子', '丑', '寅', '卯', '辰'],
  /*辛*/
  ['子', '亥', '戌', '酉', '申', '未', '午', '巳', '辰', '卯', '寅', '丑'],
  /*壬*/
  ['申', '酉', '戌', '亥', '子', '丑', '寅', '卯', '辰', '巳', '午', '未'],
  /*癸*/
  ['卯', '寅', '丑', '子', '亥', '戌', '酉', '申', '未', '午', '巳', '辰'],
]

// 节气
export const _JieQiData = {
  1799: {
    1: ['小寒', '5', '13:53:22'],
    2: ['立春', '4', '01:55:34'],
    3: ['惊蛰', '5', '20:58:28'],
    4: ['清明', '5', '03:11:30'],
    5: ['立夏', '5', '21:54:18'],
    6: ['芒种', '6', '03:04:14'],
    7: ['小暑', '7', '13:39:41'],
    8: ['立秋', '7', '23:01:57'],
    9: ['白露', '8', '00:53:03'],
    10: ['寒露', '8', '15:07:57'],
    11: ['立冬', '7', '16:56:53'],
    12: ['大雪', '7', '14:41:02'],
  },
  1800: {
    1: ['小寒', '5', '19:36:35'],
    2: ['立春', '4', '07:34:40'],
    3: ['惊蛰', '6', '02:34:31'],
    4: ['清明', '5', '08:46:58'],
    5: ['立夏', '6', '03:32:20'],
    6: ['芒种', '6', '08:47:17'],
    7: ['小暑', '7', '19:27:58'],
    8: ['立秋', '8', '04:54:05'],
    9: ['白露', '8', '11:16:38'],
    10: ['寒露', '8', '21:02:14'],
    11: ['立冬', '7', '22:50:41'],
    12: ['大雪', '7', '14:41:02'],
  },
  1801: {
    1: ['小寒', '5', '01:30:29'],
    2: ['立春', '4', '13:28:18'],
    3: ['惊蛰', '6', '08:27:51'],
    4: ['清明', '5', '14:40:36'],
    5: ['立夏', '6', '09:26:50'],
    6: ['芒种', '6', '14:42:27'],
    7: ['小暑', '8', '01:21:45'],
    8: ['立秋', '8', '10:43:43'],
    9: ['白露', '8', '12:31:41'],
    10: ['寒露', '8', '02:42:27'],
    11: ['立冬', '8', '04:28:30'],
    12: ['大雪', '7', '20:18:52'],
  },
  1802: {
    1: ['小寒', '6', '07:10:21'],
    2: ['立春', '4', '19:10:51'],
    3: ['惊蛰', '6', '14:12:25'],
    4: ['清明', '5', '20:25:57'],
    5: ['立夏', '6', '15:11:49'],
    6: ['芒种', '6', '20:26:41'],
    7: ['小暑', '8', '07:06:24'],
    8: ['立秋', '8', '16:29:33'],
    9: ['白露', '8', '18:18:19'],
    10: ['寒露', '9', '08:29:34'],
    11: ['立冬', '8', '10:16:03'],
    12: ['大雪', '8', '02:07:04'],
  },
  1803: {
    1: ['小寒', '6', '12:59:28'],
    2: ['立春', '5', '01:00:03'],
    3: ['惊蛰', '6', '20:00:00'],
    4: ['清明', '6', '02:10:40'],
    5: ['立夏', '6', '20:53:51'],
    6: ['芒种', '7', '02:07:27'],
    7: ['小暑', '8', '12:48:05'],
    8: ['立秋', '8', '22:14:16'],
    9: ['白露', '9', '00:06:28'],
    10: ['寒露', '9', '14:20:20'],
    11: ['立冬', '8', '16:08:24'],
    12: ['大雪', '8', '07:59:46'],
  },
  1804: {
    1: ['小寒', '6', '18:51:26'],
    2: ['立春', '5', '06:51:11'],
    3: ['惊蛰', '6', '01:50:36'],
    4: ['清明', '5', '08:00:30'],
    5: ['立夏', '6', '02:42:22'],
    6: ['芒种', '6', '07:54:29'],
    7: ['小暑', '7', '18:34:00'],
    8: ['立秋', '8', '04:00:28'],
    9: ['白露', '8', '05:53:37'],
    10: ['寒露', '8', '20:06:59'],
    11: ['立冬', '7', '21:52:32'],
    12: ['大雪', '7', '13:40:22'],
  },
  1805: {
    1: ['小寒', '6', '00:28:50'],
    2: ['立春', '4', '12:27:03'],
    3: ['惊蛰', '6', '07:27:09'],
    4: ['清明', '5', '13:39:30'],
    5: ['立夏', '6', '08:24:33'],
    6: ['芒种', '6', '13:40:05'],
    7: ['小暑', '8', '00:22:43'],
    8: ['立秋', '8', '09:51:11'],
    9: ['白露', '8', '11:46:01'],
    10: ['寒露', '9', '02:01:10'],
    11: ['立冬', '8', '03:47:47'],
    12: ['大雪', '7', '19:35:31'],
  },
  1806: {
    1: ['小寒', '6', '06:23:06'],
    2: ['立春', '4', '18:20:28'],
    3: ['惊蛰', '6', '13:20:40'],
    4: ['清明', '5', '19:33:50'],
    5: ['立夏', '6', '14:18:46'],
    6: ['芒种', '6', '19:32:08'],
    7: ['小暑', '8', '06:11:08'],
    8: ['立秋', '8', '15:35:56'],
    9: ['白露', '8', '17:28:38'],
    10: ['寒露', '9', '07:44:35'],
    11: ['立冬', '8', '09:34:30'],
    12: ['大雪', '8', '01:26:14'],
  },
  1807: {
    1: ['小寒', '6', '12:16:40'],
    2: ['立春', '5', '00:14:33'],
    3: ['惊蛰', '6', '19:12:46'],
    4: ['清明', '6', '01:22:42'],
    5: ['立夏', '6', '20:05:02'],
    6: ['芒种', '7', '01:16:36'],
    7: ['小暑', '8', '11:54:18'],
    8: ['立秋', '8', '21:18:44'],
    9: ['白露', '8', '23:12:21'],
    10: ['寒露', '9', '13:30:21'],
    11: ['立冬', '8', '15:22:36'],
    12: ['大雪', '8', '07:15:22'],
  },
  1808: {
    1: ['小寒', '6', '18:04:54'],
    2: ['立春', '5', '06:00:08'],
    3: ['惊蛰', '6', '00:54:44'],
    4: ['清明', '5', '07:01:40'],
    5: ['立夏', '6', '01:43:39'],
    6: ['芒种', '6', '06:58:46'],
    7: ['小暑', '8', '17:42:37'],
    8: ['立秋', '8', '03:12:56'],
    9: ['白露', '8', '05:09:57'],
    10: ['寒露', '8', '19:28:24'],
    11: ['立冬', '7', '21:19:54'],
    12: ['大雪', '7', '13:12:50'],
  },
  1809: {
    1: ['小寒', '6', '00:03:37'],
    2: ['立春', '4', '12:00:27'],
    3: ['惊蛰', '6', '06:56:10'],
    4: ['清明', '5', '13:03:15'],
    5: ['立夏', '6', '07:44:15'],
    6: ['芒种', '6', '12:57:42'],
    7: ['小暑', '7', '23:39:09'],
    8: ['立秋', '8', '09:06:23'],
    9: ['白露', '8', '11:00:03'],
    10: ['寒露', '9', '01:15:11'],
    11: ['立冬', '8', '03:03:57'],
    12: ['大雪', '7', '18:55:59'],
  },
  1810: {
    1: ['小寒', '6', '05:48:27'],
    2: ['立春', '5', '17:48:50'],
    3: ['惊蛰', '6', '12:48:27'],
    4: ['清明', '6', '18:57:53'],
    5: ['立夏', '6', '13:38:21'],
    6: ['芒种', '6', '18:48:39'],
    7: ['小暑', '8', '05:27:06'],
    8: ['立秋', '8', '14:53:28'],
    9: ['白露', '8', '16:48:23'],
    10: ['寒露', '9', '07:05:46'],
    11: ['立冬', '8', '08:56:20'],
    12: ['大雪', '8', '00:48:58'],
  },
  1811: {
    1: ['小寒', '6', '11:41:12'],
    2: ['立春', '4', '23:40:44'],
    3: ['惊蛰', '6', '18:38:58'],
    4: ['清明', '6', '00:46:53'],
    5: ['立夏', '6', '19:26:06'],
    6: ['芒种', '7', '00:35:35'],
    7: ['小暑', '8', '11:13:54'],
    8: ['立秋', '8', '20:41:33'],
    9: ['白露', '8', '22:39:17'],
    10: ['寒露', '9', '13:00:30'],
    11: ['立冬', '8', '14:54:46'],
    12: ['大雪', '8', '06:49:10'],
  },
  1812: {
    1: ['小寒', '6', '17:40:25'],
    2: ['立春', '5', '05:37:40'],
    3: ['惊蛰', '6', '00:34:06'],
    4: ['清明', '5', '06:41:18'],
    5: ['立夏', '6', '01:20:34'],
    6: ['芒种', '6', '06:30:05'],
    7: ['小暑', '7', '17:07:23'],
    8: ['立秋', '8', '02:33:08'],
    9: ['白露', '8', '04:28:39'],
    10: ['寒露', '8', '18:47:27'],
    11: ['立冬', '7', '20:39:32'],
    12: ['大雪', '7', '12:32:22'],
  },
  1813: {
    1: ['小寒', '5', '23:22:32'],
    2: ['立春', '4', '11:19:01'],
    3: ['惊蛰', '6', '06:15:25'],
    4: ['清明', '5', '12:23:52'],
    5: ['立夏', '6', '07:05:43'],
    6: ['芒种', '6', '12:18:43'],
    7: ['小暑', '7', '22:59:23'],
    8: ['立秋', '8', '08:26:32'],
    9: ['白露', '8', '10:21:41'],
    10: ['寒露', '9', '00:39:55'],
    11: ['立冬', '8', '02:31:57'],
    12: ['大雪', '7', '18:25:31'],
  },
  1814: {
    1: ['小寒', '6', '05:17:02'],
    2: ['立春', '4', '17:14:47'],
    3: ['惊蛰', '6', '12:11:51'],
    4: ['清明', '5', '18:20:06'],
    5: ['立夏', '6', '13:00:41'],
    6: ['芒种', '6', '18:11:28'],
    7: ['小暑', '8', '04:49:38'],
    8: ['立秋', '8', '14:14:35'],
    9: ['白露', '8', '16:07:45'],
    10: ['寒露', '9', '06:24:46'],
    11: ['立冬', '8', '08:17:13'],
    12: ['大雪', '8', '00:12:49'],
  },
  1815: {
    1: ['小寒', '6', '11:07:09'],
    2: ['立春', '4', '23:07:12'],
    3: ['惊蛰', '6', '18:04:29'],
    4: ['清明', '6', '00:10:40'],
    5: ['立夏', '6', '18:48:21'],
    6: ['芒种', '6', '23:56:36'],
    7: ['小暑', '8', '10:33:04'],
    8: ['立秋', '8', '19:58:02'],
    9: ['白露', '8', '21:52:44'],
    10: ['寒露', '9', '12:11:11'],
    11: ['立冬', '8', '14:03:30'],
    12: ['大雪', '8', '05:57:03'],
  },
  1816: {
    1: ['小寒', '6', '16:48:24'],
    2: ['立春', '5', '04:45:44'],
    3: ['惊蛰', '5', '23:41:20'],
    4: ['清明', '5', '05:46:56'],
    5: ['立夏', '6', '00:25:21'],
    6: ['芒种', '6', '05:36:43'],
    7: ['小暑', '7', '16:18:36'],
    8: ['立秋', '8', '01:49:24'],
    9: ['白露', '8', '03:48:43'],
    10: ['寒露', '8', '18:09:18'],
    11: ['立冬', '7', '20:01:09'],
    12: ['大雪', '7', '11:52:50'],
  },
  1817: {
    1: ['小寒', '5', '22:41:58'],
    2: ['立春', '4', '10:37:47'],
    3: ['惊蛰', '6', '05:33:24'],
    4: ['清明', '5', '11:40:30'],
    5: ['立夏', '6', '06:20:32'],
    6: ['芒种', '6', '11:32:02'],
    7: ['小暑', '7', '22:12:09'],
    8: ['立秋', '8', '07:39:52'],
    9: ['白露', '8', '09:36:01'],
    10: ['寒露', '8', '23:54:36'],
    11: ['立冬', '8', '01:45:50'],
    12: ['大雪', '7', '17:37:42'],
  },
  1818: {
    1: ['小寒', '6', '04:27:24'],
    2: ['立春', '4', '16:23:57'],
    3: ['惊蛰', '6', '11:20:20'],
    4: ['清明', '5', '17:28:04'],
    5: ['立夏', '6', '12:07:56'],
    6: ['芒种', '6', '17:17:37'],
    7: ['小暑', '8', '03:55:16'],
    8: ['立秋', '8', '13:21:45'],
    9: ['白露', '8', '15:18:33'],
    10: ['寒露', '9', '05:39:23'],
    11: ['立冬', '8', '07:33:43'],
    12: ['大雪', '7', '23:28:22'],
  },
  1819: {
    1: ['小寒', '6', '10:19:11'],
    2: ['立春', '4', '22:14:03'],
    3: ['惊蛰', '6', '17:06:12'],
    4: ['清明', '5', '23:08:53'],
    5: ['立夏', '6', '17:45:22'],
    6: ['芒种', '6', '22:54:40'],
    7: ['小暑', '8', '09:34:06'],
    8: ['立秋', '8', '19:03:28'],
    9: ['白露', '8', '21:03:47'],
    10: ['寒露', '9', '11:28:34'],
    11: ['立冬', '8', '13:26:54'],
    12: ['大雪', '8', '05:24:38'],
  },
  1820: {
    1: ['小寒', '6', '16:16:48'],
    2: ['立春', '5', '04:11:22'],
    3: ['惊蛰', '5', '23:01:56'],
    4: ['清明', '5', '05:02:14'],
    5: ['立夏', '5', '23:36:18'],
    6: ['芒种', '6', '04:44:13'],
    7: ['小暑', '7', '15:23:15'],
    8: ['立秋', '8', '00:52:03'],
    9: ['白露', '8', '02:50:40'],
    10: ['寒露', '8', '17:12:34'],
    11: ['立冬', '7', '19:08:01'],
    12: ['大雪', '7', '11:04:13'],
  },
  1821: {
    1: ['小寒', '5', '21:56:43'],
    2: ['立春', '4', '09:52:57'],
    3: ['惊蛰', '6', '04:45:33'],
    4: ['清明', '5', '10:47:14'],
    5: ['立夏', '6', '05:21:35'],
    6: ['芒种', '6', '10:29:19'],
    7: ['小暑', '7', '21:09:00'],
    8: ['立秋', '8', '06:38:58'],
    9: ['白露', '8', '08:38:28'],
    10: ['寒露', '8', '23:00:36'],
    11: ['立冬', '8', '00:55:30'],
    12: ['大雪', '7', '16:51:16'],
  },
  1822: {
    1: ['小寒', '6', '03:44:28'],
    2: ['立春', '4', '15:42:49'],
    3: ['惊蛰', '6', '10:38:20'],
    4: ['清明', '5', '16:42:11'],
    5: ['立夏', '6', '11:16:22'],
    6: ['芒种', '6', '16:21:13'],
    7: ['小暑', '8', '02:56:39'],
    8: ['立秋', '8', '12:23:30'],
    9: ['白露', '8', '14:22:00'],
    10: ['寒露', '9', '04:45:02'],
    11: ['立冬', '8', '06:41:58'],
    12: ['大雪', '7', '22:39:50'],
  },
  1823: {
    1: ['小寒', '6', '09:34:46'],
    2: ['立春', '4', '21:34:30'],
    3: ['惊蛰', '6', '16:30:40'],
    4: ['清明', '5', '22:34:23'],
    5: ['立夏', '6', '17:07:52'],
    6: ['芒种', '6', '22:10:55'],
    7: ['小暑', '8', '08:43:11'],
    8: ['立秋', '8', '18:07:10'],
    9: ['白露', '8', '20:05:03'],
    10: ['寒露', '9', '10:29:22'],
    11: ['立冬', '8', '12:27:36'],
    12: ['大雪', '8', '04:24:49'],
  },
  1824: {
    1: ['小寒', '6', '15:16:54'],
    2: ['立春', '5', '03:12:46'],
    3: ['惊蛰', '5', '22:05:57'],
    4: ['清明', '5', '04:08:52'],
    5: ['立夏', '5', '22:44:10'],
    6: ['芒种', '6', '03:51:44'],
    7: ['小暑', '7', '14:29:54'],
    8: ['立秋', '7', '23:58:33'],
    9: ['白露', '8', '01:58:51'],
    10: ['寒露', '8', '16:23:42'],
    11: ['立冬', '7', '18:21:34'],
    12: ['大雪', '7', '10:18:33'],
  },
  1825: {
    1: ['小寒', '5', '21:10:17'],
    2: ['立春', '4', '09:05:30'],
    3: ['惊蛰', '6', '03:58:22'],
    4: ['清明', '5', '10:02:18'],
    5: ['立夏', '6', '04:39:54'],
    6: ['芒种', '6', '09:49:34'],
    7: ['小暑', '7', '20:28:00'],
    8: ['立秋', '8', '05:54:18'],
    9: ['白露', '8', '07:50:07'],
    10: ['寒露', '8', '22:10:34'],
    11: ['立冬', '8', '00:06:00'],
    12: ['大雪', '7', '16:03:09'],
  },
  1826: {
    1: ['小寒', '6', '02:57:10'],
    2: ['立春', '4', '14:55:17'],
    3: ['惊蛰', '6', '09:50:07'],
    4: ['清明', '5', '15:54:19'],
    5: ['立夏', '6', '10:30:45'],
    6: ['芒种', '6', '15:38:25'],
    7: ['小暑', '8', '02:15:15'],
    8: ['立秋', '8', '11:41:16'],
    9: ['白露', '8', '13:37:35'],
    10: ['寒露', '9', '03:58:21'],
    11: ['立冬', '8', '05:53:55'],
    12: ['大雪', '7', '21:51:21'],
  },
  1827: {
    1: ['小寒', '6', '08:45:40'],
    2: ['立春', '4', '20:43:11'],
    3: ['惊蛰', '6', '15:35:43'],
    4: ['清明', '5', '21:36:17'],
    5: ['立夏', '6', '16:09:24'],
    6: ['芒种', '6', '21:16:22'],
    7: ['小暑', '8', '07:55:46'],
    8: ['立秋', '8', '17:26:46'],
    9: ['白露', '8', '19:28:50'],
    10: ['寒露', '9', '09:54:10'],
    11: ['立冬', '8', '11:51:59'],
    12: ['大雪', '8', '03:49:16'],
  },
  1828: {
    1: ['小寒', '6', '14:42:00'],
    2: ['立春', '5', '02:38:06'],
    3: ['惊蛰', '5', '21:30:15'],
    4: ['清明', '5', '03:30:59'],
    5: ['立夏', '5', '22:03:59'],
    6: ['芒种', '6', '03:10:33'],
    7: ['小暑', '7', '13:49:48'],
    8: ['立秋', '7', '23:20:56'],
    9: ['白露', '8', '01:22:53'],
    10: ['寒露', '8', '15:47:20'],
    11: ['立冬', '7', '17:43:08'],
    12: ['大雪', '7', '09:37:33'],
  },
  1829: {
    1: ['小寒', '5', '20:27:28'],
    2: ['立春', '4', '08:21:49'],
    3: ['惊蛰', '6', '03:13:51'],
    4: ['清明', '5', '09:15:56'],
    5: ['立夏', '6', '03:50:37'],
    6: ['芒种', '6', '08:57:57'],
    7: ['小暑', '7', '19:37:26'],
    8: ['立秋', '8', '05:08:58'],
    9: ['白露', '8', '07:11:58'],
    10: ['寒露', '8', '21:38:05'],
    11: ['立冬', '7', '23:35:29'],
    12: ['大雪', '7', '15:30:43'],
  },
  1830: {
    1: ['小寒', '6', '02:20:28'],
    2: ['立春', '4', '14:14:06'],
    3: ['惊蛰', '5', '09:05:38'],
    4: ['清明', '5', '15:07:29'],
    5: ['立夏', '6', '09:41:51'],
    6: ['芒种', '6', '14:48:07'],
    7: ['小暑', '8', '01:25:20'],
    8: ['立秋', '8', '10:54:44'],
    9: ['白露', '8', '12:57:19'],
    10: ['寒露', '9', '03:25:25'],
    11: ['立冬', '8', '05:26:58'],
    12: ['大雪', '7', '21:27:07'],
  },
  1831: {
    1: ['小寒', '6', '08:20:39'],
    2: ['立春', '4', '20:15:32'],
    3: ['惊蛰', '6', '15:05:27'],
    4: ['清明', '5', '21:04:03'],
    5: ['立夏', '6', '15:35:18'],
    6: ['芒种', '6', '20:39:21'],
    7: ['小暑', '8', '07:14:30'],
    8: ['立秋', '8', '16:41:39'],
    9: ['白露', '8', '18:43:04'],
    10: ['寒露', '9', '09:11:48'],
    11: ['立冬', '8', '11:14:39'],
    12: ['大雪', '8', '03:15:26'],
  },
  1832: {
    1: ['小寒', '6', '14:08:25'],
    2: ['立春', '5', '02:01:25'],
    3: ['惊蛰', '5', '20:48:28'],
    4: ['清明', '5', '02:44:09'],
    5: ['立夏', '5', '21:13:46'],
    6: ['芒种', '6', '02:19:11'],
    7: ['小暑', '7', '12:59:11'],
    8: ['立秋', '7', '22:31:52'],
    9: ['白露', '8', '00:36:24'],
    10: ['寒露', '8', '15:05:17'],
    11: ['立冬', '7', '17:07:11'],
    12: ['大雪', '7', '09:07:51'],
  },
  1833: {
    1: ['小寒', '5', '20:01:58'],
    2: ['立春', '4', '07:56:55'],
    3: ['惊蛰', '6', '02:46:03'],
    4: ['清明', '5', '08:43:27'],
    5: ['立夏', '6', '03:14:05'],
    6: ['芒种', '6', '08:19:06'],
    7: ['小暑', '7', '18:57:10'],
    8: ['立秋', '8', '04:27:25'],
    9: ['白露', '8', '06:29:05'],
    10: ['寒露', '8', '20:54:46'],
    11: ['立冬', '7', '22:54:01'],
    12: ['大雪', '7', '14:53:54'],
  },
  1834: {
    1: ['小寒', '6', '01:49:45'],
    2: ['立春', '4', '13:48:24'],
    3: ['惊蛰', '6', '08:41:27'],
    4: ['清明', '5', '14:41:04'],
    5: ['立夏', '6', '09:10:56'],
    6: ['芒种', '6', '14:12:17'],
    7: ['小暑', '8', '00:45:28'],
    8: ['立秋', '8', '10:12:11'],
    9: ['白露', '8', '12:13:17'],
    10: ['寒露', '9', '02:40:18'],
    11: ['立冬', '8', '04:40:58'],
    12: ['大雪', '7', '20:41:18'],
  },
  1835: {
    1: ['小寒', '6', '07:36:33'],
    2: ['立春', '4', '19:33:41'],
    3: ['惊蛰', '6', '14:24:45'],
    4: ['清明', '5', '20:22:15'],
    5: ['立夏', '6', '14:50:23'],
    6: ['芒种', '6', '19:51:22'],
    7: ['小暑', '8', '06:25:54'],
    8: ['立秋', '8', '15:55:12'],
    9: ['白露', '8', '18:00:00'],
    10: ['寒露', '9', '08:31:23'],
    11: ['立冬', '8', '10:35:44'],
    12: ['大雪', '8', '02:37:33'],
  },
  1836: {
    1: ['小寒', '6', '13:31:40'],
    2: ['立春', '5', '01:26:35'],
    3: ['惊蛰', '5', '20:16:13'],
    4: ['清明', '5', '02:14:00'],
    5: ['立夏', '5', '20:43:38'],
    6: ['芒种', '6', '01:46:10'],
    7: ['小暑', '7', '12:21:30'],
    8: ['立秋', '7', '21:49:53'],
    9: ['白露', '7', '23:51:39'],
    10: ['寒露', '8', '14:19:21'],
    11: ['立冬', '7', '16:20:51'],
    12: ['大雪', '7', '08:21:02'],
  },
  1837: {
    1: ['小寒', '5', '19:14:26'],
    2: ['立春', '4', '07:08:57'],
    3: ['惊蛰', '6', '01:58:30'],
    4: ['清明', '5', '07:57:07'],
    5: ['立夏', '6', '02:28:30'],
    6: ['芒种', '6', '07:32:43'],
    7: ['小暑', '7', '18:08:53'],
    8: ['立秋', '8', '03:37:12'],
    9: ['白露', '8', '05:38:02'],
    10: ['寒露', '8', '20:04:21'],
    11: ['立冬', '7', '22:04:54'],
    12: ['大雪', '7', '14:05:12'],
  },
  1838: {
    1: ['小寒', '6', '00:59:45'],
    2: ['立春', '4', '12:55:48'],
    3: ['惊蛰', '6', '07:46:20'],
    4: ['清明', '5', '13:44:33'],
    5: ['立夏', '6', '08:14:37'],
    6: ['芒种', '6', '13:17:44'],
    7: ['小暑', '7', '23:53:08'],
    8: ['立秋', '8', '09:21:19'],
    9: ['白露', '8', '11:22:43'],
    10: ['寒露', '9', '01:49:50'],
    11: ['立冬', '8', '03:51:33'],
    12: ['大雪', '7', '19:53:39'],
  },
  1839: {
    1: ['小寒', '6', '06:50:21'],
    2: ['立春', '4', '18:48:05'],
    3: ['惊蛰', '6', '13:38:55'],
    4: ['清明', '5', '19:35:49'],
    5: ['立夏', '6', '14:03:47'],
    6: ['芒种', '6', '19:05:08'],
    7: ['小暑', '8', '05:39:30'],
    8: ['立秋', '8', '15:07:11'],
    9: ['白露', '8', '17:09:08'],
    10: ['寒露', '9', '07:37:12'],
    11: ['立冬', '8', '09:38:19'],
    12: ['大雪', '8', '01:37:38'],
  },
  1840: {
    1: ['小寒', '6', '12:30:31'],
    2: ['立春', '5', '00:24:50'],
    3: ['惊蛰', '5', '19:13:33'],
    4: ['清明', '5', '01:09:47'],
    5: ['立夏', '5', '19:38:02'],
    6: ['芒种', '6', '00:41:00'],
    7: ['小暑', '7', '11:19:29'],
    8: ['立秋', '7', '20:52:40'],
    9: ['白露', '7', '22:59:02'],
    10: ['寒露', '8', '13:29:20'],
    11: ['立冬', '7', '15:30:37'],
    12: ['大雪', '7', '07:28:39'],
  },
  1841: {
    1: ['小寒', '5', '18:19:30'],
    2: ['立春', '4', '06:12:06'],
    3: ['惊蛰', '6', '01:00:29'],
    4: ['清明', '5', '06:58:20'],
    5: ['立夏', '6', '01:29:33'],
    6: ['芒种', '6', '06:34:32'],
    7: ['小暑', '7', '17:12:37'],
    8: ['立秋', '8', '02:44:18'],
    9: ['白露', '8', '04:49:07'],
    10: ['寒露', '8', '19:18:19'],
    11: ['立冬', '7', '21:19:33'],
    12: ['大雪', '7', '13:18:21'],
  },
  1842: {
    1: ['小寒', '6', '00:10:12'],
    2: ['立春', '4', '12:03:36'],
    3: ['惊蛰', '6', '06:52:21'],
    4: ['清明', '5', '12:50:01'],
    5: ['立夏', '6', '07:20:21'],
    6: ['芒种', '6', '12:23:26'],
    7: ['小暑', '7', '22:58:27'],
    8: ['立秋', '8', '08:27:10'],
    9: ['白露', '8', '10:31:12'],
    10: ['寒露', '9', '01:02:00'],
    11: ['立冬', '8', '03:06:08'],
    12: ['大雪', '7', '19:07:53'],
  },
  1843: {
    1: ['小寒', '6', '06:01:07'],
    2: ['立春', '4', '17:52:53'],
    3: ['惊蛰', '6', '12:37:12'],
    4: ['清明', '5', '18:29:10'],
    5: ['立夏', '6', '12:54:48'],
    6: ['芒种', '6', '17:56:35'],
    7: ['小暑', '8', '04:34:14'],
    8: ['立秋', '8', '14:07:22'],
    9: ['白露', '8', '16:16:11'],
    10: ['寒露', '9', '06:51:51'],
    11: ['立冬', '8', '09:00:17'],
    12: ['大雪', '8', '01:04:49'],
  },
  1844: {
    1: ['小寒', '6', '11:58:57'],
    2: ['立春', '4', '23:50:15'],
    3: ['惊蛰', '5', '18:33:11'],
    4: ['清明', '5', '00:23:31'],
    5: ['立夏', '5', '18:47:55'],
    6: ['芒种', '5', '23:49:26'],
    7: ['小暑', '7', '10:28:05'],
    8: ['立秋', '7', '20:02:17'],
    9: ['白露', '7', '22:09:51'],
    10: ['寒露', '8', '12:42:13'],
    11: ['立冬', '7', '14:47:22'],
    12: ['大雪', '7', '06:50:17'],
  },
  1845: {
    1: ['小寒', '5', '17:44:56'],
    2: ['立春', '4', '05:38:16'],
    3: ['惊蛰', '6', '00:23:34'],
    4: ['清明', '5', '06:15:29'],
    5: ['立夏', '6', '00:40:00'],
    6: ['芒种', '6', '05:40:01'],
    7: ['小暑', '7', '16:16:23'],
    8: ['立秋', '8', '01:49:09'],
    9: ['白露', '8', '03:56:49'],
    10: ['寒露', '8', '18:29:35'],
    11: ['立冬', '7', '20:34:38'],
    12: ['大雪', '7', '12:37:30'],
  },
  1846: {
    1: ['小寒', '5', '23:33:06'],
    2: ['立春', '4', '11:28:40'],
    3: ['惊蛰', '6', '06:16:39'],
    4: ['清明', '5', '12:09:44'],
    5: ['立夏', '6', '06:32:56'],
    6: ['芒种', '6', '11:29:52'],
    7: ['小暑', '7', '22:02:40'],
    8: ['立秋', '8', '07:33:13'],
    9: ['白露', '8', '09:41:22'],
    10: ['寒露', '9', '00:16:56'],
    11: ['立冬', '8', '02:25:28'],
    12: ['大雪', '7', '18:31:04'],
  },
  1847: {
    1: ['小寒', '6', '05:28:10'],
    2: ['立春', '4', '17:24:20'],
    3: ['惊蛰', '6', '12:12:29'],
    4: ['清明', '5', '18:05:49'],
    5: ['立夏', '6', '12:29:12'],
    6: ['芒种', '6', '17:25:34'],
    7: ['小暑', '8', '03:56:36'],
    8: ['立秋', '8', '13:24:24'],
    9: ['白露', '8', '15:30:39'],
    10: ['寒露', '9', '06:06:14'],
    11: ['立冬', '8', '08:15:28'],
    12: ['大雪', '8', '00:20:41'],
  },
  1848: {
    1: ['小寒', '6', '11:15:43'],
    2: ['立春', '4', '23:08:46'],
    3: ['惊蛰', '5', '17:54:16'],
    4: ['清明', '4', '23:46:45'],
    5: ['立夏', '5', '18:11:16'],
    6: ['芒种', '5', '23:10:12'],
    7: ['小暑', '7', '09:44:43'],
    8: ['立秋', '7', '19:15:42'],
    9: ['白露', '7', '21:23:07'],
    10: ['寒露', '8', '11:58:02'],
    11: ['立冬', '7', '14:06:29'],
    12: ['大雪', '7', '06:11:43'],
  },
  1849: {
    1: ['小寒', '5', '17:07:09'],
    2: ['立春', '4', '05:00:19'],
    3: ['惊蛰', '5', '23:45:44'],
    4: ['清明', '5', '05:39:00'],
    5: ['立夏', '6', '00:05:59'],
    6: ['芒种', '6', '05:07:51'],
    7: ['小暑', '7', '15:43:29'],
    8: ['立秋', '8', '01:13:23'],
    9: ['白露', '8', '03:17:58'],
    10: ['寒露', '8', '17:49:21'],
    11: ['立冬', '7', '19:55:21'],
    12: ['大雪', '7', '12:00:33'],
  },
  1850: {
    1: ['小寒', '5', '22:58:19'],
    2: ['立春', '4', '10:54:55'],
    3: ['惊蛰', '6', '05:43:06'],
    4: ['清明', '5', '11:37:11'],
    5: ['立夏', '6', '06:02:59'],
    6: ['芒种', '6', '11:02:47'],
    7: ['小暑', '7', '21:36:20'],
    8: ['立秋', '8', '07:04:11'],
    9: ['白露', '8', '09:07:29'],
    10: ['寒露', '8', '23:38:12'],
    11: ['立冬', '8', '01:43:46'],
    12: ['大雪', '7', '17:48:52'],
  },
  1851: {
    1: ['小寒', '6', '04:46:35'],
    2: ['立春', '4', '16:42:18'],
    3: ['惊蛰', '6', '11:28:16'],
    4: ['清明', '5', '17:18:41'],
    5: ['立夏', '6', '11:40:19'],
    6: ['芒种', '6', '16:37:53'],
    7: ['小暑', '8', '03:13:20'],
    8: ['立秋', '8', '12:46:23'],
    9: ['白露', '8', '14:55:41'],
    10: ['寒露', '9', '05:31:19'],
    11: ['立冬', '8', '07:39:16'],
    12: ['大雪', '7', '23:43:45'],
  },
  1852: {
    1: ['小寒', '6', '10:39:04'],
    2: ['立春', '4', '22:32:42'],
    3: ['惊蛰', '5', '17:18:04'],
    4: ['清明', '4', '23:09:29'],
    5: ['立夏', '5', '17:32:56'],
    6: ['芒种', '5', '22:32:03'],
    7: ['小暑', '7', '09:08:54'],
    8: ['立秋', '7', '18:43:24'],
    9: ['白露', '7', '20:52:51'],
    10: ['寒露', '8', '11:26:59'],
    11: ['立冬', '7', '13:32:23'],
    12: ['大雪', '7', '05:33:56'],
  },
  1853: {
    1: ['小寒', '5', '16:26:44'],
    2: ['立春', '4', '04:19:02'],
    3: ['惊蛰', '5', '23:04:37'],
    4: ['清明', '5', '04:57:35'],
    5: ['立夏', '5', '23:22:50'],
    6: ['芒种', '6', '04:22:26'],
    7: ['小暑', '7', '14:57:32'],
    8: ['立秋', '8', '00:29:44'],
    9: ['白露', '8', '02:38:39'],
    10: ['寒露', '8', '17:13:42'],
    11: ['立冬', '7', '19:20:23'],
    12: ['大雪', '7', '11:22:46'],
  },
  1854: {
    1: ['小寒', '5', '22:15:35'],
    2: ['立春', '4', '10:07:17'],
    3: ['惊蛰', '6', '04:51:57'],
    4: ['清明', '5', '10:43:22'],
    5: ['立夏', '6', '05:06:36'],
    6: ['芒种', '6', '10:04:29'],
    7: ['小暑', '7', '20:38:13'],
    8: ['立秋', '8', '06:09:31'],
    9: ['白露', '8', '08:19:20'],
    10: ['寒露', '8', '22:57:41'],
    11: ['立冬', '8', '01:09:04'],
    12: ['大雪', '7', '17:16:04'],
  },
  1855: {
    1: ['小寒', '6', '04:11:55'],
    2: ['立春', '4', '16:04:02'],
    3: ['惊蛰', '6', '10:46:45'],
    4: ['清明', '5', '16:35:31'],
    5: ['立夏', '6', '10:56:51'],
    6: ['芒种', '6', '15:53:58'],
    7: ['小暑', '8', '02:27:43'],
    8: ['立秋', '8', '11:58:29'],
    9: ['白露', '8', '14:07:08'],
    10: ['寒露', '9', '04:45:09'],
    11: ['立冬', '8', '06:56:58'],
    12: ['大雪', '7', '23:04:18'],
  },
  1856: {
    1: ['小寒', '6', '09:59:44'],
    2: ['立春', '4', '21:50:20'],
    3: ['惊蛰', '5', '16:30:30'],
    4: ['清明', '4', '22:16:29'],
    5: ['立夏', '5', '16:35:51'],
    6: ['芒种', '5', '21:32:40'],
    7: ['小暑', '7', '08:08:34'],
    8: ['立秋', '7', '17:43:15'],
    9: ['白露', '7', '19:54:26'],
    10: ['寒露', '8', '10:32:00'],
    11: ['立冬', '7', '12:42:16'],
    12: ['大雪', '7', '04:48:57'],
  },
  1857: {
    1: ['小寒', '5', '15:45:10'],
    2: ['立春', '4', '03:37:33'],
    3: ['惊蛰', '5', '22:19:42'],
    4: ['清明', '5', '04:07:13'],
    5: ['立夏', '5', '22:27:43'],
    6: ['芒种', '6', '03:24:57'],
    7: ['小暑', '7', '13:59:49'],
    8: ['立秋', '7', '23:33:04'],
    9: ['白露', '8', '01:43:20'],
    10: ['寒露', '8', '16:19:50'],
    11: ['立冬', '7', '18:28:48'],
    12: ['大雪', '7', '10:34:59'],
  },
  1858: {
    1: ['小寒', '5', '21:32:34'],
    2: ['立春', '4', '09:28:12'],
    3: ['惊蛰', '6', '04:14:20'],
    4: ['清明', '5', '10:04:35'],
    5: ['立夏', '6', '04:24:58'],
    6: ['芒种', '6', '09:19:31'],
    7: ['小暑', '7', '19:50:23'],
    8: ['立秋', '8', '05:19:29'],
    9: ['白露', '8', '07:27:46'],
    10: ['寒露', '8', '22:05:04'],
    11: ['立冬', '8', '00:15:48'],
    12: ['大雪', '7', '16:22:55'],
  },
  1859: {
    1: ['小寒', '6', '03:19:40'],
    2: ['立春', '4', '15:12:47'],
    3: ['惊蛰', '6', '09:55:40'],
    4: ['清明', '5', '15:42:46'],
    5: ['立夏', '6', '10:00:21'],
    6: ['芒种', '6', '14:53:11'],
    7: ['小暑', '8', '01:24:46'],
    8: ['立秋', '8', '10:56:46'],
    9: ['白露', '8', '13:08:47'],
    10: ['寒露', '9', '03:50:16'],
    11: ['立冬', '8', '06:04:41'],
    12: ['大雪', '7', '22:13:30'],
  },
  1860: {
    1: ['小寒', '6', '09:09:29'],
    2: ['立春', '4', '21:00:34'],
    3: ['惊蛰', '5', '15:41:47'],
    4: ['清明', '4', '21:29:07'],
    5: ['立夏', '5', '15:49:17'],
    6: ['芒种', '5', '20:45:37'],
    7: ['小暑', '7', '07:19:57'],
    8: ['立秋', '7', '16:53:08'],
    9: ['白露', '7', '19:03:48'],
    10: ['寒露', '8', '09:42:11'],
    11: ['立冬', '7', '11:53:47'],
    12: ['大雪', '7', '04:01:17'],
  },
  1861: {
    1: ['小寒', '5', '14:57:20'],
    2: ['立春', '4', '02:48:57'],
    3: ['惊蛰', '5', '21:30:35'],
    4: ['清明', '5', '03:18:24'],
    5: ['立夏', '5', '21:39:25'],
    6: ['芒种', '6', '02:36:30'],
    7: ['小暑', '7', '13:10:06'],
    8: ['立秋', '7', '22:41:10'],
    9: ['白露', '8', '00:49:45'],
    10: ['寒露', '8', '15:26:19'],
    11: ['立冬', '7', '17:36:40'],
    12: ['大雪', '7', '09:44:02'],
  },
  1862: {
    1: ['小寒', '5', '20:41:16'],
    2: ['立春', '4', '08:34:44'],
    3: ['惊蛰', '6', '03:17:31'],
    4: ['清明', '5', '09:04:13'],
    5: ['立夏', '6', '03:22:12'],
    6: ['芒种', '6', '08:16:31'],
    7: ['小暑', '7', '18:49:14'],
    8: ['立秋', '8', '04:21:01'],
    9: ['白露', '8', '06:31:31'],
    10: ['寒露', '8', '21:10:36'],
    11: ['立冬', '7', '23:23:28'],
    12: ['大雪', '7', '15:33:09'],
  },
  1863: {
    1: ['小寒', '6', '02:32:25'],
    2: ['立春', '4', '14:27:19'],
    3: ['惊蛰', '6', '09:10:39'],
    4: ['清明', '5', '14:57:17'],
    5: ['立夏', '6', '09:14:49'],
    6: ['芒种', '6', '14:08:36'],
    7: ['小暑', '8', '00:41:30'],
    8: ['立秋', '8', '10:14:08'],
    9: ['白露', '8', '12:25:31'],
    10: ['寒露', '9', '03:05:14'],
    11: ['立冬', '8', '05:17:21'],
    12: ['大雪', '7', '21:24:27'],
  },
  1864: {
    1: ['小寒', '6', '08:20:08'],
    2: ['立春', '4', '20:11:42'],
    3: ['惊蛰', '5', '14:52:54'],
    4: ['清明', '4', '20:38:54'],
    5: ['立夏', '5', '14:56:45'],
    6: ['芒种', '5', '19:51:17'],
    7: ['小暑', '7', '06:25:45'],
    8: ['立秋', '7', '16:01:14'],
    9: ['白露', '7', '18:15:26'],
    10: ['寒露', '8', '08:56:23'],
    11: ['立冬', '7', '11:08:20'],
    12: ['大雪', '7', '03:14:23'],
  },
  1865: {
    1: ['小寒', '5', '14:08:35'],
    2: ['立春', '4', '01:58:59'],
    3: ['惊蛰', '5', '20:40:08'],
    4: ['清明', '5', '02:27:28'],
    5: ['立夏', '5', '20:47:50'],
    6: ['芒种', '6', '01:44:32'],
    7: ['小暑', '7', '12:19:07'],
    8: ['立秋', '7', '21:53:26'],
    9: ['白露', '8', '00:06:53'],
    10: ['寒露', '8', '14:48:02'],
    11: ['立冬', '7', '17:01:00'],
    12: ['大雪', '7', '09:08:36'],
  },
  1866: {
    1: ['小寒', '5', '20:04:21'],
    2: ['立春', '4', '07:56:01'],
    3: ['惊蛰', '6', '02:37:58'],
    4: ['清明', '5', '08:25:36'],
    5: ['立夏', '6', '02:45:26'],
    6: ['芒种', '6', '07:40:57'],
    7: ['小暑', '7', '18:13:35'],
    8: ['立秋', '8', '03:44:52'],
    9: ['白露', '8', '05:56:04'],
    10: ['寒露', '8', '20:37:33'],
    11: ['立冬', '7', '22:52:59'],
    12: ['大雪', '7', '15:03:34'],
  },
  1867: {
    1: ['小寒', '6', '02:00:46'],
    2: ['立春', '4', '13:50:48'],
    3: ['惊蛰', '6', '08:28:15'],
    4: ['清明', '5', '14:10:00'],
    5: ['立夏', '6', '08:24:31'],
    6: ['芒种', '6', '13:17:06'],
    7: ['小暑', '7', '23:50:35'],
    8: ['立秋', '8', '09:25:37'],
    9: ['白露', '8', '11:40:52'],
    10: ['寒露', '9', '02:25:48'],
    11: ['立冬', '8', '04:44:09'],
    12: ['大雪', '7', '20:56:47'],
  },
  1868: {
    1: ['小寒', '6', '07:55:08'],
    2: ['立春', '4', '19:45:34'],
    3: ['惊蛰', '5', '14:22:37'],
    4: ['清明', '4', '20:03:32'],
    5: ['立夏', '5', '14:17:56'],
    6: ['芒种', '5', '19:11:42'],
    7: ['小暑', '7', '05:47:20'],
    8: ['立秋', '7', '15:24:35'],
    9: ['白露', '7', '17:40:04'],
    10: ['寒露', '8', '08:22:22'],
    11: ['立冬', '7', '10:36:55'],
    12: ['大雪', '7', '02:47:02'],
  },
  1869: {
    1: ['小寒', '5', '13:45:20'],
    2: ['立春', '4', '01:37:58'],
    3: ['惊蛰', '5', '20:18:16'],
    4: ['清明', '5', '02:01:55'],
    5: ['立夏', '5', '20:17:14'],
    6: ['芒种', '6', '01:09:50'],
    7: ['小暑', '7', '11:42:27'],
    8: ['立秋', '7', '21:16:09'],
    9: ['白露', '7', '23:29:45'],
    10: ['寒露', '8', '14:11:27'],
    11: ['立冬', '7', '16:25:15'],
    12: ['大雪', '7', '08:34:24'],
  },
  1870: {
    1: ['小寒', '5', '19:32:35'],
    2: ['立春', '4', '07:26:33'],
    3: ['惊蛰', '6', '02:08:55'],
    4: ['清明', '5', '07:53:18'],
    5: ['立夏', '6', '02:06:39'],
    6: ['芒种', '6', '06:55:14'],
    7: ['小暑', '7', '17:24:07'],
    8: ['立秋', '8', '02:55:59'],
    9: ['白露', '8', '05:10:17'],
    10: ['寒露', '8', '19:55:18'],
    11: ['立冬', '7', '22:13:25'],
    12: ['大雪', '7', '14:25:44'],
  },
  1871: {
    1: ['小寒', '6', '01:24:56'],
    2: ['立春', '5', '13:18:17'],
    3: ['惊蛰', '6', '07:59:42'],
    4: ['清明', '5', '13:44:21'],
    5: ['立夏', '6', '07:59:19'],
    6: ['芒种', '6', '12:49:32'],
    7: ['小暑', '7', '23:19:00'],
    8: ['立秋', '8', '08:50:32'],
    9: ['白露', '8', '11:04:06'],
    10: ['寒露', '9', '01:48:40'],
    11: ['立冬', '8', '04:06:29'],
    12: ['大雪', '7', '20:17:49'],
  },
  1872: {
    1: ['小寒', '6', '07:14:45'],
    2: ['立春', '4', '19:04:46'],
    3: ['惊蛰', '5', '13:43:03'],
    4: ['清明', '4', '19:26:13'],
    5: ['立夏', '5', '13:41:57'],
    6: ['芒种', '5', '18:34:29'],
    7: ['小暑', '7', '05:06:10'],
    8: ['立秋', '7', '14:39:00'],
    9: ['白露', '7', '16:52:29'],
    10: ['寒露', '8', '07:35:32'],
    11: ['立冬', '7', '09:51:49'],
    12: ['大雪', '7', '02:02:41'],
  },
  1873: {
    1: ['小寒', '5', '13:00:00'],
    2: ['立春', '4', '00:50:27'],
    3: ['惊蛰', '5', '19:28:46'],
    4: ['清明', '5', '01:11:56'],
    5: ['立夏', '5', '19:28:35'],
    6: ['芒种', '6', '00:22:57'],
    7: ['小暑', '7', '10:56:03'],
    8: ['立秋', '7', '20:28:49'],
    9: ['白露', '7', '22:41:06'],
    10: ['寒露', '8', '13:22:32'],
    11: ['立冬', '7', '15:37:35'],
    12: ['大雪', '7', '07:48:33'],
  },
  1874: {
    1: ['小寒', '5', '18:47:38'],
    2: ['立春', '4', '06:40:51'],
    3: ['惊蛰', '6', '01:21:36'],
    4: ['清明', '5', '07:05:46'],
    5: ['立夏', '6', '01:21:42'],
    6: ['芒种', '6', '06:14:44'],
    7: ['小暑', '7', '16:47:07'],
    8: ['立秋', '8', '02:19:09'],
    9: ['白露', '8', '04:30:26'],
    10: ['寒露', '8', '19:11:17'],
    11: ['立冬', '7', '21:26:17'],
    12: ['大雪', '7', '13:37:25'],
  },
  1875: {
    1: ['小寒', '6', '00:36:08'],
    2: ['立春', '4', '12:27:43'],
    3: ['惊蛰', '6', '07:05:30'],
    4: ['清明', '5', '12:45:35'],
    5: ['立夏', '6', '06:57:00'],
    6: ['芒种', '6', '11:46:32'],
    7: ['小暑', '7', '22:18:44'],
    8: ['立秋', '8', '07:54:51'],
    9: ['白露', '8', '10:12:04'],
    10: ['寒露', '9', '00:57:49'],
    11: ['立冬', '8', '03:15:12'],
    12: ['大雪', '7', '19:25:50'],
  },
  1876: {
    1: ['小寒', '6', '06:22:18'],
    2: ['立春', '4', '18:11:41'],
    3: ['惊蛰', '5', '12:48:11'],
    4: ['清明', '4', '18:28:18'],
    5: ['立夏', '5', '12:41:04'],
    6: ['芒种', '5', '17:32:54'],
    7: ['小暑', '7', '04:07:38'],
    8: ['立秋', '7', '13:46:11'],
    9: ['白露', '7', '16:05:00'],
    10: ['寒露', '8', '06:50:42'],
    11: ['立冬', '7', '09:06:29'],
    12: ['大雪', '7', '01:14:49'],
  },
  1877: {
    1: ['小寒', '5', '12:09:13'],
    2: ['立春', '3', '23:57:35'],
    3: ['惊蛰', '5', '18:34:45'],
    4: ['清明', '5', '00:16:56'],
    5: ['立夏', '5', '18:31:54'],
    6: ['芒种', '5', '23:24:36'],
    7: ['小暑', '7', '09:57:43'],
    8: ['立秋', '7', '19:32:54'],
    9: ['白露', '7', '21:49:37'],
    10: ['寒露', '8', '12:35:43'],
    11: ['立冬', '7', '14:53:20'],
    12: ['大雪', '7', '07:03:37'],
  },
  1878: {
    1: ['小寒', '5', '17:59:13'],
    2: ['立春', '4', '05:47:45'],
    3: ['惊蛰', '6', '00:23:53'],
    4: ['清明', '5', '06:03:23'],
    5: ['立夏', '6', '00:14:15'],
    6: ['芒种', '6', '05:02:30'],
    7: ['小暑', '7', '15:32:26'],
    8: ['立秋', '8', '01:06:18'],
    9: ['白露', '8', '03:23:45'],
    10: ['寒露', '8', '18:13:13'],
    11: ['立冬', '7', '20:36:10'],
    12: ['大雪', '7', '12:51:49'],
  },
  1879: {
    1: ['小寒', '5', '23:50:57'],
    2: ['立春', '4', '11:40:06'],
    3: ['惊蛰', '6', '06:14:14'],
    4: ['清明', '5', '11:51:12'],
    5: ['立夏', '6', '06:00:58'],
    6: ['芒种', '6', '10:49:57'],
    7: ['小暑', '7', '21:21:37'],
    8: ['立秋', '8', '06:57:16'],
    9: ['白露', '8', '09:15:24'],
    10: ['寒露', '9', '00:04:36'],
    11: ['立冬', '8', '02:27:02'],
    12: ['大雪', '7', '18:42:27'],
  },
  1880: {
    1: ['小寒', '6', '05:41:36'],
    2: ['立春', '4', '17:30:30'],
    3: ['惊蛰', '5', '12:03:47'],
    4: ['清明', '4', '17:39:20'],
    5: ['立夏', '5', '11:47:49'],
    6: ['芒种', '5', '16:36:25'],
    7: ['小暑', '7', '03:08:39'],
    8: ['立秋', '7', '12:45:28'],
    9: ['白露', '7', '15:04:16'],
    10: ['寒露', '8', '05:52:14'],
    11: ['立冬', '7', '08:12:33'],
    12: ['大雪', '7', '00:26:48'],
  },
  1881: {
    1: ['小寒', '5', '11:26:35'],
    2: ['立春', '3', '23:17:38'],
    3: ['惊蛰', '5', '17:53:28'],
    4: ['清明', '4', '23:30:48'],
    5: ['立夏', '5', '17:39:39'],
    6: ['芒种', '5', '22:27:11'],
    7: ['小暑', '7', '08:57:33'],
    8: ['立秋', '7', '18:32:38'],
    9: ['白露', '7', '20:50:52'],
    10: ['寒露', '8', '11:39:09'],
    11: ['立冬', '7', '13:59:36'],
    12: ['大雪', '7', '06:13:53'],
  },
  1882: {
    1: ['小寒', '5', '17:14:41'],
    2: ['立春', '4', '05:08:21'],
    3: ['惊蛰', '5', '23:48:00'],
    4: ['清明', '5', '05:28:56'],
    5: ['立夏', '5', '23:39:27'],
    6: ['芒种', '6', '04:26:17'],
    7: ['小暑', '7', '14:54:33'],
    8: ['立秋', '8', '00:26:59'],
    9: ['白露', '8', '02:43:08'],
    10: ['寒露', '8', '17:31:22'],
    11: ['立冬', '7', '19:53:30'],
    12: ['大雪', '7', '12:09:20'],
  },
  1883: {
    1: ['小寒', '5', '23:09:43'],
    2: ['立春', '4', '11:00:47'],
    3: ['惊蛰', '6', '05:36:50'],
    4: ['清明', '5', '11:14:22'],
    5: ['立夏', '6', '05:22:14'],
    6: ['芒种', '6', '10:07:09'],
    7: ['小暑', '7', '20:34:38'],
    8: ['立秋', '8', '06:08:18'],
    9: ['白露', '8', '08:27:05'],
    10: ['寒露', '8', '23:18:10'],
    11: ['立冬', '8', '01:42:38'],
    12: ['大雪', '7', '17:59:29'],
  },
  1884: {
    1: ['小寒', '6', '04:59:23'],
    2: ['立春', '4', '16:49:01'],
    3: ['惊蛰', '5', '11:23:39'],
    4: ['清明', '4', '17:00:59'],
    5: ['立夏', '5', '11:10:49'],
    6: ['芒种', '5', '15:59:39'],
    7: ['小暑', '7', '02:31:14'],
    8: ['立秋', '7', '12:07:04'],
    9: ['白露', '7', '14:25:18'],
    10: ['寒露', '8', '05:13:51'],
    11: ['立冬', '7', '07:35:17'],
    12: ['大雪', '6', '23:50:11'],
  },
  1885: {
    1: ['小寒', '5', '10:49:50'],
    2: ['立春', '3', '22:40:31'],
    3: ['惊蛰', '5', '17:16:54'],
    4: ['清明', '4', '22:56:23'],
    5: ['立夏', '5', '17:08:26'],
    6: ['芒种', '5', '21:58:59'],
    7: ['小暑', '7', '08:30:42'],
    8: ['立秋', '7', '18:04:30'],
    9: ['白露', '7', '20:19:45'],
    10: ['寒露', '8', '11:05:43'],
    11: ['立冬', '7', '13:25:34'],
    12: ['大雪', '7', '05:40:06'],
  },
  1886: {
    1: ['小寒', '5', '16:40:37'],
    2: ['立春', '4', '04:32:52'],
    3: ['惊蛰', '5', '23:10:00'],
    4: ['清明', '5', '04:47:48'],
    5: ['立夏', '5', '22:55:46'],
    6: ['芒种', '6', '03:41:31'],
    7: ['小暑', '7', '14:10:15'],
    8: ['立秋', '7', '23:44:02'],
    9: ['白露', '8', '02:01:09'],
    10: ['寒露', '8', '16:49:33'],
    11: ['立冬', '7', '19:11:44'],
    12: ['大雪', '7', '11:28:05'],
  },
  1887: {
    1: ['小寒', '5', '22:29:40'],
    2: ['立春', '4', '10:22:08'],
    3: ['惊蛰', '6', '04:58:51'],
    4: ['清明', '5', '10:36:19'],
    5: ['立夏', '6', '04:44:43'],
    6: ['芒种', '6', '09:31:54'],
    7: ['小暑', '7', '20:02:47'],
    8: ['立秋', '8', '05:39:26'],
    9: ['白露', '8', '07:59:30'],
    10: ['寒露', '8', '22:49:31'],
    11: ['立冬', '8', '01:10:45'],
    12: ['大雪', '7', '17:24:00'],
  },
  1888: {
    1: ['小寒', '6', '11:03:30'],
    2: ['立春', '4', '22:42:49'],
    3: ['惊蛰', '5', '16:46:32'],
    4: ['清明', '4', '21:39:04'],
    5: ['立夏', '5', '15:01:43'],
    6: ['芒种', '5', '19:14:53'],
    7: ['小暑', '7', '05:32:54'],
    8: ['立秋', '7', '15:20:15'],
    9: ['白露', '7', '18:11:31'],
    10: ['寒露', '8', '09:44:30'],
    11: ['立冬', '7', '12:48:55'],
    12: ['大雪', '7', '05:34:28'],
  },
  1889: {
    1: ['小寒', '5', '10:10:39'],
    2: ['立春', '3', '21:57:55'],
    3: ['惊蛰', '5', '16:31:45'],
    4: ['清明', '4', '22:09:20'],
    5: ['立夏', '5', '16:19:36'],
    6: ['芒种', '5', '21:08:16'],
    7: ['小暑', '7', '07:39:26'],
    8: ['立秋', '7', '17:15:38'],
    9: ['白露', '7', '19:35:49'],
    10: ['寒露', '8', '10:27:01'],
    11: ['立冬', '7', '12:50:05'],
    12: ['大雪', '7', '05:04:41'],
  },
  1890: {
    1: ['小寒', '5', '16:02:31'],
    2: ['立春', '4', '03:50:47'],
    3: ['惊蛰', '5', '22:24:50'],
    4: ['清明', '5', '04:02:15'],
    5: ['立夏', '5', '22:12:25'],
    6: ['芒种', '6', '03:01:14'],
    7: ['小暑', '7', '13:32:24'],
    8: ['立秋', '7', '23:08:00'],
    9: ['白露', '8', '01:27:18'],
    10: ['寒露', '8', '16:18:50'],
    11: ['立冬', '7', '18:44:11'],
    12: ['大雪', '7', '11:01:54'],
  },
  1891: {
    1: ['小寒', '5', '22:01:15'],
    2: ['立春', '4', '09:47:46'],
    3: ['惊蛰', '6', '04:16:52'],
    4: ['清明', '5', '09:47:35'],
    5: ['立夏', '6', '03:51:36'],
    6: ['芒种', '6', '08:36:46'],
    7: ['小暑', '7', '19:07:22'],
    8: ['立秋', '8', '04:45:06'],
    9: ['白露', '8', '07:07:37'],
    10: ['寒露', '8', '22:01:43'],
    11: ['立冬', '8', '00:28:46'],
    12: ['大雪', '7', '16:47:38'],
  },
  1892: {
    1: ['小寒', '6', '03:48:04'],
    2: ['立春', '4', '15:35:34'],
    3: ['惊蛰', '5', '10:04:51'],
    4: ['清明', '4', '15:34:38'],
    5: ['立夏', '5', '09:37:25'],
    6: ['芒种', '5', '14:22:44'],
    7: ['小暑', '7', '00:55:25'],
    8: ['立秋', '7', '10:35:40'],
    9: ['白露', '7', '12:59:29'],
    10: ['寒露', '8', '03:52:49'],
    11: ['立冬', '7', '06:17:24'],
    12: ['大雪', '6', '22:34:07'],
  },
  1893: {
    1: ['小寒', '5', '09:34:25'],
    2: ['立春', '3', '21:24:09'],
    3: ['惊蛰', '5', '15:57:09'],
    4: ['清明', '4', '21:30:38'],
    5: ['立夏', '5', '15:35:16'],
    6: ['芒种', '5', '20:19:49'],
    7: ['小暑', '7', '06:49:49'],
    8: ['立秋', '7', '16:26:43'],
    9: ['白露', '7', '18:48:06'],
    10: ['寒露', '8', '09:40:38'],
    11: ['立冬', '7', '12:05:07'],
    12: ['大雪', '7', '04:21:36'],
  },
  1894: {
    1: ['小寒', '5', '15:21:57'],
    2: ['立春', '4', '03:12:37'],
    3: ['惊蛰', '5', '21:46:48'],
    4: ['清明', '5', '03:20:01'],
    5: ['立夏', '5', '21:21:55'],
    6: ['芒种', '6', '02:01:08'],
    7: ['小暑', '7', '12:25:16'],
    8: ['立秋', '7', '21:58:52'],
    9: ['白露', '8', '00:20:16'],
    10: ['寒露', '8', '15:15:33'],
    11: ['立冬', '7', '17:44:24'],
    12: ['大雪', '7', '10:04:48'],
  },
  1895: {
    1: ['小寒', '5', '21:07:04'],
    2: ['立春', '4', '08:57:33'],
    3: ['惊蛰', '6', '03:30:44'],
    4: ['清明', '5', '09:03:51'],
    5: ['立夏', '6', '03:07:20'],
    6: ['芒种', '6', '07:49:18'],
    7: ['小暑', '7', '18:15:35'],
    8: ['立秋', '8', '03:50:16'],
    9: ['白露', '8', '06:12:26'],
    10: ['寒露', '8', '21:08:03'],
    11: ['立冬', '7', '23:36:24'],
    12: ['大雪', '7', '15:55:34'],
  },
  1896: {
    1: ['小寒', '6', '02:55:49'],
    2: ['立春', '4', '14:43:41'],
    3: ['惊蛰', '5', '09:14:46'],
    4: ['清明', '4', '14:47:30'],
    5: ['立夏', '5', '08:52:35'],
    6: ['芒种', '5', '13:37:31'],
    7: ['小暑', '7', '00:06:31'],
    8: ['立秋', '7', '09:41:41'],
    9: ['白露', '7', '12:02:07'],
    10: ['寒露', '8', '02:55:04'],
    11: ['立冬', '7', '05:21:20'],
    12: ['大雪', '6', '21:39:44'],
  },
  1897: {
    1: ['小寒', '5', '08:40:25'],
    2: ['立春', '3', '20:29:09'],
    3: ['惊蛰', '5', '15:00:46'],
    4: ['清明', '4', '20:33:42'],
    5: ['立夏', '5', '14:38:50'],
    6: ['芒种', '5', '19:23:20'],
    7: ['小暑', '7', '05:51:45'],
    8: ['立秋', '7', '15:26:09'],
    9: ['白露', '7', '17:45:10'],
    10: ['寒露', '8', '08:36:42'],
    11: ['立冬', '7', '11:02:20'],
    12: ['大雪', '7', '03:21:24'],
  },
  1898: {
    1: ['小寒', '5', '14:24:07'],
    2: ['立春', '4', '02:15:42'],
    3: ['惊蛰', '5', '20:49:51'],
    4: ['清明', '5', '02:24:04'],
    5: ['立夏', '5', '20:29:24'],
    6: ['芒种', '6', '01:14:11'],
    7: ['小暑', '7', '11:43:31'],
    8: ['立秋', '7', '21:19:21'],
    9: ['白露', '7', '23:39:25'],
    10: ['寒露', '8', '14:31:14'],
    11: ['立冬', '7', '16:56:52'],
    12: ['大雪', '7', '09:15:44'],
  },
  1899: {
    1: ['小寒', '5', '20:17:27'],
    2: ['立春', '4', '08:06:56'],
    3: ['惊蛰', '6', '02:38:11'],
    4: ['清明', '5', '08:08:49'],
    5: ['立夏', '6', '02:10:28'],
    6: ['芒种', '6', '06:52:38'],
    7: ['小暑', '7', '17:21:27'],
    8: ['立秋', '8', '02:59:33'],
    9: ['白露', '8', '05:23:58'],
    10: ['寒露', '8', '20:19:42'],
    11: ['立冬', '7', '22:46:49'],
    12: ['大雪', '7', '15:04:33'],
  },
  1900: {
    1: ['小寒', '6', '02:03:57'],
    2: ['立春', '4', '13:51:31'],
    3: ['惊蛰', '6', '08:21:52'],
    4: ['清明', '5', '13:52:41'],
    5: ['立夏', '6', '07:55:12'],
    6: ['芒种', '6', '12:38:55'],
    7: ['小暑', '7', '23:10:08'],
    8: ['立秋', '8', '08:50:34'],
    9: ['白露', '8', '11:16:38'],
    10: ['寒露', '9', '02:13:09'],
    11: ['立冬', '8', '04:39:44'],
    12: ['大雪', '7', '20:55:50'],
  },
  1901: {
    1: ['小寒', '6', '07:53:23'],
    2: ['立春', '4', '19:39:52'],
    3: ['惊蛰', '6', '14:10:53'],
    4: ['清明', '5', '19:44:21'],
    5: ['立夏', '6', '13:50:24'],
    6: ['芒种', '6', '18:36:27'],
    7: ['小暑', '8', '05:07:34'],
    8: ['立秋', '8', '14:46:06'],
    9: ['白露', '8', '17:10:15'],
    10: ['寒露', '9', '08:06:28'],
    11: ['立冬', '8', '10:34:29'],
    12: ['大雪', '8', '02:52:37'],
  },
  1902: {
    1: ['小寒', '6', '13:51:33'],
    2: ['立春', '5', '01:38:10'],
    3: ['惊蛰', '6', '20:07:32'],
    4: ['清明', '6', '01:37:26'],
    5: ['立夏', '6', '19:38:48'],
    6: ['芒种', '7', '00:19:47'],
    7: ['小暑', '8', '10:46:19'],
    8: ['立秋', '8', '20:22:16'],
    9: ['白露', '8', '22:46:25'],
    10: ['寒露', '9', '13:45:10'],
    11: ['立冬', '8', '16:17:46'],
    12: ['大雪', '8', '08:41:01'],
  },
  1903: {
    1: ['小寒', '6', '19:43:43'],
    2: ['立春', '5', '07:31:17'],
    3: ['惊蛰', '7', '01:58:52'],
    4: ['清明', '6', '07:25:53'],
    5: ['立夏', '7', '01:25:22'],
    6: ['芒种', '7', '06:07:07'],
    7: ['小暑', '8', '16:36:36'],
    8: ['立秋', '9', '02:15:50'],
    9: ['白露', '9', '04:42:21'],
    10: ['寒露', '9', '19:41:44'],
    11: ['立冬', '8', '22:13:23'],
    12: ['大雪', '8', '14:35:19'],
  },
  1904: {
    1: ['小寒', '7', '01:37:02'],
    2: ['立春', '5', '13:24:07'],
    3: ['惊蛰', '6', '07:51:39'],
    4: ['清明', '5', '13:18:51'],
    5: ['立夏', '6', '07:18:34'],
    6: ['芒种', '6', '12:00:58'],
    7: ['小暑', '7', '22:31:41'],
    8: ['立秋', '8', '08:11:51'],
    9: ['白露', '8', '10:37:58'],
    10: ['寒露', '9', '01:35:34'],
    11: ['立冬', '8', '04:04:58'],
    12: ['大雪', '7', '20:25:20'],
  },
  1905: {
    1: ['小寒', '6', '07:27:06'],
    2: ['立春', '4', '19:15:49'],
    3: ['惊蛰', '6', '13:45:36'],
    4: ['清明', '5', '19:14:28'],
    5: ['立夏', '6', '13:14:04'],
    6: ['芒种', '6', '17:53:33'],
    7: ['小暑', '8', '04:19:59'],
    8: ['立秋', '8', '13:56:57'],
    9: ['白露', '8', '16:21:46'],
    10: ['寒露', '9', '07:19:36'],
    11: ['立冬', '8', '09:49:46'],
    12: ['大雪', '8', '02:10:47'],
  },
  1906: {
    1: ['小寒', '6', '13:13:27'],
    2: ['立春', '5', '01:03:54'],
    3: ['惊蛰', '6', '19:36:06'],
    4: ['清明', '6', '01:07:16'],
    5: ['立夏', '6', '19:08:29'],
    6: ['芒种', '6', '23:48:54'],
    7: ['小暑', '8', '10:15:16'],
    8: ['立秋', '8', '19:51:34'],
    9: ['白露', '8', '22:16:12'],
    10: ['寒露', '9', '13:14:53'],
    11: ['立冬', '8', '15:46:54'],
    12: ['大雪', '8', '08:09:25'],
  },
  1907: {
    1: ['小寒', '6', '19:11:25'],
    2: ['立春', '5', '06:58:49'],
    3: ['惊蛰', '7', '01:27:05'],
    4: ['清明', '6', '06:54:47'],
    5: ['立夏', '7', '00:53:35'],
    6: ['芒种', '7', '05:32:56'],
    7: ['小暑', '8', '15:59:10'],
    8: ['立秋', '9', '01:35:58'],
    9: ['白露', '9', '04:02:02'],
    10: ['寒露', '9', '19:02:42'],
    11: ['立冬', '8', '21:36:17'],
    12: ['大雪', '8', '13:59:26'],
  },
  1908: {
    1: ['小寒', '7', '01:01:07'],
    2: ['立春', '5', '12:47:13'],
    3: ['惊蛰', '6', '07:13:34'],
    4: ['清明', '5', '12:39:46'],
    5: ['立夏', '6', '06:38:20'],
    6: ['芒种', '6', '11:19:03'],
    7: ['小暑', '7', '21:48:00'],
    8: ['立秋', '8', '07:26:42'],
    9: ['白露', '8', '09:52:16'],
    10: ['寒露', '9', '00:50:51'],
    11: ['立冬', '8', '03:22:01'],
    12: ['大雪', '7', '19:43:37'],
  },
  1909: {
    1: ['小寒', '6', '06:45:13'],
    2: ['立春', '4', '18:32:31'],
    3: ['惊蛰', '6', '13:00:47'],
    4: ['清明', '5', '18:29:25'],
    5: ['立夏', '6', '12:30:50'],
    6: ['芒种', '6', '17:13:56'],
    7: ['小暑', '8', '03:43:57'],
    8: ['立秋', '8', '13:22:28'],
    9: ['白露', '8', '15:46:35'],
    10: ['寒露', '9', '06:43:08'],
    11: ['立冬', '8', '09:13:03'],
    12: ['大雪', '8', '01:34:49'],
  },
  1910: {
    1: ['小寒', '6', '12:37:57'],
    2: ['立春', '5', '00:27:22'],
    3: ['惊蛰', '6', '18:56:30'],
    4: ['清明', '6', '00:22:55'],
    5: ['立夏', '6', '18:19:20'],
    6: ['芒种', '6', '22:56:20'],
    7: ['小暑', '8', '09:21:02'],
    8: ['立秋', '8', '18:57:08'],
    9: ['白露', '8', '21:22:10'],
    10: ['寒露', '9', '12:21:05'],
    11: ['立冬', '8', '14:53:23'],
    12: ['大雪', '8', '07:16:53'],
  },
  1911: {
    1: ['小寒', '6', '18:20:52'],
    2: ['立春', '5', '06:10:16'],
    3: ['惊蛰', '7', '00:38:50'],
    4: ['清明', '6', '06:04:32'],
    5: ['立夏', '7', '00:00:18'],
    6: ['芒种', '7', '04:37:52'],
    7: ['小暑', '8', '15:04:55'],
    8: ['立秋', '9', '00:44:25'],
    9: ['白露', '9', '03:13:16'],
    10: ['寒露', '9', '18:14:56'],
    11: ['立冬', '8', '20:47:00'],
    12: ['大雪', '8', '13:07:34'],
  },
  1912: {
    1: ['小寒', '7', '00:07:29'],
    2: ['立春', '5', '11:53:31'],
    3: ['惊蛰', '6', '06:20:59'],
    4: ['清明', '5', '11:48:15'],
    5: ['立夏', '6', '05:47:03'],
    6: ['芒种', '6', '10:27:29'],
    7: ['小暑', '7', '20:56:42'],
    8: ['立秋', '8', '06:37:10'],
    9: ['白露', '8', '09:05:39'],
    10: ['寒露', '9', '00:06:42'],
    11: ['立冬', '8', '02:38:38'],
    12: ['大雪', '7', '18:58:53'],
  },
  1913: {
    1: ['小寒', '6', '05:57:54'],
    2: ['立春', '4', '17:42:38'],
    3: ['惊蛰', '6', '12:08:58'],
    4: ['清明', '5', '17:35:51'],
    5: ['立夏', '6', '11:34:39'],
    6: ['芒种', '6', '16:13:24'],
    7: ['小暑', '8', '02:38:52'],
    8: ['立秋', '8', '12:15:47'],
    9: ['白露', '8', '14:42:24'],
    10: ['寒露', '9', '05:43:40'],
    11: ['立冬', '8', '08:17:42'],
    12: ['大雪', '8', '00:41:01'],
  },
  1914: {
    1: ['小寒', '6', '11:42:51'],
    2: ['立春', '4', '23:29:16'],
    3: ['惊蛰', '6', '17:55:48'],
    4: ['清明', '5', '23:21:50'],
    5: ['立夏', '6', '17:20:03'],
    6: ['芒种', '6', '21:59:56'],
    7: ['小暑', '8', '08:27:12'],
    8: ['立秋', '8', '18:05:11'],
    9: ['白露', '8', '20:32:26'],
    10: ['寒露', '9', '11:34:47'],
    11: ['立冬', '8', '14:11:01'],
    12: ['大雪', '8', '06:37:05'],
  },
  1915: {
    1: ['小寒', '6', '17:40:16'],
    2: ['立春', '5', '05:25:26'],
    3: ['惊蛰', '6', '23:48:16'],
    4: ['清明', '6', '05:09:15'],
    5: ['立夏', '6', '23:02:44'],
    6: ['芒种', '7', '03:40:07'],
    7: ['小暑', '8', '14:07:45'],
    8: ['立秋', '8', '23:47:41'],
    9: ['白露', '9', '02:17:05'],
    10: ['寒露', '9', '17:20:52'],
    11: ['立冬', '8', '19:57:38'],
    12: ['大雪', '8', '12:23:53'],
  },
  1916: {
    1: ['小寒', '6', '23:27:47'],
    2: ['立春', '5', '11:13:58'],
    3: ['惊蛰', '6', '05:37:21'],
    4: ['清明', '5', '10:57:49'],
    5: ['立夏', '6', '04:49:45'],
    6: ['芒种', '6', '09:25:39'],
    7: ['小暑', '7', '19:53:33'],
    8: ['立秋', '8', '05:34:55'],
    9: ['白露', '8', '08:04:59'],
    10: ['寒露', '8', '23:07:51'],
    11: ['立冬', '8', '01:42:15'],
    12: ['大雪', '7', '18:06:09'],
  },
  1917: {
    1: ['小寒', '6', '05:09:27'],
    2: ['立春', '4', '16:57:32'],
    3: ['惊蛰', '6', '11:24:48'],
    4: ['清明', '5', '16:49:54'],
    5: ['立夏', '6', '10:45:42'],
    6: ['芒种', '6', '15:23:10'],
    7: ['小暑', '8', '01:50:13'],
    8: ['立秋', '8', '11:30:07'],
    9: ['白露', '8', '13:59:21'],
    10: ['寒露', '9', '05:02:08'],
    11: ['立冬', '8', '07:36:54'],
    12: ['大雪', '7', '00:00:59'],
  },
  1918: {
    1: ['小寒', '6', '11:04:23'],
    2: ['立春', '4', '22:53:05'],
    3: ['惊蛰', '6', '17:20:55'],
    4: ['清明', '5', '22:45:12'],
    5: ['立夏', '6', '16:38:11'],
    6: ['芒种', '6', '21:10:57'],
    7: ['小暑', '8', '07:32:07'],
    8: ['立秋', '8', '17:07:24'],
    9: ['白露', '8', '19:35:26'],
    10: ['寒露', '9', '10:40:17'],
    11: ['立冬', '8', '13:18:52'],
    12: ['大雪', '8', '05:46:29'],
  },
  1919: {
    1: ['小寒', '6', '16:51:28'],
    2: ['立春', '5', '04:39:23'],
    3: ['惊蛰', '6', '23:05:29'],
    4: ['清明', '6', '04:28:44'],
    5: ['立夏', '6', '22:22:00'],
    6: ['芒种', '7', '02:56:36'],
    7: ['小暑', '8', '13:20:30'],
    8: ['立秋', '8', '22:58:01'],
    9: ['白露', '9', '01:27:37'],
    10: ['寒露', '9', '16:33:20'],
    11: ['立冬', '8', '19:11:30'],
    12: ['大雪', '8', '11:37:47'],
  },
  1920: {
    1: ['小寒', '6', '22:40:47'],
    2: ['立春', '5', '10:26:26'],
    3: ['惊蛰', '6', '04:51:02'],
    4: ['清明', '5', '10:14:54'],
    5: ['立夏', '6', '04:11:17'],
    6: ['芒种', '6', '08:50:22'],
    7: ['小暑', '7', '19:18:36'],
    8: ['立秋', '8', '04:58:14'],
    9: ['白露', '8', '07:26:32'],
    10: ['寒露', '8', '22:29:08'],
    11: ['立冬', '8', '01:04:54'],
    12: ['大雪', '7', '17:30:16'],
  },
  1921: {
    1: ['小寒', '6', '04:33:40'],
    2: ['立春', '4', '16:20:12'],
    3: ['惊蛰', '6', '10:45:09'],
    4: ['清明', '5', '16:08:41'],
    5: ['立夏', '6', '10:04:17'],
    6: ['芒种', '6', '14:41:25'],
    7: ['小暑', '8', '01:06:34'],
    8: ['立秋', '8', '10:43:25'],
    9: ['白露', '8', '13:09:39'],
    10: ['寒露', '9', '04:10:36'],
    11: ['立冬', '8', '06:45:30'],
    12: ['大雪', '7', '23:11:25'],
  },
  1922: {
    1: ['小寒', '6', '10:16:55'],
    2: ['立春', '4', '22:06:24'],
    3: ['惊蛰', '6', '16:33:49'],
    4: ['清明', '5', '21:58:00'],
    5: ['立夏', '6', '15:52:50'],
    6: ['芒种', '6', '20:30:15'],
    7: ['小暑', '8', '06:57:25'],
    8: ['立秋', '8', '16:37:08'],
    9: ['白露', '8', '19:06:19'],
    10: ['寒露', '9', '10:09:25'],
    11: ['立冬', '8', '12:45:12'],
    12: ['大雪', '8', '05:10:38'],
  },
  1923: {
    1: ['小寒', '6', '16:14:00'],
    2: ['立春', '5', '04:00:17'],
    3: ['惊蛰', '6', '22:24:26'],
    4: ['清明', '6', '03:45:47'],
    5: ['立夏', '6', '21:38:14'],
    6: ['芒种', '7', '02:14:18'],
    7: ['小暑', '8', '12:42:11'],
    8: ['立秋', '8', '22:24:29'],
    9: ['白露', '9', '00:57:09'],
    10: ['寒露', '9', '16:03:22'],
    11: ['立冬', '8', '18:40:20'],
    12: ['大雪', '8', '11:04:33'],
  },
  1924: {
    1: ['小寒', '6', '22:05:33'],
    2: ['立春', '5', '09:49:32'],
    3: ['惊蛰', '6', '04:12:12'],
    4: ['清明', '5', '09:33:07'],
    5: ['立夏', '6', '03:25:39'],
    6: ['芒种', '6', '08:01:31'],
    7: ['小暑', '7', '18:29:24'],
    8: ['立秋', '8', '04:12:14'],
    9: ['白露', '8', '06:45:30'],
    10: ['寒露', '8', '21:52:09'],
    11: ['立冬', '8', '00:29:11'],
    12: ['大雪', '7', '16:52:59'],
  },
  1925: {
    1: ['小寒', '6', '03:53:14'],
    2: ['立春', '4', '15:36:45'],
    3: ['惊蛰', '6', '09:59:50'],
    4: ['清明', '5', '15:22:27'],
    5: ['立夏', '6', '09:17:51'],
    6: ['芒种', '6', '13:56:22'],
    7: ['小暑', '8', '00:24:54'],
    8: ['立秋', '8', '10:07:05'],
    9: ['白露', '8', '12:40:01'],
    10: ['寒露', '9', '03:47:22'],
    11: ['立冬', '8', '06:26:13'],
    12: ['大雪', '7', '22:52:17'],
  },
  1926: {
    1: ['小寒', '6', '09:54:17'],
    2: ['立春', '4', '21:38:16'],
    3: ['惊蛰', '6', '15:59:41'],
    4: ['清明', '5', '21:18:17'],
    5: ['立夏', '6', '15:08:20'],
    6: ['芒种', '6', '19:41:37'],
    7: ['小暑', '8', '06:05:36'],
    8: ['立秋', '8', '15:44:12'],
    9: ['白露', '8', '18:15:51'],
    10: ['寒露', '9', '09:24:51'],
    11: ['立冬', '8', '12:07:42'],
    12: ['大雪', '8', '04:38:39'],
  },
  1927: {
    1: ['小寒', '6', '15:44:37'],
    2: ['立春', '5', '03:30:02'],
    3: ['惊蛰', '6', '21:50:16'],
    4: ['清明', '6', '03:06:06'],
    5: ['立夏', '6', '20:53:04'],
    6: ['芒种', '7', '01:24:45'],
    7: ['小暑', '8', '11:49:55'],
    8: ['立秋', '8', '21:31:23'],
    9: ['白露', '8', '00:05:25'],
    10: ['寒露', '9', '15:15:05'],
    11: ['立冬', '8', '17:56:54'],
    12: ['大雪', '8', '10:26:18'],
  },
  1928: {
    1: ['小寒', '6', '21:31:11'],
    2: ['立春', '5', '09:16:22'],
    3: ['惊蛰', '6', '03:37:14'],
    4: ['清明', '5', '08:54:31'],
    5: ['立夏', '6', '02:43:29'],
    6: ['芒种', '6', '07:17:09'],
    7: ['小暑', '7', '17:44:15'],
    8: ['立秋', '8', '03:27:30'],
    9: ['白露', '8', '06:01:45'],
    10: ['寒露', '8', '21:09:51'],
    11: ['立冬', '7', '23:49:30'],
    12: ['大雪', '7', '16:17:16'],
  },
  1929: {
    1: ['小寒', '6', '03:22:01'],
    2: ['立春', '4', '15:08:43'],
    3: ['惊蛰', '6', '09:31:57'],
    4: ['清明', '5', '14:51:13'],
    5: ['立夏', '6', '08:40:20'],
    6: ['芒种', '6', '13:10:47'],
    7: ['小暑', '7', '23:31:38'],
    8: ['立秋', '8', '09:08:41'],
    9: ['白露', '8', '11:39:34'],
    10: ['寒露', '9', '02:47:02'],
    11: ['立冬', '8', '05:27:27'],
    12: ['大雪', '7', '21:56:24'],
  },
  1930: {
    1: ['小寒', '6', '09:02:32'],
    2: ['立春', '4', '20:51:07'],
    3: ['惊蛰', '6', '15:16:33'],
    4: ['清明', '5', '20:37:22'],
    5: ['立夏', '6', '14:26:59'],
    6: ['芒种', '6', '18:58:02'],
    7: ['小暑', '8', '05:19:40'],
    8: ['立秋', '8', '14:56:58'],
    9: ['白露', '8', '17:28:22'],
    10: ['寒露', '9', '08:37:28'],
    11: ['立冬', '8', '11:20:12'],
    12: ['大雪', '8', '03:50:37'],
  },
  1931: {
    1: ['小寒', '6', '14:55:35'],
    2: ['立春', '5', '02:40:38'],
    3: ['惊蛰', '6', '21:02:06'],
    4: ['清明', '6', '02:20:26'],
    5: ['立夏', '6', '20:09:35'],
    6: ['芒种', '7', '00:41:45'],
    7: ['小暑', '8', '11:05:34'],
    8: ['立秋', '8', '20:44:52'],
    9: ['白露', '8', '23:17:15'],
    10: ['寒露', '9', '14:26:51'],
    11: ['立冬', '8', '17:09:51'],
    12: ['大雪', '8', '09:40:15'],
  },
  1932: {
    1: ['小寒', '6', '20:45:03'],
    2: ['立春', '5', '08:29:20'],
    3: ['惊蛰', '6', '02:49:19'],
    4: ['清明', '5', '08:06:19'],
    5: ['立夏', '6', '01:55:08'],
    6: ['芒种', '6', '06:27:43'],
    7: ['小暑', '7', '16:52:15'],
    8: ['立秋', '8', '02:31:48'],
    9: ['白露', '8', '05:02:52'],
    10: ['寒露', '8', '20:09:38'],
    11: ['立冬', '7', '22:49:40'],
    12: ['大雪', '7', '15:18:22'],
  },
  1933: {
    1: ['小寒', '6', '02:23:20'],
    2: ['立春', '4', '14:09:16'],
    3: ['惊蛰', '6', '08:31:24'],
    4: ['清明', '5', '13:50:29'],
    5: ['立夏', '6', '07:41:45'],
    6: ['芒种', '6', '12:17:19'],
    7: ['小暑', '7', '22:44:17'],
    8: ['立秋', '8', '08:25:30'],
    9: ['白露', '8', '10:57:26'],
    10: ['寒露', '9', '02:03:53'],
    11: ['立冬', '8', '04:42:58'],
    12: ['大雪', '7', '21:11:05'],
  },
  1934: {
    1: ['小寒', '6', '08:16:27'],
    2: ['立春', '4', '20:03:37'],
    3: ['惊蛰', '6', '14:26:20'],
    4: ['清明', '5', '19:43:39'],
    5: ['立夏', '6', '13:30:44'],
    6: ['芒种', '6', '18:01:21'],
    7: ['小暑', '8', '04:24:25'],
    8: ['立秋', '8', '14:03:38'],
    9: ['白露', '8', '16:36:08'],
    10: ['寒露', '9', '07:44:59'],
    11: ['立冬', '8', '10:26:41'],
    12: ['大雪', '8', '02:56:31'],
  },
  1935: {
    1: ['小寒', '6', '14:02:19'],
    2: ['立春', '5', '01:48:41'],
    3: ['惊蛰', '6', '20:10:10'],
    4: ['清明', '6', '01:26:21'],
    5: ['立夏', '6', '19:12:02'],
    6: ['芒种', '6', '23:41:35'],
    7: ['小暑', '8', '10:05:32'],
    8: ['立秋', '8', '19:47:48'],
    9: ['白露', '8', '22:24:04'],
    10: ['寒露', '9', '13:35:40'],
    11: ['立冬', '8', '16:17:31'],
    12: ['大雪', '8', '08:44:50'],
  },
  1936: {
    1: ['小寒', '6', '19:46:37'],
    2: ['立春', '5', '07:29:16'],
    3: ['惊蛰', '6', '01:49:06'],
    4: ['清明', '5', '07:06:44'],
    5: ['立夏', '6', '00:56:30'],
    6: ['芒种', '6', '05:30:40'],
    7: ['小暑', '7', '15:58:18'],
    8: ['立秋', '8', '01:43:10'],
    9: ['白露', '8', '04:20:35'],
    10: ['寒露', '8', '19:32:25'],
    11: ['立冬', '7', '22:14:38'],
    12: ['大雪', '7', '14:42:13'],
  },
  1937: {
    1: ['小寒', '6', '01:43:44'],
    2: ['立春', '4', '13:25:33'],
    3: ['惊蛰', '6', '07:44:24'],
    4: ['清明', '5', '13:01:22'],
    5: ['立夏', '6', '06:50:35'],
    6: ['芒种', '6', '11:22:48'],
    7: ['小暑', '7', '21:45:55'],
    8: ['立秋', '8', '07:25:20'],
    9: ['白露', '8', '09:59:23'],
    10: ['寒露', '9', '01:10:54'],
    11: ['立冬', '8', '03:55:15'],
    12: ['大雪', '7', '20:26:16'],
  },
  1938: {
    1: ['小寒', '6', '07:31:08'],
    2: ['立春', '4', '19:14:58'],
    3: ['惊蛰', '6', '13:33:46'],
    4: ['清明', '5', '18:48:39'],
    5: ['立夏', '6', '12:35:09'],
    6: ['芒种', '6', '17:06:37'],
    7: ['小暑', '8', '03:31:21'],
    8: ['立秋', '8', '13:12:41'],
    9: ['白露', '8', '15:48:08'],
    10: ['寒露', '9', '07:01:24'],
    11: ['立冬', '8', '09:48:19'],
    12: ['大雪', '8', '02:21:58'],
  },
  1939: {
    1: ['小寒', '6', '13:27:51'],
    2: ['立春', '5', '01:10:26'],
    3: ['惊蛰', '6', '19:26:11'],
    4: ['清明', '6', '00:37:24'],
    5: ['立夏', '6', '18:21:02'],
    6: ['芒种', '6', '22:51:38'],
    7: ['小暑', '8', '09:18:20'],
    8: ['立秋', '8', '19:03:27'],
    9: ['白露', '8', '21:42:01'],
    10: ['寒露', '9', '12:56:36'],
    11: ['立冬', '8', '15:43:30'],
    12: ['大雪', '8', '08:17:00'],
  },
  1940: {
    1: ['小寒', '6', '19:23:40'],
    2: ['立春', '5', '07:07:32'],
    3: ['惊蛰', '6', '01:23:58'],
    4: ['清明', '5', '06:34:34'],
    5: ['立夏', '6', '00:16:16'],
    6: ['芒种', '6', '04:44:02'],
    7: ['小暑', '7', '15:08:01'],
    8: ['立秋', '8', '00:51:29'],
    9: ['白露', '8', '03:29:14'],
    10: ['寒露', '8', '18:42:23'],
    11: ['立冬', '7', '21:26:46'],
    12: ['大雪', '7', '13:57:51'],
  },
  1941: {
    1: ['小寒', '6', '01:03:54'],
    2: ['立春', '4', '12:49:44'],
    3: ['惊蛰', '6', '07:10:04'],
    4: ['清明', '5', '12:24:55'],
    5: ['立夏', '6', '06:09:50'],
    6: ['芒种', '6', '10:39:12'],
    7: ['小暑', '7', '21:03:04'],
    8: ['立秋', '8', '06:45:52'],
    9: ['白露', '8', '09:23:48'],
    10: ['寒露', '9', '00:38:12'],
    11: ['立冬', '8', '03:24:03'],
    12: ['大雪', '7', '19:55:58'],
  },
  1942: {
    1: ['小寒', '6', '07:02:18'],
    2: ['立春', '4', '18:48:34'],
    3: ['惊蛰', '6', '13:09:20'],
    4: ['清明', '5', '18:23:50'],
    5: ['立夏', '6', '12:06:50'],
    6: ['芒种', '6', '16:32:31'],
    7: ['小暑', '8', '02:51:46'],
    8: ['立秋', '8', '12:30:18'],
    9: ['白露', '8', '15:06:07'],
    10: ['寒露', '9', '06:21:42'],
    11: ['立冬', '8', '09:11:07'],
    12: ['大雪', '8', '01:46:47'],
  },
  1943: {
    1: ['小寒', '6', '12:54:50'],
    2: ['立春', '5', '00:40:04'],
    3: ['惊蛰', '6', '18:58:30'],
    4: ['清明', '6', '00:11:10'],
    5: ['立夏', '6', '17:53:21'],
    6: ['芒种', '6', '22:18:57'],
    7: ['小暑', '8', '08:38:50'],
    8: ['立秋', '8', '18:18:30'],
    9: ['白露', '8', '20:55:08'],
    10: ['寒露', '9', '12:10:29'],
    11: ['立冬', '8', '14:58:43'],
    12: ['大雪', '8', '07:32:50'],
  },
  1944: {
    1: ['小寒', '6', '18:39:15'],
    2: ['立春', '5', '06:22:55'],
    3: ['惊蛰', '6', '00:40:26'],
    4: ['清明', '5', '05:53:58'],
    5: ['立夏', '5', '23:39:43'],
    6: ['芒种', '6', '04:10:53'],
    7: ['小暑', '7', '14:36:02'],
    8: ['立秋', '8', '00:18:51'],
    9: ['白露', '8', '02:55:32'],
    10: ['寒露', '8', '18:08:43'],
    11: ['立冬', '7', '20:54:39'],
    12: ['大雪', '7', '13:27:38'],
  },
  1945: {
    1: ['小寒', '6', '00:34:26'],
    2: ['立春', '4', '12:19:22'],
    3: ['惊蛰', '6', '06:37:59'],
    4: ['清明', '5', '11:51:46'],
    5: ['立夏', '6', '05:36:35'],
    6: ['芒种', '6', '10:05:24'],
    7: ['小暑', '7', '20:26:46'],
    8: ['立秋', '8', '06:05:03'],
    9: ['白露', '8', '08:38:07'],
    10: ['寒露', '8', '23:49:07'],
    11: ['立冬', '8', '02:34:11'],
    12: ['大雪', '7', '19:07:39'],
  },
  1946: {
    1: ['小寒', '6', '06:16:19'],
    2: ['立春', '4', '18:03:53'],
    3: ['惊蛰', '6', '12:24:38'],
    4: ['清明', '5', '17:38:32'],
    5: ['立夏', '6', '11:21:29'],
    6: ['芒种', '6', '15:48:42'],
    7: ['小暑', '8', '02:10:48'],
    8: ['立秋', '8', '11:51:35'],
    9: ['白露', '8', '14:27:25'],
    10: ['寒露', '9', '05:40:47'],
    11: ['立冬', '8', '08:27:09'],
    12: ['大雪', '8', '01:00:11'],
  },
  1947: {
    1: ['小寒', '6', '12:06:20'],
    2: ['立春', '4', '23:50:21'],
    3: ['惊蛰', '6', '18:07:56'],
    4: ['清明', '5', '23:20:08'],
    5: ['立夏', '6', '17:02:57'],
    6: ['芒种', '6', '21:31:12'],
    7: ['小暑', '8', '07:55:48'],
    8: ['立秋', '8', '17:40:51'],
    9: ['白露', '8', '20:21:03'],
    10: ['寒露', '9', '11:37:17'],
    11: ['立冬', '8', '14:24:22'],
    12: ['大雪', '8', '06:56:11'],
  },
  1948: {
    1: ['小寒', '6', '18:00:13'],
    2: ['立春', '5', '05:42:00'],
    3: ['惊蛰', '5', '23:57:53'],
    4: ['清明', '5', '05:09:20'],
    5: ['立夏', '5', '22:52:13'],
    6: ['芒种', '6', '03:20:19'],
    7: ['小暑', '7', '13:43:28'],
    8: ['立秋', '7', '23:26:17'],
    9: ['白露', '8', '02:04:59'],
    10: ['寒露', '8', '17:20:16'],
    11: ['立冬', '7', '20:06:32'],
    12: ['大雪', '7', '12:37:37'],
  },
  1949: {
    1: ['小寒', '5', '23:41:08'],
    2: ['立春', '4', '11:22:49'],
    3: ['惊蛰', '6', '05:39:16'],
    4: ['清明', '5', '10:51:56'],
    5: ['立夏', '6', '04:36:34'],
    6: ['芒种', '6', '09:06:49'],
    7: ['小暑', '7', '19:31:35'],
    8: ['立秋', '8', '05:14:56'],
    9: ['白露', '8', '07:54:09'],
    10: ['寒露', '8', '23:11:02'],
    11: ['立冬', '8', '01:59:46'],
    12: ['大雪', '7', '18:33:24'],
  },
  1950: {
    1: ['小寒', '6', '05:38:43'],
    2: ['立春', '4', '17:20:46'],
    3: ['惊蛰', '6', '11:35:26'],
    4: ['清明', '5', '16:44:27'],
    5: ['立夏', '6', '10:24:41'],
    6: ['芒种', '6', '14:51:00'],
    7: ['小暑', '8', '01:13:17'],
    8: ['立秋', '8', '10:55:11'],
    9: ['白露', '8', '13:33:39'],
    10: ['寒露', '9', '04:51:39'],
    11: ['立冬', '8', '07:43:43'],
    12: ['大雪', '8', '00:21:40'],
  },
  1951: {
    1: ['小寒', '6', '11:30:22'],
    2: ['立春', '4', '23:13:26'],
    3: ['惊蛰', '6', '17:26:40'],
    4: ['清明', '5', '22:32:38'],
    5: ['立夏', '6', '16:09:15'],
    6: ['芒种', '6', '20:32:32'],
    7: ['小暑', '8', '06:53:51'],
    8: ['立秋', '8', '16:37:26'],
    9: ['白露', '8', '19:18:10'],
    10: ['寒露', '9', '10:36:23'],
    11: ['立冬', '8', '13:26:36'],
    12: ['大雪', '8', '06:02:18'],
  },
  1952: {
    1: ['小寒', '6', '17:09:45'],
    2: ['立春', '5', '04:52:54'],
    3: ['惊蛰', '5', '23:07:18'],
    4: ['清明', '5', '04:15:02'],
    5: ['立夏', '5', '21:54:01'],
    6: ['芒种', '6', '02:20:18'],
    7: ['小暑', '7', '12:44:38'],
    8: ['立秋', '7', '22:30:57'],
    9: ['白露', '8', '01:13:42'],
    10: ['寒露', '8', '16:32:25'],
    11: ['立冬', '7', '19:21:34'],
    12: ['大雪', '7', '11:55:33'],
  },
  1953: {
    1: ['小寒', '5', '23:02:02'],
    2: ['立春', '4', '10:45:53'],
    3: ['惊蛰', '6', '05:02:26'],
    4: ['清明', '5', '10:12:36'],
    5: ['立夏', '6', '03:52:18'],
    6: ['芒种', '6', '08:16:04'],
    7: ['小暑', '7', '18:34:54'],
    8: ['立秋', '8', '04:14:35'],
    9: ['白露', '8', '06:52:43'],
    10: ['寒露', '8', '22:10:25'],
    11: ['立冬', '8', '01:00:57'],
    12: ['大雪', '7', '17:36:59'],
  },
  1954: {
    1: ['小寒', '6', '04:45:17'],
    2: ['立春', '4', '16:30:41'],
    3: ['惊蛰', '6', '10:48:32'],
    4: ['清明', '5', '15:59:10'],
    5: ['立夏', '6', '09:38:10'],
    6: ['芒种', '6', '14:00:49'],
    7: ['小暑', '8', '00:19:10'],
    8: ['立秋', '8', '09:59:04'],
    9: ['白露', '8', '12:37:51'],
    10: ['寒露', '9', '03:57:18'],
    11: ['立冬', '8', '06:50:34'],
    12: ['大雪', '7', '23:28:29'],
  },
  1955: {
    1: ['小寒', '6', '10:35:52'],
    2: ['立春', '4', '22:17:36'],
    3: ['惊蛰', '6', '16:30:57'],
    4: ['清明', '5', '21:38:44'],
    5: ['立夏', '6', '15:17:58'],
    6: ['芒种', '6', '19:43:25'],
    7: ['小暑', '8', '06:05:52'],
    8: ['立秋', '8', '15:50:02'],
    9: ['白露', '8', '18:31:46'],
    10: ['寒露', '9', '09:52:08'],
    11: ['立冬', '8', '12:45:09'],
    12: ['大雪', '8', '05:22:46'],
  },
  1956: {
    1: ['小寒', '6', '16:30:17'],
    2: ['立春', '5', '04:11:55'],
    3: ['惊蛰', '5', '22:24:27'],
    4: ['清明', '5', '03:31:09'],
    5: ['立夏', '5', '21:09:58'],
    6: ['芒种', '6', '01:35:47'],
    7: ['小暑', '7', '11:57:59'],
    8: ['立秋', '7', '21:40:12'],
    9: ['白露', '8', '00:18:56'],
    10: ['寒露', '8', '15:35:53'],
    11: ['立冬', '7', '18:25:54'],
    12: ['大雪', '7', '11:02:06'],
  },
  1957: {
    1: ['小寒', '5', '22:10:25'],
    2: ['立春', '4', '09:54:37'],
    3: ['惊蛰', '6', '04:10:07'],
    4: ['清明', '5', '09:18:49'],
    5: ['立夏', '6', '02:58:22'],
    6: ['芒种', '6', '07:24:43'],
    7: ['小暑', '7', '17:48:09'],
    8: ['立秋', '8', '03:32:03'],
    9: ['白露', '8', '06:12:11'],
    10: ['寒露', '8', '21:29:58'],
    11: ['立冬', '8', '00:20:01'],
    12: ['大雪', '7', '16:55:56'],
  },
  1958: {
    1: ['小寒', '6', '04:04:20'],
    2: ['立春', '4', '15:49:11'],
    3: ['惊蛰', '6', '10:04:52'],
    4: ['清明', '5', '15:12:21'],
    5: ['立夏', '6', '08:49:10'],
    6: ['芒种', '6', '13:12:11'],
    7: ['小暑', '7', '23:33:25'],
    8: ['立秋', '8', '09:17:10'],
    9: ['白露', '8', '11:58:49'],
    10: ['寒露', '9', '03:19:08'],
    11: ['立冬', '8', '06:11:53'],
    12: ['大雪', '7', '22:49:35'],
  },
  1959: {
    1: ['小寒', '6', '09:58:18'],
    2: ['立春', '4', '21:42:10'],
    3: ['惊蛰', '6', '15:56:35'],
    4: ['清明', '5', '21:03:02'],
    5: ['立夏', '6', '14:38:42'],
    6: ['芒种', '6', '19:00:03'],
    7: ['小暑', '8', '05:19:52'],
    8: ['立秋', '8', '15:04:04'],
    9: ['白露', '8', '17:47:54'],
    10: ['寒露', '9', '09:09:48'],
    11: ['立冬', '8', '12:02:03'],
    12: ['大雪', '8', '04:37:16'],
  },
  1960: {
    1: ['小寒', '6', '15:42:27'],
    2: ['立春', '5', '03:23:09'],
    3: ['惊蛰', '5', '21:36:06'],
    4: ['清明', '5', '02:43:33'],
    5: ['立夏', '5', '20:22:33'],
    6: ['芒种', '6', '00:48:34'],
    7: ['小暑', '7', '11:12:39'],
    8: ['立秋', '7', '20:59:44'],
    9: ['白露', '7', '23:45:22'],
    10: ['寒露', '8', '15:08:39'],
    11: ['立冬', '7', '18:02:01'],
    12: ['大雪', '7', '10:37:44'],
  },
  1961: {
    1: ['小寒', '5', '21:42:36'],
    2: ['立春', '4', '09:22:26'],
    3: ['惊蛰', '6', '03:34:39'],
    4: ['清明', '5', '08:42:07'],
    5: ['立夏', '6', '02:21:16'],
    6: ['芒种', '6', '06:46:00'],
    7: ['小暑', '7', '17:06:35'],
    8: ['立秋', '8', '02:48:19'],
    9: ['白露', '8', '05:29:12'],
    10: ['寒露', '8', '20:50:56'],
    11: ['立冬', '7', '23:46:11'],
    12: ['大雪', '7', '16:25:54'],
  },
  1962: {
    1: ['小寒', '6', '03:34:56'],
    2: ['立春', '4', '15:17:20'],
    3: ['惊蛰', '6', '09:29:29'],
    4: ['清明', '5', '14:34:14'],
    5: ['立夏', '6', '08:09:28'],
    6: ['芒种', '6', '12:31:15'],
    7: ['小暑', '7', '22:51:05'],
    8: ['立秋', '8', '08:33:40'],
    9: ['白露', '8', '11:15:20'],
    10: ['寒露', '9', '02:37:53'],
    11: ['立冬', '8', '05:34:54'],
    12: ['大雪', '7', '22:16:39'],
  },
  1963: {
    1: ['小寒', '6', '09:26:26'],
    2: ['立春', '4', '21:07:44'],
    3: ['惊蛰', '6', '15:17:09'],
    4: ['清明', '5', '20:18:39'],
    5: ['立夏', '6', '13:51:57'],
    6: ['芒种', '6', '18:14:26'],
    7: ['小暑', '8', '04:37:37'],
    8: ['立秋', '8', '14:25:24'],
    9: ['白露', '8', '17:11:50'],
    10: ['寒露', '9', '08:36:14'],
    11: ['立冬', '8', '11:32:19'],
    12: ['大雪', '8', '04:12:36'],
  },
  1964: {
    1: ['小寒', '6', '15:22:20'],
    2: ['立春', '5', '03:04:55'],
    3: ['惊蛰', '5', '21:15:59'],
    4: ['清明', '5', '02:18:20'],
    5: ['立夏', '5', '19:51:01'],
    6: ['芒种', '6', '00:11:43'],
    7: ['小暑', '7', '10:32:07'],
    8: ['立秋', '7', '20:16:09'],
    9: ['白露', '7', '22:59:26'],
    10: ['寒露', '8', '14:21:30'],
    11: ['立冬', '7', '17:15:06'],
    12: ['大雪', '7', '09:53:03'],
  },
  1965: {
    1: ['小寒', '5', '21:01:57'],
    2: ['立春', '4', '08:46:06'],
    3: ['惊蛰', '6', '03:00:38'],
    4: ['清明', '5', '08:06:43'],
    5: ['立夏', '6', '01:41:32'],
    6: ['芒种', '6', '06:02:06'],
    7: ['小暑', '7', '16:21:22'],
    8: ['立秋', '8', '02:04:36'],
    9: ['白露', '8', '04:47:50'],
    10: ['寒露', '8', '20:11:07'],
    11: ['立冬', '7', '23:06:32'],
    12: ['大雪', '7', '15:45:32'],
  },
  1966: {
    1: ['小寒', '6', '02:54:20'],
    2: ['立春', '4', '14:37:48'],
    3: ['惊蛰', '6', '08:51:21'],
    4: ['清明', '5', '13:56:29'],
    5: ['立夏', '6', '07:30:26'],
    6: ['芒种', '6', '11:49:37'],
    7: ['小暑', '7', '22:06:59'],
    8: ['立秋', '8', '07:48:56'],
    9: ['白露', '8', '10:32:01'],
    10: ['寒露', '9', '01:56:43'],
    11: ['立冬', '8', '04:55:15'],
    12: ['大雪', '7', '21:37:45'],
  },
  1967: {
    1: ['小寒', '6', '08:48:19'],
    2: ['立春', '4', '20:30:49'],
    3: ['惊蛰', '6', '14:41:53'],
    4: ['清明', '5', '19:44:41'],
    5: ['立夏', '6', '13:17:26'],
    6: ['芒种', '6', '17:36:18'],
    7: ['小暑', '8', '03:53:19'],
    8: ['立秋', '8', '13:34:51'],
    9: ['白露', '8', '16:17:42'],
    10: ['寒露', '9', '07:41:11'],
    11: ['立冬', '8', '10:37:23'],
    12: ['大雪', '8', '03:17:28'],
  },
  1968: {
    1: ['小寒', '6', '14:26:10'],
    2: ['立春', '5', '02:07:23'],
    3: ['惊蛰', '5', '20:17:45'],
    4: ['清明', '5', '01:20:53'],
    5: ['立夏', '5', '18:55:47'],
    6: ['芒种', '5', '23:19:05'],
    7: ['小暑', '7', '09:41:37'],
    8: ['立秋', '7', '19:27:11'],
    9: ['白露', '7', '22:11:24'],
    10: ['寒露', '8', '13:34:23'],
    11: ['立冬', '7', '16:29:17'],
    12: ['大雪', '7', '09:08:15'],
  },
  1969: {
    1: ['小寒', '5', '20:16:48'],
    2: ['立春', '4', '07:58:52'],
    3: ['惊蛰', '6', '02:10:34'],
    4: ['清明', '5', '07:14:51'],
    5: ['立夏', '6', '00:49:47'],
    6: ['芒种', '6', '05:11:29'],
    7: ['小暑', '7', '15:31:31'],
    8: ['立秋', '8', '01:14:06'],
    9: ['白露', '8', '03:55:25'],
    10: ['寒露', '8', '19:16:40'],
    11: ['立冬', '7', '22:11:20'],
    12: ['大雪', '7', '14:51:18'],
  },
  1970: {
    1: ['小寒', '6', '02:01:39'],
    2: ['立春', '4', '13:45:42'],
    3: ['惊蛰', '6', '07:58:27'],
    4: ['清明', '5', '13:01:44'],
    5: ['立夏', '6', '06:33:47'],
    6: ['芒种', '6', '10:52:13'],
    7: ['小暑', '7', '21:10:31'],
    8: ['立秋', '8', '06:54:06'],
    9: ['白露', '8', '09:37:53'],
    10: ['寒露', '9', '01:01:32'],
    11: ['立冬', '8', '03:57:43'],
    12: ['大雪', '7', '20:37:19'],
  },
  1971: {
    1: ['小寒', '6', '07:45:06'],
    2: ['立春', '4', '19:25:25'],
    3: ['惊蛰', '6', '13:34:44'],
    4: ['清明', '5', '18:36:00'],
    5: ['立夏', '6', '12:08:08'],
    6: ['芒种', '6', '16:28:51'],
    7: ['小暑', '8', '02:51:07'],
    8: ['立秋', '8', '12:40:12'],
    9: ['白露', '8', '15:30:12'],
    10: ['寒露', '9', '06:58:34'],
    11: ['立冬', '8', '09:56:37'],
    12: ['大雪', '8', '02:35:42'],
  },
  1972: {
    1: ['小寒', '6', '13:41:50'],
    2: ['立春', '5', '01:20:13'],
    3: ['惊蛰', '5', '19:28:04'],
    4: ['清明', '5', '00:28:50'],
    5: ['立夏', '5', '18:01:10'],
    6: ['芒种', '5', '22:21:59'],
    7: ['小暑', '7', '08:42:53'],
    8: ['立秋', '7', '18:28:29'],
    9: ['白露', '7', '21:15:06'],
    10: ['寒露', '8', '12:41:45'],
    11: ['立冬', '7', '15:39:23'],
    12: ['大雪', '7', '08:18:42'],
  },
  1973: {
    1: ['小寒', '5', '19:25:19'],
    2: ['立春', '4', '07:04:12'],
    3: ['惊蛰', '6', '01:12:36'],
    4: ['清明', '5', '06:13:53'],
    5: ['立夏', '5', '23:46:23'],
    6: ['芒种', '6', '04:06:50'],
    7: ['小暑', '7', '14:27:21'],
    8: ['立秋', '8', '00:12:48'],
    9: ['白露', '8', '02:59:24'],
    10: ['寒露', '8', '18:27:15'],
    11: ['立冬', '7', '21:27:38'],
    12: ['大雪', '7', '14:10:23'],
  },
  1974: {
    1: ['小寒', '6', '01:19:55'],
    2: ['立春', '4', '13:00:05'],
    3: ['惊蛰', '6', '07:07:06'],
    4: ['清明', '5', '12:05:00'],
    5: ['立夏', '6', '05:33:52'],
    6: ['芒种', '6', '09:51:39'],
    7: ['小暑', '7', '20:11:06'],
    8: ['立秋', '8', '05:57:10'],
    9: ['白露', '8', '08:45:04'],
    10: ['寒露', '9', '00:14:39'],
    11: ['立冬', '8', '03:17:58'],
    12: ['大雪', '7', '20:04:37'],
  },
  1975: {
    1: ['小寒', '6', '07:17:30'],
    2: ['立春', '4', '18:59:12'],
    3: ['惊蛰', '6', '13:05:47'],
    4: ['清明', '5', '18:01:30'],
    5: ['立夏', '6', '11:27:11'],
    6: ['芒种', '6', '15:42:01'],
    7: ['小暑', '8', '01:59:24'],
    8: ['立秋', '8', '11:44:53'],
    9: ['白露', '8', '14:33:17'],
    10: ['寒露', '9', '06:02:04'],
    11: ['立冬', '8', '09:02:36'],
    12: ['大雪', '8', '01:46:09'],
  },
  1976: {
    1: ['小寒', '6', '12:57:22'],
    2: ['立春', '5', '00:39:28'],
    3: ['惊蛰', '5', '18:48:06'],
    4: ['清明', '4', '23:46:27'],
    5: ['立夏', '5', '17:14:24'],
    6: ['芒种', '5', '21:31:13'],
    7: ['小暑', '7', '07:50:50'],
    8: ['立秋', '7', '17:38:21'],
    9: ['白露', '7', '20:28:12'],
    10: ['寒露', '8', '11:58:03'],
    11: ['立冬', '7', '14:58:34'],
    12: ['大雪', '7', '07:40:56'],
  },
  1977: {
    1: ['小寒', '5', '18:51:03'],
    2: ['立春', '4', '06:33:25'],
    3: ['惊蛰', '6', '00:44:09'],
    4: ['清明', '5', '05:45:44'],
    5: ['立夏', '5', '23:16:00'],
    6: ['芒种', '6', '03:32:01'],
    7: ['小暑', '7', '13:47:52'],
    8: ['立秋', '7', '23:30:14'],
    9: ['白露', '8', '02:15:41'],
    10: ['寒露', '8', '17:43:56'],
    11: ['立冬', '7', '20:45:49'],
    12: ['大雪', '7', '13:30:49'],
  },
  1978: {
    1: ['小寒', '6', '00:43:12'],
    2: ['立春', '4', '12:26:57'],
    3: ['惊蛰', '6', '06:38:11'],
    4: ['清明', '5', '11:39:20'],
    5: ['立夏', '6', '05:08:32'],
    6: ['芒种', '6', '09:23:05'],
    7: ['小暑', '7', '19:36:57'],
    8: ['立秋', '8', '05:17:40'],
    9: ['白露', '8', '08:02:24'],
    10: ['寒露', '8', '23:30:54'],
    11: ['立冬', '8', '02:34:01'],
    12: ['大雪', '7', '19:20:01'],
  },
  1979: {
    1: ['小寒', '6', '06:31:33'],
    2: ['立春', '4', '18:12:18'],
    3: ['惊蛰', '6', '12:19:38'],
    4: ['清明', '5', '17:17:57'],
    5: ['立夏', '6', '10:47:10'],
    6: ['芒种', '6', '15:05:11'],
    7: ['小暑', '8', '01:24:37'],
    8: ['立秋', '8', '11:10:53'],
    9: ['白露', '8', '13:59:45'],
    10: ['寒露', '9', '05:30:02'],
    11: ['立冬', '8', '08:32:47'],
    12: ['大雪', '8', '01:17:48'],
  },
  1980: {
    1: ['小寒', '6', '12:28:53'],
    2: ['立春', '5', '00:09:28'],
    3: ['惊蛰', '5', '18:16:29'],
    4: ['清明', '4', '23:14:42'],
    5: ['立夏', '5', '16:44:28'],
    6: ['芒种', '5', '21:03:44'],
    7: ['小暑', '7', '07:23:56'],
    8: ['立秋', '7', '17:08:30'],
    9: ['白露', '7', '19:53:27'],
    10: ['寒露', '8', '11:19:14'],
    11: ['立冬', '7', '14:18:13'],
    12: ['大雪', '7', '07:01:15'],
  },
  1981: {
    1: ['小寒', '5', '18:12:38'],
    2: ['立春', '4', '05:55:23'],
    3: ['惊蛰', '6', '00:05:07'],
    4: ['清明', '5', '05:05:02'],
    5: ['立夏', '5', '22:34:47'],
    6: ['芒种', '6', '02:52:39'],
    7: ['小暑', '7', '13:11:52'],
    8: ['立秋', '7', '22:57:09'],
    9: ['白露', '8', '01:43:13'],
    10: ['寒露', '8', '17:09:32'],
    11: ['立冬', '7', '20:08:29'],
    12: ['大雪', '7', '12:51:15'],
  },
  1982: {
    1: ['小寒', '6', '00:02:35'],
    2: ['立春', '4', '11:45:28'],
    3: ['惊蛰', '6', '05:54:34'],
    4: ['清明', '5', '10:52:41'],
    5: ['立夏', '6', '04:19:59'],
    6: ['芒种', '6', '08:35:53'],
    7: ['小暑', '7', '18:54:35'],
    8: ['立秋', '8', '04:41:45'],
    9: ['白露', '8', '07:31:43'],
    10: ['寒露', '8', '23:02:09'],
    11: ['立冬', '8', '02:04:06'],
    12: ['大雪', '7', '18:48:05'],
  },
  1983: {
    1: ['小寒', '6', '05:58:42'],
    2: ['立春', '4', '17:39:42'],
    3: ['惊蛰', '6', '11:47:12'],
    4: ['清明', '5', '16:44:23'],
    5: ['立夏', '6', '10:10:51'],
    6: ['芒种', '6', '14:25:42'],
    7: ['小暑', '8', '00:43:13'],
    8: ['立秋', '8', '10:29:37'],
    9: ['白露', '8', '13:20:03'],
    10: ['寒露', '9', '04:51:04'],
    11: ['立冬', '8', '07:52:12'],
    12: ['大雪', '8', '00:33:40'],
  },
  1984: {
    1: ['小寒', '6', '11:40:51'],
    2: ['立春', '4', '23:18:44'],
    3: ['惊蛰', '5', '17:24:39'],
    4: ['清明', '4', '22:22:20'],
    5: ['立夏', '5', '15:50:57'],
    6: ['芒种', '5', '20:08:37'],
    7: ['小暑', '7', '06:29:06'],
    8: ['立秋', '7', '16:17:53'],
    9: ['白露', '7', '19:09:50'],
    10: ['寒露', '8', '10:42:35'],
    11: ['立冬', '7', '13:45:32'],
    12: ['大雪', '7', '06:28:03'],
  },
  1985: {
    1: ['小寒', '5', '17:35:05'],
    2: ['立春', '4', '05:11:47'],
    3: ['惊蛰', '5', '23:16:21'],
    4: ['清明', '5', '04:13:35'],
    5: ['立夏', '5', '21:42:32'],
    6: ['芒种', '6', '01:59:56'],
    7: ['小暑', '7', '12:18:35'],
    8: ['立秋', '7', '22:04:16'],
    9: ['白露', '8', '00:53:01'],
    10: ['寒露', '8', '16:24:33'],
    11: ['立冬', '7', '19:29:29'],
    12: ['大雪', '7', '12:16:21'],
  },
  1986: {
    1: ['小寒', '5', '23:28:02'],
    2: ['立春', '4', '11:07:42'],
    3: ['惊蛰', '6', '05:12:08'],
    4: ['清明', '5', '10:06:07'],
    5: ['立夏', '6', '03:30:36'],
    6: ['芒种', '6', '07:44:23'],
    7: ['小暑', '7', '18:00:45'],
    8: ['立秋', '8', '03:45:36'],
    9: ['白露', '8', '06:34:37'],
    10: ['寒露', '8', '22:06:45'],
    11: ['立冬', '8', '01:12:49'],
    12: ['大雪', '7', '18:00:56'],
  },
  1987: {
    1: ['小寒', '6', '05:13:00'],
    2: ['立春', '4', '16:51:40'],
    3: ['惊蛰', '6', '10:53:37'],
    4: ['清明', '5', '15:44:08'],
    5: ['立夏', '6', '09:05:35'],
    6: ['芒种', '6', '13:18:58'],
    7: ['小暑', '7', '23:38:39'],
    8: ['立秋', '8', '09:29:13'],
    9: ['白露', '8', '12:24:07'],
    10: ['寒露', '9', '03:59:40'],
    11: ['立冬', '8', '07:05:40'],
    12: ['大雪', '7', '23:52:12'],
  },
  1988: {
    1: ['小寒', '6', '11:03:30'],
    2: ['立春', '4', '22:42:49'],
    3: ['惊蛰', '5', '16:46:32'],
    4: ['清明', '4', '21:39:04'],
    5: ['立夏', '5', '15:01:43'],
    6: ['芒种', '5', '19:14:53'],
    7: ['小暑', '7', '05:32:54'],
    8: ['立秋', '7', '15:20:15'],
    9: ['白露', '7', '18:11:31'],
    10: ['寒露', '8', '09:44:30'],
    11: ['立冬', '7', '12:48:55'],
    12: ['大雪', '7', '05:34:28'],
  },
  1989: {
    1: ['小寒', '5', '16:45:55'],
    2: ['立春', '4', '04:27:09'],
    3: ['惊蛰', '5', '22:34:08'],
    4: ['清明', '5', '03:29:54'],
    5: ['立夏', '5', '20:53:55'],
    6: ['芒种', '6', '01:05:13'],
    7: ['小暑', '7', '11:19:25'],
    8: ['立秋', '7', '21:03:52'],
    9: ['白露', '7', '23:53:53'],
    10: ['寒露', '8', '15:27:19'],
    11: ['立冬', '7', '18:33:32'],
    12: ['大雪', '7', '11:20:57'],
  },
  1990: {
    1: ['小寒', '5', '22:33:14'],
    2: ['立春', '4', '10:14:00'],
    3: ['惊蛰', '6', '04:19:18'],
    4: ['清明', '5', '09:12:56'],
    5: ['立夏', '6', '02:35:26'],
    6: ['芒种', '6', '06:46:18'],
    7: ['小暑', '7', '17:00:28'],
    8: ['立秋', '8', '02:45:32'],
    9: ['白露', '8', '05:37:28'],
    10: ['寒露', '8', '21:13:49'],
    11: ['立冬', '8', '00:23:30'],
    12: ['大雪', '7', '17:14:10'],
  },
  1991: {
    1: ['小寒', '6', '04:28:07'],
    2: ['立春', '4', '16:08:24'],
    3: ['惊蛰', '6', '10:12:15'],
    4: ['清明', '5', '15:04:42'],
    5: ['立夏', '6', '08:26:53'],
    6: ['芒种', '6', '12:38:17'],
    7: ['小暑', '7', '22:52:59'],
    8: ['立秋', '8', '08:37:15'],
    9: ['白露', '8', '11:27:21'],
    10: ['寒露', '9', '03:01:07'],
    11: ['立冬', '8', '06:07:50'],
    12: ['大雪', '7', '22:56:00'],
  },
  1992: {
    1: ['小寒', '6', '10:08:31'],
    2: ['立春', '4', '21:48:17'],
    3: ['惊蛰', '5', '15:52:08'],
    4: ['清明', '4', '20:45:08'],
    5: ['立夏', '5', '14:08:40'],
    6: ['芒种', '5', '18:22:19'],
    7: ['小暑', '7', '04:40:15'],
    8: ['立秋', '7', '14:27:24'],
    9: ['白露', '7', '17:18:20'],
    10: ['寒露', '8', '08:51:29'],
    11: ['立冬', '7', '11:57:02'],
    12: ['大雪', '7', '04:44:12'],
  },
  1993: {
    1: ['小寒', '5', '15:56:31'],
    2: ['立春', '4', '03:37:09'],
    3: ['惊蛰', '5', '21:42:32'],
    4: ['清明', '5', '02:37:11'],
    5: ['立夏', '5', '20:01:43'],
    6: ['芒种', '6', '00:15:13'],
    7: ['小暑', '7', '10:32:02'],
    8: ['立秋', '7', '20:17:58'],
    9: ['白露', '7', '23:07:47'],
    10: ['寒露', '8', '14:40:02'],
    11: ['立冬', '7', '17:45:33'],
    12: ['大雪', '7', '10:33:49'],
  },
  1994: {
    1: ['小寒', '5', '21:48:07'],
    2: ['立春', '4', '09:30:56'],
    3: ['惊蛰', '6', '03:37:42'],
    4: ['清明', '5', '08:31:48'],
    5: ['立夏', '6', '01:54:05'],
    6: ['芒种', '6', '06:04:52'],
    7: ['小暑', '7', '16:19:22'],
    8: ['立秋', '8', '02:04:22'],
    9: ['白露', '8', '04:55:07'],
    10: ['寒露', '8', '20:29:05'],
    11: ['立冬', '7', '23:35:36'],
    12: ['大雪', '7', '16:22:53'],
  },
  1995: {
    1: ['小寒', '6', '03:34:05'],
    2: ['立春', '4', '15:12:51'],
    3: ['惊蛰', '6', '09:16:04'],
    4: ['清明', '5', '14:08:06'],
    5: ['立夏', '6', '07:30:03'],
    6: ['芒种', '6', '11:42:28'],
    7: ['小暑', '7', '22:01:00'],
    8: ['立秋', '8', '07:51:44'],
    9: ['白露', '8', '10:48:34'],
    10: ['寒露', '9', '02:27:12'],
    11: ['立冬', '8', '05:35:35'],
    12: ['大雪', '7', '22:22:15'],
  },
  1996: {
    1: ['小寒', '6', '09:31:27'],
    2: ['立春', '4', '21:07:54'],
    3: ['惊蛰', '5', '15:09:39'],
    4: ['清明', '4', '20:02:01'],
    5: ['立夏', '5', '13:26:02'],
    6: ['芒种', '5', '17:40:47'],
    7: ['小暑', '7', '04:00:00'],
    8: ['立秋', '7', '13:48:49'],
    9: ['白露', '7', '16:42:25'],
    10: ['寒露', '8', '08:18:42'],
    11: ['立冬', '7', '11:26:33'],
    12: ['大雪', '7', '04:14:00'],
  },
  1997: {
    1: ['小寒', '5', '15:24:28'],
    2: ['立春', '4', '03:01:57'],
    3: ['惊蛰', '5', '21:04:07'],
    4: ['清明', '5', '01:56:16'],
    5: ['立夏', '5', '19:19:26'],
    6: ['芒种', '5', '23:32:31'],
    7: ['小暑', '7', '09:49:23'],
    8: ['立秋', '7', '19:36:18'],
    9: ['白露', '7', '22:28:49'],
    10: ['寒露', '8', '14:05:10'],
    11: ['立冬', '7', '17:14:38'],
    12: ['大雪', '7', '10:04:52'],
  },
  1998: {
    1: ['小寒', '5', '21:18:09'],
    2: ['立春', '4', '08:56:52'],
    3: ['惊蛰', '6', '02:57:15'],
    4: ['清明', '5', '07:44:57'],
    5: ['立夏', '6', '01:03:10'],
    6: ['芒种', '6', '05:13:22'],
    7: ['小暑', '7', '15:30:25'],
    8: ['立秋', '8', '01:19:50'],
    9: ['白露', '8', '04:15:55'],
    10: ['寒露', '8', '19:55:45'],
    11: ['立冬', '7', '23:08:23'],
    12: ['大雪', '7', '16:01:35'],
  },
  1999: {
    1: ['小寒', '6', '03:17:09'],
    2: ['立春', '4', '14:57:03'],
    3: ['惊蛰', '6', '08:57:42'],
    4: ['清明', '5', '13:44:37'],
    5: ['立夏', '6', '07:01:00'],
    6: ['芒种', '6', '11:09:07'],
    7: ['小暑', '7', '21:24:59'],
    8: ['立秋', '8', '07:14:06'],
    9: ['白露', '8', '10:09:59'],
    10: ['寒露', '9', '01:48:21'],
    11: ['立冬', '8', '04:57:51'],
    12: ['大雪', '7', '21:47:27'],
  },
  2000: {
    1: ['小寒', '6', '09:00:42'],
    2: ['立春', '4', '20:40:24'],
    3: ['惊蛰', '5', '14:42:40'],
    4: ['清明', '4', '19:31:58'],
    5: ['立夏', '5', '12:50:10'],
    6: ['芒种', '5', '16:58:34'],
    7: ['小暑', '7', '03:13:56'],
    8: ['立秋', '7', '13:02:59'],
    9: ['白露', '7', '15:59:10'],
    10: ['寒露', '8', '07:38:13'],
    11: ['立冬', '7', '10:48:04'],
    12: ['大雪', '7', '03:37:02'],
  },
  2001: {
    1: ['小寒', '5', '14:49:16'],
    2: ['立春', '4', '02:28:49'],
    3: ['惊蛰', '5', '20:32:28'],
    4: ['清明', '5', '01:24:22'],
    5: ['立夏', '5', '18:44:50'],
    6: ['芒种', '5', '22:53:35'],
    7: ['小暑', '7', '09:06:42'],
    8: ['立秋', '7', '18:52:21'],
    9: ['白露', '7', '21:46:11'],
    10: ['寒露', '8', '13:25:01'],
    11: ['立冬', '7', '16:36:52'],
    12: ['大雪', '7', '09:28:53'],
  },
  2002: {
    1: ['小寒', '5', '20:43:30'],
    2: ['立春', '4', '08:24:05'],
    3: ['惊蛰', '6', '02:27:33'],
    4: ['清明', '5', '07:18:17'],
    5: ['立夏', '6', '00:37:18'],
    6: ['芒种', '6', '04:44:46'],
    7: ['小暑', '7', '14:56:11'],
    8: ['立秋', '8', '00:39:18'],
    9: ['白露', '8', '03:31:02'],
    10: ['寒露', '8', '19:09:18'],
    11: ['立冬', '7', '22:21:49'],
    12: ['大雪', '7', '15:14:14'],
  },
  2003: {
    1: ['小寒', '6', '02:27:43'],
    2: ['立春', '4', '14:05:20'],
    3: ['惊蛰', '6', '08:04:52'],
    4: ['清明', '5', '12:52:29'],
    5: ['立夏', '6', '06:10:29'],
    6: ['芒种', '6', '10:19:43'],
    7: ['小暑', '7', '20:35:39'],
    8: ['立秋', '8', '06:24:18'],
    9: ['白露', '8', '09:20:14'],
    10: ['寒露', '9', '01:00:33'],
    11: ['立冬', '8', '04:13:11'],
    12: ['大雪', '7', '21:05:09'],
  },
  2004: {
    1: ['小寒', '6', '08:18:33'],
    2: ['立春', '4', '19:56:13'],
    3: ['惊蛰', '5', '13:55:38'],
    4: ['清明', '4', '18:43:19'],
    5: ['立夏', '5', '12:02:28'],
    6: ['芒种', '5', '16:13:46'],
    7: ['小暑', '7', '02:31:16'],
    8: ['立秋', '7', '12:19:36'],
    9: ['白露', '7', '15:12:55'],
    10: ['寒露', '8', '06:49:18'],
    11: ['立冬', '7', '09:58:33'],
    12: ['大雪', '7', '02:48:57'],
  },
  2005: {
    1: ['小寒', '5', '14:02:59'],
    2: ['立春', '4', '01:43:02'],
    3: ['惊蛰', '5', '19:45:10'],
    4: ['清明', '5', '00:34:17'],
    5: ['立夏', '5', '17:52:50'],
    6: ['芒种', '5', '22:01:52'],
    7: ['小暑', '7', '08:16:34'],
    8: ['立秋', '7', '18:03:21'],
    9: ['白露', '7', '20:56:40'],
    10: ['寒露', '8', '12:33:18'],
    11: ['立冬', '7', '15:42:26'],
    12: ['大雪', '7', '08:32:41'],
  },
  2006: {
    1: ['小寒', '5', '19:46:57'],
    2: ['立春', '4', '07:27:16'],
    3: ['惊蛰', '6', '01:28:40'],
    4: ['清明', '5', '06:15:31'],
    5: ['立夏', '5', '23:30:39'],
    6: ['芒种', '6', '03:36:59'],
    7: ['小暑', '7', '13:51:27'],
    8: ['立秋', '7', '23:40:47'],
    9: ['白露', '8', '02:39:01'],
    10: ['寒露', '8', '18:21:23'],
    11: ['立冬', '7', '21:34:51'],
    12: ['大雪', '7', '14:26:49'],
  },
  2007: {
    1: ['小寒', '6', '01:40:10'],
    2: ['立春', '4', '13:18:12'],
    3: ['惊蛰', '6', '07:17:59'],
    4: ['清明', '5', '12:04:39'],
    5: ['立夏', '6', '05:20:23'],
    6: ['芒种', '6', '09:27:04'],
    7: ['小暑', '7', '19:41:44'],
    8: ['立秋', '8', '05:31:14'],
    9: ['白露', '8', '08:29:28'],
    10: ['寒露', '9', '00:11:29'],
    11: ['立冬', '8', '03:24:01'],
    12: ['大雪', '7', '20:14:04'],
  },
  2008: {
    1: ['小寒', '6', '07:24:50'],
    2: ['立春', '4', '19:00:24'],
    3: ['惊蛰', '5', '12:58:48'],
    4: ['清明', '4', '17:45:51'],
    5: ['立夏', '5', '11:03:25'],
    6: ['芒种', '5', '15:11:43'],
    7: ['小暑', '7', '01:26:49'],
    8: ['立秋', '7', '11:16:10'],
    9: ['白露', '7', '14:14:08'],
    10: ['寒露', '8', '05:56:37'],
    11: ['立冬', '7', '09:10:33'],
    12: ['大雪', '7', '02:02:17'],
  },
  2009: {
    1: ['小寒', '5', '13:14:07'],
    2: ['立春', '4', '00:49:47'],
    3: ['惊蛰', '5', '18:47:31'],
    4: ['清明', '4', '23:33:46'],
    5: ['立夏', '5', '16:50:49'],
    6: ['芒种', '5', '20:59:03'],
    7: ['小暑', '7', '07:13:29'],
    8: ['立秋', '7', '17:01:09'],
    9: ['白露', '7', '19:57:36'],
    10: ['寒露', '8', '11:40:03'],
    11: ['立冬', '7', '14:56:15'],
    12: ['大雪', '7', '07:52:14'],
  },
  2010: {
    1: ['小寒', '5', '19:08:46'],
    2: ['立春', '4', '06:47:51'],
    3: ['惊蛰', '6', '00:46:21'],
    4: ['清明', '5', '05:30:29'],
    5: ['立夏', '5', '22:44:01'],
    6: ['芒种', '6', '02:49:23'],
    7: ['小暑', '7', '13:02:23'],
    8: ['立秋', '7', '22:49:07'],
    9: ['白露', '8', '01:44:40'],
    10: ['寒露', '8', '17:26:29'],
    11: ['立冬', '7', '20:42:29'],
    12: ['大雪', '7', '13:38:22'],
  },
  2011: {
    1: ['小寒', '6', '00:54:37'],
    2: ['立春', '4', '12:32:56'],
    3: ['惊蛰', '6', '06:29:58'],
    4: ['清明', '5', '11:11:58'],
    5: ['立夏', '6', '04:23:12'],
    6: ['芒种', '6', '08:27:20'],
    7: ['小暑', '7', '18:42:00'],
    8: ['立秋', '8', '04:33:26'],
    9: ['白露', '8', '07:34:13'],
    10: ['寒露', '8', '23:19:05'],
    11: ['立冬', '8', '02:34:55'],
    12: ['大雪', '7', '19:28:59'],
  },
  2012: {
    1: ['小寒', '6', '06:43:54'],
    2: ['立春', '4', '18:22:23'],
    3: ['惊蛰', '5', '12:21:02'],
    4: ['清明', '4', '17:05:36'],
    5: ['立夏', '5', '10:19:40'],
    6: ['芒种', '5', '14:25:53'],
    7: ['小暑', '7', '00:40:43'],
    8: ['立秋', '7', '10:30:32'],
    9: ['白露', '7', '13:29:00'],
    10: ['寒露', '8', '05:11:42'],
    11: ['立冬', '7', '08:25:56'],
    12: ['大雪', '7', '01:18:55'],
  },
  2013: {
    1: ['小寒', '5', '12:33:37'],
    2: ['立春', '4', '00:13:25'],
    3: ['惊蛰', '5', '18:14:51'],
    4: ['清明', '4', '23:02:27'],
    5: ['立夏', '5', '16:18:09'],
    6: ['芒种', '5', '20:23:19'],
    7: ['小暑', '7', '06:34:36'],
    8: ['立秋', '7', '16:20:21'],
    9: ['白露', '7', '19:16:16'],
    10: ['寒露', '8', '10:58:29'],
    11: ['立冬', '7', '14:13:52'],
    12: ['大雪', '7', '07:08:31'],
  },
  2014: {
    1: ['小寒', '5', '18:24:10'],
    2: ['立春', '4', '06:03:15'],
    3: ['惊蛰', '6', '00:02:15'],
    4: ['清明', '5', '04:46:39'],
    5: ['立夏', '5', '21:59:25'],
    6: ['芒种', '6', '02:03:02'],
    7: ['小暑', '7', '12:14:45'],
    8: ['立秋', '7', '22:02:28'],
    9: ['白露', '8', '01:01:25'],
    10: ['寒露', '8', '16:47:29'],
    11: ['立冬', '7', '20:06:40'],
    12: ['大雪', '7', '13:04:05'],
  },
  2015: {
    1: ['小寒', '6', '00:20:32'],
    2: ['立春', '4', '11:58:27'],
    3: ['惊蛰', '6', '05:55:39'],
    4: ['清明', '5', '10:39:07'],
    5: ['立夏', '6', '03:52:35'],
    6: ['芒种', '6', '07:58:09'],
    7: ['小暑', '7', '18:12:14'],
    8: ['立秋', '8', '04:01:23'],
    9: ['白露', '8', '06:59:33'],
    10: ['寒露', '8', '22:42:47'],
    11: ['立冬', '8', '01:58:36'],
    12: ['大雪', '7', '18:53:19'],
  },
  2016: {
    1: ['小寒', '6', '06:08:21'],
    2: ['立春', '4', '17:46:00'],
    3: ['惊蛰', '5', '11:43:30'],
    4: ['清明', '4', '16:27:29'],
    5: ['立夏', '5', '09:41:50'],
    6: ['芒种', '5', '13:48:28'],
    7: ['小暑', '7', '00:03:18'],
    8: ['立秋', '7', '09:52:58'],
    9: ['白露', '7', '12:51:02'],
    10: ['寒露', '8', '04:33:20'],
    11: ['立冬', '7', '07:47:38'],
    12: ['大雪', '7', '00:41:05'],
  },
  2017: {
    1: ['小寒', '5', '11:55:42'],
    2: ['立春', '3', '23:34:01'],
    3: ['惊蛰', '5', '17:32:40'],
    4: ['清明', '4', '22:17:16'],
    5: ['立夏', '5', '15:30:59'],
    6: ['芒种', '5', '19:36:33'],
    7: ['小暑', '7', '05:50:38'],
    8: ['立秋', '7', '15:39:58'],
    9: ['白露', '7', '18:38:34'],
    10: ['寒露', '8', '10:22:05'],
    11: ['立冬', '7', '13:37:45'],
    12: ['大雪', '7', '06:32:35'],
  },
  2018: {
    1: ['小寒', '5', '17:48:41'],
    2: ['立春', '4', '05:28:25'],
    3: ['惊蛰', '5', '23:28:06'],
    4: ['清明', '5', '04:12:43'],
    5: ['立夏', '5', '21:25:18'],
    6: ['芒种', '6', '01:29:04'],
    7: ['小暑', '7', '11:41:47'],
    8: ['立秋', '7', '21:30:34'],
    9: ['白露', '8', '00:29:37'],
    10: ['寒露', '8', '16:14:37'],
    11: ['立冬', '7', '19:31:39'],
    12: ['大雪', '7', '12:25:48'],
  },
  2019: {
    1: ['小寒', '5', '23:38:52'],
    2: ['立春', '4', '11:14:14'],
    3: ['惊蛰', '6', '05:09:39'],
    4: ['清明', '5', '09:51:21'],
    5: ['立夏', '6', '03:02:40'],
    6: ['芒种', '6', '07:06:18'],
    7: ['小暑', '7', '17:20:25'],
    8: ['立秋', '8', '03:12:57'],
    9: ['白露', '8', '06:16:46'],
    10: ['寒露', '8', '22:05:32'],
    11: ['立冬', '8', '01:24:15'],
    12: ['大雪', '7', '18:18:21'],
  },
  2020: {
    1: ['小寒', '6', '05:29:59'],
    2: ['立春', '4', '17:03:12'],
    3: ['惊蛰', '5', '10:56:44'],
    4: ['清明', '4', '15:38:02'],
    5: ['立夏', '5', '08:51:16'],
    6: ['芒种', '5', '12:58:18'],
    7: ['小暑', '6', '23:14:20'],
    8: ['立秋', '7', '09:06:03'],
    9: ['白露', '7', '12:07:54'],
    10: ['寒露', '8', '03:55:07'],
    11: ['立冬', '7', '07:13:46'],
    12: ['大雪', '7', '00:09:21'],
  },
  2021: {
    1: ['小寒', '5', '11:23:17'],
    2: ['立春', '3', '22:58:39'],
    3: ['惊蛰', '5', '16:53:32'],
    4: ['清明', '4', '21:34:58'],
    5: ['立夏', '5', '14:47:01'],
    6: ['芒种', '5', '18:51:57'],
    7: ['小暑', '7', '05:05:19'],
    8: ['立秋', '7', '14:53:48'],
    9: ['白露', '7', '17:52:46'],
    10: ['寒露', '8', '09:38:53'],
    11: ['立冬', '7', '12:58:37'],
    12: ['大雪', '7', '05:56:55'],
  },
  2022: {
    1: ['小寒', '5', '17:13:54'],
    2: ['立春', '4', '04:50:36'],
    3: ['惊蛰', '5', '22:43:34'],
    4: ['清明', '5', '03:20:03'],
    5: ['立夏', '5', '20:25:46'],
    6: ['芒种', '6', '00:25:37'],
    7: ['小暑', '7', '10:37:49'],
    8: ['立秋', '7', '20:28:57'],
    9: ['白露', '7', '23:32:07'],
    10: ['寒露', '8', '15:22:16'],
    11: ['立冬', '7', '18:45:18'],
    12: ['大雪', '7', '11:46:04'],
  },
  2023: {
    1: ['小寒', '5', '23:04:39'],
    2: ['立春', '4', '10:42:21'],
    3: ['惊蛰', '6', '04:36:02'],
    4: ['清明', '5', '09:12:52'],
    5: ['立夏', '6', '02:18:34'],
    6: ['芒种', '6', '06:18:10'],
    7: ['小暑', '7', '16:30:29'],
    8: ['立秋', '8', '02:22:41'],
    9: ['白露', '8', '05:26:31'],
    10: ['寒露', '8', '21:15:23'],
    11: ['立冬', '8', '00:35:23'],
    12: ['大雪', '7', '17:32:44'],
  },
  2024: {
    1: ['小寒', '6', '04:49:09'],
    2: ['立春', '4', '16:26:53'],
    3: ['惊蛰', '5', '10:22:31'],
    4: ['清明', '4', '15:02:03'],
    5: ['立夏', '5', '08:09:51'],
    6: ['芒种', '5', '12:09:40'],
    7: ['小暑', '6', '22:19:49'],
    8: ['立秋', '7', '08:09:01'],
    9: ['白露', '7', '11:11:06'],
    10: ['寒露', '8', '02:59:43'],
    11: ['立冬', '7', '06:19:49'],
    12: ['大雪', '6', '23:16:47'],
  },
  2025: {
    1: ['小寒', '5', '10:32:31'],
    2: ['立春', '3', '22:10:13'],
    3: ['惊蛰', '5', '16:07:02'],
    4: ['清明', '4', '20:48:21'],
    5: ['立夏', '5', '13:56:57'],
    6: ['芒种', '5', '17:56:16'],
    7: ['小暑', '7', '04:04:43'],
    8: ['立秋', '7', '13:51:19'],
    9: ['白露', '7', '16:51:41'],
    10: ['寒露', '8', '08:40:57'],
    11: ['立冬', '7', '12:03:48'],
    12: ['大雪', '7', '05:04:20'],
  },
  2026: {
    1: ['小寒', '5', '16:22:53'],
    2: ['立春', '4', '04:01:51'],
    3: ['惊蛰', '5', '21:58:43'],
    4: ['清明', '5', '02:39:43'],
    5: ['立夏', '5', '19:48:27'],
    6: ['芒种', '5', '23:48:04'],
    7: ['小暑', '7', '09:56:40'],
    8: ['立秋', '7', '19:42:26'],
    9: ['白露', '7', '22:40:59'],
    10: ['寒露', '8', '14:28:59'],
    11: ['立冬', '7', '17:51:46'],
    12: ['大雪', '7', '10:52:14'],
  },
  2027: {
    1: ['小寒', '5', '22:09:39'],
    2: ['立春', '4', '09:46:00'],
    3: ['惊蛰', '6', '03:39:14'],
    4: ['清明', '5', '08:17:12'],
    5: ['立夏', '6', '01:24:53'],
    6: ['芒种', '6', '05:25:29'],
    7: ['小暑', '7', '15:36:44'],
    8: ['立秋', '8', '01:26:27'],
    9: ['白露', '8', '04:28:08'],
    10: ['寒露', '8', '20:16:46'],
    11: ['立冬', '7', '23:38:15'],
    12: ['大雪', '7', '16:37:21'],
  },
  2028: {
    1: ['小寒', '6', '03:54:19'],
    2: ['立春', '4', '15:30:53'],
    3: ['惊蛰', '5', '09:24:27'],
    4: ['清明', '4', '14:02:45'],
    5: ['立夏', '5', '07:11:51'],
    6: ['芒种', '5', '11:15:39'],
    7: ['小暑', '6', '21:29:57'],
    8: ['立秋', '7', '07:20:50'],
    9: ['白露', '7', '10:21:49'],
    10: ['寒露', '8', '02:08:10'],
    11: ['立冬', '7', '05:26:54'],
    12: ['大雪', '6', '22:24:19'],
  },
  2029: {
    1: ['小寒', '5', '09:41:34'],
    2: ['立春', '3', '21:20:25'],
    3: ['惊蛰', '5', '15:17:15'],
    4: ['清明', '4', '19:58:02'],
    5: ['立夏', '5', '13:07:24'],
    6: ['芒种', '5', '17:09:36'],
    7: ['小暑', '7', '03:22:01'],
    8: ['立秋', '7', '13:11:22'],
    9: ['白露', '7', '16:11:32'],
    10: ['寒露', '8', '07:57:45'],
    11: ['立冬', '7', '11:16:23'],
    12: ['大雪', '7', '04:13:25'],
  },
  2030: {
    1: ['小寒', '5', '15:30:11'],
    2: ['立春', '4', '03:08:04'],
    3: ['惊蛰', '5', '21:02:55'],
    4: ['清明', '5', '01:40:37'],
    5: ['立夏', '5', '18:45:54'],
    6: ['芒种', '5', '22:44:06'],
    7: ['小暑', '7', '08:55:05'],
    8: ['立秋', '7', '18:46:56'],
    9: ['白露', '7', '21:52:26'],
    10: ['寒露', '8', '13:44:52'],
    11: ['立冬', '7', '17:08:20'],
    12: ['大雪', '7', '10:07:13'],
  },
  2031: {
    1: ['小寒', '5', '21:22:44'],
    2: ['立春', '4', '08:57:55'],
    3: ['惊蛰', '6', '02:50:38'],
    4: ['清明', '5', '07:27:59'],
    5: ['立夏', '6', '00:34:47'],
    6: ['芒种', '6', '04:35:17'],
    7: ['小暑', '7', '14:48:26'],
    8: ['立秋', '8', '00:42:31'],
    9: ['白露', '8', '03:49:45'],
    10: ['寒露', '8', '19:42:33'],
    11: ['立冬', '7', '23:05:15'],
    12: ['大雪', '7', '16:02:27'],
  },
  2032: {
    1: ['小寒', '6', '03:15:40'],
    2: ['立春', '4', '14:48:32'],
    3: ['惊蛰', '5', '08:39:48'],
    4: ['清明', '4', '13:17:10'],
    5: ['立夏', '5', '06:25:25'],
    6: ['芒种', '5', '10:27:32'],
    7: ['小暑', '6', '20:40:27'],
    8: ['立秋', '7', '06:32:16'],
    9: ['白露', '7', '09:37:27'],
    10: ['寒露', '8', '01:29:58'],
    11: ['立冬', '7', '04:53:49'],
    12: ['大雪', '6', '21:52:52'],
  },
  2033: {
    1: ['小寒', '5', '09:07:39'],
    2: ['立春', '3', '20:41:08'],
    3: ['惊蛰', '5', '14:31:54'],
    4: ['清明', '4', '19:07:41'],
    5: ['立夏', '5', '12:13:18'],
    6: ['芒种', '5', '16:12:58'],
    7: ['小暑', '7', '02:24:29'],
    8: ['立秋', '7', '12:15:17'],
    9: ['白露', '7', '15:19:53'],
    10: ['寒露', '8', '07:13:28'],
    11: ['立冬', '7', '10:40:36'],
    12: ['大雪', '7', '03:44:27'],
  },
  2034: {
    1: ['小寒', '5', '15:04:02'],
    2: ['立春', '4', '02:40:41'],
    3: ['惊蛰', '5', '20:31:54'],
    4: ['清明', '5', '01:05:45'],
    5: ['立夏', '5', '18:08:40'],
    6: ['芒种', '5', '22:06:12'],
    7: ['小暑', '7', '08:17:09'],
    8: ['立秋', '7', '18:08:37'],
    9: ['白露', '7', '21:13:29'],
    10: ['寒露', '8', '13:06:36'],
    11: ['立冬', '7', '16:33:09'],
    12: ['大雪', '7', '09:36:19'],
  },
  2035: {
    1: ['小寒', '5', '20:55:13'],
    2: ['立春', '4', '08:31:04'],
    3: ['惊蛰', '6', '02:21:08'],
    4: ['清明', '5', '06:53:21'],
    5: ['立夏', '5', '23:54:25'],
    6: ['芒种', '6', '03:50:19'],
    7: ['小暑', '7', '14:00:39'],
    8: ['立秋', '7', '23:53:49'],
    9: ['白露', '8', '03:01:58'],
    10: ['寒露', '8', '18:57:10'],
    11: ['立冬', '7', '22:23:20'],
    12: ['大雪', '7', '15:25:00'],
  },
  2036: {
    1: ['小寒', '6', '02:42:59'],
    2: ['立春', '4', '14:19:25'],
    3: ['惊蛰', '5', '08:11:18'],
    4: ['清明', '4', '12:45:44'],
    5: ['立夏', '5', '05:48:51'],
    6: ['芒种', '5', '09:46:28'],
    7: ['小暑', '6', '19:57:00'],
    8: ['立秋', '7', '05:48:24'],
    9: ['白露', '7', '08:54:27'],
    10: ['寒露', '8', '00:48:26'],
    11: ['立冬', '7', '04:14:07'],
    12: ['大雪', '6', '21:15:29'],
  },
  2037: {
    1: ['小寒', '5', '08:33:31'],
    2: ['立春', '3', '20:11:04'],
    3: ['惊蛰', '5', '14:05:38'],
    4: ['清明', '4', '18:43:29'],
    5: ['立夏', '5', '11:48:55'],
    6: ['芒种', '5', '15:46:17'],
    7: ['小暑', '7', '01:54:35'],
    8: ['立秋', '7', '11:42:28'],
    9: ['白露', '7', '14:45:00'],
    10: ['寒露', '8', '06:37:16'],
    11: ['立冬', '7', '10:03:30'],
    12: ['大雪', '7', '03:06:43'],
  },
  2038: {
    1: ['小寒', '5', '14:26:13'],
    2: ['立春', '4', '02:03:12'],
    3: ['惊蛰', '5', '19:54:55'],
    4: ['清明', '5', '00:28:53'],
    5: ['立夏', '5', '17:30:37'],
    6: ['芒种', '5', '21:25:03'],
    7: ['小暑', '7', '07:31:56'],
    8: ['立秋', '7', '17:20:44'],
    9: ['白露', '7', '20:25:42'],
    10: ['寒露', '8', '12:20:59'],
    11: ['立冬', '7', '15:50:16'],
    12: ['大雪', '7', '08:55:48'],
  },
  2039: {
    1: ['小寒', '5', '20:16:04'],
    2: ['立春', '4', '07:52:19'],
    3: ['惊蛰', '6', '01:42:27'],
    4: ['清明', '5', '06:15:11'],
    5: ['立夏', '5', '23:17:33'],
    6: ['芒种', '6', '03:14:53'],
    7: ['小暑', '7', '13:25:33'],
    8: ['立秋', '7', '23:17:29'],
    9: ['白露', '8', '02:23:26'],
    10: ['寒露', '8', '18:16:40'],
    11: ['立冬', '7', '21:42:17'],
    12: ['大雪', '7', '14:44:28'],
  },
  2040: {
    1: ['小寒', '6', '02:03:00'],
    2: ['立春', '4', '13:39:17'],
    3: ['惊蛰', '5', '07:30:37'],
    4: ['清明', '4', '12:04:54'],
    5: ['立夏', '5', '05:08:44'],
    6: ['芒种', '5', '09:07:24'],
    7: ['小暑', '6', '19:18:36'],
    8: ['立秋', '7', '05:09:25'],
    9: ['白露', '7', '08:13:28'],
    10: ['寒露', '8', '00:04:54'],
    11: ['立冬', '7', '03:28:40'],
    12: ['大雪', '6', '20:29:25'],
  },
  2041: {
    1: ['小寒', '5', '07:47:29'],
    2: ['立春', '3', '19:24:30'],
    3: ['惊蛰', '5', '13:17:12'],
    4: ['清明', '4', '17:51:58'],
    5: ['立夏', '5', '10:53:52'],
    6: ['芒种', '5', '14:49:07'],
    7: ['小暑', '7', '00:57:50'],
    8: ['立秋', '7', '10:48:02'],
    9: ['白露', '7', '13:52:54'],
    10: ['寒露', '8', '05:46:19'],
    11: ['立冬', '7', '09:12:27'],
    12: ['大雪', '7', '02:15:08'],
  },
  2042: {
    1: ['小寒', '5', '13:34:29'],
    2: ['立春', '4', '01:12:11'],
    3: ['惊蛰', '5', '19:05:08'],
    4: ['清明', '4', '23:40:00'],
    5: ['立夏', '5', '16:42:11'],
    6: ['芒种', '5', '20:37:33'],
    7: ['小暑', '7', '06:46:36'],
    8: ['立秋', '7', '16:38:08'],
    9: ['白露', '7', '19:44:48'],
    10: ['寒露', '8', '11:39:54'],
    11: ['立冬', '7', '15:06:58'],
    12: ['大雪', '7', '08:08:33'],
  },
  2043: {
    1: ['小寒', '5', '19:24:40'],
    2: ['立春', '4', '06:58:05'],
    3: ['惊蛰', '6', '00:47:05'],
    4: ['清明', '5', '05:19:35'],
    5: ['立夏', '5', '22:21:24'],
    6: ['芒种', '6', '02:17:28'],
    7: ['小暑', '7', '12:27:09'],
    8: ['立秋', '7', '22:20:04'],
    9: ['白露', '8', '01:29:29'],
    10: ['寒露', '8', '17:27:02'],
    11: ['立冬', '7', '20:55:08'],
    12: ['大雪', '7', '13:56:40'],
  },
  2044: {
    1: ['小寒', '6', '01:11:49'],
    2: ['立春', '4', '12:43:36'],
    3: ['惊蛰', '5', '06:30:54'],
    4: ['清明', '4', '11:02:24'],
    5: ['立夏', '5', '04:04:47'],
    6: ['芒种', '5', '08:03:18'],
    7: ['小暑', '6', '18:15:13'],
    8: ['立秋', '7', '04:07:54'],
    9: ['白露', '7', '07:15:49'],
    10: ['寒露', '7', '23:12:36'],
    11: ['立冬', '7', '02:41:17'],
    12: ['大雪', '6', '19:44:30'],
  },
  2045: {
    1: ['小寒', '5', '07:01:49'],
    2: ['立春', '3', '18:35:35'],
    3: ['惊蛰', '5', '12:24:20'],
    4: ['清明', '4', '16:56:35'],
    5: ['立夏', '5', '09:58:48'],
    6: ['芒种', '5', '13:56:18'],
    7: ['小暑', '7', '00:07:21'],
    8: ['立秋', '7', '09:58:56'],
    9: ['白露', '7', '13:04:44'],
    10: ['寒露', '8', '04:59:56'],
    11: ['立冬', '7', '08:29:07'],
    12: ['大雪', '7', '01:34:51'],
  },
  2046: {
    1: ['小寒', '5', '12:55:16'],
    2: ['立春', '4', '00:30:22'],
    3: ['惊蛰', '5', '18:17:04'],
    4: ['清明', '4', '22:44:15'],
    5: ['立夏', '5', '15:39:58'],
    6: ['芒种', '5', '19:31:31'],
    7: ['小暑', '7', '05:39:33'],
    8: ['立秋', '7', '15:32:36'],
    9: ['白露', '7', '18:42:35'],
    10: ['寒露', '8', '10:41:42'],
    11: ['立冬', '7', '14:13:26'],
    12: ['大雪', '7', '07:20:33'],
  },
  2047: {
    1: ['小寒', '5', '18:41:38'],
    2: ['立春', '4', '06:17:17'],
    3: ['惊蛰', '6', '00:04:33'],
    4: ['清明', '5', '04:31:57'],
    5: ['立夏', '5', '21:27:47'],
    6: ['芒种', '6', '01:20:08'],
    7: ['小暑', '7', '11:29:44'],
    8: ['立秋', '7', '21:25:08'],
    9: ['白露', '8', '00:37:26'],
    10: ['寒露', '8', '16:36:57'],
    11: ['立冬', '7', '20:06:36'],
    12: ['大雪', '7', '13:10:17'],
  },
  2048: {
    1: ['小寒', '6', '00:28:38'],
    2: ['立春', '4', '12:03:52'],
    3: ['惊蛰', '5', '05:53:23'],
    4: ['清明', '4', '10:24:32'],
    5: ['立夏', '5', '03:23:44'],
    6: ['芒种', '5', '07:17:32'],
    7: ['小暑', '6', '17:26:02'],
    8: ['立秋', '7', '03:18:06'],
    9: ['白露', '7', '06:27:20'],
    10: ['寒露', '7', '22:25:59'],
    11: ['立冬', '7', '01:56:05'],
    12: ['大雪', '6', '19:00:03'],
  },
  2049: {
    1: ['小寒', '5', '06:17:57'],
    2: ['立春', '3', '17:52:36'],
    3: ['惊蛰', '5', '11:42:10'],
    4: ['清明', '4', '16:13:37'],
    5: ['立夏', '5', '09:11:52'],
    6: ['芒种', '5', '13:02:58'],
    7: ['小暑', '6', '23:08:03'],
    8: ['立秋', '7', '08:57:09'],
    9: ['白露', '7', '12:04:46'],
    10: ['寒露', '8', '04:04:15'],
    11: ['立冬', '7', '07:37:38'],
    12: ['大雪', '7', '00:45:52'],
  },
  2050: {
    1: ['小寒', '5', '12:07:06'],
    2: ['立春', '3', '23:43:00'],
    3: ['惊蛰', '5', '17:31:56'],
    4: ['清明', '4', '20:02:27'],
    5: ['立夏', '5', '15:01:12'],
    6: ['芒种', '5', '18:54:03'],
    7: ['小暑', '7', '05:01:06'],
    8: ['立秋', '7', '14:51:43'],
    9: ['白露', '7', '17:59:53'],
    10: ['寒露', '8', '09:59:23'],
    11: ['立冬', '7', '13:32:54'],
    12: ['大雪', '7', '06:41:00'],
  },
  2051: {
    1: ['小寒', '5', '18:01:24'],
    2: ['立春', '4', '05:35:20'],
    3: ['惊蛰', '5', '23:21:17'],
    4: ['清明', '5', '03:48:54'],
    5: ['立夏', '5', '20:46:20'],
    6: ['芒种', '6', '00:39:56'],
    7: ['小暑', '7', '10:48:41'],
    8: ['立秋', '7', '20:41:04'],
    9: ['白露', '7', '23:50:33'],
    10: ['寒露', '8', '15:49:41'],
    11: ['立冬', '7', '19:21:22'],
    12: ['大雪', '7', '12:27:52'],
  },
  2052: {
    1: ['小寒', '5', '23:47:46'],
    2: ['立春', '4', '11:22:11'],
    3: ['惊蛰', '5', '05:08:47'],
    4: ['清明', '4', '09:36:33'],
    5: ['立夏', '5', '02:34:01'],
    6: ['芒种', '5', '06:28:41'],
    7: ['小暑', '6', '16:39:13'],
    8: ['立秋', '7', '02:32:29'],
    9: ['白露', '7', '05:41:23'],
    10: ['寒露', '7', '21:39:03'],
    11: ['立冬', '7', '01:09:06'],
    12: ['大雪', '6', '18:14:43'],
  },
  2053: {
    1: ['小寒', '5', '05:35:21'],
    2: ['立春', '3', '17:12:16'],
    3: ['惊蛰', '5', '11:02:31'],
    4: ['清明', '4', '15:33:43'],
    5: ['立夏', '5', '08:32:48'],
    6: ['芒种', '5', '12:26:52'],
    7: ['小暑', '6', '22:36:22'],
    8: ['立秋', '7', '08:29:14'],
    9: ['白露', '7', '11:37:51'],
    10: ['寒露', '8', '03:35:18'],
    11: ['立冬', '7', '07:05:22'],
    12: ['大雪', '7', '00:11:06'],
  },
  2054: {
    1: ['小寒', '5', '11:31:31'],
    2: ['立春', '3', '23:07:09'],
    3: ['惊蛰', '5', '16:54:45'],
    4: ['清明', '4', '21:22:18'],
    5: ['立夏', '5', '14:17:05'],
    6: ['芒种', '5', '18:06:43'],
    7: ['小暑', '7', '04:13:01'],
    8: ['立秋', '7', '14:06:12'],
    9: ['白露', '7', '17:18:48'],
    10: ['寒露', '8', '09:21:26'],
    11: ['立冬', '7', '12:55:31'],
    12: ['大雪', '7', '06:02:38'],
  },
  2055: {
    1: ['小寒', '5', '17:21:48'],
    2: ['立春', '4', '04:55:02'],
    3: ['惊蛰', '5', '22:40:40'],
    4: ['清明', '5', '03:07:27'],
    5: ['立夏', '5', '20:03:05'],
    6: ['芒种', '5', '23:55:08'],
    7: ['小暑', '7', '10:04:27'],
    8: ['立秋', '7', '20:00:16'],
    9: ['白露', '7', '23:14:47'],
    10: ['寒露', '8', '15:18:16'],
    11: ['立冬', '7', '18:51:59'],
    12: ['大雪', '7', '11:57:42'],
  },
  2056: {
    1: ['小寒', '5', '23:14:54'],
    2: ['立春', '4', '10:46:23'],
    3: ['惊蛰', '5', '04:31:22'],
    4: ['清明', '4', '08:59:13'],
    5: ['立夏', '5', '01:57:12'],
    6: ['芒种', '5', '05:51:34'],
    7: ['小暑', '6', '16:01:34'],
    8: ['立秋', '7', '01:55:18'],
    9: ['白露', '7', '05:06:32'],
    10: ['寒露', '7', '21:08:20'],
    11: ['立冬', '7', '00:42:34'],
    12: ['大雪', '6', '17:50:09'],
  },
  2057: {
    1: ['小寒', '5', '05:09:17'],
    2: ['立春', '3', '16:41:44'],
    3: ['惊蛰', '5', '10:26:14'],
    4: ['清明', '4', '14:51:50'],
    5: ['立夏', '5', '07:45:52'],
    6: ['芒种', '5', '11:35:32'],
    7: ['小暑', '6', '21:41:40'],
    8: ['立秋', '7', '07:33:10'],
    9: ['白露', '7', '10:43:19'],
    10: ['寒露', '8', '02:45:23'],
    11: ['立冬', '7', '06:22:02'],
    12: ['大雪', '6', '23:33:53'],
  },
  2058: {
    1: ['小寒', '5', '10:57:47'],
    2: ['立春', '3', '22:33:44'],
    3: ['惊蛰', '5', '16:19:07'],
    4: ['清明', '4', '20:43:13'],
    5: ['立夏', '5', '13:35:14'],
    6: ['芒种', '5', '17:23:58'],
    7: ['小暑', '7', '03:30:46'],
    8: ['立秋', '7', '13:24:29'],
    9: ['白露', '7', '16:37:15'],
    10: ['寒露', '8', '08:40:28'],
    11: ['立冬', '7', '12:16:22'],
    12: ['大雪', '7', '05:26:20'],
  },
  2059: {
    1: ['小寒', '5', '16:48:25'],
    2: ['立春', '4', '04:23:11'],
    3: ['惊蛰', '5', '22:07:58'],
    4: ['清明', '5', '02:31:40'],
    5: ['立夏', '5', '19:23:12'],
    6: ['芒种', '5', '23:11:30'],
    7: ['小暑', '7', '09:18:03'],
    8: ['立秋', '7', '19:11:57'],
    9: ['白露', '7', '22:25:48'],
    10: ['寒露', '8', '14:29:51'],
    11: ['立冬', '7', '18:04:54'],
    12: ['大雪', '7', '11:12:50'],
  },
  2060: {
    1: ['小寒', '5', '22:33:05'],
    2: ['立春', '4', '10:07:24'],
    3: ['惊蛰', '5', '03:53:19'],
    4: ['清明', '4', '08:18:58'],
    5: ['立夏', '5', '01:12:03'],
    6: ['芒种', '5', '05:00:48'],
    7: ['小暑', '6', '15:06:30'],
    8: ['立秋', '7', '00:58:23'],
    9: ['白露', '7', '04:09:51'],
    10: ['寒露', '7', '20:12:45'],
    11: ['立冬', '6', '23:48:06'],
    12: ['大雪', '6', '16:56:48'],
  },
  2061: {
    1: ['小寒', '5', '04:17:40'],
    2: ['立春', '3', '15:52:57'],
    3: ['惊蛰', '5', '09:40:53'],
    4: ['清明', '4', '14:09:37'],
    5: ['立夏', '5', '07:05:43'],
    6: ['芒种', '5', '10:55:52'],
    7: ['小暑', '6', '21:01:19'],
    8: ['立秋', '7', '06:52:04'],
    9: ['白露', '7', '10:01:47'],
    10: ['寒露', '8', '02:03:21'],
    11: ['立冬', '7', '05:39:06'],
    12: ['大雪', '6', '22:49:37'],
  },
  2062: {
    1: ['小寒', '5', '10:11:57'],
    2: ['立春', '3', '21:46:16'],
    3: ['惊蛰', '5', '15:30:38'],
    4: ['清明', '4', '19:54:40'],
    5: ['立夏', '5', '12:46:40'],
    6: ['芒种', '5', '16:34:00'],
    7: ['小暑', '7', '02:37:40'],
    8: ['立秋', '7', '12:28:10'],
    9: ['白露', '7', '15:39:39'],
    10: ['寒露', '8', '07:43:48'],
    11: ['立冬', '7', '11:21:46'],
    12: ['大雪', '7', '04:33:42'],
  },
  2063: {
    1: ['小寒', '5', '15:56:27'],
    2: ['立春', '4', '03:30:24'],
    3: ['惊蛰', '5', '21:13:37'],
    4: ['清明', '5', '01:36:09'],
    5: ['立夏', '5', '18:27:33'],
    6: ['芒种', '5', '22:16:49'],
    7: ['小暑', '7', '08:24:42'],
    8: ['立秋', '7', '18:19:20'],
    9: ['白露', '7', '21:32:47'],
    10: ['寒露', '8', '13:36:09'],
    11: ['立冬', '7', '17:11:20'],
    12: ['大雪', '7', '10:19:59'],
  },
  2064: {
    1: ['小寒', '5', '21:40:30'],
    2: ['立春', '4', '09:14:04'],
    3: ['惊蛰', '5', '02:58:37'],
    4: ['清明', '4', '07:23:36'],
    5: ['立夏', '5', '00:17:46'],
    6: ['芒种', '5', '04:09:22'],
    7: ['小暑', '6', '14:18:52'],
    8: ['立秋', '7', '00:13:34'],
    9: ['白露', '7', '03:25:36'],
    10: ['寒露', '7', '19:27:13'],
    11: ['立冬', '6', '23:00:53'],
    12: ['大雪', '6', '16:08:31'],
  },
  2065: {
    1: ['小寒', '5', '03:28:46'],
    2: ['立春', '3', '15:02:53'],
    3: ['惊蛰', '5', '08:48:22'],
    4: ['清明', '4', '13:13:10'],
    5: ['立夏', '5', '06:04:39'],
    6: ['芒种', '5', '09:51:25'],
    7: ['小暑', '6', '19:56:05'],
    8: ['立秋', '7', '05:48:32'],
    9: ['白露', '7', '09:01:12'],
    10: ['寒露', '8', '01:05:10'],
    11: ['立冬', '7', '04:41:50'],
    12: ['大雪', '6', '21:52:07'],
  },
  2066: {
    1: ['小寒', '5', '09:14:02'],
    2: ['立春', '3', '20:48:35'],
    3: ['惊蛰', '5', '14:33:21'],
    4: ['清明', '4', '18:56:59'],
    5: ['立夏', '5', '11:47:55'],
    6: ['芒种', '5', '15:35:07'],
    7: ['小暑', '7', '01:41:08'],
    8: ['立秋', '7', '11:36:11'],
    9: ['白露', '7', '14:52:34'],
    10: ['寒露', '8', '07:00:06'],
    11: ['立冬', '7', '10:38:29'],
    12: ['大雪', '7', '03:47:43'],
  },
  2067: {
    1: ['小寒', '5', '15:06:18'],
    2: ['立春', '4', '02:36:34'],
    3: ['惊蛰', '5', '20:17:46'],
    4: ['清明', '5', '00:39:51'],
    5: ['立夏', '5', '17:31:26'],
    6: ['芒种', '5', '21:20:34'],
    7: ['小暑', '7', '07:28:24'],
    8: ['立秋', '7', '17:24:20'],
    9: ['白露', '7', '20:41:33'],
    10: ['寒露', '8', '12:50:12'],
    11: ['立冬', '7', '16:29:41'],
    12: ['大雪', '7', '09:39:52'],
  },
  2068: {
    1: ['小寒', '5', '20:58:41'],
    2: ['立春', '4', '08:28:16'],
    3: ['惊蛰', '5', '02:08:10'],
    4: ['清明', '4', '06:28:58'],
    5: ['立夏', '4', '23:19:50'],
    6: ['芒种', '5', '03:08:48'],
    7: ['小暑', '6', '13:16:07'],
    8: ['立秋', '6', '23:10:23'],
    9: ['白露', '7', '02:25:05'],
    10: ['寒露', '7', '18:32:19'],
    11: ['立冬', '6', '22:12:39'],
    12: ['大雪', '6', '15:25:25'],
  },
  2069: {
    1: ['小寒', '5', '02:47:33'],
    2: ['立春', '3', '14:20:04'],
    3: ['惊蛰', '5', '08:01:48'],
    4: ['清明', '4', '12:23:14'],
    5: ['立夏', '5', '05:13:57'],
    6: ['芒种', '5', '09:02:35'],
    7: ['小暑', '6', '19:10:13'],
    8: ['立秋', '7', '05:05:15'],
    9: ['白露', '7', '08:19:53'],
    10: ['寒露', '8', '00:26:15'],
    11: ['立冬', '7', '04:06:43'],
    12: ['大雪', '6', '21:21:35'],
  },
  2070: {
    1: ['小寒', '5', '08:46:46'],
    2: ['立春', '3', '20:21:03'],
    3: ['惊蛰', '5', '14:01:40'],
    4: ['清明', '4', '18:19:02'],
    5: ['立夏', '5', '11:04:02'],
    6: ['芒种', '5', '14:47:15'],
    7: ['小暑', '7', '00:51:19'],
    8: ['立秋', '7', '10:45:51'],
    9: ['白露', '7', '14:03:03'],
    10: ['寒露', '8', '06:12:36'],
    11: ['立冬', '7', '09:54:48'],
    12: ['大雪', '7', '03:10:00'],
  },
  2071: {
    1: ['小寒', '5', '14:35:10'],
    2: ['立春', '4', '02:10:05'],
    3: ['惊蛰', '5', '19:51:51'],
    4: ['清明', '5', '00:09:51'],
    5: ['立夏', '5', '16:54:28'],
    6: ['芒种', '5', '20:37:12'],
    7: ['小暑', '7', '06:42:02'],
    8: ['立秋', '7', '16:38:24'],
    9: ['白露', '7', '19:57:12'],
    10: ['寒露', '8', '12:07:13'],
    11: ['立冬', '7', '15:47:57'],
    12: ['大雪', '7', '09:00:02'],
  },
  2072: {
    1: ['小寒', '5', '20:22:12'],
    2: ['立春', '4', '07:56:15'],
    3: ['惊蛰', '5', '01:40:12'],
    4: ['清明', '4', '06:02:57'],
    5: ['立夏', '4', '22:52:58'],
    6: ['芒种', '5', '02:39:12'],
    7: ['小暑', '6', '12:44:26'],
    8: ['立秋', '6', '22:38:36'],
    9: ['白露', '7', '01:54:23'],
    10: ['寒露', '7', '18:02:32'],
    11: ['立冬', '6', '21:43:06'],
    12: ['大雪', '6', '14:55:43'],
  },
  2073: {
    1: ['小寒', '5', '02:18:06'],
    2: ['立春', '3', '13:52:00'],
    3: ['惊蛰', '5', '07:35:58'],
    4: ['清明', '4', '11:58:32'],
    5: ['立夏', '5', '04:47:03'],
    6: ['芒种', '5', '08:29:55'],
    7: ['小暑', '6', '18:30:07'],
    8: ['立秋', '7', '04:19:29'],
    9: ['白露', '7', '07:32:34'],
    10: ['寒露', '7', '23:40:33'],
    11: ['立冬', '7', '03:23:22'],
    12: ['大雪', '6', '20:39:40'],
  },
  2074: {
    1: ['小寒', '5', '08:05:20'],
    2: ['立春', '3', '19:40:32'],
    3: ['惊蛰', '5', '13:23:33'],
    4: ['清明', '4', '17:44:24'],
    5: ['立夏', '5', '10:32:25'],
    6: ['芒种', '5', '14:16:56'],
    7: ['小暑', '7', '00:20:15'],
    8: ['立秋', '7', '10:12:30'],
    9: ['白露', '7', '13:27:32'],
    10: ['寒露', '8', '05:36:30'],
    11: ['立冬', '7', '09:18:59'],
    12: ['大雪', '7', '02:33:41'],
  },
  2075: {
    1: ['小寒', '5', '13:57:08'],
    2: ['立春', '4', '01:29:52'],
    3: ['惊蛰', '5', '19:10:38'],
    4: ['清明', '4', '23:30:17'],
    5: ['立夏', '5', '16:18:58'],
    6: ['芒种', '5', '20:05:58'],
    7: ['小暑', '7', '06:12:45'],
    8: ['立秋', '7', '16:07:39'],
    9: ['白露', '7', '19:23:13'],
    10: ['寒露', '8', '11:30:43'],
    11: ['立冬', '7', '15:10:53'],
    12: ['大雪', '7', '08:23:44'],
  },
  2076: {
    1: ['小寒', '5', '19:46:20'],
    2: ['立春', '4', '07:19:09'],
    3: ['惊蛰', '5', '01:00:11'],
    4: ['清明', '4', '05:19:37'],
    5: ['立夏', '4', '22:07:39'],
    6: ['芒种', '5', '01:53:50'],
    7: ['小暑', '6', '11:59:41'],
    8: ['立秋', '6', '21:53:50'],
    9: ['白露', '7', '01:08:18'],
    10: ['寒露', '7', '17:14:10'],
    11: ['立冬', '6', '20:52:46'],
    12: ['大雪', '6', '14:04:47'],
  },
  2077: {
    1: ['小寒', '5', '01:27:46'],
    2: ['立春', '3', '13:02:24'],
    3: ['惊蛰', '5', '06:46:07'],
    4: ['清明', '4', '11:08:01'],
    5: ['立夏', '5', '03:57:21'],
    6: ['芒种', '5', '07:43:51'],
    7: ['小暑', '6', '17:50:09'],
    8: ['立秋', '7', '03:45:47'],
    9: ['白露', '7', '07:02:27'],
    10: ['寒露', '7', '23:10:05'],
    11: ['立冬', '7', '02:49:34'],
    12: ['大雪', '6', '20:01:45'],
  },
  2078: {
    1: ['小寒', '5', '07:24:04'],
    2: ['立春', '3', '18:56:39'],
    3: ['惊蛰', '5', '12:37:12'],
    4: ['清明', '4', '16:55:23'],
    5: ['立夏', '5', '09:40:55'],
    6: ['芒种', '5', '13:24:03'],
    7: ['小暑', '6', '23:28:05'],
    8: ['立秋', '7', '09:23:27'],
    9: ['白露', '7', '12:42:56'],
    10: ['寒露', '8', '04:55:18'],
    11: ['立冬', '7', '08:38:41'],
    12: ['大雪', '7', '01:52:03'],
  },
  2079: {
    1: ['小寒', '5', '13:12:47'],
    2: ['立春', '4', '00:42:30'],
    3: ['惊蛰', '5', '18:20:17'],
    4: ['清明', '4', '22:36:42'],
    5: ['立夏', '5', '15:21:37'],
    6: ['芒种', '5', '19:05:14'],
    7: ['小暑', '7', '05:11:01'],
    8: ['立秋', '7', '15:08:39'],
    9: ['白露', '7', '18:29:36'],
    10: ['寒露', '8', '10:42:44'],
    11: ['立冬', '7', '14:26:25'],
    12: ['大雪', '7', '07:39:20'],
  },
  2080: {
    1: ['小寒', '5', '18:58:54'],
    2: ['立春', '4', '06:27:16'],
    3: ['惊蛰', '5', '00:04:28'],
    4: ['清明', '4', '04:22:02'],
    5: ['立夏', '4', '21:09:59'],
    6: ['芒种', '5', '00:57:06'],
    7: ['小暑', '6', '11:04:57'],
    8: ['立秋', '6', '21:02:26'],
    9: ['白露', '7', '00:21:45'],
    10: ['寒露', '7', '16:33:39'],
    11: ['立冬', '6', '20:17:58'],
    12: ['大雪', '6', '13:33:11'],
  },
  2081: {
    1: ['小寒', '5', '00:55:21'],
    2: ['立春', '3', '12:25:15'],
    3: ['惊蛰', '5', '06:02:03'],
    4: ['清明', '4', '10:16:34'],
    5: ['立夏', '5', '02:59:17'],
    6: ['芒种', '5', '06:40:30'],
    7: ['小暑', '6', '16:42:50'],
    8: ['立秋', '7', '02:36:22'],
    9: ['白露', '7', '05:53:57'],
    10: ['寒露', '7', '22:05:53'],
    11: ['立冬', '7', '01:52:06'],
    12: ['大雪', '6', '19:11:07'],
  },
  2082: {
    1: ['小寒', '5', '06:37:56'],
    2: ['立春', '3', '18:11:32'],
    3: ['惊蛰', '5', '11:49:29'],
    4: ['清明', '4', '16:02:28'],
    5: ['立夏', '5', '08:42:17'],
    6: ['芒种', '5', '12:21:31'],
    7: ['小暑', '6', '22:24:26'],
    8: ['立秋', '7', '08:20:39'],
    9: ['白露', '7', '11:41:55'],
    10: ['寒露', '8', '03:56:51'],
    11: ['立冬', '7', '07:43:36'],
    12: ['大雪', '7', '01:00:54'],
  },
  2083: {
    1: ['小寒', '5', '12:25:30'],
    2: ['立春', '3', '23:57:43'],
    3: ['惊蛰', '5', '17:35:35'],
    4: ['清明', '4', '21:49:38'],
    5: ['立夏', '5', '14:30:57'],
    6: ['芒种', '5', '18:11:19'],
    7: ['小暑', '7', '04:15:10'],
    8: ['立秋', '7', '14:12:11'],
    9: ['白露', '7', '17:33:51'],
    10: ['寒露', '8', '09:48:49'],
    11: ['立冬', '7', '13:35:03'],
    12: ['大雪', '7', '06:51:09'],
  },
  2084: {
    1: ['小寒', '5', '18:14:21'],
    2: ['立春', '4', '05:45:58'],
    3: ['惊蛰', '4', '23:24:25'],
    4: ['清明', '4', '03:39:49'],
    5: ['立夏', '4', '20:22:18'],
    6: ['芒种', '5', '00:02:05'],
    7: ['小暑', '6', '10:02:50'],
    8: ['立秋', '6', '19:55:43'],
    9: ['白露', '6', '23:13:43'],
    10: ['寒露', '7', '15:26:36'],
    11: ['立冬', '6', '19:12:54'],
    12: ['大雪', '6', '12:30:32'],
  },
  2085: {
    1: ['小寒', '4', '23:55:40'],
    2: ['立春', '3', '11:29:14'],
    3: ['惊蛰', '5', '05:09:52'],
    4: ['清明', '4', '09:27:41'],
    5: ['立夏', '5', '02:12:25'],
    6: ['芒种', '5', '05:53:57'],
    7: ['小暑', '6', '15:55:42'],
    8: ['立秋', '7', '01:48:49'],
    9: ['白露', '7', '05:06:51'],
    10: ['寒露', '7', '21:19:50'],
    11: ['立冬', '7', '01:06:59'],
    12: ['大雪', '6', '18:26:27'],
  },
  2086: {
    1: ['小寒', '5', '05:53:02'],
    2: ['立春', '3', '17:25:48'],
    3: ['惊蛰', '5', '11:03:16'],
    4: ['清明', '4', '15:17:00'],
    5: ['立夏', '5', '07:58:18'],
    6: ['芒种', '5', '11:38:02'],
    7: ['小暑', '6', '21:39:27'],
    8: ['立秋', '7', '07:32:49'],
    9: ['白露', '7', '10:51:49'],
    10: ['寒露', '8', '03:06:27'],
    11: ['立冬', '7', '06:55:05'],
    12: ['大雪', '7', '00:15:16'],
  },
  2087: {
    1: ['小寒', '5', '11:41:58'],
    2: ['立春', '3', '23:14:34'],
    3: ['惊蛰', '5', '16:51:22'],
    4: ['清明', '4', '21:03:54'],
    5: ['立夏', '5', '13:44:06'],
    6: ['芒种', '5', '17:23:53'],
    7: ['小暑', '7', '03:27:22'],
    8: ['立秋', '7', '13:23:42'],
    9: ['白露', '7', '16:43:45'],
    10: ['寒露', '8', '08:56:55'],
    11: ['立冬', '7', '12:42:36'],
    12: ['大雪', '7', '05:59:44'],
  },
  2088: {
    1: ['小寒', '5', '17:24:39'],
    2: ['立春', '4', '04:57:31'],
    3: ['惊蛰', '4', '22:36:25'],
    4: ['清明', '4', '02:52:11'],
    5: ['立夏', '4', '19:36:07'],
    6: ['芒种', '4', '23:19:24'],
    7: ['小暑', '6', '09:25:21'],
    8: ['立秋', '6', '19:23:00'],
    9: ['白露', '6', '22:43:22'],
    10: ['寒露', '7', '14:55:44'],
    11: ['立冬', '6', '18:40:05'],
    12: ['大雪', '6', '11:56:06'],
  },
  2089: {
    1: ['小寒', '4', '23:20:37'],
    2: ['立春', '3', '10:54:02'],
    3: ['惊蛰', '5', '04:34:03'],
    4: ['清明', '4', '08:49:49'],
    5: ['立夏', '5', '01:31:14'],
    6: ['芒种', '5', '05:09:54'],
    7: ['小暑', '6', '15:10:30'],
    8: ['立秋', '7', '01:04:04'],
    9: ['白露', '7', '04:23:24'],
    10: ['寒露', '7', '20:37:22'],
    11: ['立冬', '7', '00:24:11'],
    12: ['大雪', '6', '17:42:20'],
  },
  2090: {
    1: ['小寒', '5', '05:08:05'],
    2: ['立春', '3', '16:41:40'],
    3: ['惊蛰', '5', '10:20:54'],
    4: ['清明', '4', '14:35:37'],
    5: ['立夏', '5', '07:16:07'],
    6: ['芒种', '5', '10:54:21'],
    7: ['小暑', '6', '20:55:59'],
    8: ['立秋', '7', '06:52:11'],
    9: ['白露', '7', '10:15:14'],
    10: ['寒露', '8', '02:33:08'],
    11: ['立冬', '7', '06:22:05'],
    12: ['大雪', '6', '23:39:14'],
  },
  2091: {
    1: ['小寒', '5', '11:01:21'],
    2: ['立春', '3', '22:30:13'],
    3: ['惊蛰', '5', '16:05:44'],
    4: ['清明', '4', '20:19:33'],
    5: ['立夏', '5', '13:02:29'],
    6: ['芒种', '5', '16:44:53'],
    7: ['小暑', '7', '02:50:17'],
    8: ['立秋', '7', '12:48:52'],
    9: ['白露', '7', '16:12:50'],
    10: ['寒露', '8', '08:30:49'],
    11: ['立冬', '7', '12:20:06'],
    12: ['大雪', '7', '05:37:54'],
  },
  2092: {
    1: ['小寒', '5', '17:00:11'],
    2: ['立春', '4', '04:28:13'],
    3: ['惊蛰', '4', '22:02:02'],
    4: ['清明', '4', '02:13:58'],
    5: ['立夏', '4', '18:55:41'],
    6: ['芒种', '4', '22:37:09'],
    7: ['小暑', '6', '08:40:20'],
    8: ['立秋', '6', '18:35:25'],
    9: ['白露', '6', '21:55:37'],
    10: ['寒露', '7', '14:11:04'],
    11: ['立冬', '6', '18:00:17'],
    12: ['大雪', '6', '11:20:28'],
  },
  2093: {
    1: ['小寒', '4', '22:46:27'],
    2: ['立春', '3', '10:18:00'],
    3: ['惊蛰', '5', '03:53:49'],
    4: ['清明', '4', '08:05:39'],
    5: ['立夏', '5', '00:45:44'],
    6: ['芒种', '5', '04:26:01'],
    7: ['小暑', '6', '14:30:02'],
    8: ['立秋', '7', '00:27:07'],
    9: ['白露', '7', '03:49:07'],
    10: ['寒露', '7', '20:05:25'],
    11: ['立冬', '6', '23:55:12'],
    12: ['大雪', '6', '17:16:43'],
  },
  2094: {
    1: ['小寒', '5', '04:44:24'],
    2: ['立春', '3', '16:16:28'],
    3: ['惊蛰', '5', '09:50:51'],
    4: ['清明', '4', '13:59:26'],
    5: ['立夏', '5', '06:35:09'],
    6: ['芒种', '5', '10:11:23'],
    7: ['小暑', '6', '20:13:26'],
    8: ['立秋', '7', '06:11:03'],
    9: ['白露', '7', '09:35:29'],
    10: ['寒露', '8', '01:54:44'],
    11: ['立冬', '7', '05:46:08'],
    12: ['大雪', '6', '23:07:31'],
  },
  2095: {
    1: ['小寒', '5', '10:34:27'],
    2: ['立春', '3', '22:06:29'],
    3: ['惊蛰', '5', '15:41:26'],
    4: ['清明', '4', '19:50:19'],
    5: ['立夏', '5', '12:25:20'],
    6: ['芒种', '5', '15:59:50'],
    7: ['小暑', '7', '02:00:26'],
    8: ['立秋', '7', '11:58:04'],
    9: ['白露', '7', '15:22:53'],
    10: ['寒露', '8', '07:41:54'],
    11: ['立冬', '7', '11:32:05'],
    12: ['大雪', '7', '04:51:02'],
  },
  2096: {
    1: ['小寒', '5', '16:15:22'],
    2: ['立春', '4', '03:46:18'],
    3: ['惊蛰', '4', '21:22:37'],
    4: ['清明', '4', '01:35:11'],
    5: ['立夏', '4', '18:15:06'],
    6: ['芒种', '4', '21:53:52'],
    7: ['小暑', '6', '07:56:03'],
    8: ['立秋', '6', '17:52:51'],
    9: ['白露', '6', '21:16:27'],
    10: ['寒露', '7', '13:34:49'],
    11: ['立冬', '6', '17:25:21'],
    12: ['大雪', '6', '10:45:17'],
  },
  2097: {
    1: ['小寒', '4', '22:10:20'],
    2: ['立春', '3', '09:41:26'],
    3: ['惊蛰', '5', '03:17:46'],
    4: ['清明', '4', '07:29:41'],
    5: ['立夏', '5', '00:07:39'],
    6: ['芒种', '5', '03:43:10'],
    7: ['小暑', '6', '13:40:50'],
    8: ['立秋', '6', '23:32:21'],
    9: ['白露', '7', '02:52:19'],
    10: ['寒露', '7', '19:10:21'],
    11: ['立冬', '6', '23:03:19'],
    12: ['大雪', '6', '16:27:13'],
  },
  2098: {
    1: ['小寒', '5', '03:55:53'],
    2: ['立春', '3', '15:28:27'],
    3: ['惊蛰', '5', '09:03:28'],
    4: ['清明', '4', '13:12:44'],
    5: ['立夏', '5', '05:48:20'],
    6: ['芒种', '5', '09:22:51'],
    7: ['小暑', '6', '19:21:48'],
    8: ['立秋', '7', '05:16:00'],
    9: ['白露', '7', '08:38:09'],
    10: ['寒露', '8', '00:57:23'],
    11: ['立冬', '7', '04:50:08'],
    12: ['大雪', '6', '22:12:21'],
  },
  2099: {
    1: ['小寒', '5', '09:38:43'],
    2: ['立春', '3', '21:08:57'],
    3: ['惊蛰', '5', '14:42:05'],
    4: ['清明', '4', '18:50:53'],
    5: ['立夏', '5', '11:28:31'],
    6: ['芒种', '5', '15:07:13'],
    7: ['小暑', '7', '01:11:09'],
    8: ['立秋', '7', '11:09:40'],
    9: ['白露', '7', '14:33:36'],
    10: ['寒露', '8', '06:51:38'],
    11: ['立冬', '7', '10:42:05'],
    12: ['大雪', '7', '04:02:43'],
  },
  2100: {
    1: ['小寒', '5', '15:28:44'],
    2: ['立春', '4', '02:59:45'],
    3: ['惊蛰', '5', '20:34:01'],
    4: ['清明', '5', '00:43:16'],
    5: ['立夏', '5', '17:20:24'],
    6: ['芒种', '5', '20:57:35'],
    7: ['小暑', '7', '06:58:30'],
    8: ['立秋', '7', '16:53:33'],
    9: ['白露', '7', '20:14:46'],
    10: ['寒露', '8', '12:30:41'],
    11: ['立冬', '7', '16:19:34'],
    12: ['大雪', '7', '09:39:35'],
  },
}

// 节气2
export const _JieQiData2 = {
  1799: {
    1: ['大寒', '20', '07:20:55'],
    2: ['雨水', '18', '22:14:03'],
    3: ['春分', '20', '22:30:37'],
    4: ['谷雨', '20', '11:02:09'],
    5: ['小满', '21', '11:27:56'],
    6: ['夏至', '21', '20:08:46'],
    7: ['大暑', '23', '07:00:28'],
    8: ['处暑', '23', '13:18:42'],
    9: ['秋分', '23', '09:40:38'],
    10: ['霜降', '23', '17:35:28'],
    11: ['小雪', '22', '13:55:33'],
    12: ['冬至', '22', '08:16:05'],
  },
  1800: {
    1: ['大寒', '20', '13:08:14'],
    2: ['雨水', '19', '03:57:32'],
    3: ['春分', '21', '04:11:27'],
    4: ['谷雨', '20', '16:42:14'],
    5: ['小满', '21', '17:09:04'],
    6: ['夏至', '22', '01:51:28'],
    7: ['大暑', '23', '12:44:12'],
    8: ['处暑', '23', '19:03:13'],
    9: ['秋分', '23', '15:25:26'],
    10: ['霜降', '23', '23:19:52'],
    11: ['小雪', '22', '19:39:46'],
    12: ['冬至', '22', '08:16:05'],
  },
  1801: {
    1: ['大寒', '20', '18:52:31'],
    2: ['雨水', '19', '09:41:26'],
    3: ['春分', '21', '09:55:23'],
    4: ['谷雨', '20', '22:27:14'],
    5: ['小满', '21', '22:56:27'],
    6: ['夏至', '22', '07:41:40'],
    7: ['大暑', '23', '18:35:29'],
    8: ['处暑', '24', '00:53:15'],
    9: ['秋分', '23', '21:13:03'],
    10: ['霜降', '24', '05:05:14'],
    11: ['小雪', '22', '01:24:16'],
    12: ['冬至', '22', '14:01:39'],
  },
  1802: {
    1: ['大寒', '21', '00:40:26'],
    2: ['雨水', '19', '15:31:53'],
    3: ['春分', '21', '15:47:52'],
    4: ['谷雨', '21', '04:21:04'],
    5: ['小满', '22', '04:50:36'],
    6: ['夏至', '22', '13:35:20'],
    7: ['大暑', '24', '00:28:16'],
    8: ['处暑', '24', '06:44:16'],
    9: ['秋分', '24', '03:02:08'],
    10: ['霜降', '24', '10:53:12'],
    11: ['小雪', '23', '07:12:12'],
    12: ['冬至', '22', '19:50:33'],
  },
  1803: {
    1: ['大寒', '21', '06:30:19'],
    2: ['雨水', '19', '21:21:00'],
    3: ['春分', '21', '21:33:42'],
    4: ['谷雨', '21', '10:01:51'],
    5: ['小满', '22', '10:26:19'],
    6: ['夏至', '22', '19:08:01'],
    7: ['大暑', '24', '06:01:42'],
    8: ['处暑', '24', '12:21:24'],
    9: ['秋分', '24', '08:43:25'],
    10: ['霜降', '24', '16:37:31'],
    11: ['小雪', '23', '12:57:51'],
    12: ['冬至', '23', '01:35:50'],
  },
  1804: {
    1: ['大寒', '21', '12:14:27'],
    2: ['雨水', '20', '03:04:27'],
    3: ['春分', '21', '03:17:07'],
    4: ['谷雨', '20', '15:45:46'],
    5: ['小满', '21', '16:11:44'],
    6: ['夏至', '22', '00:56:03'],
    7: ['大暑', '23', '11:53:03'],
    8: ['处暑', '23', '18:16:11'],
    9: ['秋分', '23', '14:39:43'],
    10: ['霜降', '23', '22:32:32'],
    11: ['小雪', '22', '18:49:40'],
    12: ['冬至', '22', '07:24:02'],
  },
  1805: {
    1: ['大寒', '20', '18:00:08'],
    2: ['雨水', '19', '08:49:47'],
    3: ['春分', '21', '09:04:21'],
    4: ['谷雨', '20', '21:35:57'],
    5: ['小满', '21', '22:04:14'],
    6: ['夏至', '22', '06:49:22'],
    7: ['大暑', '23', '17:45:11'],
    8: ['处暑', '24', '00:06:13'],
    9: ['秋分', '23', '20:28:54'],
    10: ['霜降', '24', '04:21:54'],
    11: ['小雪', '23', '00:39:11'],
    12: ['冬至', '22', '13:13:12'],
  },
  1806: {
    1: ['大寒', '20', '23:48:38'],
    2: ['雨水', '19', '14:37:47'],
    3: ['春分', '21', '14:52:09'],
    4: ['谷雨', '21', '03:22:48'],
    5: ['小满', '22', '03:48:24'],
    6: ['夏至', '22', '12:29:54'],
    7: ['大暑', '23', '23:23:05'],
    8: ['处暑', '24', '05:43:26'],
    9: ['秋分', '24', '02:07:51'],
    10: ['霜降', '24', '10:04:42'],
    11: ['小雪', '23', '06:26:26'],
    12: ['冬至', '22', '19:03:52'],
  },
  1807: {
    1: ['大寒', '21', '05:40:41'],
    2: ['雨水', '19', '20:29:01'],
    3: ['春分', '21', '20:41:22'],
    4: ['谷雨', '21', '09:10:58'],
    5: ['小满', '22', '09:37:32'],
    6: ['夏至', '22', '18:20:45'],
    7: ['大暑', '24', '05:15:12'],
    8: ['处暑', '24', '11:36:20'],
    9: ['秋分', '24', '08:01:37'],
    10: ['霜降', '24', '16:00:02'],
    11: ['小雪', '23', '12:23:13'],
    12: ['冬至', '23', '01:00:47'],
  },
  1808: {
    1: ['大寒', '21', '11:35:57'],
    2: ['雨水', '20', '02:21:02'],
    3: ['春分', '21', '02:29:25'],
    4: ['谷雨', '20', '14:55:50'],
    5: ['小满', '21', '15:21:27'],
    6: ['夏至', '22', '00:06:03'],
    7: ['大暑', '23', '11:02:45'],
    8: ['处暑', '23', '17:25:37'],
    9: ['秋分', '23', '13:51:07'],
    10: ['霜降', '23', '21:48:31'],
    11: ['小雪', '22', '18:11:11'],
    12: ['冬至', '22', '06:49:37'],
  },
  1809: {
    1: ['大寒', '20', '17:26:25'],
    2: ['雨水', '19', '08:12:55'],
    3: ['春分', '21', '08:21:45'],
    4: ['谷雨', '20', '20:47:28'],
    5: ['小满', '21', '21:12:09'],
    6: ['夏至', '22', '05:56:36'],
    7: ['大暑', '23', '16:53:50'],
    8: ['处暑', '23', '23:17:06'],
    9: ['秋分', '23', '19:42:02'],
    10: ['霜降', '24', '03:37:47'],
    11: ['小雪', '22', '23:58:58'],
    12: ['冬至', '22', '12:37:39'],
  },
  1810: {
    1: ['大寒', '20', '23:16:57'],
    2: ['雨水', '19', '14:07:28'],
    3: ['春分', '21', '14:20:26'],
    4: ['谷雨', '21', '02:48:47'],
    5: ['小满', '22', '03:13:21'],
    6: ['夏至', '22', '11:55:30'],
    7: ['大暑', '23', '22:50:14'],
    8: ['处暑', '24', '05:11:54'],
    9: ['秋分', '24', '01:36:39'],
    10: ['霜降', '24', '09:33:11'],
    11: ['小雪', '23', '05:55:01'],
    12: ['冬至', '22', '18:33:57'],
  },
  1811: {
    1: ['大寒', '21', '05:13:00'],
    2: ['雨水', '19', '20:02:19'],
    3: ['春分', '21', '20:12:56'],
    4: ['谷雨', '21', '08:37:52'],
    5: ['小满', '22', '08:58:14'],
    6: ['夏至', '22', '17:36:18'],
    7: ['大暑', '24', '04:28:54'],
    8: ['处暑', '24', '10:51:40'],
    9: ['秋分', '24', '07:20:00'],
    10: ['霜降', '24', '15:20:55'],
    11: ['小雪', '23', '11:45:54'],
    12: ['冬至', '23', '00:25:07'],
  },
  1812: {
    1: ['大寒', '21', '11:02:08'],
    2: ['雨水', '20', '01:49:15'],
    3: ['春分', '21', '01:58:53'],
    4: ['谷雨', '20', '14:24:35'],
    5: ['小满', '21', '14:47:26'],
    6: ['夏至', '21', '23:28:48'],
    7: ['大暑', '23', '10:24:00'],
    8: ['处暑', '23', '16:47:56'],
    9: ['秋分', '23', '13:15:45'],
    10: ['霜降', '23', '21:15:07'],
    11: ['小雪', '22', '17:38:25'],
    12: ['冬至', '22', '06:16:16'],
  },
  1813: {
    1: ['大寒', '20', '16:52:13'],
    2: ['雨水', '19', '07:38:55'],
    3: ['春分', '21', '07:49:35'],
    4: ['谷雨', '21', '20:17:54'],
    5: ['小满', '21', '20:43:56'],
    6: ['夏至', '22', '05:27:30'],
    7: ['大暑', '23', '16:22:16'],
    8: ['处暑', '23', '22:43:02'],
    9: ['秋分', '23', '19:07:30'],
    10: ['霜降', '24', '03:04:58'],
    11: ['小雪', '22', '23:28:08'],
    12: ['冬至', '22', '12:07:16'],
  },
  1814: {
    1: ['大寒', '20', '22:44:58'],
    2: ['雨水', '19', '13:32:39'],
    3: ['春分', '21', '13:42:42'],
    4: ['谷雨', '21', '02:08:22'],
    5: ['小满', '22', '02:30:11'],
    6: ['夏至', '22', '11:09:28'],
    7: ['大暑', '23', '22:01:44'],
    8: ['处暑', '24', '04:21:47'],
    9: ['秋分', '24', '00:46:24'],
    10: ['霜降', '24', '08:44:45'],
    11: ['小雪', '23', '05:09:43'],
    12: ['冬至', '22', '17:51:17'],
  },
  1815: {
    1: ['大寒', '21', '04:31:24'],
    2: ['雨水', '19', '19:20:25'],
    3: ['春分', '21', '19:30:08'],
    4: ['谷雨', '21', '07:55:00'],
    5: ['小满', '22', '08:17:12'],
    6: ['夏至', '22', '16:58:08'],
    7: ['大暑', '24', '03:52:40'],
    8: ['处暑', '23', '10:15:20'],
    9: ['秋分', '24', '06:41:55'],
    10: ['霜降', '24', '14:40:47'],
    11: ['小雪', '23', '11:04:21'],
    12: ['冬至', '22', '23:43:12'],
  },
  1816: {
    1: ['大寒', '21', '10:20:25'],
    2: ['雨水', '20', '01:07:15'],
    3: ['春分', '21', '01:15:44'],
    4: ['谷雨', '20', '13:39:56'],
    5: ['小满', '21', '14:02:07'],
    6: ['夏至', '21', '22:44:11'],
    7: ['大暑', '23', '09:40:27'],
    8: ['处暑', '23', '16:04:51'],
    9: ['秋分', '23', '12:32:38'],
    10: ['霜降', '23', '20:31:11'],
    11: ['小雪', '22', '16:53:13'],
    12: ['冬至', '22', '05:30:04'],
  },
  1817: {
    1: ['大寒', '20', '16:05:30'],
    2: ['雨水', '19', '06:51:30'],
    3: ['春分', '21', '07:00:18'],
    4: ['谷雨', '20', '19:25:22'],
    5: ['小满', '21', '19:47:58'],
    6: ['夏至', '22', '04:29:48'],
    7: ['大暑', '23', '15:25:50'],
    8: ['处暑', '23', '21:50:08'],
    9: ['秋分', '23', '18:18:02'],
    10: ['霜降', '24', '02:17:00'],
    11: ['小雪', '22', '22:39:24'],
    12: ['冬至', '22', '11:16:29'],
  },
  1818: {
    1: ['大寒', '20', '21:52:16'],
    2: ['雨水', '19', '12:39:05'],
    3: ['春分', '21', '12:49:30'],
    4: ['谷雨', '21', '01:16:50'],
    5: ['小满', '22', '01:41:05'],
    6: ['夏至', '22', '10:22:52'],
    7: ['大暑', '23', '21:17:50'],
    8: ['处暑', '24', '03:41:10'],
    9: ['秋分', '24', '00:09:08'],
    10: ['霜降', '24', '08:09:44'],
    11: ['小雪', '23', '04:34:48'],
    12: ['冬至', '22', '17:14:07'],
  },
  1819: {
    1: ['大寒', '21', '03:49:56'],
    2: ['雨水', '19', '18:33:36'],
    3: ['春分', '21', '18:38:20'],
    4: ['谷雨', '21', '06:59:30'],
    5: ['小满', '22', '07:18:52'],
    6: ['夏至', '22', '15:57:41'],
    7: ['大暑', '24', '02:51:30'],
    8: ['处暑', '24', '09:15:53'],
    9: ['秋分', '24', '05:46:50'],
    10: ['霜降', '24', '13:51:24'],
    11: ['小雪', '23', '10:20:12'],
    12: ['冬至', '22', '23:01:45'],
  },
  1820: {
    1: ['大寒', '21', '09:38:01'],
    2: ['雨水', '20', '00:20:42'],
    3: ['春分', '21', '00:23:28'],
    4: ['谷雨', '20', '12:42:25'],
    5: ['小满', '21', '13:01:12'],
    6: ['夏至', '21', '21:42:12'],
    7: ['大暑', '23', '08:39:39'],
    8: ['处暑', '23', '15:06:36'],
    9: ['秋分', '23', '11:37:36'],
    10: ['霜降', '23', '19:40:20'],
    11: ['小雪', '22', '16:07:09'],
    12: ['冬至', '22', '04:48:01'],
  },
  1821: {
    1: ['大寒', '20', '15:25:11'],
    2: ['雨水', '19', '06:09:55'],
    3: ['春分', '21', '06:15:10'],
    4: ['谷雨', '20', '18:36:12'],
    5: ['小满', '21', '18:55:59'],
    6: ['夏至', '22', '03:37:01'],
    7: ['大暑', '23', '14:33:39'],
    8: ['处暑', '23', '20:58:51'],
    9: ['秋分', '23', '17:27:56'],
    10: ['霜降', '24', '01:28:54'],
    11: ['小雪', '22', '21:54:34'],
    12: ['冬至', '22', '10:35:38'],
  },
  1822: {
    1: ['大寒', '20', '21:14:34'],
    2: ['雨水', '19', '12:01:55'],
    3: ['春分', '21', '12:09:04'],
    4: ['谷雨', '21', '00:29:10'],
    5: ['小满', '22', '00:44:23'],
    6: ['夏至', '22', '09:18:38'],
    7: ['大暑', '23', '20:09:52'],
    8: ['处暑', '24', '02:33:11'],
    9: ['秋分', '23', '23:03:18'],
    10: ['霜降', '24', '07:06:51'],
    11: ['小雪', '23', '03:35:03'],
    12: ['冬至', '22', '16:17:57'],
  },
  1823: {
    1: ['大寒', '21', '02:58:13'],
    2: ['雨水', '19', '17:46:33'],
    3: ['春分', '21', '17:54:24'],
    4: ['谷雨', '21', '06:15:36'],
    5: ['小满', '22', '06:32:34'],
    6: ['夏至', '22', '15:08:17'],
    7: ['大暑', '24', '02:00:05'],
    8: ['处暑', '24', '08:24:13'],
    9: ['秋分', '24', '04:56:01'],
    10: ['霜降', '24', '13:01:25'],
    11: ['小雪', '23', '09:30:04'],
    12: ['冬至', '22', '22:11:03'],
  },
  1824: {
    1: ['大寒', '21', '08:47:40'],
    2: ['雨水', '19', '23:32:27'],
    3: ['春分', '20', '23:38:31'],
    4: ['谷雨', '20', '12:00:15'],
    5: ['小满', '21', '12:19:33'],
    6: ['夏至', '21', '20:58:19'],
    7: ['大暑', '23', '07:51:57'],
    8: ['处暑', '23', '14:15:51'],
    9: ['秋分', '23', '10:46:18'],
    10: ['霜降', '23', '18:50:12'],
    11: ['小雪', '22', '15:18:08'],
    12: ['冬至', '22', '03:59:06'],
  },
  1825: {
    1: ['大寒', '20', '14:35:32'],
    2: ['雨水', '19', '05:19:41'],
    3: ['春分', '21', '05:25:16'],
    4: ['谷雨', '20', '17:47:16'],
    5: ['小满', '21', '18:07:23'],
    6: ['夏至', '22', '02:46:48'],
    7: ['大暑', '23', '13:40:29'],
    8: ['处暑', '23', '20:03:08'],
    9: ['秋分', '23', '16:31:20'],
    10: ['霜降', '24', '00:33:16'],
    11: ['小雪', '22', '21:00:38'],
    12: ['冬至', '22', '09:42:47'],
  },
  1826: {
    1: ['大寒', '20', '20:21:41'],
    2: ['雨水', '19', '11:08:27'],
    3: ['春分', '21', '11:16:00'],
    4: ['谷雨', '20', '23:39:27'],
    5: ['小满', '22', '00:00:54'],
    6: ['夏至', '22', '08:41:38'],
    7: ['大暑', '23', '19:36:36'],
    8: ['处暑', '24', '02:00:06'],
    9: ['秋分', '23', '22:28:12'],
    10: ['霜降', '24', '06:29:35'],
    11: ['小雪', '23', '02:56:45'],
    12: ['冬至', '22', '15:39:20'],
  },
  1827: {
    1: ['大寒', '21', '02:18:23'],
    2: ['雨水', '19', '17:03:43'],
    3: ['春分', '21', '17:07:44'],
    4: ['谷雨', '21', '05:26:09'],
    5: ['小满', '22', '05:42:51'],
    6: ['夏至', '22', '14:20:51'],
    7: ['大暑', '24', '01:15:41'],
    8: ['处暑', '24', '07:41:41'],
    9: ['秋分', '24', '04:13:30'],
    10: ['霜降', '24', '12:17:45'],
    11: ['小雪', '23', '08:45:49'],
    12: ['冬至', '22', '21:27:23'],
  },
  1828: {
    1: ['大寒', '21', '08:04:49'],
    2: ['雨水', '19', '22:49:13'],
    3: ['春分', '20', '22:52:59'],
    4: ['谷雨', '20', '11:11:15'],
    5: ['小满', '21', '11:28:03'],
    6: ['夏至', '21', '20:07:34'],
    7: ['大暑', '23', '07:05:43'],
    8: ['处暑', '23', '13:35:24'],
    9: ['秋分', '23', '10:09:32'],
    10: ['霜降', '23', '18:13:51'],
    11: ['小雪', '22', '14:39:52'],
    12: ['冬至', '22', '03:18:21'],
  },
  1829: {
    1: ['大寒', '20', '13:53:07'],
    2: ['雨水', '19', '04:36:37'],
    3: ['春分', '21', '04:41:55'],
    4: ['谷雨', '21', '17:03:33'],
    5: ['小满', '21', '17:23:39'],
    6: ['夏至', '22', '02:04:46'],
    7: ['大暑', '23', '13:02:43'],
    8: ['处暑', '23', '19:31:12'],
    9: ['秋分', '23', '16:04:39'],
    10: ['霜降', '24', '00:09:20'],
    11: ['小雪', '22', '20:36:09'],
    12: ['冬至', '22', '09:15:05'],
  },
  1830: {
    1: ['大寒', '20', '19:49:37'],
    2: ['雨水', '19', '10:32:24'],
    3: ['春分', '21', '10:36:34'],
    4: ['谷雨', '20', '22:55:59'],
    5: ['小满', '21', '23:12:18'],
    6: ['夏至', '22', '07:48:03'],
    7: ['大暑', '23', '18:40:52'],
    8: ['处暑', '24', '01:06:55'],
    9: ['秋分', '23', '21:41:17'],
    10: ['霜降', '24', '05:49:35'],
    11: ['小雪', '23', '02:21:21'],
    12: ['冬至', '22', '15:04:47'],
  },
  1831: {
    1: ['大寒', '21', '01:41:49'],
    2: ['雨水', '19', '16:24:19'],
    3: ['春分', '21', '16:26:02'],
    4: ['谷雨', '21', '04:43:03'],
    5: ['小满', '22', '04:58:57'],
    6: ['夏至', '22', '13:36:25'],
    7: ['大暑', '24', '00:31:12'],
    8: ['处暑', '24', '06:58:42'],
    9: ['秋分', '24', '03:34:44'],
    10: ['霜降', '24', '11:45:00'],
    11: ['小雪', '23', '08:18:02'],
    12: ['冬至', '22', '21:01:26'],
  },
  1832: {
    1: ['大寒', '21', '07:37:04'],
    2: ['雨水', '19', '22:17:11'],
    3: ['春分', '20', '22:16:20'],
    4: ['谷雨', '20', '10:31:36'],
    5: ['小满', '21', '10:47:22'],
    6: ['夏至', '21', '19:26:46'],
    7: ['大暑', '23', '06:24:18'],
    8: ['处暑', '23', '12:52:53'],
    9: ['秋分', '23', '09:27:37'],
    10: ['霜降', '23', '17:35:34'],
    11: ['小雪', '22', '14:07:25'],
    12: ['冬至', '22', '02:51:33'],
  },
  1833: {
    1: ['大寒', '20', '13:29:13'],
    2: ['雨水', '19', '04:11:26'],
    3: ['春分', '21', '04:11:42'],
    4: ['谷雨', '20', '16:26:29'],
    5: ['小满', '21', '16:40:13'],
    6: ['夏至', '22', '01:16:26'],
    7: ['大暑', '23', '12:11:22'],
    8: ['处暑', '23', '18:38:39'],
    9: ['秋分', '23', '15:12:07'],
    10: ['霜降', '23', '23:18:22'],
    11: ['小雪', '22', '19:48:55'],
    12: ['冬至', '22', '08:33:23'],
  },
  1834: {
    1: ['大寒', '20', '19:13:36'],
    2: ['雨水', '19', '09:59:51'],
    3: ['春分', '21', '10:04:04'],
    4: ['谷雨', '20', '22:21:29'],
    5: ['小满', '21', '22:35:59'],
    6: ['夏至', '22', '07:11:27'],
    7: ['大暑', '23', '18:05:09'],
    8: ['处暑', '24', '00:32:08'],
    9: ['秋分', '23', '21:06:35'],
    10: ['霜降', '24', '05:14:12'],
    11: ['小雪', '23', '01:45:30'],
    12: ['冬至', '22', '14:29:52'],
  },
  1835: {
    1: ['大寒', '21', '01:09:02'],
    2: ['雨水', '19', '15:53:29'],
    3: ['春分', '21', '15:55:30'],
    4: ['谷雨', '21', '04:10:14'],
    5: ['小满', '22', '04:21:47'],
    6: ['夏至', '22', '12:54:37'],
    7: ['大暑', '23', '23:46:14'],
    8: ['处暑', '24', '06:12:42'],
    9: ['秋分', '24', '02:48:59'],
    10: ['霜降', '24', '10:59:43'],
    11: ['小雪', '23', '07:33:29'],
    12: ['冬至', '22', '20:18:03'],
  },
  1836: {
    1: ['大寒', '21', '06:55:30'],
    2: ['雨水', '19', '21:37:54'],
    3: ['春分', '20', '21:38:47'],
    4: ['谷雨', '20', '09:53:39'],
    5: ['小满', '21', '10:06:15'],
    6: ['夏至', '21', '18:40:56'],
    7: ['大暑', '23', '05:34:51'],
    8: ['处暑', '23', '12:02:22'],
    9: ['秋分', '23', '08:37:48'],
    10: ['霜降', '23', '16:46:50'],
    11: ['小雪', '22', '13:18:54'],
    12: ['冬至', '22', '02:02:14'],
  },
  1837: {
    1: ['大寒', '20', '12:38:51'],
    2: ['雨水', '19', '03:21:02'],
    3: ['春分', '21', '03:23:07'],
    4: ['谷雨', '20', '15:41:17'],
    5: ['小满', '21', '15:58:24'],
    6: ['夏至', '22', '00:36:44'],
    7: ['大暑', '23', '11:32:01'],
    8: ['处暑', '23', '17:58:22'],
    9: ['秋分', '23', '14:31:09'],
    10: ['霜降', '23', '22:37:48'],
    11: ['小雪', '22', '19:09:01'],
    12: ['冬至', '22', '07:53:08'],
  },
  1838: {
    1: ['大寒', '20', '18:31:27'],
    2: ['雨水', '19', '09:14:59'],
    3: ['春分', '21', '09:16:45'],
    4: ['谷雨', '20', '21:32:11'],
    5: ['小满', '21', '21:44:59'],
    6: ['夏至', '22', '06:18:27'],
    7: ['大暑', '23', '17:09:39'],
    8: ['处暑', '23', '23:34:06'],
    9: ['秋分', '23', '20:06:50'],
    10: ['霜降', '24', '04:14:19'],
    11: ['小雪', '23', '00:47:02'],
    12: ['冬至', '22', '13:33:10'],
  },
  1839: {
    1: ['大寒', '21', '00:13:29'],
    2: ['雨水', '19', '14:58:03'],
    3: ['春分', '21', '14:59:14'],
    4: ['谷雨', '21', '03:13:09'],
    5: ['小满', '22', '03:25:15'],
    6: ['夏至', '22', '12:00:18'],
    7: ['大暑', '23', '22:54:42'],
    8: ['处暑', '24', '05:22:49'],
    9: ['秋分', '24', '01:58:57'],
    10: ['霜降', '24', '10:08:02'],
    11: ['小雪', '23', '06:39:20'],
    12: ['冬至', '22', '19:21:52'],
  },
  1840: {
    1: ['大寒', '21', '05:58:09'],
    2: ['雨水', '19', '20:39:57'],
    3: ['春分', '20', '20:40:29'],
    4: ['谷雨', '20', '08:55:33'],
    5: ['小满', '21', '09:09:40'],
    6: ['夏至', '21', '17:47:32'],
    7: ['大暑', '23', '04:45:16'],
    8: ['处暑', '23', '11:15:47'],
    9: ['秋分', '23', '07:52:40'],
    10: ['霜降', '23', '16:01:17'],
    11: ['小雪', '22', '12:31:26'],
    12: ['冬至', '22', '01:12:23'],
  },
  1841: {
    1: ['大寒', '20', '11:47:03'],
    2: ['雨水', '19', '02:27:44'],
    3: ['春分', '21', '02:28:02'],
    4: ['谷雨', '20', '14:43:32'],
    5: ['小满', '21', '14:57:28'],
    6: ['夏至', '21', '23:33:06'],
    7: ['大暑', '23', '10:28:03'],
    8: ['处暑', '23', '16:57:04'],
    9: ['秋分', '23', '13:33:33'],
    10: ['霜降', '23', '21:42:32'],
    11: ['小雪', '22', '18:13:33'],
    12: ['冬至', '22', '06:55:24'],
  },
  1842: {
    1: ['大寒', '20', '17:30:46'],
    2: ['雨水', '19', '08:11:58'],
    3: ['春分', '21', '08:12:48'],
    4: ['谷雨', '20', '20:29:13'],
    5: ['小满', '21', '20:44:37'],
    6: ['夏至', '22', '05:21:45'],
    7: ['大暑', '23', '16:17:19'],
    8: ['处暑', '23', '22:47:03'],
    9: ['秋分', '23', '19:25:21'],
    10: ['霜降', '24', '03:37:04'],
    11: ['小雪', '23', '00:11:09'],
    12: ['冬至', '22', '12:55:16'],
  },
  1843: {
    1: ['大寒', '20', '23:30:31'],
    2: ['雨水', '19', '14:08:35'],
    3: ['春分', '21', '14:04:19'],
    4: ['谷雨', '21', '02:15:16'],
    5: ['小满', '22', '02:26:38'],
    6: ['夏至', '22', '11:02:15'],
    7: ['大暑', '23', '21:58:01'],
    8: ['处暑', '24', '04:28:40'],
    9: ['秋分', '24', '01:09:02'],
    10: ['霜降', '24', '09:23:58'],
    11: ['小雪', '23', '06:01:16'],
    12: ['冬至', '22', '18:47:23'],
  },
  1844: {
    1: ['大寒', '21', '05:23:06'],
    2: ['雨水', '19', '20:00:11'],
    3: ['春分', '20', '19:53:35'],
    4: ['谷雨', '20', '08:01:34'],
    5: ['小满', '21', '08:10:29'],
    6: ['夏至', '21', '16:45:46'],
    7: ['大暑', '23', '03:43:48'],
    8: ['处暑', '23', '10:16:45'],
    9: ['秋分', '23', '06:57:04'],
    10: ['霜降', '23', '15:10:05'],
    11: ['小雪', '22', '11:45:22'],
    12: ['冬至', '22', '00:30:48'],
  },
  1845: {
    1: ['大寒', '20', '11:07:35'],
    2: ['雨水', '19', '01:47:04'],
    3: ['春分', '21', '01:43:26'],
    4: ['谷雨', '20', '13:54:18'],
    5: ['小满', '21', '14:05:30'],
    6: ['夏至', '21', '22:41:57'],
    7: ['大暑', '23', '09:40:13'],
    8: ['处暑', '23', '16:13:15'],
    9: ['秋分', '23', '12:53:30'],
    10: ['霜降', '23', '21:05:59'],
    11: ['小雪', '22', '17:40:46'],
    12: ['冬至', '22', '06:26:36'],
  },
  1846: {
    1: ['大寒', '20', '17:05:11'],
    2: ['雨水', '19', '07:47:18'],
    3: ['春分', '21', '07:45:23'],
    4: ['谷雨', '20', '19:54:55'],
    5: ['小满', '21', '20:01:16'],
    6: ['夏至', '22', '04:30:28'],
    7: ['大暑', '23', '15:21:33'],
    8: ['处暑', '23', '21:50:32'],
    9: ['秋分', '23', '18:30:56'],
    10: ['霜降', '24', '02:46:09'],
    11: ['小雪', '22', '23:24:01'],
    12: ['冬至', '22', '12:11:59'],
  },
  1847: {
    1: ['大寒', '20', '22:51:37'],
    2: ['雨水', '19', '13:34:00'],
    3: ['春分', '21', '13:31:57'],
    4: ['谷雨', '21', '01:41:28'],
    5: ['小满', '22', '01:48:03'],
    6: ['夏至', '22', '10:17:58'],
    7: ['大暑', '23', '21:09:58'],
    8: ['处暑', '24', '03:39:58'],
    9: ['秋分', '24', '00:22:09'],
    10: ['霜降', '24', '08:39:29'],
    11: ['小雪', '23', '05:18:08'],
    12: ['冬至', '22', '18:04:45'],
  },
  1848: {
    1: ['大寒', '21', '04:41:21'],
    2: ['雨水', '19', '19:20:43'],
    3: ['春分', '20', '19:17:38'],
    4: ['谷雨', '20', '07:29:04'],
    5: ['小满', '21', '07:39:41'],
    6: ['夏至', '21', '16:14:00'],
    7: ['大暑', '23', '03:09:09'],
    8: ['处暑', '23', '09:39:36'],
    9: ['秋分', '23', '06:19:47'],
    10: ['霜降', '23', '14:34:45'],
    11: ['小雪', '22', '11:12:32'],
    12: ['冬至', '21', '23:59:37'],
  },
  1849: {
    1: ['大寒', '20', '10:36:52'],
    2: ['雨水', '19', '01:16:10'],
    3: ['春分', '21', '01:12:31'],
    4: ['谷雨', '20', '13:23:35'],
    5: ['小满', '21', '13:34:00'],
    6: ['夏至', '21', '22:06:50'],
    7: ['大暑', '23', '08:59:08'],
    8: ['处暑', '23', '15:26:27'],
    9: ['秋分', '23', '12:03:21'],
    10: ['霜降', '23', '20:15:34'],
    11: ['小雪', '22', '16:52:16'],
    12: ['冬至', '22', '05:40:35'],
  },
  1850: {
    1: ['大寒', '20', '16:20:47'],
    2: ['雨水', '19', '07:03:20'],
    3: ['春分', '21', '07:01:45'],
    4: ['谷雨', '20', '19:13:25'],
    5: ['小满', '21', '19:24:12'],
    6: ['夏至', '22', '03:58:36'],
    7: ['大暑', '23', '14:52:59'],
    8: ['处暑', '23', '21:22:01'],
    9: ['秋分', '23', '18:00:02'],
    10: ['霜降', '24', '02:12:33'],
    11: ['小雪', '22', '22:49:08'],
    12: ['冬至', '22', '11:37:19'],
  },
  1851: {
    1: ['大寒', '20', '22:16:57'],
    2: ['雨水', '19', '12:58:00'],
    3: ['春分', '21', '12:53:55'],
    4: ['谷雨', '21', '01:02:13'],
    5: ['小满', '22', '01:09:42'],
    6: ['夏至', '22', '09:42:38'],
    7: ['大暑', '23', '20:38:02'],
    8: ['处暑', '24', '03:09:30'],
    9: ['秋分', '23', '23:50:20'],
    10: ['霜降', '24', '08:04:58'],
    11: ['小雪', '23', '04:41:51'],
    12: ['冬至', '22', '17:28:27'],
  },
  1852: {
    1: ['大寒', '21', '04:06:00'],
    2: ['雨水', '19', '18:45:41'],
    3: ['春分', '20', '18:41:02'],
    4: ['谷雨', '20', '06:49:01'],
    5: ['小满', '21', '06:55:49'],
    6: ['夏至', '21', '15:28:11'],
    7: ['大暑', '23', '02:24:42'],
    8: ['处暑', '23', '08:58:16'],
    9: ['秋分', '23', '05:40:09'],
    10: ['霜降', '23', '13:54:03'],
    11: ['小雪', '22', '10:28:39'],
    12: ['冬至', '21', '23:12:20'],
  },
  1853: {
    1: ['大寒', '20', '09:47:35'],
    2: ['雨水', '19', '00:26:40'],
    3: ['春分', '21', '00:23:41'],
    4: ['谷雨', '20', '12:35:20'],
    5: ['小满', '21', '12:46:32'],
    6: ['夏至', '21', '21:22:00'],
    7: ['大暑', '23', '08:19:25'],
    8: ['处暑', '23', '14:53:19'],
    9: ['秋分', '23', '11:36:00'],
    10: ['霜降', '23', '19:50:57'],
    11: ['小雪', '22', '16:26:31'],
    12: ['冬至', '22', '05:10:36'],
  },
  1854: {
    1: ['大寒', '20', '15:45:34'],
    2: ['雨水', '19', '06:23:56'],
    3: ['春分', '21', '06:19:38'],
    4: ['谷雨', '20', '18:28:44'],
    5: ['小满', '21', '18:36:14'],
    6: ['夏至', '22', '03:07:02'],
    7: ['大暑', '23', '13:59:13'],
    8: ['处暑', '23', '20:29:18'],
    9: ['秋分', '23', '17:11:45'],
    10: ['霜降', '24', '01:29:47'],
    11: ['小雪', '22', '22:09:54'],
    12: ['冬至', '22', '10:58:05'],
  },
  1855: {
    1: ['大寒', '20', '21:35:01'],
    2: ['雨水', '19', '12:12:24'],
    3: ['春分', '21', '12:04:59'],
    4: ['谷雨', '21', '00:10:48'],
    5: ['小满', '22', '00:16:17'],
    6: ['夏至', '22', '08:47:26'],
    7: ['大暑', '23', '19:41:43'],
    8: ['处暑', '24', '02:13:52'],
    9: ['秋分', '23', '22:58:08'],
    10: ['霜降', '24', '07:17:56'],
    11: ['小雪', '23', '03:59:05'],
    12: ['冬至', '22', '16:47:09'],
  },
  1856: {
    1: ['大寒', '21', '03:22:49'],
    2: ['雨水', '19', '17:58:10'],
    3: ['春分', '20', '17:48:53'],
    4: ['谷雨', '20', '05:54:09'],
    5: ['小满', '21', '06:01:08'],
    6: ['夏至', '21', '14:35:34'],
    7: ['大暑', '23', '01:34:11'],
    8: ['处暑', '23', '08:09:20'],
    9: ['秋分', '23', '04:53:12'],
    10: ['霜降', '23', '13:10:35'],
    11: ['小雪', '22', '09:50:06'],
    12: ['冬至', '21', '22:38:23'],
  },
  1857: {
    1: ['大寒', '20', '09:15:42'],
    2: ['雨水', '18', '23:53:03'],
    3: ['春分', '20', '23:44:55'],
    4: ['谷雨', '20', '11:49:50'],
    5: ['小满', '21', '11:54:43'],
    6: ['夏至', '21', '20:24:50'],
    7: ['大暑', '23', '07:18:17'],
    8: ['处暑', '23', '13:50:04'],
    9: ['秋分', '23', '10:32:16'],
    10: ['霜降', '23', '18:48:19'],
    11: ['小雪', '22', '15:26:48'],
    12: ['冬至', '22', '04:15:24'],
  },
  1858: {
    1: ['大寒', '20', '14:55:05'],
    2: ['雨水', '19', '05:36:12'],
    3: ['春分', '21', '05:31:36'],
    4: ['谷雨', '20', '17:38:11'],
    5: ['小满', '21', '17:42:45'],
    6: ['夏至', '22', '02:12:18'],
    7: ['大暑', '23', '13:05:27'],
    8: ['处暑', '23', '19:37:40'],
    9: ['秋分', '23', '16:21:54'],
    10: ['霜降', '24', '00:40:44'],
    11: ['小雪', '22', '21:21:05'],
    12: ['冬至', '22', '10:09:40'],
  },
  1859: {
    1: ['大寒', '20', '20:47:18'],
    2: ['雨水', '19', '11:25:25'],
    3: ['春分', '21', '11:18:14'],
    4: ['谷雨', '20', '23:23:08'],
    5: ['小满', '21', '23:26:36'],
    6: ['夏至', '22', '07:55:41'],
    7: ['大暑', '23', '18:49:08'],
    8: ['处暑', '24', '01:22:00'],
    9: ['秋分', '23', '22:07:38'],
    10: ['霜降', '24', '06:28:55'],
    11: ['小雪', '23', '03:11:32'],
    12: ['冬至', '22', '16:00:40'],
  },
  1860: {
    1: ['大寒', '21', '02:37:05'],
    2: ['雨水', '19', '17:13:13'],
    3: ['春分', '20', '17:04:22'],
    4: ['谷雨', '20', '05:08:44'],
    5: ['小满', '21', '05:12:29'],
    6: ['夏至', '21', '13:41:48'],
    7: ['大暑', '23', '00:35:37'],
    8: ['处暑', '23', '07:08:22'],
    9: ['秋分', '23', '03:52:29'],
    10: ['霜降', '23', '12:11:33'],
    11: ['小雪', '22', '08:52:29'],
    12: ['冬至', '21', '21:41:03'],
  },
  1861: {
    1: ['大寒', '20', '08:17:41'],
    2: ['雨水', '18', '22:54:16'],
    3: ['春分', '20', '22:46:17'],
    4: ['谷雨', '20', '10:52:40'],
    5: ['小满', '21', '11:00:06'],
    6: ['夏至', '21', '19:33:27'],
    7: ['大暑', '23', '06:29:38'],
    8: ['处暑', '23', '13:03:00'],
    9: ['秋分', '23', '09:46:35'],
    10: ['霜降', '23', '18:04:26'],
    11: ['小雪', '22', '14:44:37'],
    12: ['冬至', '22', '03:33:39'],
  },
  1862: {
    1: ['大寒', '20', '14:11:50'],
    2: ['雨水', '19', '04:50:08'],
    3: ['春分', '21', '04:42:28'],
    4: ['谷雨', '20', '16:46:38'],
    5: ['小满', '21', '16:50:04'],
    6: ['夏至', '22', '01:19:17'],
    7: ['大暑', '23', '12:11:56'],
    8: ['处暑', '23', '18:42:58'],
    9: ['秋分', '23', '15:26:03'],
    10: ['霜降', '23', '23:44:58'],
    11: ['小雪', '22', '20:27:08'],
    12: ['冬至', '22', '09:18:30'],
  },
  1863: {
    1: ['大寒', '20', '19:58:45'],
    2: ['雨水', '19', '10:38:00'],
    3: ['春分', '21', '10:29:46'],
    4: ['谷雨', '20', '22:32:13'],
    5: ['小满', '21', '22:33:27'],
    6: ['夏至', '22', '07:01:42'],
    7: ['大暑', '23', '17:55:49'],
    8: ['处暑', '24', '00:29:54'],
    9: ['秋分', '23', '21:16:10'],
    10: ['霜降', '24', '05:36:46'],
    11: ['小雪', '23', '02:17:47'],
    12: ['冬至', '22', '15:05:47'],
  },
  1864: {
    1: ['大寒', '21', '01:42:06'],
    2: ['雨水', '19', '16:18:35'],
    3: ['春分', '20', '16:09:52'],
    4: ['谷雨', '20', '04:14:16'],
    5: ['小满', '21', '04:19:07'],
    6: ['夏至', '21', '12:51:40'],
    7: ['大暑', '22', '23:50:20'],
    8: ['处暑', '23', '06:28:13'],
    9: ['秋分', '23', '03:16:06'],
    10: ['霜降', '23', '11:36:30'],
    11: ['小雪', '22', '08:16:36'],
    12: ['冬至', '21', '21:03:20'],
  },
  1865: {
    1: ['大寒', '20', '07:38:25'],
    2: ['雨水', '18', '22:14:14'],
    3: ['春分', '20', '22:05:45'],
    4: ['谷雨', '20', '10:10:56'],
    5: ['小满', '21', '10:15:54'],
    6: ['夏至', '21', '18:45:54'],
    7: ['大暑', '23', '05:39:42'],
    8: ['处暑', '23', '12:13:20'],
    9: ['秋分', '23', '08:59:19'],
    10: ['霜降', '23', '17:19:44'],
    11: ['小雪', '22', '14:01:02'],
    12: ['冬至', '22', '02:49:25'],
  },
  1866: {
    1: ['大寒', '20', '13:25:59'],
    2: ['雨水', '19', '04:02:45'],
    3: ['春分', '21', '03:54:30'],
    4: ['谷雨', '20', '15:59:12'],
    5: ['小满', '21', '16:03:31'],
    6: ['夏至', '22', '00:33:49'],
    7: ['大暑', '23', '11:28:20'],
    8: ['处暑', '23', '18:02:40'],
    9: ['秋分', '23', '14:50:22'],
    10: ['霜降', '23', '23:13:50'],
    11: ['小雪', '22', '19:58:32'],
    12: ['冬至', '22', '08:49:15'],
  },
  1867: {
    1: ['大寒', '20', '19:25:31'],
    2: ['雨水', '19', '09:59:08'],
    3: ['春分', '21', '09:46:16'],
    4: ['谷雨', '20', '21:46:51'],
    5: ['小满', '21', '21:49:01'],
    6: ['夏至', '22', '06:19:39'],
    7: ['大暑', '23', '17:16:27'],
    8: ['处暑', '23', '23:53:09'],
    9: ['秋分', '23', '20:42:30'],
    10: ['霜降', '24', '05:07:41'],
    11: ['小雪', '23', '01:54:24'],
    12: ['冬至', '22', '14:46:48'],
  },
  1868: {
    1: ['大寒', '21', '01:24:12'],
    2: ['雨水', '19', '15:57:52'],
    3: ['春分', '20', '15:43:35'],
    4: ['谷雨', '20', '03:41:40'],
    5: ['小满', '21', '03:41:10'],
    6: ['夏至', '21', '12:09:47'],
    7: ['大暑', '22', '23:06:03'],
    8: ['处暑', '23', '05:42:59'],
    9: ['秋分', '23', '02:31:05'],
    10: ['霜降', '23', '10:53:12'],
    11: ['小雪', '22', '07:36:46'],
    12: ['冬至', '21', '20:27:52'],
  },
  1869: {
    1: ['大寒', '20', '07:06:21'],
    2: ['雨水', '18', '21:42:53'],
    3: ['春分', '20', '21:31:57'],
    4: ['谷雨', '20', '09:32:45'],
    5: ['小满', '21', '09:34:11'],
    6: ['夏至', '21', '18:04:13'],
    7: ['大暑', '23', '05:01:06'],
    8: ['处暑', '23', '11:38:39'],
    9: ['秋分', '23', '08:27:51'],
    10: ['霜降', '23', '16:50:18'],
    11: ['小雪', '22', '13:33:08'],
    12: ['冬至', '22', '02:23:25'],
  },
  1870: {
    1: ['大寒', '20', '13:02:15'],
    2: ['雨水', '19', '03:40:41'],
    3: ['春分', '21', '03:31:53'],
    4: ['谷雨', '20', '15:32:52'],
    5: ['小满', '21', '15:31:21'],
    6: ['夏至', '21', '23:56:09'],
    7: ['大暑', '23', '10:47:28'],
    8: ['处暑', '23', '17:21:00'],
    9: ['秋分', '23', '14:09:26'],
    10: ['霜降', '23', '22:34:17'],
    11: ['小雪', '22', '19:20:30'],
    12: ['冬至', '22', '08:13:02'],
  },
  1871: {
    1: ['大寒', '20', '18:52:19'],
    2: ['雨水', '19', '09:29:45'],
    3: ['春分', '21', '09:19:37'],
    4: ['谷雨', '20', '21:19:50'],
    5: ['小满', '21', '21:17:45'],
    6: ['夏至', '22', '05:41:44'],
    7: ['大暑', '23', '16:32:37'],
    8: ['处暑', '23', '23:06:33'],
    9: ['秋分', '23', '19:56:01'],
    10: ['霜降', '24', '04:21:57'],
    11: ['小雪', '23', '01:08:10'],
    12: ['冬至', '22', '13:59:02'],
  },
  1872: {
    1: ['大寒', '21', '00:35:06'],
    2: ['雨水', '19', '15:09:07'],
    3: ['春分', '20', '14:57:16'],
    4: ['谷雨', '20', '02:58:57'],
    5: ['小满', '21', '03:01:38'],
    6: ['夏至', '21', '11:31:48'],
    7: ['大暑', '22', '22:27:47'],
    8: ['处暑', '23', '05:04:18'],
    9: ['秋分', '23', '01:53:23'],
    10: ['霜降', '23', '10:17:27'],
    11: ['小雪', '22', '07:02:30'],
    12: ['冬至', '21', '19:53:25'],
  },
  1873: {
    1: ['大寒', '20', '06:30:05'],
    2: ['雨水', '18', '21:04:22'],
    3: ['春分', '20', '20:52:19'],
    4: ['谷雨', '20', '08:53:43'],
    5: ['小满', '21', '08:56:08'],
    6: ['夏至', '21', '17:24:57'],
    7: ['大暑', '23', '04:17:38'],
    8: ['处暑', '23', '10:49:49'],
    9: ['秋分', '23', '07:35:04'],
    10: ['霜降', '23', '15:56:28'],
    11: ['小雪', '22', '12:40:33'],
    12: ['冬至', '22', '01:32:30'],
  },
  1874: {
    1: ['大寒', '20', '12:11:45'],
    2: ['雨水', '19', '02:48:43'],
    3: ['春分', '21', '02:37:53'],
    4: ['谷雨', '20', '14:38:24'],
    5: ['小满', '21', '14:38:50'],
    6: ['夏至', '21', '23:07:06'],
    7: ['大暑', '23', '10:01:23'],
    8: ['处暑', '23', '16:35:44'],
    9: ['秋分', '23', '13:22:49'],
    10: ['霜降', '23', '21:45:31'],
    11: ['小雪', '22', '18:30:13'],
    12: ['冬至', '22', '07:22:03'],
  },
  1875: {
    1: ['大寒', '20', '18:00:00'],
    2: ['雨水', '19', '08:34:43'],
    3: ['春分', '21', '08:21:11'],
    4: ['谷雨', '20', '20:19:15'],
    5: ['小满', '21', '20:18:14'],
    6: ['夏至', '22', '04:46:56'],
    7: ['大暑', '23', '15:44:22'],
    8: ['处暑', '23', '22:23:33'],
    9: ['秋分', '23', '19:14:56'],
    10: ['霜降', '24', '03:40:17'],
    11: ['小雪', '23', '00:25:28'],
    12: ['冬至', '22', '13:15:50'],
  },
  1876: {
    1: ['大寒', '20', '23:51:40'],
    2: ['雨水', '19', '14:24:36'],
    3: ['春分', '20', '14:09:53'],
    4: ['谷雨', '20', '02:07:02'],
    5: ['小满', '21', '02:04:57'],
    6: ['夏至', '21', '10:32:08'],
    7: ['大暑', '22', '21:28:19'],
    8: ['处暑', '23', '04:07:17'],
    9: ['秋分', '23', '00:58:39'],
    10: ['霜降', '23', '09:23:00'],
    11: ['小雪', '22', '06:06:12'],
    12: ['冬至', '21', '18:54:18'],
  },
  1877: {
    1: ['大寒', '20', '05:28:30'],
    2: ['雨水', '18', '20:01:12'],
    3: ['春分', '20', '19:47:51'],
    4: ['谷雨', '20', '07:47:28'],
    5: ['小满', '21', '07:48:15'],
    6: ['夏至', '21', '16:17:57'],
    7: ['大暑', '23', '03:15:16'],
    8: ['处暑', '23', '09:54:58'],
    9: ['秋分', '23', '06:48:08'],
    10: ['霜降', '23', '15:15:06'],
    11: ['小雪', '22', '12:00:42'],
    12: ['冬至', '22', '00:50:16'],
  },
  1878: {
    1: ['大寒', '20', '11:24:51'],
    2: ['雨水', '19', '01:57:08'],
    3: ['春分', '21', '01:42:37'],
    4: ['谷雨', '20', '13:40:05'],
    5: ['小满', '21', '13:37:45'],
    6: ['夏至', '21', '22:03:42'],
    7: ['大暑', '23', '08:57:17'],
    8: ['处暑', '23', '15:33:55'],
    9: ['秋分', '23', '12:26:31'],
    10: ['霜降', '23', '20:56:20'],
    11: ['小雪', '22', '17:46:54'],
    12: ['冬至', '22', '06:41:14'],
  },
  1879: {
    1: ['大寒', '20', '17:18:20'],
    2: ['雨水', '19', '07:49:48'],
    3: ['春分', '21', '07:31:55'],
    4: ['谷雨', '20', '19:25:29'],
    5: ['小满', '21', '19:20:02'],
    6: ['夏至', '22', '03:44:19'],
    7: ['大暑', '23', '14:37:58'],
    8: ['处暑', '23', '21:15:44'],
    9: ['秋分', '23', '18:09:17'],
    10: ['霜降', '24', '02:39:33'],
    11: ['小雪', '22', '23:30:10'],
    12: ['冬至', '22', '12:24:25'],
  },
  1880: {
    1: ['大寒', '20', '23:01:16'],
    2: ['雨水', '19', '13:32:11'],
    3: ['春分', '20', '13:13:35'],
    4: ['谷雨', '20', '01:07:05'],
    5: ['小满', '21', '01:03:27'],
    6: ['夏至', '21', '09:31:40'],
    7: ['大暑', '22', '20:30:10'],
    8: ['处暑', '23', '03:11:57'],
    9: ['秋分', '23', '00:06:43'],
    10: ['霜降', '23', '08:35:31'],
    11: ['小雪', '22', '05:24:22'],
    12: ['冬至', '21', '18:18:15'],
  },
  1881: {
    1: ['大寒', '20', '04:56:31'],
    2: ['雨水', '18', '19:29:59'],
    3: ['春分', '20', '19:13:52'],
    4: ['谷雨', '20', '07:08:31'],
    5: ['小满', '21', '07:03:44'],
    6: ['夏至', '21', '15:28:08'],
    7: ['大暑', '23', '02:21:14'],
    8: ['处暑', '23', '08:58:08'],
    9: ['秋分', '23', '05:50:07'],
    10: ['霜降', '23', '14:17:44'],
    11: ['小雪', '22', '11:06:06'],
    12: ['冬至', '22', '00:00:30'],
  },
  1882: {
    1: ['大寒', '20', '10:40:51'],
    2: ['雨水', '19', '01:17:34'],
    3: ['春分', '21', '01:04:36'],
    4: ['谷雨', '20', '13:00:33'],
    5: ['小满', '21', '12:54:30'],
    6: ['夏至', '21', '21:16:37'],
    7: ['大暑', '23', '08:08:05'],
    8: ['处暑', '23', '14:44:34'],
    9: ['秋分', '23', '11:37:42'],
    10: ['霜降', '23', '20:07:50'],
    11: ['小雪', '22', '16:58:37'],
    12: ['冬至', '22', '05:53:37'],
  },
  1883: {
    1: ['大寒', '20', '16:32:01'],
    2: ['雨水', '19', '07:05:30'],
    3: ['春分', '21', '06:49:46'],
    4: ['谷雨', '20', '18:44:41'],
    5: ['小满', '21', '18:39:27'],
    6: ['夏至', '22', '03:03:29'],
    7: ['大暑', '23', '13:57:30'],
    8: ['处暑', '23', '20:36:47'],
    9: ['秋分', '23', '17:32:18'],
    10: ['霜降', '24', '02:04:27'],
    11: ['小雪', '22', '22:56:43'],
    12: ['冬至', '22', '11:52:03'],
  },
  1884: {
    1: ['大寒', '20', '22:29:37'],
    2: ['雨水', '19', '13:01:34'],
    3: ['春分', '20', '12:44:32'],
    4: ['谷雨', '20', '00:39:06'],
    5: ['小满', '21', '00:34:31'],
    6: ['夏至', '21', '08:59:02'],
    7: ['大暑', '22', '19:52:12'],
    8: ['处暑', '23', '02:29:04'],
    9: ['秋分', '22', '23:21:14'],
    10: ['霜降', '23', '07:49:46'],
    11: ['小雪', '22', '04:39:16'],
    12: ['冬至', '21', '17:33:33'],
  },
  1885: {
    1: ['大寒', '20', '04:11:42'],
    2: ['雨水', '18', '18:45:02'],
    3: ['春分', '20', '18:29:38'],
    4: ['谷雨', '20', '06:25:59'],
    5: ['小满', '21', '06:23:34'],
    6: ['夏至', '21', '14:50:51'],
    7: ['大暑', '23', '01:46:17'],
    8: ['处暑', '23', '08:24:06'],
    9: ['秋分', '23', '05:16:11'],
    10: ['霜降', '23', '13:44:09'],
    11: ['小雪', '22', '10:33:07'],
    12: ['冬至', '21', '23:27:31'],
  },
  1886: {
    1: ['大寒', '20', '10:06:39'],
    2: ['雨水', '19', '00:41:23'],
    3: ['春分', '21', '00:26:25'],
    4: ['谷雨', '20', '12:21:29'],
    5: ['小满', '21', '12:16:35'],
    6: ['夏至', '21', '20:41:14'],
    7: ['大暑', '23', '07:35:01'],
    8: ['处暑', '23', '14:12:15'],
    9: ['秋分', '23', '11:04:31'],
    10: ['霜降', '23', '19:33:28'],
    11: ['小雪', '22', '16:23:58'],
    12: ['冬至', '22', '05:19:54'],
  },
  1887: {
    1: ['大寒', '20', '16:00:00'],
    2: ['雨水', '19', '06:34:37'],
    3: ['春分', '21', '06:18:30'],
    4: ['谷雨', '20', '18:11:44'],
    5: ['小满', '21', '18:04:38'],
    6: ['夏至', '22', '02:27:23'],
    7: ['大暑', '23', '13:20:42'],
    8: ['处暑', '23', '19:59:36'],
    9: ['秋分', '23', '16:54:18'],
    10: ['霜降', '24', '01:24:01'],
    11: ['小雪', '22', '22:12:39'],
    12: ['冬至', '22', '11:04:54'],
  },
  1888: {
    1: ['大寒', '21', '04:24:17'],
    2: ['雨水', '19', '18:35:07'],
    3: ['春分', '20', '17:38:35'],
    4: ['谷雨', '20', '04:44:47'],
    5: ['小满', '21', '03:56:40'],
    6: ['夏至', '21', '11:56:31'],
    7: ['大暑', '22', '22:51:05'],
    8: ['处暑', '23', '05:54:00'],
    9: ['秋分', '23', '03:28:50'],
    10: ['霜降', '23', '12:44:06'],
    11: ['小雪', '22', '10:11:59'],
    12: ['冬至', '21', '23:27:53'],
  },
  1889: {
    1: ['大寒', '20', '03:37:21'],
    2: ['雨水', '18', '18:07:44'],
    3: ['春分', '20', '17:50:53'],
    4: ['谷雨', '20', '05:46:53'],
    5: ['小满', '21', '05:44:00'],
    6: ['夏至', '21', '14:10:02'],
    7: ['大暑', '23', '01:04:42'],
    8: ['处暑', '23', '07:43:31'],
    9: ['秋分', '23', '04:38:13'],
    10: ['霜降', '23', '13:08:49'],
    11: ['小雪', '22', '09:58:50'],
    12: ['冬至', '21', '22:51:57'],
  },
  1890: {
    1: ['大寒', '20', '09:27:54'],
    2: ['雨水', '18', '23:58:49'],
    3: ['春分', '20', '23:41:03'],
    4: ['谷雨', '20', '11:35:02'],
    5: ['小满', '21', '11:29:45'],
    6: ['夏至', '21', '19:53:58'],
    7: ['大暑', '23', '06:47:49'],
    8: ['处暑', '23', '13:26:45'],
    9: ['秋分', '23', '10:22:36'],
    10: ['霜降', '23', '18:55:51'],
    11: ['小雪', '22', '15:49:20'],
    12: ['冬至', '22', '04:44:58'],
  },
  1891: {
    1: ['大寒', '20', '15:20:36'],
    2: ['雨水', '19', '05:48:03'],
    3: ['春分', '21', '05:24:56'],
    4: ['谷雨', '20', '17:14:01'],
    5: ['小满', '21', '17:06:45'],
    6: ['夏至', '22', '01:32:39'],
    7: ['大暑', '23', '12:30:44'],
    8: ['处暑', '23', '19:14:31'],
    9: ['秋分', '23', '16:13:54'],
    10: ['霜降', '24', '00:49:06'],
    11: ['小雪', '22', '21:43:51'],
    12: ['冬至', '22', '10:40:35'],
  },
  1892: {
    1: ['大寒', '20', '21:17:26'],
    2: ['雨水', '19', '11:45:37'],
    3: ['春分', '20', '11:22:02'],
    4: ['谷雨', '19', '23:09:15'],
    5: ['小满', '20', '22:59:35'],
    6: ['夏至', '21', '07:23:31'],
    7: ['大暑', '22', '18:20:04'],
    8: ['处暑', '23', '01:02:14'],
    9: ['秋分', '22', '21:59:37'],
    10: ['霜降', '23', '06:31:57'],
    11: ['小雪', '22', '03:23:48'],
    12: ['冬至', '21', '16:19:22'],
  },
  1893: {
    1: ['大寒', '20', '02:57:29'],
    2: ['雨水', '18', '17:28:43'],
    3: ['春分', '20', '17:08:28'],
    4: ['谷雨', '20', '04:57:37'],
    5: ['小满', '21', '04:47:37'],
    6: ['夏至', '21', '13:10:05'],
    7: ['大暑', '23', '00:05:34'],
    8: ['处暑', '23', '06:47:47'],
    9: ['秋分', '23', '03:46:20'],
    10: ['霜降', '23', '12:20:00'],
    11: ['小雪', '22', '09:12:13'],
    12: ['冬至', '21', '22:07:25'],
  },
  1894: {
    1: ['大寒', '20', '08:45:38'],
    2: ['雨水', '18', '23:18:07'],
    3: ['春分', '20', '22:59:22'],
    4: ['谷雨', '20', '10:49:04'],
    5: ['小满', '21', '10:37:45'],
    6: ['夏至', '21', '18:56:53'],
    7: ['大暑', '23', '05:48:45'],
    8: ['处暑', '23', '12:28:51'],
    9: ['秋分', '23', '09:27:31'],
    10: ['霜降', '23', '18:03:50'],
    11: ['小雪', '22', '15:00:00'],
    12: ['冬至', '22', '03:58:18'],
  },
  1895: {
    1: ['大寒', '20', '14:37:34'],
    2: ['雨水', '19', '05:09:17'],
    3: ['春分', '21', '04:49:18'],
    4: ['谷雨', '20', '16:38:12'],
    5: ['小满', '21', '16:26:19'],
    6: ['夏至', '22', '00:44:07'],
    7: ['大暑', '23', '11:33:42'],
    8: ['处暑', '23', '18:12:11'],
    9: ['秋分', '23', '15:10:31'],
    10: ['霜降', '23', '23:46:36'],
    11: ['小雪', '22', '20:41:58'],
    12: ['冬至', '22', '09:38:44'],
  },
  1896: {
    1: ['大寒', '20', '20:15:38'],
    2: ['雨水', '19', '10:44:49'],
    3: ['春分', '20', '10:23:24'],
    4: ['谷雨', '19', '22:13:04'],
    5: ['小满', '20', '22:04:40'],
    6: ['夏至', '21', '06:28:16'],
    7: ['大暑', '22', '17:23:28'],
    8: ['处暑', '23', '00:05:00'],
    9: ['秋分', '22', '21:03:35'],
    10: ['霜降', '23', '05:38:32'],
    11: ['小雪', '22', '02:32:53'],
    12: ['冬至', '21', '15:29:25'],
  },
  1897: {
    1: ['大寒', '20', '02:06:47'],
    2: ['雨水', '18', '16:36:41'],
    3: ['春分', '20', '16:16:13'],
    4: ['谷雨', '20', '04:07:19'],
    5: ['小满', '21', '04:00:06'],
    6: ['夏至', '21', '12:23:24'],
    7: ['大暑', '22', '23:16:38'],
    8: ['处暑', '23', '05:54:30'],
    9: ['秋分', '23', '02:49:00'],
    10: ['霜降', '23', '11:21:09'],
    11: ['小雪', '22', '08:14:49'],
    12: ['冬至', '21', '21:12:48'],
  },
  1898: {
    1: ['大寒', '20', '07:53:05'],
    2: ['雨水', '18', '22:25:51'],
    3: ['春分', '20', '22:06:31'],
    4: ['谷雨', '20', '09:56:17'],
    5: ['小满', '21', '09:46:15'],
    6: ['夏至', '21', '18:07:08'],
    7: ['大暑', '23', '04:59:45'],
    8: ['处暑', '23', '11:38:43'],
    9: ['秋分', '23', '08:34:36'],
    10: ['霜降', '23', '17:07:41'],
    11: ['小雪', '22', '14:01:43'],
    12: ['冬至', '22', '02:59:10'],
  },
  1899: {
    1: ['大寒', '20', '13:37:41'],
    2: ['雨水', '19', '04:07:54'],
    3: ['春分', '21', '03:45:46'],
    4: ['谷雨', '20', '15:33:12'],
    5: ['小满', '21', '15:22:35'],
    6: ['夏至', '21', '23:45:36'],
    7: ['大暑', '23', '10:42:57'],
    8: ['处暑', '23', '17:28:20'],
    9: ['秋分', '23', '14:30:09'],
    10: ['霜降', '23', '23:06:33'],
    11: ['小雪', '22', '20:00:44'],
    12: ['冬至', '22', '08:56:12'],
  },
  1900: {
    1: ['大寒', '21', '19:32:25'],
    2: ['雨水', '19', '10:01:14'],
    3: ['春分', '21', '09:39:01'],
    4: ['谷雨', '20', '21:27:06'],
    5: ['小满', '21', '21:16:55'],
    6: ['夏至', '22', '05:39:45'],
    7: ['大暑', '23', '16:36:07'],
    8: ['处暑', '23', '23:19:49'],
    9: ['秋分', '23', '20:20:11'],
    10: ['霜降', '24', '04:55:16'],
    11: ['小雪', '23', '01:47:50'],
    12: ['冬至', '22', '14:41:34'],
  },
  1901: {
    1: ['大寒', '21', '01:16:28'],
    2: ['雨水', '19', '15:44:54'],
    3: ['春分', '21', '15:23:35'],
    4: ['谷雨', '21', '03:13:26'],
    5: ['小满', '22', '03:04:39'],
    6: ['夏至', '22', '11:27:46'],
    7: ['大暑', '23', '22:23:45'],
    8: ['处暑', '24', '05:07:29'],
    9: ['秋分', '24', '02:08:56'],
    10: ['霜降', '24', '10:46:14'],
    11: ['小雪', '23', '07:41:13'],
    12: ['冬至', '22', '14:41:34'],
  },
  1902: {
    1: ['大寒', '21', '07:11:56'],
    2: ['雨水', '19', '21:39:42'],
    3: ['春分', '21', '21:16:33'],
    4: ['谷雨', '21', '09:04:08'],
    5: ['小满', '22', '08:53:31'],
    6: ['夏至', '22', '17:15:08'],
    7: ['大暑', '24', '04:09:52'],
    8: ['处暑', '24', '10:53:03'],
    9: ['秋分', '24', '07:55:20'],
    10: ['霜降', '24', '16:35:38'],
    11: ['小雪', '23', '13:35:23'],
    12: ['冬至', '23', '02:35:31'],
  },
  1903: {
    1: ['大寒', '21', '13:13:32'],
    2: ['雨水', '20', '03:40:48'],
    3: ['春分', '22', '03:14:46'],
    4: ['谷雨', '21', '14:58:39'],
    5: ['小满', '22', '14:45:01'],
    6: ['夏至', '22', '23:04:55'],
    7: ['大暑', '24', '09:58:45'],
    8: ['处暑', '24', '16:41:35'],
    9: ['秋分', '24', '13:43:41'],
    10: ['霜降', '24', '22:23:03'],
    11: ['小雪', '23', '19:21:24'],
    12: ['冬至', '23', '08:20:25'],
  },
  1904: {
    1: ['大寒', '21', '18:57:51'],
    2: ['雨水', '20', '09:24:51'],
    3: ['春分', '21', '08:58:34'],
    4: ['谷雨', '20', '20:42:08'],
    5: ['小满', '21', '20:28:55'],
    6: ['夏至', '22', '04:51:21'],
    7: ['大暑', '23', '15:49:35'],
    8: ['处暑', '23', '22:36:24'],
    9: ['秋分', '23', '19:40:12'],
    10: ['霜降', '24', '04:19:02'],
    11: ['小雪', '23', '01:15:53'],
    12: ['冬至', '22', '14:13:56'],
  },
  1905: {
    1: ['大寒', '21', '00:51:56'],
    2: ['雨水', '19', '15:20:58'],
    3: ['春分', '21', '14:57:31'],
    4: ['谷雨', '21', '02:43:45'],
    5: ['小满', '22', '02:31:16'],
    6: ['夏至', '22', '10:51:22'],
    7: ['大暑', '23', '21:45:37'],
    8: ['处暑', '24', '04:28:36'],
    9: ['秋分', '24', '01:29:56'],
    10: ['霜降', '24', '10:07:55'],
    11: ['小雪', '23', '07:04:53'],
    12: ['冬至', '22', '20:03:41'],
  },
  1906: {
    1: ['大寒', '21', '06:43:14'],
    2: ['雨水', '19', '21:14:27'],
    3: ['春分', '21', '20:52:47'],
    4: ['谷雨', '21', '08:39:10'],
    5: ['小满', '22', '08:24:55'],
    6: ['夏至', '22', '16:41:48'],
    7: ['大暑', '24', '03:32:32'],
    8: ['处暑', '24', '10:13:32'],
    9: ['秋分', '24', '07:14:59'],
    10: ['霜降', '24', '15:54:43'],
    11: ['小雪', '23', '12:53:51'],
    12: ['冬至', '23', '01:53:16'],
  },
  1907: {
    1: ['大寒', '21', '12:30:47'],
    2: ['雨水', '20', '02:58:18'],
    3: ['春分', '22', '02:32:59'],
    4: ['谷雨', '21', '14:17:13'],
    5: ['小满', '22', '14:03:14'],
    6: ['夏至', '22', '22:22:59'],
    7: ['大暑', '24', '09:17:56'],
    8: ['处暑', '24', '16:03:23'],
    9: ['秋分', '24', '13:08:52'],
    10: ['霜降', '24', '21:51:30'],
    11: ['小雪', '23', '18:52:03'],
    12: ['冬至', '23', '07:51:32'],
  },
  1908: {
    1: ['大寒', '21', '18:28:04'],
    2: ['雨水', '20', '08:53:54'],
    3: ['春分', '21', '08:27:14'],
    4: ['谷雨', '20', '20:11:15'],
    5: ['小满', '21', '19:58:06'],
    6: ['夏至', '22', '04:19:01'],
    7: ['大暑', '23', '15:14:05'],
    8: ['处暑', '23', '21:56:59'],
    9: ['秋分', '23', '18:58:15'],
    10: ['霜降', '24', '03:36:47'],
    11: ['小雪', '23', '00:34:37'],
    12: ['冬至', '22', '13:33:24'],
  },
  1909: {
    1: ['大寒', '21', '00:10:55'],
    2: ['雨水', '19', '14:38:19'],
    3: ['春分', '21', '14:12:56'],
    4: ['谷雨', '21', '01:57:44'],
    5: ['小满', '22', '01:44:52'],
    6: ['夏至', '22', '10:05:31'],
    7: ['大暑', '23', '21:00:26'],
    8: ['处暑', '24', '03:43:30'],
    9: ['秋分', '24', '00:44:29'],
    10: ['霜降', '24', '09:22:30'],
    11: ['小雪', '23', '06:20:15'],
    12: ['冬至', '22', '19:19:47'],
  },
  1910: {
    1: ['大寒', '21', '05:58:56'],
    2: ['雨水', '19', '20:28:07'],
    3: ['春分', '21', '20:02:52'],
    4: ['谷雨', '21', '07:45:42'],
    5: ['小满', '22', '07:30:08'],
    6: ['夏至', '22', '15:48:41'],
    7: ['大暑', '24', '02:42:56'],
    8: ['处暑', '24', '09:27:20'],
    9: ['秋分', '24', '06:30:44'],
    10: ['霜降', '24', '15:11:08'],
    11: ['小雪', '23', '12:10:50'],
    12: ['冬至', '23', '01:11:43'],
  },
  1911: {
    1: ['大寒', '21', '11:51:23'],
    2: ['雨水', '20', '02:20:16'],
    3: ['春分', '22', '01:54:20'],
    4: ['谷雨', '21', '13:35:55'],
    5: ['小满', '22', '13:18:33'],
    6: ['夏至', '22', '21:35:30'],
    7: ['大暑', '24', '08:28:36'],
    8: ['处暑', '24', '15:12:57'],
    9: ['秋分', '24', '12:17:30'],
    10: ['霜降', '24', '20:58:11'],
    11: ['小雪', '23', '17:55:53'],
    12: ['冬至', '23', '06:53:09'],
  },
  1912: {
    1: ['大寒', '21', '17:29:06'],
    2: ['雨水', '20', '07:55:34'],
    3: ['春分', '21', '07:29:19'],
    4: ['谷雨', '20', '19:12:21'],
    5: ['小满', '21', '18:57:06'],
    6: ['夏至', '22', '03:16:51'],
    7: ['大暑', '23', '14:13:40'],
    8: ['处暑', '23', '21:01:19'],
    9: ['秋分', '23', '18:07:59'],
    10: ['霜降', '24', '02:50:00'],
    11: ['小雪', '23', '23:48:08'],
    12: ['冬至', '22', '12:44:39'],
  },
  1913: {
    1: ['大寒', '20', '23:19:04'],
    2: ['雨水', '19', '13:44:12'],
    3: ['春分', '21', '13:17:55'],
    4: ['谷雨', '21', '01:02:51'],
    5: ['小满', '22', '00:49:51'],
    6: ['夏至', '22', '09:09:26'],
    7: ['大暑', '23', '20:03:41'],
    8: ['处暑', '24', '02:48:09'],
    9: ['秋分', '24', '23:52:41'],
    10: ['霜降', '24', '08:34:49'],
    11: ['小雪', '23', '05:35:12'],
    12: ['冬至', '22', '18:34:51'],
  },
  1914: {
    1: ['大寒', '21', '05:11:49'],
    2: ['雨水', '19', '19:37:54'],
    3: ['春分', '21', '19:10:42'],
    4: ['谷雨', '21', '06:53:12'],
    5: ['小满', '22', '06:37:38'],
    6: ['夏至', '22', '14:55:00'],
    7: ['大暑', '24', '01:46:52'],
    8: ['处暑', '24', '08:29:34'],
    9: ['秋分', '24', '05:33:47'],
    10: ['霜降', '24', '14:17:16'],
    11: ['小雪', '23', '11:20:21'],
    12: ['冬至', '23', '00:22:22'],
  },
  1915: {
    1: ['大寒', '21', '10:59:30'],
    2: ['雨水', '20', '01:23:03'],
    3: ['春分', '22', '00:51:14'],
    4: ['谷雨', '21', '12:28:46'],
    5: ['小满', '22', '12:10:23'],
    6: ['夏至', '22', '20:29:20'],
    7: ['大暑', '24', '07:26:21'],
    8: ['处暑', '24', '14:14:58'],
    9: ['秋分', '24', '11:23:45'],
    10: ['霜降', '24', '20:09:39'],
    11: ['小雪', '23', '17:13:26'],
    12: ['冬至', '23', '06:15:44'],
  },
  1916: {
    1: ['大寒', '21', '16:53:33'],
    2: ['雨水', '20', '07:17:59'],
    3: ['春分', '21', '06:46:50'],
    4: ['谷雨', '20', '18:24:35'],
    5: ['小满', '21', '18:05:50'],
    6: ['夏至', '22', '02:24:21'],
    7: ['大暑', '23', '13:21:08'],
    8: ['处暑', '23', '20:08:31'],
    9: ['秋分', '23', '17:14:43'],
    10: ['霜降', '24', '01:57:11'],
    11: ['小雪', '22', '22:57:44'],
    12: ['冬至', '22', '11:58:29'],
  },
  1917: {
    1: ['大寒', '20', '22:37:18'],
    2: ['雨水', '19', '13:04:44'],
    3: ['春分', '21', '12:37:11'],
    4: ['谷雨', '21', '00:17:22'],
    5: ['小满', '21', '23:58:31'],
    6: ['夏至', '22', '08:14:16'],
    7: ['大暑', '23', '19:07:45'],
    8: ['处暑', '24', '01:53:38'],
    9: ['秋分', '23', '23:00:06'],
    10: ['霜降', '24', '07:43:37'],
    11: ['小雪', '23', '04:44:52'],
    12: ['冬至', '22', '17:45:37'],
  },
  1918: {
    1: ['大寒', '21', '04:24:32'],
    2: ['雨水', '19', '18:52:41'],
    3: ['春分', '21', '18:25:37'],
    4: ['谷雨', '21', '06:05:23'],
    5: ['小满', '22', '05:45:27'],
    6: ['夏至', '22', '13:59:34'],
    7: ['大暑', '24', '00:51:23'],
    8: ['处暑', '24', '07:37:07'],
    9: ['秋分', '24', '04:45:37'],
    10: ['霜降', '24', '13:32:47'],
    11: ['小雪', '23', '10:38:02'],
    12: ['冬至', '22', '23:41:27'],
  },
  1919: {
    1: ['大寒', '21', '10:20:40'],
    2: ['雨水', '20', '00:47:25'],
    3: ['春分', '22', '00:19:05'],
    4: ['谷雨', '21', '11:58:35'],
    5: ['小满', '22', '11:39:04'],
    6: ['夏至', '22', '19:53:30'],
    7: ['大暑', '24', '06:44:26'],
    8: ['处暑', '24', '13:28:16'],
    9: ['秋分', '24', '10:35:18'],
    10: ['霜降', '24', '19:21:14'],
    11: ['小雪', '23', '16:25:07'],
    12: ['冬至', '23', '05:27:01'],
  },
  1920: {
    1: ['大寒', '21', '16:04:20'],
    2: ['雨水', '20', '06:28:57'],
    3: ['春分', '21', '05:59:15'],
    4: ['谷雨', '20', '17:39:07'],
    5: ['小满', '21', '17:21:43'],
    6: ['夏至', '22', '01:39:45'],
    7: ['大暑', '23', '12:34:53'],
    8: ['处暑', '23', '19:21:15'],
    9: ['秋分', '23', '16:28:05'],
    10: ['霜降', '24', '01:12:39'],
    11: ['小雪', '22', '22:15:23'],
    12: ['冬至', '22', '11:16:56'],
  },
  1921: {
    1: ['大寒', '20', '21:54:39'],
    2: ['雨水', '19', '12:19:56'],
    3: ['春分', '21', '11:50:58'],
    4: ['谷雨', '20', '23:32:14'],
    5: ['小满', '21', '23:16:40'],
    6: ['夏至', '22', '07:35:35'],
    7: ['大暑', '23', '18:30:15'],
    8: ['处暑', '24', '01:15:07'],
    9: ['秋分', '23', '22:19:42'],
    10: ['霜降', '24', '07:02:15'],
    11: ['小雪', '23', '04:04:27'],
    12: ['冬至', '22', '17:07:23'],
  },
  1922: {
    1: ['大寒', '21', '03:47:54'],
    2: ['雨水', '19', '18:16:09'],
    3: ['春分', '21', '17:48:33'],
    4: ['谷雨', '21', '05:28:32'],
    5: ['小满', '22', '05:10:13'],
    6: ['夏至', '22', '13:26:39'],
    7: ['大暑', '24', '00:19:38'],
    8: ['处暑', '24', '07:04:09'],
    9: ['秋分', '24', '04:09:32'],
    10: ['霜降', '24', '12:52:52'],
    11: ['小雪', '23', '09:55:09'],
    12: ['冬至', '22', '22:56:52'],
  },
  1923: {
    1: ['大寒', '21', '09:34:45'],
    2: ['雨水', '19', '23:59:40'],
    3: ['春分', '21', '23:28:42'],
    4: ['谷雨', '21', '11:05:33'],
    5: ['小满', '22', '10:45:13'],
    6: ['夏至', '22', '19:02:42'],
    7: ['大暑', '24', '06:00:29'],
    8: ['处暑', '24', '12:51:45'],
    9: ['秋分', '24', '10:03:30'],
    10: ['霜降', '24', '18:50:49'],
    11: ['小雪', '23', '15:53:36'],
    12: ['冬至', '23', '04:53:13'],
  },
  1924: {
    1: ['大寒', '21', '15:28:21'],
    2: ['雨水', '20', '05:51:16'],
    3: ['春分', '21', '05:20:05'],
    4: ['谷雨', '20', '16:58:33'],
    5: ['小满', '21', '16:40:25'],
    6: ['夏至', '22', '00:59:18'],
    7: ['大暑', '23', '11:57:27'],
    8: ['处暑', '23', '18:47:53'],
    9: ['秋分', '23', '15:58:13'],
    10: ['霜降', '24', '00:44:22'],
    11: ['小雪', '22', '21:46:22'],
    12: ['冬至', '22', '10:45:24'],
  },
  1925: {
    1: ['大寒', '20', '21:20:08'],
    2: ['雨水', '19', '11:42:59'],
    3: ['春分', '21', '11:12:06'],
    4: ['谷雨', '20', '22:51:05'],
    5: ['小满', '21', '22:32:53'],
    6: ['夏至', '22', '06:49:54'],
    7: ['大暑', '23', '17:44:47'],
    8: ['处暑', '24', '00:33:05'],
    9: ['秋分', '23', '21:43:19'],
    10: ['霜降', '24', '06:31:02'],
    11: ['小雪', '23', '03:35:24'],
    12: ['冬至', '22', '16:36:35'],
  },
  1926: {
    1: ['大寒', '21', '03:12:25'],
    2: ['雨水', '19', '17:34:43'],
    3: ['春分', '21', '17:01:08'],
    4: ['谷雨', '21', '04:36:03'],
    5: ['小满', '22', '04:14:26'],
    6: ['夏至', '22', '12:29:58'],
    7: ['大暑', '23', '23:24:44'],
    8: ['处暑', '24', '06:13:54'],
    9: ['秋分', '24', '03:26:32'],
    10: ['霜降', '24', '12:18:14'],
    11: ['小雪', '23', '09:27:33'],
    12: ['冬至', '22', '22:33:18'],
  },
  1927: {
    1: ['大寒', '21', '09:11:48'],
    2: ['雨水', '19', '23:34:13'],
    3: ['春分', '21', '22:59:02'],
    4: ['谷雨', '21', '10:31:38'],
    5: ['小满', '22', '10:07:47'],
    6: ['夏至', '22', '18:22:07'],
    7: ['大暑', '24', '05:16:41'],
    8: ['处暑', '24', '12:05:23'],
    9: ['秋分', '24', '09:16:52'],
    10: ['霜降', '24', '18:06:37'],
    11: ['小雪', '23', '15:13:55'],
    12: ['冬至', '23', '04:18:26'],
  },
  1928: {
    1: ['大寒', '21', '14:56:36'],
    2: ['雨水', '20', '05:19:12'],
    3: ['春分', '21', '04:44:11'],
    4: ['谷雨', '20', '16:16:40'],
    5: ['小满', '21', '15:52:19'],
    6: ['夏至', '21', '00:06:23'],
    7: ['大暑', '23', '11:02:13'],
    8: ['处暑', '23', '17:53:05'],
    9: ['秋分', '23', '15:05:26'],
    10: ['霜降', '23', '23:54:28'],
    11: ['小雪', '22', '21:00:12'],
    12: ['冬至', '22', '10:03:36'],
  },
  1929: {
    1: ['大寒', '20', '20:42:10'],
    2: ['雨水', '19', '11:06:48'],
    3: ['春分', '21', '10:34:45'],
    4: ['谷雨', '20', '22:10:15'],
    5: ['小满', '21', '21:47:33'],
    6: ['夏至', '22', '06:00:33'],
    7: ['大暑', '23', '16:53:14'],
    8: ['处暑', '23', '23:41:12'],
    9: ['秋分', '23', '20:52:15'],
    10: ['霜降', '24', '05:41:24'],
    11: ['小雪', '23', '02:48:03'],
    12: ['冬至', '22', '15:52:41'],
  },
  1930: {
    1: ['大寒', '21', '02:32:56'],
    2: ['雨水', '19', '16:59:45'],
    3: ['春分', '21', '16:29:42'],
    4: ['谷雨', '21', '04:05:45'],
    5: ['小满', '22', '03:41:59'],
    6: ['夏至', '22', '11:52:45'],
    7: ['大暑', '23', '22:41:53'],
    8: ['处暑', '24', '05:26:17'],
    9: ['秋分', '24', '02:35:52'],
    10: ['霜降', '24', '11:25:57'],
    11: ['小雪', '23', '08:34:25'],
    12: ['冬至', '22', '21:39:29'],
  },
  1931: {
    1: ['大寒', '21', '08:17:27'],
    2: ['雨水', '19', '22:40:14'],
    3: ['春分', '21', '22:06:14'],
    4: ['谷雨', '21', '09:39:45'],
    5: ['小满', '22', '09:15:21'],
    6: ['夏至', '22', '17:28:00'],
    7: ['大暑', '24', '04:21:20'],
    8: ['处暑', '24', '11:10:13'],
    9: ['秋分', '24', '08:23:15'],
    10: ['霜降', '24', '17:15:26'],
    11: ['小雪', '23', '14:24:38'],
    12: ['冬至', '23', '03:29:31'],
  },
  1932: {
    1: ['大寒', '21', '14:06:45'],
    2: ['雨水', '20', '04:28:19'],
    3: ['春分', '21', '03:53:32'],
    4: ['谷雨', '20', '15:28:01'],
    5: ['小满', '21', '15:06:33'],
    6: ['夏至', '21', '23:22:34'],
    7: ['大暑', '23', '10:17:59'],
    8: ['处暑', '23', '17:06:10'],
    9: ['秋分', '23', '14:15:49'],
    10: ['霜降', '23', '23:03:50'],
    11: ['小雪', '22', '20:10:05'],
    12: ['冬至', '22', '09:14:12'],
  },
  1933: {
    1: ['大寒', '20', '19:52:39'],
    2: ['雨水', '19', '10:16:15'],
    3: ['春分', '21', '09:43:03'],
    4: ['谷雨', '20', '21:18:14'],
    5: ['小满', '21', '20:56:45'],
    6: ['夏至', '22', '05:11:45'],
    7: ['大暑', '23', '16:05:22'],
    8: ['处暑', '23', '22:52:19'],
    9: ['秋分', '23', '20:01:06'],
    10: ['霜降', '24', '04:48:03'],
    11: ['小雪', '23', '01:53:24'],
    12: ['冬至', '22', '14:57:26'],
  },
  1934: {
    1: ['大寒', '21', '01:36:51'],
    2: ['雨水', '19', '16:01:37'],
    3: ['春分', '21', '15:27:53'],
    4: ['谷雨', '21', '03:00:07'],
    5: ['小满', '22', '02:34:51'],
    6: ['夏至', '22', '10:47:51'],
    7: ['大暑', '23', '21:42:07'],
    8: ['处暑', '24', '04:32:00'],
    9: ['秋分', '24', '01:45:08'],
    10: ['霜降', '24', '10:36:15'],
    11: ['小雪', '23', '07:44:20'],
    12: ['冬至', '22', '20:49:22'],
  },
  1935: {
    1: ['大寒', '21', '07:28:17'],
    2: ['雨水', '19', '21:51:56'],
    3: ['春分', '21', '21:17:43'],
    4: ['谷雨', '21', '08:50:04'],
    5: ['小满', '22', '08:24:47'],
    6: ['夏至', '22', '16:37:51'],
    7: ['大暑', '24', '03:32:54'],
    8: ['处暑', '24', '10:23:56'],
    9: ['秋分', '24', '07:38:07'],
    10: ['霜降', '24', '16:29:09'],
    11: ['小雪', '23', '13:35:22'],
    12: ['冬至', '23', '02:37:03'],
  },
  1936: {
    1: ['大寒', '21', '13:12:13'],
    2: ['雨水', '20', '03:33:00'],
    3: ['春分', '21', '02:57:48'],
    4: ['谷雨', '20', '14:31:04'],
    5: ['小满', '21', '14:07:24'],
    6: ['夏至', '21', '22:21:34'],
    7: ['大暑', '23', '09:17:50'],
    8: ['处暑', '23', '16:10:28'],
    9: ['秋分', '23', '13:25:54'],
    10: ['霜降', '23', '22:18:02'],
    11: ['小雪', '22', '19:25:00'],
    12: ['冬至', '22', '08:26:37'],
  },
  1937: {
    1: ['大寒', '20', '19:00:57'],
    2: ['雨水', '19', '09:20:41'],
    3: ['春分', '21', '08:45:01'],
    4: ['谷雨', '20', '20:19:08'],
    5: ['小满', '21', '19:57:07'],
    6: ['夏至', '22', '04:11:56'],
    7: ['大暑', '23', '15:06:53'],
    8: ['处暑', '23', '21:57:49'],
    9: ['秋分', '23', '19:12:54'],
    10: ['霜降', '24', '04:06:30'],
    11: ['小雪', '23', '01:16:27'],
    12: ['冬至', '22', '14:21:36'],
  },
  1938: {
    1: ['大寒', '21', '00:58:42'],
    2: ['雨水', '19', '15:19:33'],
    3: ['春分', '21', '14:43:02'],
    4: ['谷雨', '21', '02:14:41'],
    5: ['小满', '22', '01:50:08'],
    6: ['夏至', '22', '10:03:32'],
    7: ['大暑', '23', '20:57:02'],
    8: ['处暑', '24', '03:45:46'],
    9: ['秋分', '24', '00:59:27'],
    10: ['霜降', '24', '09:53:44'],
    11: ['小雪', '23', '07:06:02'],
    12: ['冬至', '22', '20:13:21'],
  },
  1939: {
    1: ['大寒', '21', '06:50:40'],
    2: ['雨水', '19', '21:09:15'],
    3: ['春分', '21', '20:28:26'],
    4: ['谷雨', '21', '07:55:05'],
    5: ['小满', '22', '07:26:38'],
    6: ['夏至', '22', '15:39:22'],
    7: ['大暑', '24', '02:36:36'],
    8: ['处暑', '24', '09:31:08'],
    9: ['秋分', '24', '06:49:25'],
    10: ['霜降', '24', '15:45:49'],
    11: ['小雪', '23', '12:58:28'],
    12: ['冬至', '23', '02:05:55'],
  },
  1940: {
    1: ['大寒', '21', '12:44:03'],
    2: ['雨水', '20', '03:03:42'],
    3: ['春分', '21', '02:23:41'],
    4: ['谷雨', '20', '13:50:52'],
    5: ['小满', '21', '13:23:00'],
    6: ['夏至', '21', '21:36:22'],
    7: ['大暑', '23', '08:34:03'],
    8: ['处暑', '23', '15:28:30'],
    9: ['秋分', '23', '12:45:32'],
    10: ['霜降', '23', '21:39:18'],
    11: ['小雪', '22', '18:48:55'],
    12: ['冬至', '22', '07:54:41'],
  },
  1941: {
    1: ['大寒', '20', '18:33:37'],
    2: ['雨水', '19', '08:56:21'],
    3: ['春分', '21', '08:20:19'],
    4: ['谷雨', '20', '19:50:24'],
    5: ['小满', '21', '19:22:47'],
    6: ['夏至', '22', '03:33:15'],
    7: ['大暑', '23', '14:26:08'],
    8: ['处暑', '23', '21:16:51'],
    9: ['秋分', '23', '18:32:42'],
    10: ['霜降', '24', '03:27:09'],
    11: ['小雪', '23', '00:37:47'],
    12: ['冬至', '22', '13:44:06'],
  },
  1942: {
    1: ['大寒', '21', '00:23:28'],
    2: ['雨水', '19', '14:46:46'],
    3: ['春分', '21', '14:10:34'],
    4: ['谷雨', '21', '01:39:05'],
    5: ['小满', '22', '01:08:38'],
    6: ['夏至', '22', '09:16:13'],
    7: ['大暑', '23', '20:07:23'],
    8: ['处暑', '24', '02:58:10'],
    9: ['秋分', '24', '00:16:24'],
    10: ['霜降', '24', '09:15:08'],
    11: ['小雪', '23', '06:30:21'],
    12: ['冬至', '22', '19:39:31'],
  },
  1943: {
    1: ['大寒', '21', '06:18:52'],
    2: ['雨水', '19', '20:40:13'],
    3: ['春分', '21', '20:02:34'],
    4: ['谷雨', '21', '07:31:29'],
    5: ['小满', '22', '07:02:49'],
    6: ['夏至', '22', '15:12:17'],
    7: ['大暑', '24', '02:04:30'],
    8: ['处暑', '24', '08:54:59'],
    9: ['秋分', '24', '06:11:41'],
    10: ['霜降', '24', '15:08:15'],
    11: ['小雪', '23', '12:21:26'],
    12: ['冬至', '23', '01:29:04'],
  },
  1944: {
    1: ['大寒', '21', '12:07:04'],
    2: ['雨水', '20', '02:27:05'],
    3: ['春分', '21', '01:48:32'],
    4: ['谷雨', '20', '13:17:45'],
    5: ['小满', '21', '12:50:46'],
    6: ['夏至', '21', '21:02:14'],
    7: ['大暑', '23', '07:55:49'],
    8: ['处暑', '23', '14:46:26'],
    9: ['秋分', '23', '12:01:35'],
    10: ['霜降', '23', '20:55:56'],
    11: ['小雪', '22', '18:07:30'],
    12: ['冬至', '22', '07:14:45'],
  },
  1945: {
    1: ['大寒', '20', '17:53:36'],
    2: ['雨水', '19', '08:14:51'],
    3: ['春分', '21', '07:37:10'],
    4: ['谷雨', '20', '19:06:51'],
    5: ['小满', '21', '18:40:12'],
    6: ['夏至', '22', '02:52:00'],
    7: ['大暑', '23', '13:45:23'],
    8: ['处暑', '23', '20:35:16'],
    9: ['秋分', '23', '17:49:44'],
    10: ['霜降', '24', '02:43:34'],
    11: ['小雪', '22', '23:55:11'],
    12: ['冬至', '22', '13:03:32'],
  },
  1946: {
    1: ['大寒', '20', '23:44:35'],
    2: ['雨水', '19', '14:08:30'],
    3: ['春分', '21', '13:32:37'],
    4: ['谷雨', '21', '01:02:08'],
    5: ['小满', '22', '00:33:53'],
    6: ['夏至', '22', '08:44:17'],
    7: ['大暑', '23', '19:37:00'],
    8: ['处暑', '24', '02:26:19'],
    9: ['秋分', '23', '23:40:34'],
    10: ['霜降', '24', '08:34:39'],
    11: ['小雪', '23', '05:46:15'],
    12: ['冬至', '22', '18:53:17'],
  },
  1947: {
    1: ['大寒', '21', '05:31:30'],
    2: ['雨水', '19', '19:51:53'],
    3: ['春分', '21', '19:12:38'],
    4: ['谷雨', '21', '06:39:22'],
    5: ['小满', '22', '06:09:00'],
    6: ['夏至', '22', '14:18:47'],
    7: ['大暑', '24', '01:14:09'],
    8: ['处暑', '24', '08:08:56'],
    9: ['秋分', '24', '05:28:35'],
    10: ['霜降', '24', '14:25:50'],
    11: ['小雪', '23', '11:37:36'],
    12: ['冬至', '23', '00:42:43'],
  },
  1948: {
    1: ['大寒', '21', '11:18:22'],
    2: ['雨水', '20', '01:36:38'],
    3: ['春分', '21', '00:56:43'],
    4: ['谷雨', '20', '12:24:50'],
    5: ['小满', '21', '11:57:35'],
    6: ['夏至', '21', '20:10:32'],
    7: ['大暑', '23', '07:07:29'],
    8: ['处暑', '23', '14:02:30'],
    9: ['秋分', '23', '11:21:39'],
    10: ['霜降', '23', '20:17:57'],
    11: ['小雪', '22', '17:28:47'],
    12: ['冬至', '22', '06:33:13'],
  },
  1949: {
    1: ['大寒', '20', '17:08:32'],
    2: ['雨水', '19', '07:27:03'],
    3: ['春分', '21', '06:48:01'],
    4: ['谷雨', '20', '18:17:15'],
    5: ['小满', '21', '17:50:38'],
    6: ['夏至', '22', '02:02:43'],
    7: ['大暑', '23', '12:56:39'],
    8: ['处暑', '23', '19:48:11'],
    9: ['秋分', '23', '17:05:48'],
    10: ['霜降', '24', '02:02:57'],
    11: ['小雪', '22', '23:16:02'],
    12: ['冬至', '22', '12:22:51'],
  },
  1950: {
    1: ['大寒', '20', '22:59:35'],
    2: ['雨水', '19', '13:17:29'],
    3: ['春分', '21', '12:35:06'],
    4: ['谷雨', '20', '23:59:06'],
    5: ['小满', '21', '23:27:07'],
    6: ['夏至', '22', '07:36:00'],
    7: ['大暑', '23', '18:29:53'],
    8: ['处暑', '24', '01:23:09'],
    9: ['秋分', '23', '22:43:32'],
    10: ['霜降', '24', '07:44:43'],
    11: ['小雪', '23', '05:02:29'],
    12: ['冬至', '22', '18:13:18'],
  },
  1951: {
    1: ['大寒', '21', '04:52:02'],
    2: ['雨水', '19', '19:09:38'],
    3: ['春分', '21', '18:25:41'],
    4: ['谷雨', '21', '05:48:03'],
    5: ['小满', '22', '05:15:22'],
    6: ['夏至', '22', '13:24:48'],
    7: ['大暑', '24', '00:20:37'],
    8: ['处暑', '24', '07:16:05'],
    9: ['秋分', '24', '04:36:50'],
    10: ['霜降', '24', '13:36:00'],
    11: ['小雪', '23', '10:51:03'],
    12: ['冬至', '23', '00:00:01'],
  },
  1952: {
    1: ['大寒', '21', '10:38:22'],
    2: ['雨水', '20', '00:56:40'],
    3: ['春分', '21', '00:13:42'],
    4: ['谷雨', '20', '11:36:37'],
    5: ['小满', '21', '11:03:49'],
    6: ['夏至', '21', '19:12:30'],
    7: ['大暑', '23', '06:07:25'],
    8: ['处暑', '23', '13:02:47'],
    9: ['秋分', '23', '10:23:39'],
    10: ['霜降', '23', '19:22:10'],
    11: ['小雪', '22', '16:35:36'],
    12: ['冬至', '22', '05:43:06'],
  },
  1953: {
    1: ['大寒', '20', '16:21:18'],
    2: ['雨水', '19', '06:41:05'],
    3: ['春分', '21', '06:00:30'],
    4: ['谷雨', '20', '17:25:21'],
    5: ['小满', '21', '16:52:47'],
    6: ['夏至', '22', '00:59:53'],
    7: ['大暑', '23', '11:52:06'],
    8: ['处暑', '23', '18:45:09'],
    9: ['秋分', '23', '16:05:52'],
    10: ['霜降', '24', '01:06:14'],
    11: ['小雪', '22', '22:22:03'],
    12: ['冬至', '22', '11:31:25'],
  },
  1954: {
    1: ['大寒', '20', '22:11:01'],
    2: ['雨水', '19', '12:32:18'],
    3: ['春分', '21', '11:53:23'],
    4: ['谷雨', '20', '23:19:32'],
    5: ['小满', '21', '22:47:22'],
    6: ['夏至', '22', '06:54:00'],
    7: ['大暑', '23', '17:44:54'],
    8: ['处暑', '24', '00:35:52'],
    9: ['秋分', '23', '21:55:13'],
    10: ['霜降', '24', '06:56:19'],
    11: ['小雪', '23', '04:14:10'],
    12: ['冬至', '22', '17:24:19'],
  },
  1955: {
    1: ['大寒', '21', '04:01:50'],
    2: ['雨水', '19', '18:18:45'],
    3: ['春分', '21', '17:35:04'],
    4: ['谷雨', '21', '04:57:50'],
    5: ['小满', '22', '04:24:19'],
    6: ['夏至', '22', '12:31:19'],
    7: ['大暑', '23', '23:24:30'],
    8: ['处暑', '24', '06:18:53'],
    9: ['秋分', '24', '03:40:50'],
    10: ['霜降', '24', '12:43:01'],
    11: ['小雪', '23', '10:00:51'],
    12: ['冬至', '22', '23:10:52'],
  },
  1956: {
    1: ['大寒', '21', '09:48:16'],
    2: ['雨水', '20', '00:04:37'],
    3: ['春分', '20', '23:20:15'],
    4: ['谷雨', '20', '10:43:25'],
    5: ['小满', '21', '10:12:32'],
    6: ['夏至', '21', '18:23:41'],
    7: ['大暑', '23', '05:19:52'],
    8: ['处暑', '23', '12:14:46'],
    9: ['秋分', '23', '09:35:02'],
    10: ['霜降', '23', '18:34:19'],
    11: ['小雪', '22', '15:49:50'],
    12: ['冬至', '22', '04:59:27'],
  },
  1957: {
    1: ['大寒', '20', '15:38:35'],
    2: ['雨水', '19', '05:57:58'],
    3: ['春分', '21', '05:16:27'],
    4: ['谷雨', '20', '16:41:12'],
    5: ['小满', '21', '16:10:23'],
    6: ['夏至', '22', '00:20:28'],
    7: ['大暑', '23', '11:14:48'],
    8: ['处暑', '23', '18:07:31'],
    9: ['秋分', '23', '15:26:02'],
    10: ['霜降', '24', '00:24:10'],
    11: ['小雪', '22', '21:39:00'],
    12: ['冬至', '22', '10:48:34'],
  },
  1958: {
    1: ['大寒', '20', '21:28:27'],
    2: ['雨水', '19', '11:48:26'],
    3: ['春分', '21', '11:05:47'],
    4: ['谷雨', '20', '22:26:58'],
    5: ['小满', '21', '21:51:00'],
    6: ['夏至', '22', '05:56:51'],
    7: ['大暑', '23', '16:50:26'],
    8: ['处暑', '23', '23:45:53'],
    9: ['秋分', '23', '21:08:49'],
    10: ['霜降', '24', '06:11:18'],
    11: ['小雪', '23', '03:29:06'],
    12: ['冬至', '22', '16:39:40'],
  },
  1959: {
    1: ['大寒', '21', '03:18:50'],
    2: ['雨水', '19', '17:37:33'],
    3: ['春分', '21', '16:54:29'],
    4: ['谷雨', '21', '04:16:27'],
    5: ['小满', '22', '03:42:05'],
    6: ['夏至', '22', '11:49:44'],
    7: ['大暑', '23', '22:45:25'],
    8: ['处暑', '24', '05:43:29'],
    9: ['秋分', '24', '03:08:24'],
    10: ['霜降', '24', '12:10:58'],
    11: ['小雪', '23', '09:26:53'],
    12: ['冬至', '22', '22:34:18'],
  },
  1960: {
    1: ['大寒', '21', '09:10:02'],
    2: ['雨水', '19', '23:26:17'],
    3: ['春分', '20', '22:42:38'],
    4: ['谷雨', '20', '10:05:51'],
    5: ['小满', '21', '09:33:28'],
    6: ['夏至', '21', '17:42:15'],
    7: ['大暑', '23', '04:37:25'],
    8: ['处暑', '23', '11:34:22'],
    9: ['秋分', '23', '08:58:50'],
    10: ['霜降', '23', '18:01:49'],
    11: ['小雪', '22', '15:18:20'],
    12: ['冬至', '22', '04:25:53'],
  },
  1961: {
    1: ['大寒', '20', '15:01:06'],
    2: ['雨水', '19', '05:16:27'],
    3: ['春分', '21', '04:32:04'],
    4: ['谷雨', '20', '15:55:02'],
    5: ['小满', '21', '15:22:14'],
    6: ['夏至', '21', '23:30:04'],
    7: ['大暑', '23', '10:23:34'],
    8: ['处暑', '23', '17:18:30'],
    9: ['秋分', '23', '14:42:25'],
    10: ['霜降', '23', '23:47:21'],
    11: ['小雪', '22', '21:07:40'],
    12: ['冬至', '22', '10:19:26'],
  },
  1962: {
    1: ['大寒', '20', '20:57:53'],
    2: ['雨水', '19', '11:14:34'],
    3: ['春分', '21', '10:29:31'],
    4: ['谷雨', '20', '21:50:40'],
    5: ['小满', '21', '21:16:30'],
    6: ['夏至', '22', '05:24:05'],
    7: ['大暑', '23', '16:17:56'],
    8: ['处暑', '23', '23:12:27'],
    9: ['秋分', '23', '20:35:11'],
    10: ['霜降', '24', '05:39:59'],
    11: ['小雪', '23', '03:01:50'],
    12: ['冬至', '22', '16:15:14'],
  },
  1963: {
    1: ['大寒', '21', '02:53:51'],
    2: ['雨水', '19', '17:08:34'],
    3: ['春分', '21', '16:19:39'],
    4: ['谷雨', '21', '03:36:07'],
    5: ['小满', '22', '02:58:07'],
    6: ['夏至', '22', '11:04:00'],
    7: ['大暑', '23', '21:59:11'],
    8: ['处暑', '24', '04:57:29'],
    9: ['秋分', '24', '02:23:27'],
    10: ['霜降', '24', '11:28:48'],
    11: ['小雪', '23', '08:49:20'],
    12: ['冬至', '22', '22:01:52'],
  },
  1964: {
    1: ['大寒', '21', '08:41:03'],
    2: ['雨水', '19', '22:57:17'],
    3: ['春分', '20', '22:09:50'],
    4: ['谷雨', '20', '09:27:08'],
    5: ['小满', '21', '08:49:45'],
    6: ['夏至', '21', '16:56:47'],
    7: ['大暑', '23', '03:52:43'],
    8: ['处暑', '23', '10:51:01'],
    9: ['秋分', '23', '08:16:38'],
    10: ['霜降', '23', '17:20:40'],
    11: ['小雪', '22', '14:38:53'],
    12: ['冬至', '22', '03:49:31'],
  },
  1965: {
    1: ['大寒', '20', '14:28:51'],
    2: ['雨水', '19', '04:47:48'],
    3: ['春分', '21', '04:04:44'],
    4: ['谷雨', '20', '15:26:03'],
    5: ['小满', '21', '14:50:13'],
    6: ['夏至', '21', '22:55:40'],
    7: ['大暑', '23', '09:48:09'],
    8: ['处暑', '23', '16:42:40'],
    9: ['秋分', '23', '14:05:57'],
    10: ['霜降', '23', '23:09:55'],
    11: ['小雪', '22', '20:29:08'],
    12: ['冬至', '22', '09:40:23'],
  },
  1966: {
    1: ['大寒', '20', '20:19:39'],
    2: ['雨水', '19', '10:37:47'],
    3: ['春分', '21', '09:52:54'],
    4: ['谷雨', '20', '21:11:30'],
    5: ['小满', '21', '20:32:01'],
    6: ['夏至', '22', '04:33:21'],
    7: ['大暑', '23', '15:23:10'],
    8: ['处暑', '23', '22:17:42'],
    9: ['秋分', '23', '19:43:08'],
    10: ['霜降', '24', '04:50:45'],
    11: ['小雪', '23', '02:14:05'],
    12: ['冬至', '22', '15:28:08'],
  },
  1967: {
    1: ['大寒', '21', '02:07:30'],
    2: ['雨水', '19', '16:23:38'],
    3: ['春分', '21', '15:36:46'],
    4: ['谷雨', '21', '02:55:07'],
    5: ['小满', '22', '02:17:52'],
    6: ['夏至', '22', '10:22:49'],
    7: ['大暑', '23', '21:15:49'],
    8: ['处暑', '24', '04:12:24'],
    9: ['秋分', '24', '01:38:01'],
    10: ['霜降', '24', '10:43:44'],
    11: ['小雪', '23', '08:04:26'],
    12: ['冬至', '22', '21:16:17'],
  },
  1968: {
    1: ['大寒', '21', '07:54:06'],
    2: ['雨水', '19', '22:09:13'],
    3: ['春分', '20', '21:22:01'],
    4: ['谷雨', '20', '08:41:07'],
    5: ['小满', '21', '08:05:50'],
    6: ['夏至', '21', '16:13:16'],
    7: ['大暑', '23', '03:07:23'],
    8: ['处暑', '23', '10:02:51'],
    9: ['秋分', '23', '07:26:10'],
    10: ['霜降', '23', '16:29:34'],
    11: ['小雪', '22', '13:48:31'],
    12: ['冬至', '22', '02:59:45'],
  },
  1969: {
    1: ['大寒', '20', '13:38:10'],
    2: ['雨水', '19', '03:54:28'],
    3: ['春分', '21', '03:08:04'],
    4: ['谷雨', '20', '14:26:51'],
    5: ['小满', '21', '13:49:42'],
    6: ['夏至', '21', '21:55:01'],
    7: ['大暑', '23', '08:48:08'],
    8: ['处暑', '23', '15:43:20'],
    9: ['秋分', '23', '13:06:53'],
    10: ['霜降', '23', '22:11:02'],
    11: ['小雪', '22', '19:31:04'],
    12: ['冬至', '22', '08:43:41'],
  },
  1970: {
    1: ['大寒', '20', '19:23:47'],
    2: ['雨水', '19', '09:41:46'],
    3: ['春分', '21', '08:56:19'],
    4: ['谷雨', '20', '20:14:56'],
    5: ['小满', '21', '19:37:19'],
    6: ['夏至', '22', '03:42:38'],
    7: ['大暑', '23', '14:36:52'],
    8: ['处暑', '23', '21:33:53'],
    9: ['秋分', '23', '18:58:59'],
    10: ['霜降', '24', '04:04:14'],
    11: ['小雪', '23', '01:24:32'],
    12: ['冬至', '22', '14:35:40'],
  },
  1971: {
    1: ['大寒', '21', '01:12:39'],
    2: ['雨水', '19', '15:26:55'],
    3: ['春分', '21', '14:38:06'],
    4: ['谷雨', '21', '01:54:13'],
    5: ['小满', '22', '01:14:59'],
    6: ['夏至', '22', '09:19:34'],
    7: ['大暑', '23', '20:14:43'],
    8: ['处暑', '24', '03:15:14'],
    9: ['秋分', '24', '00:44:52'],
    10: ['霜降', '24', '09:53:08'],
    11: ['小雪', '23', '07:13:56'],
    12: ['冬至', '22', '20:23:53'],
  },
  1972: {
    1: ['大寒', '21', '06:58:59'],
    2: ['雨水', '19', '21:11:23'],
    3: ['春分', '20', '20:21:25'],
    4: ['谷雨', '20', '07:37:29'],
    5: ['小满', '21', '06:59:29'],
    6: ['夏至', '21', '15:06:10'],
    7: ['大暑', '23', '02:02:30'],
    8: ['处暑', '23', '09:03:01'],
    9: ['秋分', '23', '06:32:45'],
    10: ['霜降', '23', '15:41:27'],
    11: ['小雪', '22', '13:02:41'],
    12: ['冬至', '22', '02:12:53'],
  },
  1973: {
    1: ['大寒', '20', '12:48:12'],
    2: ['雨水', '19', '03:01:09'],
    3: ['春分', '21', '02:12:26'],
    4: ['谷雨', '20', '13:30:21'],
    5: ['小满', '21', '12:53:49'],
    6: ['夏至', '21', '21:00:34'],
    7: ['大暑', '23', '07:55:32'],
    8: ['处暑', '23', '14:53:27'],
    9: ['秋分', '23', '12:21:06'],
    10: ['霜降', '23', '21:30:09'],
    11: ['小雪', '22', '18:54:00'],
    12: ['冬至', '22', '08:07:41'],
  },
  1974: {
    1: ['大寒', '20', '18:45:40'],
    2: ['雨水', '19', '08:58:41'],
    3: ['春分', '21', '08:06:38'],
    4: ['谷雨', '20', '19:18:51'],
    5: ['小满', '21', '18:36:02'],
    6: ['夏至', '22', '02:37:36'],
    7: ['大暑', '23', '13:30:10'],
    8: ['处暑', '23', '20:28:40'],
    9: ['秋分', '23', '17:58:26'],
    10: ['霜降', '24', '03:10:36'],
    11: ['小雪', '23', '00:38:27'],
    12: ['冬至', '22', '13:55:56'],
  },
  1975: {
    1: ['大寒', '21', '00:36:14'],
    2: ['雨水', '19', '14:49:41'],
    3: ['春分', '21', '13:56:39'],
    4: ['谷雨', '21', '01:07:12'],
    5: ['小满', '22', '00:23:40'],
    6: ['夏至', '22', '08:26:25'],
    7: ['大暑', '23', '19:21:44'],
    8: ['处暑', '24', '02:23:37'],
    9: ['秋分', '23', '23:55:12'],
    10: ['霜降', '24', '09:06:01'],
    11: ['小雪', '23', '06:30:42'],
    12: ['冬至', '22', '19:45:33'],
  },
  1976: {
    1: ['大寒', '21', '06:25:06'],
    2: ['雨水', '19', '20:39:55'],
    3: ['春分', '20', '19:49:36'],
    4: ['谷雨', '20', '07:02:56'],
    5: ['小满', '21', '06:21:04'],
    6: ['夏至', '21', '14:24:11'],
    7: ['大暑', '23', '01:18:26'],
    8: ['处暑', '23', '08:18:15'],
    9: ['秋分', '23', '05:48:11'],
    10: ['霜降', '23', '14:58:01'],
    11: ['小雪', '22', '12:21:28'],
    12: ['冬至', '22', '01:35:06'],
  },
  1977: {
    1: ['大寒', '20', '12:14:25'],
    2: ['雨水', '19', '02:30:25'],
    3: ['春分', '21', '01:42:15'],
    4: ['谷雨', '20', '12:57:12'],
    5: ['小满', '21', '12:14:20'],
    6: ['夏至', '21', '20:13:44'],
    7: ['大暑', '23', '07:03:38'],
    8: ['处暑', '23', '14:00:14'],
    9: ['秋分', '23', '11:29:13'],
    10: ['霜降', '23', '20:40:39'],
    11: ['小雪', '22', '18:06:59'],
    12: ['冬至', '22', '07:23:08'],
  },
  1978: {
    1: ['大寒', '20', '18:03:59'],
    2: ['雨水', '19', '08:20:57'],
    3: ['春分', '21', '07:33:34'],
    4: ['谷雨', '20', '18:49:32'],
    5: ['小满', '21', '18:08:26'],
    6: ['夏至', '22', '02:09:33'],
    7: ['大暑', '23', '13:00:14'],
    8: ['处暑', '23', '19:56:46'],
    9: ['秋分', '23', '17:25:24'],
    10: ['霜降', '24', '02:37:09'],
    11: ['小雪', '23', '00:04:36'],
    12: ['冬至', '22', '13:20:57'],
  },
  1979: {
    1: ['大寒', '20', '23:59:56'],
    2: ['雨水', '19', '14:13:13'],
    3: ['春分', '21', '13:21:55'],
    4: ['谷雨', '21', '00:35:21'],
    5: ['小满', '21', '23:53:50'],
    6: ['夏至', '22', '07:56:09'],
    7: ['大暑', '23', '18:48:32'],
    8: ['处暑', '24', '01:46:43'],
    9: ['秋分', '23', '23:16:22'],
    10: ['霜降', '24', '08:27:50'],
    11: ['小雪', '23', '05:54:06'],
    12: ['冬至', '22', '19:09:45'],
  },
  1980: {
    1: ['大寒', '21', '05:48:37'],
    2: ['雨水', '19', '20:01:38'],
    3: ['春分', '20', '19:09:40'],
    4: ['谷雨', '20', '06:22:41'],
    5: ['小满', '21', '05:42:02'],
    6: ['夏至', '21', '13:47:00'],
    7: ['大暑', '23', '00:41:59'],
    8: ['处暑', '23', '07:40:38'],
    9: ['秋分', '23', '05:08:40'],
    10: ['霜降', '23', '14:17:30'],
    11: ['小雪', '22', '11:41:23'],
    12: ['冬至', '22', '00:56:04'],
  },
  1981: {
    1: ['大寒', '20', '11:35:58'],
    2: ['雨水', '19', '01:51:38'],
    3: ['春分', '21', '01:02:49'],
    4: ['谷雨', '20', '12:18:31'],
    5: ['小满', '21', '11:39:25'],
    6: ['夏至', '21', '19:44:40'],
    7: ['大暑', '23', '06:39:43'],
    8: ['处暑', '23', '13:38:10'],
    9: ['秋分', '23', '11:05:11'],
    10: ['霜降', '23', '20:12:49'],
    11: ['小雪', '22', '17:35:56'],
    12: ['冬至', '22', '06:50:31'],
  },
  1982: {
    1: ['大寒', '20', '17:30:53'],
    2: ['雨水', '19', '07:46:31'],
    3: ['春分', '21', '06:55:50'],
    4: ['谷雨', '20', '18:07:27'],
    5: ['小满', '21', '17:22:53'],
    6: ['夏至', '22', '01:22:59'],
    7: ['大暑', '23', '12:15:23'],
    8: ['处暑', '23', '19:15:13'],
    9: ['秋分', '23', '16:46:11'],
    10: ['霜降', '24', '01:57:47'],
    11: ['小雪', '22', '23:23:18'],
    12: ['冬至', '22', '12:38:09'],
  },
  1983: {
    1: ['大寒', '20', '23:16:56'],
    2: ['雨水', '19', '13:30:34'],
    3: ['春分', '21', '12:38:44'],
    4: ['谷雨', '20', '23:50:09'],
    5: ['小满', '21', '23:06:26'],
    6: ['夏至', '22', '07:08:41'],
    7: ['大暑', '23', '18:04:07'],
    8: ['处暑', '24', '01:07:29'],
    9: ['秋分', '23', '22:41:37'],
    10: ['霜降', '24', '07:54:17'],
    11: ['小雪', '23', '05:18:20'],
    12: ['冬至', '22', '18:29:55'],
  },
  1984: {
    1: ['大寒', '21', '05:05:02'],
    2: ['雨水', '19', '19:16:13'],
    3: ['春分', '20', '18:24:19'],
    4: ['谷雨', '20', '05:38:06'],
    5: ['小满', '21', '04:57:36'],
    6: ['夏至', '21', '13:02:14'],
    7: ['大暑', '22', '23:58:12'],
    8: ['处暑', '23', '07:00:10'],
    9: ['秋分', '23', '04:32:53'],
    10: ['霜降', '23', '13:45:39'],
    11: ['小雪', '22', '11:10:38'],
    12: ['冬至', '22', '00:22:48'],
  },
  1985: {
    1: ['大寒', '20', '10:57:33'],
    2: ['雨水', '19', '01:07:21'],
    3: ['春分', '21', '00:13:43'],
    4: ['谷雨', '20', '11:25:46'],
    5: ['小满', '21', '10:42:55'],
    6: ['夏至', '21', '18:44:07'],
    7: ['大暑', '23', '05:36:26'],
    8: ['处暑', '23', '12:35:41'],
    9: ['秋分', '23', '10:07:27'],
    10: ['霜降', '23', '19:21:52'],
    11: ['小雪', '22', '16:50:46'],
    12: ['冬至', '22', '06:07:40'],
  },
  1986: {
    1: ['大寒', '20', '16:46:12'],
    2: ['雨水', '19', '06:57:31'],
    3: ['春分', '21', '06:02:41'],
    4: ['谷雨', '20', '17:12:08'],
    5: ['小满', '21', '16:27:55'],
    6: ['夏至', '22', '00:29:57'],
    7: ['大暑', '23', '11:24:23'],
    8: ['处暑', '23', '18:25:47'],
    9: ['秋分', '23', '15:58:52'],
    10: ['霜降', '24', '01:14:11'],
    11: ['小雪', '22', '22:44:20'],
    12: ['冬至', '22', '12:02:07'],
  },
  1987: {
    1: ['大寒', '20', '22:40:23'],
    2: ['雨水', '19', '12:49:57'],
    3: ['春分', '21', '11:51:58'],
    4: ['谷雨', '20', '22:57:32'],
    5: ['小满', '21', '22:10:01'],
    6: ['夏至', '22', '06:10:45'],
    7: ['大暑', '23', '17:06:02'],
    8: ['处暑', '24', '00:09:50'],
    9: ['秋分', '23', '21:45:16'],
    10: ['霜降', '24', '07:00:52'],
    11: ['小雪', '23', '04:29:23'],
    12: ['冬至', '22', '17:45:52'],
  },
  1988: {
    1: ['大寒', '21', '04:24:17'],
    2: ['雨水', '19', '18:35:07'],
    3: ['春分', '20', '17:38:35'],
    4: ['谷雨', '20', '04:44:47'],
    5: ['小满', '21', '03:56:40'],
    6: ['夏至', '21', '11:56:31'],
    7: ['大暑', '22', '22:51:05'],
    8: ['处暑', '23', '05:54:00'],
    9: ['秋分', '23', '03:28:50'],
    10: ['霜降', '23', '12:44:06'],
    11: ['小雪', '22', '10:11:59'],
    12: ['冬至', '21', '23:27:53'],
  },
  1989: {
    1: ['大寒', '20', '10:06:59'],
    2: ['雨水', '19', '00:20:30'],
    3: ['春分', '20', '23:28:15'],
    4: ['谷雨', '20', '10:38:56'],
    5: ['小满', '21', '09:53:32'],
    6: ['夏至', '21', '17:53:00'],
    7: ['大暑', '23', '04:45:28'],
    8: ['处暑', '23', '11:46:13'],
    9: ['秋分', '23', '09:19:37'],
    10: ['霜降', '23', '18:35:08'],
    11: ['小雪', '22', '16:04:37'],
    12: ['冬至', '22', '05:22:00'],
  },
  1990: {
    1: ['大寒', '20', '16:01:33'],
    2: ['雨水', '19', '06:14:01'],
    3: ['春分', '21', '05:19:15'],
    4: ['谷雨', '20', '16:26:32'],
    5: ['小满', '21', '15:37:23'],
    6: ['夏至', '21', '23:32:46'],
    7: ['大暑', '23', '10:21:30'],
    8: ['处暑', '23', '17:20:49'],
    9: ['秋分', '23', '14:55:29'],
    10: ['霜降', '24', '00:13:56'],
    11: ['小雪', '22', '21:46:55'],
    12: ['冬至', '22', '11:06:59'],
  },
  1991: {
    1: ['大寒', '20', '21:47:05'],
    2: ['雨水', '19', '11:58:20'],
    3: ['春分', '21', '11:01:56'],
    4: ['谷雨', '20', '22:08:23'],
    5: ['小满', '21', '21:20:14'],
    6: ['夏至', '22', '05:18:47'],
    7: ['大暑', '23', '16:11:08'],
    8: ['处暑', '23', '23:12:51'],
    9: ['秋分', '23', '20:48:06'],
    10: ['霜降', '24', '06:05:10'],
    11: ['小雪', '23', '03:35:45'],
    12: ['冬至', '22', '16:53:38'],
  },
  1992: {
    1: ['大寒', '21', '03:32:29'],
    2: ['雨水', '19', '17:43:30'],
    3: ['春分', '20', '16:48:04'],
    4: ['谷雨', '20', '03:56:53'],
    5: ['小满', '21', '03:12:08'],
    6: ['夏至', '21', '11:14:08'],
    7: ['大暑', '22', '22:08:49'],
    8: ['处暑', '23', '05:10:06'],
    9: ['秋分', '23', '02:42:46'],
    10: ['霜降', '23', '11:57:07'],
    11: ['小雪', '22', '09:25:51'],
    12: ['冬至', '21', '22:43:13'],
  },
  1993: {
    1: ['大寒', '20', '09:22:49'],
    2: ['雨水', '18', '23:35:10'],
    3: ['春分', '20', '22:40:39'],
    4: ['谷雨', '20', '09:49:01'],
    5: ['小满', '21', '09:01:43'],
    6: ['夏至', '21', '16:59:44'],
    7: ['大暑', '23', '03:50:49'],
    8: ['处暑', '23', '10:50:18'],
    9: ['秋分', '23', '08:22:30'],
    10: ['霜降', '23', '17:37:08'],
    11: ['小雪', '22', '15:06:51'],
    12: ['冬至', '22', '04:25:48'],
  },
  1994: {
    1: ['大寒', '20', '15:07:24'],
    2: ['雨水', '19', '05:21:38'],
    3: ['春分', '21', '04:28:01'],
    4: ['谷雨', '20', '15:36:00'],
    5: ['小满', '21', '14:48:28'],
    6: ['夏至', '21', '22:47:32'],
    7: ['大暑', '23', '09:41:00'],
    8: ['处暑', '23', '16:43:45'],
    9: ['秋分', '23', '14:19:13'],
    10: ['霜降', '23', '23:36:01'],
    11: ['小雪', '22', '21:05:58'],
    12: ['冬至', '22', '10:22:43'],
  },
  1995: {
    1: ['大寒', '20', '21:00:27'],
    2: ['雨水', '19', '11:10:44'],
    3: ['春分', '21', '10:14:27'],
    4: ['谷雨', '20', '21:21:29'],
    5: ['小满', '21', '20:34:11'],
    6: ['夏至', '22', '04:34:22'],
    7: ['大暑', '23', '15:29:40'],
    8: ['处暑', '23', '22:34:50'],
    9: ['秋分', '23', '20:13:00'],
    10: ['霜降', '24', '05:31:31'],
    11: ['小雪', '23', '03:01:23'],
    12: ['冬至', '22', '16:16:47'],
  },
  1996: {
    1: ['大寒', '21', '02:52:30'],
    2: ['雨水', '19', '17:00:43'],
    3: ['春分', '20', '16:03:04'],
    4: ['谷雨', '20', '03:09:53'],
    5: ['小满', '21', '02:23:06'],
    6: ['夏至', '21', '10:23:44'],
    7: ['大暑', '22', '21:18:42'],
    8: ['处暑', '23', '04:22:50'],
    9: ['秋分', '23', '02:00:06'],
    10: ['霜降', '23', '11:18:42'],
    11: ['小雪', '22', '08:49:24'],
    12: ['冬至', '21', '22:05:53'],
  },
  1997: {
    1: ['大寒', '20', '08:42:31'],
    2: ['雨水', '18', '22:51:29'],
    3: ['春分', '20', '21:54:40'],
    4: ['谷雨', '20', '09:02:49'],
    5: ['小满', '21', '08:17:53'],
    6: ['夏至', '21', '16:19:56'],
    7: ['大暑', '23', '03:15:26'],
    8: ['处暑', '23', '10:19:11'],
    9: ['秋分', '23', '07:55:47'],
    10: ['霜降', '23', '17:14:45'],
    11: ['小雪', '22', '14:47:33'],
    12: ['冬至', '22', '04:07:02'],
  },
  1998: {
    1: ['大寒', '20', '14:46:04'],
    2: ['雨水', '19', '04:54:53'],
    3: ['春分', '21', '03:54:32'],
    4: ['谷雨', '20', '14:56:43'],
    5: ['小满', '21', '14:05:26'],
    6: ['夏至', '21', '22:02:34'],
    7: ['大暑', '23', '08:55:22'],
    8: ['处暑', '23', '15:58:56'],
    9: ['秋分', '23', '13:37:11'],
    10: ['霜降', '23', '22:58:35'],
    11: ['小雪', '22', '20:34:12'],
    12: ['冬至', '22', '09:56:27'],
  },
  1999: {
    1: ['大寒', '20', '20:37:21'],
    2: ['雨水', '19', '10:46:50'],
    3: ['春分', '21', '09:45:50'],
    4: ['谷雨', '20', '20:46:00'],
    5: ['小满', '21', '19:52:25'],
    6: ['夏至', '22', '03:49:07'],
    7: ['大暑', '23', '14:44:06'],
    8: ['处暑', '23', '21:51:05'],
    9: ['秋分', '23', '19:31:31'],
    10: ['霜降', '24', '04:52:14'],
    11: ['小雪', '23', '02:24:50'],
    12: ['冬至', '22', '15:43:48'],
  },
  2000: {
    1: ['大寒', '21', '02:23:03'],
    2: ['雨水', '19', '16:33:18'],
    3: ['春分', '20', '15:35:15'],
    4: ['谷雨', '20', '02:39:30'],
    5: ['小满', '21', '01:49:24'],
    6: ['夏至', '21', '09:47:43'],
    7: ['大暑', '22', '20:42:41'],
    8: ['处暑', '23', '03:48:31'],
    9: ['秋分', '23', '01:27:35'],
    10: ['霜降', '23', '10:47:28'],
    11: ['小雪', '22', '08:19:20'],
    12: ['冬至', '21', '21:37:26'],
  },
  2001: {
    1: ['大寒', '20', '08:16:18'],
    2: ['雨水', '18', '22:27:16'],
    3: ['春分', '20', '21:30:44'],
    4: ['谷雨', '20', '08:35:53'],
    5: ['小满', '21', '07:44:12'],
    6: ['夏至', '21', '15:37:43'],
    7: ['大暑', '23', '02:26:14'],
    8: ['处暑', '23', '09:27:08'],
    9: ['秋分', '23', '07:04:28'],
    10: ['霜降', '23', '16:25:36'],
    11: ['小雪', '22', '14:00:28'],
    12: ['冬至', '22', '03:21:30'],
  },
  2002: {
    1: ['大寒', '20', '14:02:01'],
    2: ['雨水', '19', '04:13:18'],
    3: ['春分', '21', '03:16:07'],
    4: ['谷雨', '20', '14:20:28'],
    5: ['小满', '21', '13:29:06'],
    6: ['夏至', '21', '21:24:24'],
    7: ['大暑', '23', '08:14:51'],
    8: ['处暑', '23', '15:16:58'],
    9: ['秋分', '23', '12:55:23'],
    10: ['霜降', '23', '22:17:49'],
    11: ['小雪', '22', '19:53:44'],
    12: ['冬至', '22', '09:14:22'],
  },
  2003: {
    1: ['大寒', '20', '19:52:35'],
    2: ['雨水', '19', '10:00:13'],
    3: ['春分', '21', '08:59:46'],
    4: ['谷雨', '20', '20:02:48'],
    5: ['小满', '21', '19:12:25'],
    6: ['夏至', '22', '03:10:28'],
    7: ['大暑', '23', '14:04:08'],
    8: ['处暑', '23', '21:08:10'],
    9: ['秋分', '23', '18:46:49'],
    10: ['霜降', '24', '04:08:27'],
    11: ['小雪', '23', '01:43:21'],
    12: ['冬至', '22', '15:03:48'],
  },
  2004: {
    1: ['大寒', '21', '01:42:22'],
    2: ['雨水', '19', '15:49:59'],
    3: ['春分', '20', '14:48:38'],
    4: ['谷雨', '20', '01:50:25'],
    5: ['小满', '21', '00:59:12'],
    6: ['夏至', '21', '08:56:51'],
    7: ['大暑', '22', '19:50:09'],
    8: ['处暑', '23', '02:53:15'],
    9: ['秋分', '23', '00:29:50'],
    10: ['霜降', '23', '09:48:49'],
    11: ['小雪', '22', '07:21:40'],
    12: ['冬至', '21', '20:41:36'],
  },
  2005: {
    1: ['大寒', '20', '07:21:34'],
    2: ['雨水', '18', '21:31:57'],
    3: ['春分', '20', '20:33:26'],
    4: ['谷雨', '20', '07:37:15'],
    5: ['小满', '21', '06:47:24'],
    6: ['夏至', '21', '14:46:07'],
    7: ['大暑', '23', '01:40:42'],
    8: ['处暑', '23', '08:45:27'],
    9: ['秋分', '23', '06:23:11'],
    10: ['霜降', '23', '15:42:20'],
    11: ['小雪', '22', '13:14:58'],
    12: ['冬至', '22', '02:34:56'],
  },
  2006: {
    1: ['大寒', '20', '13:15:18'],
    2: ['雨水', '19', '03:25:34'],
    3: ['春分', '21', '02:25:34'],
    4: ['谷雨', '20', '13:26:03'],
    5: ['小满', '21', '12:31:33'],
    6: ['夏至', '21', '20:25:51'],
    7: ['大暑', '23', '07:17:42'],
    8: ['处暑', '23', '14:22:34'],
    9: ['秋分', '23', '12:03:22'],
    10: ['霜降', '23', '21:26:28'],
    11: ['小雪', '22', '19:01:45'],
    12: ['冬至', '22', '08:22:05'],
  },
  2007: {
    1: ['大寒', '20', '19:00:49'],
    2: ['雨水', '19', '09:08:56'],
    3: ['春分', '21', '08:07:25'],
    4: ['谷雨', '20', '19:07:05'],
    5: ['小满', '21', '18:11:56'],
    6: ['夏至', '22', '02:06:26'],
    7: ['大暑', '23', '13:00:10'],
    8: ['处暑', '23', '20:07:57'],
    9: ['秋分', '23', '17:51:13'],
    10: ['霜降', '24', '03:15:23'],
    11: ['小雪', '23', '00:49:53'],
    12: ['冬至', '22', '14:07:48'],
  },
  2008: {
    1: ['大寒', '21', '00:43:31'],
    2: ['雨水', '19', '14:49:33'],
    3: ['春分', '20', '13:48:17'],
    4: ['谷雨', '20', '00:51:08'],
    5: ['小满', '21', '00:00:53'],
    6: ['夏至', '21', '07:59:21'],
    7: ['大暑', '22', '18:54:47'],
    8: ['处暑', '23', '02:02:14'],
    9: ['秋分', '22', '23:44:29'],
    10: ['霜降', '23', '09:08:38'],
    11: ['小雪', '22', '06:44:19'],
    12: ['冬至', '21', '20:03:45'],
  },
  2009: {
    1: ['大寒', '20', '06:40:20'],
    2: ['雨水', '18', '20:46:06'],
    3: ['春分', '20', '19:43:38'],
    4: ['谷雨', '20', '06:44:25'],
    5: ['小满', '21', '05:51:10'],
    6: ['夏至', '21', '13:45:30'],
    7: ['大暑', '23', '00:35:42'],
    8: ['处暑', '23', '07:38:33'],
    9: ['秋分', '23', '05:18:35'],
    10: ['霜降', '23', '14:43:28'],
    11: ['小雪', '22', '12:22:33'],
    12: ['冬至', '22', '01:46:47'],
  },
  2010: {
    1: ['大寒', '20', '12:27:41'],
    2: ['雨水', '19', '02:35:37'],
    3: ['春分', '21', '01:32:12'],
    4: ['谷雨', '20', '12:29:48'],
    5: ['小满', '21', '11:33:53'],
    6: ['夏至', '21', '19:28:24'],
    7: ['大暑', '23', '06:21:12'],
    8: ['处暑', '23', '13:26:57'],
    9: ['秋分', '23', '11:09:02'],
    10: ['霜降', '23', '20:35:04'],
    11: ['小雪', '22', '18:14:33'],
    12: ['冬至', '22', '07:38:27'],
  },
  2011: {
    1: ['大寒', '20', '18:18:32'],
    2: ['雨水', '19', '08:25:19'],
    3: ['春分', '21', '07:20:44'],
    4: ['谷雨', '20', '18:17:26'],
    5: ['小满', '21', '17:21:10'],
    6: ['夏至', '22', '01:16:29'],
    7: ['大暑', '23', '12:11:48'],
    8: ['处暑', '23', '19:20:38'],
    9: ['秋分', '23', '17:04:37'],
    10: ['霜降', '24', '02:30:18'],
    11: ['小雪', '23', '00:07:48'],
    12: ['冬至', '22', '13:30:01'],
  },
  2012: {
    1: ['大寒', '21', '00:09:49'],
    2: ['雨水', '19', '14:17:35'],
    3: ['春分', '20', '13:14:25'],
    4: ['谷雨', '20', '00:12:04'],
    5: ['小满', '20', '23:15:31'],
    6: ['夏至', '21', '07:08:48'],
    7: ['大暑', '22', '18:00:51'],
    8: ['处暑', '23', '01:06:50'],
    9: ['秋分', '22', '22:48:59'],
    10: ['霜降', '23', '08:13:33'],
    11: ['小雪', '22', '05:50:07'],
    12: ['冬至', '21', '19:11:35'],
  },
  2013: {
    1: ['大寒', '20', '05:51:42'],
    2: ['雨水', '18', '20:01:35'],
    3: ['春分', '20', '19:01:55'],
    4: ['谷雨', '20', '06:03:18'],
    5: ['小满', '21', '05:09:30'],
    6: ['夏至', '21', '13:03:56'],
    7: ['大暑', '22', '23:55:58'],
    8: ['处暑', '23', '07:01:41'],
    9: ['秋分', '23', '04:44:08'],
    10: ['霜降', '23', '14:09:48'],
    11: ['小雪', '22', '11:48:06'],
    12: ['冬至', '22', '01:10:59'],
  },
  2014: {
    1: ['大寒', '20', '11:51:14'],
    2: ['雨水', '19', '01:59:29'],
    3: ['春分', '21', '00:57:06'],
    4: ['谷雨', '20', '11:55:32'],
    5: ['小满', '21', '10:59:02'],
    6: ['夏至', '21', '18:51:13'],
    7: ['大暑', '23', '05:41:21'],
    8: ['处暑', '23', '12:45:58'],
    9: ['秋分', '23', '10:29:04'],
    10: ['霜降', '23', '19:57:03'],
    11: ['小雪', '22', '17:38:11'],
    12: ['冬至', '22', '07:03:01'],
  },
  2015: {
    1: ['大寒', '20', '17:43:14'],
    2: ['雨水', '19', '07:49:47'],
    3: ['春分', '21', '06:45:07'],
    4: ['谷雨', '20', '17:41:50'],
    5: ['小满', '21', '16:44:45'],
    6: ['夏至', '22', '00:37:53'],
    7: ['大暑', '23', '11:30:25'],
    8: ['处暑', '23', '18:37:15'],
    9: ['秋分', '23', '16:20:31'],
    10: ['霜降', '24', '01:46:41'],
    11: ['小雪', '22', '23:25:15'],
    12: ['冬至', '22', '12:47:55'],
  },
  2016: {
    1: ['大寒', '20', '23:27:04'],
    2: ['雨水', '19', '13:33:41'],
    3: ['春分', '20', '12:30:08'],
    4: ['谷雨', '19', '23:29:23'],
    5: ['小满', '20', '22:36:26'],
    6: ['夏至', '21', '06:34:09'],
    7: ['大暑', '22', '17:30:10'],
    8: ['处暑', '23', '00:38:26'],
    9: ['秋分', '22', '22:21:05'],
    10: ['霜降', '23', '07:45:30'],
    11: ['小雪', '22', '05:22:20'],
    12: ['冬至', '21', '18:44:07'],
  },
  2017: {
    1: ['大寒', '20', '05:23:33'],
    2: ['雨水', '18', '19:31:16'],
    3: ['春分', '20', '18:28:35'],
    4: ['谷雨', '20', '05:26:58'],
    5: ['小满', '21', '04:30:53'],
    6: ['夏至', '21', '12:24:06'],
    7: ['大暑', '22', '23:15:18'],
    8: ['处暑', '23', '06:20:09'],
    9: ['秋分', '23', '04:01:44'],
    10: ['霜降', '23', '13:26:36'],
    11: ['小雪', '22', '11:04:34'],
    12: ['冬至', '22', '00:27:53'],
  },
  2018: {
    1: ['大寒', '20', '11:08:58'],
    2: ['雨水', '19', '01:17:57'],
    3: ['春分', '21', '00:15:24'],
    4: ['谷雨', '20', '11:12:29'],
    5: ['小满', '21', '10:14:33'],
    6: ['夏至', '21', '18:07:12'],
    7: ['大暑', '23', '05:00:16'],
    8: ['处暑', '23', '12:08:30'],
    9: ['秋分', '23', '09:54:01'],
    10: ['霜降', '23', '19:22:18'],
    11: ['小雪', '22', '17:01:24'],
    12: ['冬至', '22', '06:22:38'],
  },
  2019: {
    1: ['大寒', '20', '16:59:27'],
    2: ['雨水', '19', '07:03:51'],
    3: ['春分', '21', '05:58:20'],
    4: ['谷雨', '20', '16:55:10'],
    5: ['小满', '21', '15:59:01'],
    6: ['夏至', '21', '23:54:09'],
    7: ['大暑', '23', '10:50:16'],
    8: ['处暑', '23', '18:01:53'],
    9: ['秋分', '23', '15:50:02'],
    10: ['霜降', '24', '01:19:37'],
    11: ['小雪', '22', '22:58:48'],
    12: ['冬至', '22', '12:19:18'],
  },
  2020: {
    1: ['大寒', '20', '22:54:33'],
    2: ['雨水', '19', '12:56:53'],
    3: ['春分', '20', '11:49:29'],
    4: ['谷雨', '19', '22:45:21'],
    5: ['小满', '20', '21:49:09'],
    6: ['夏至', '21', '05:43:33'],
    7: ['大暑', '22', '16:36:44'],
    8: ['处暑', '22', '23:44:48'],
    9: ['秋分', '22', '21:30:32'],
    10: ['霜降', '23', '06:59:25'],
    11: ['小雪', '22', '04:39:38'],
    12: ['冬至', '21', '18:02:12'],
  },
  2021: {
    1: ['大寒', '20', '04:39:42'],
    2: ['雨水', '18', '18:43:49'],
    3: ['春分', '20', '17:37:19'],
    4: ['谷雨', '20', '04:33:14'],
    5: ['小满', '21', '03:36:58'],
    6: ['夏至', '21', '11:32:00'],
    7: ['大暑', '22', '22:26:16'],
    8: ['处暑', '23', '05:34:48'],
    9: ['秋分', '23', '03:20:55'],
    10: ['霜降', '23', '12:51:00'],
    11: ['小雪', '22', '10:33:34'],
    12: ['冬至', '21', '23:59:09'],
  },
  2022: {
    1: ['大寒', '20', '10:38:56'],
    2: ['雨水', '19', '00:42:50'],
    3: ['春分', '20', '23:33:15'],
    4: ['谷雨', '20', '10:24:07'],
    5: ['小满', '21', '09:22:25'],
    6: ['夏至', '21', '17:13:40'],
    7: ['大暑', '23', '04:06:49'],
    8: ['处暑', '23', '11:15:59'],
    9: ['秋分', '23', '09:03:31'],
    10: ['霜降', '23', '18:35:31'],
    11: ['小雪', '22', '16:20:18'],
    12: ['冬至', '22', '05:48:01'],
  },
  2023: {
    1: ['大寒', '20', '16:29:20'],
    2: ['雨水', '19', '06:34:05'],
    3: ['春分', '21', '05:24:14'],
    4: ['谷雨', '20', '16:13:26'],
    5: ['小满', '21', '15:08:59'],
    6: ['夏至', '21', '22:57:37'],
    7: ['大暑', '23', '09:50:15'],
    8: ['处暑', '23', '17:01:06'],
    9: ['秋分', '23', '14:49:46'],
    10: ['霜降', '24', '00:20:39'],
    11: ['小雪', '22', '22:02:29'],
    12: ['冬至', '22', '11:27:09'],
  },
  2024: {
    1: ['大寒', '20', '22:07:08'],
    2: ['雨水', '19', '12:12:58'],
    3: ['春分', '20', '11:06:12'],
    4: ['谷雨', '19', '21:59:33'],
    5: ['小满', '20', '20:59:17'],
    6: ['夏至', '21', '04:50:46'],
    7: ['大暑', '22', '15:44:11'],
    8: ['处暑', '22', '22:54:48'],
    9: ['秋分', '22', '20:43:27'],
    10: ['霜降', '23', '06:14:32'],
    11: ['小雪', '22', '03:56:16'],
    12: ['冬至', '21', '17:20:20'],
  },
  2025: {
    1: ['大寒', '20', '03:59:52'],
    2: ['雨水', '18', '18:06:18'],
    3: ['春分', '20', '17:01:14'],
    4: ['谷雨', '20', '03:55:45'],
    5: ['小满', '21', '02:54:23'],
    6: ['夏至', '21', '10:42:00'],
    7: ['大暑', '22', '21:29:11'],
    8: ['处暑', '23', '04:33:35'],
    9: ['秋分', '23', '02:19:04'],
    10: ['霜降', '23', '11:50:39'],
    11: ['小雪', '22', '09:35:18'],
    12: ['冬至', '21', '23:02:48'],
  },
  2026: {
    1: ['大寒', '20', '09:44:39'],
    2: ['雨水', '18', '23:51:39'],
    3: ['春分', '20', '22:45:42'],
    4: ['谷雨', '20', '09:38:51'],
    5: ['小满', '21', '08:36:28'],
    6: ['夏至', '21', '16:24:12'],
    7: ['大暑', '23', '03:12:48'],
    8: ['处暑', '23', '10:18:31'],
    9: ['秋分', '23', '08:04:56'],
    10: ['霜降', '23', '17:37:39'],
    11: ['小雪', '22', '15:23:03'],
    12: ['冬至', '22', '04:49:55'],
  },
  2027: {
    1: ['大寒', '20', '15:29:32'],
    2: ['雨水', '19', '05:33:10'],
    3: ['春分', '21', '04:24:24'],
    4: ['谷雨', '20', '15:17:20'],
    5: ['小满', '21', '14:17:55'],
    6: ['夏至', '21', '22:10:30'],
    7: ['大暑', '23', '09:04:20'],
    8: ['处暑', '23', '16:13:59'],
    9: ['秋分', '23', '14:01:23'],
    10: ['霜降', '23', '23:32:33'],
    11: ['小雪', '22', '21:15:54'],
    12: ['冬至', '22', '10:41:50'],
  },
  2028: {
    1: ['大寒', '20', '21:21:37'],
    2: ['雨水', '19', '11:25:42'],
    3: ['春分', '20', '10:16:49'],
    4: ['谷雨', '19', '21:09:10'],
    5: ['小满', '20', '20:09:28'],
    6: ['夏至', '21', '04:01:39'],
    7: ['大暑', '22', '14:53:38'],
    8: ['处暑', '22', '22:00:35'],
    9: ['秋分', '22', '19:44:59'],
    10: ['霜降', '23', '05:13:03'],
    11: ['小雪', '22', '02:54:02'],
    12: ['冬至', '21', '16:19:19'],
  },
  2029: {
    1: ['大寒', '20', '03:00:32'],
    2: ['雨水', '18', '17:07:34'],
    3: ['春分', '20', '16:01:37'],
    4: ['谷雨', '20', '02:55:20'],
    5: ['小满', '21', '01:55:30'],
    6: ['夏至', '21', '09:47:55'],
    7: ['大暑', '22', '20:41:43'],
    8: ['处暑', '23', '03:51:14'],
    9: ['秋分', '23', '01:38:09'],
    10: ['霜降', '23', '11:07:45'],
    11: ['小雪', '22', '08:49:01'],
    12: ['冬至', '21', '22:13:45'],
  },
  2030: {
    1: ['大寒', '20', '08:54:01'],
    2: ['雨水', '18', '22:59:34'],
    3: ['春分', '20', '21:51:43'],
    4: ['谷雨', '20', '08:43:13'],
    5: ['小满', '21', '07:40:42'],
    6: ['夏至', '21', '15:30:54'],
    7: ['大暑', '23', '02:24:29'],
    8: ['处暑', '23', '09:36:00'],
    9: ['秋分', '23', '07:26:30'],
    10: ['霜降', '23', '17:00:10'],
    11: ['小雪', '22', '14:44:12'],
    12: ['冬至', '22', '04:09:13'],
  },
  2031: {
    1: ['大寒', '20', '14:47:33'],
    2: ['雨水', '19', '04:50:30'],
    3: ['春分', '21', '03:40:34'],
    4: ['谷雨', '20', '14:30:49'],
    5: ['小满', '21', '13:27:29'],
    6: ['夏至', '21', '21:16:43'],
    7: ['大暑', '23', '08:10:03'],
    8: ['处暑', '23', '15:22:54'],
    9: ['秋分', '23', '13:14:54'],
    10: ['霜降', '23', '22:49:01'],
    11: ['小雪', '22', '20:32:11'],
    12: ['冬至', '22', '09:55:07'],
  },
  2032: {
    1: ['大寒', '20', '20:30:53'],
    2: ['雨水', '19', '10:31:49'],
    3: ['春分', '20', '09:21:29'],
    4: ['谷雨', '19', '20:13:43'],
    5: ['小满', '20', '19:14:33'],
    6: ['夏至', '21', '03:08:19'],
    7: ['大暑', '22', '14:04:18'],
    8: ['处暑', '22', '21:17:53'],
    9: ['秋分', '22', '19:10:27'],
    10: ['霜降', '23', '04:45:47'],
    11: ['小雪', '22', '02:30:44'],
    12: ['冬至', '21', '15:55:29'],
  },
  2033: {
    1: ['大寒', '20', '02:32:20'],
    2: ['雨水', '18', '16:33:22'],
    3: ['春分', '20', '15:22:17'],
    4: ['谷雨', '20', '02:12:40'],
    5: ['小满', '21', '01:10:30'],
    6: ['夏至', '21', '09:00:40'],
    7: ['大暑', '22', '19:52:21'],
    8: ['处暑', '23', '03:01:22'],
    9: ['秋分', '23', '00:51:12'],
    10: ['霜降', '23', '10:27:08'],
    11: ['小雪', '22', '08:15:42'],
    12: ['冬至', '21', '21:45:32'],
  },
  2034: {
    1: ['大寒', '20', '08:26:49'],
    2: ['雨水', '18', '22:29:43'],
    3: ['春分', '20', '21:17:01'],
    4: ['谷雨', '20', '08:03:14'],
    5: ['小满', '21', '06:56:24'],
    6: ['夏至', '21', '14:43:42'],
    7: ['大暑', '23', '01:35:51'],
    8: ['处暑', '23', '08:47:16'],
    9: ['秋分', '23', '06:39:04'],
    10: ['霜降', '23', '16:15:57'],
    11: ['小雪', '22', '14:04:28'],
    12: ['冬至', '22', '03:33:30'],
  },
  2035: {
    1: ['大寒', '20', '14:13:46'],
    2: ['雨水', '19', '04:15:39'],
    3: ['春分', '21', '03:02:12'],
    4: ['谷雨', '20', '13:48:28'],
    5: ['小满', '21', '12:42:56'],
    6: ['夏至', '21', '20:32:38'],
    7: ['大暑', '23', '07:28:11'],
    8: ['处暑', '23', '14:43:39'],
    9: ['秋分', '23', '12:38:26'],
    10: ['霜降', '23', '22:15:39'],
    11: ['小雪', '22', '20:02:41'],
    12: ['冬至', '22', '09:30:21'],
  },
  2036: {
    1: ['大寒', '20', '20:10:31'],
    2: ['雨水', '19', '10:13:46'],
    3: ['春分', '20', '09:02:19'],
    4: ['谷雨', '19', '19:49:58'],
    5: ['小满', '20', '18:44:21'],
    6: ['夏至', '21', '02:31:42'],
    7: ['大暑', '22', '13:22:08'],
    8: ['处暑', '22', '20:31:52'],
    9: ['秋分', '22', '18:22:46'],
    10: ['霜降', '23', '03:58:17'],
    11: ['小雪', '22', '01:44:45'],
    12: ['冬至', '21', '15:12:20'],
  },
  2037: {
    1: ['大寒', '20', '01:53:11'],
    2: ['雨水', '18', '15:58:22'],
    3: ['春分', '20', '14:49:43'],
    4: ['谷雨', '20', '01:39:46'],
    5: ['小满', '21', '00:34:54'],
    6: ['夏至', '21', '08:21:52'],
    7: ['大暑', '22', '19:12:02'],
    8: ['处暑', '23', '02:21:28'],
    9: ['秋分', '23', '00:12:31'],
    10: ['霜降', '23', '09:49:18'],
    11: ['小雪', '22', '07:37:50'],
    12: ['冬至', '21', '21:07:11'],
  },
  2038: {
    1: ['大寒', '20', '07:48:17'],
    2: ['雨水', '18', '21:51:33'],
    3: ['春分', '20', '20:40:04'],
    4: ['谷雨', '20', '07:27:58'],
    5: ['小满', '21', '06:22:08'],
    6: ['夏至', '21', '14:08:49'],
    7: ['大暑', '23', '00:59:19'],
    8: ['处暑', '23', '08:09:33'],
    9: ['秋分', '23', '06:01:40'],
    10: ['霜降', '23', '15:40:05'],
    11: ['小雪', '22', '13:30:44'],
    12: ['冬至', '22', '03:01:44'],
  },
  2039: {
    1: ['大寒', '20', '13:43:04'],
    2: ['雨水', '19', '03:45:09'],
    3: ['春分', '21', '02:31:26'],
    4: ['谷雨', '20', '13:17:11'],
    5: ['小满', '21', '12:10:17'],
    6: ['夏至', '21', '19:56:50'],
    7: ['大暑', '23', '06:47:33'],
    8: ['处暑', '23', '13:58:04'],
    9: ['秋分', '23', '11:49:00'],
    10: ['霜降', '23', '21:24:27'],
    11: ['小雪', '22', '19:11:35'],
    12: ['冬至', '22', '08:39:59'],
  },
  2040: {
    1: ['大寒', '20', '19:20:26'],
    2: ['雨水', '19', '09:23:12'],
    3: ['春分', '20', '08:11:05'],
    4: ['谷雨', '19', '18:58:57'],
    5: ['小满', '20', '17:55:06'],
    6: ['夏至', '21', '01:45:46'],
    7: ['大暑', '22', '12:40:11'],
    8: ['处暑', '22', '19:52:41'],
    9: ['秋分', '22', '17:44:17'],
    10: ['霜降', '23', '03:19:07'],
    11: ['小雪', '22', '01:04:53'],
    12: ['冬至', '21', '14:32:13'],
  },
  2041: {
    1: ['大寒', '20', '01:12:40'],
    2: ['雨水', '18', '15:16:38'],
    3: ['春分', '20', '14:06:11'],
    4: ['谷雨', '20', '00:54:18'],
    5: ['小满', '20', '23:48:12'],
    6: ['夏至', '21', '07:35:12'],
    7: ['大暑', '22', '18:26:02'],
    8: ['处暑', '23', '01:35:37'],
    9: ['秋分', '22', '23:25:54'],
    10: ['霜降', '23', '09:01:18'],
    11: ['小雪', '22', '06:48:39'],
    12: ['冬至', '21', '20:17:40'],
  },
  2042: {
    1: ['大寒', '20', '06:59:23'],
    2: ['雨水', '18', '21:03:49'],
    3: ['春分', '20', '19:52:39'],
    4: ['谷雨', '20', '06:39:07'],
    5: ['小满', '21', '05:30:36'],
    6: ['夏至', '21', '13:15:10'],
    7: ['大暑', '23', '00:05:39'],
    8: ['处暑', '23', '07:17:26'],
    9: ['秋分', '23', '05:10:52'],
    10: ['霜降', '23', '14:48:52'],
    11: ['小雪', '22', '12:36:42'],
    12: ['冬至', '22', '02:03:23'],
  },
  2043: {
    1: ['大寒', '20', '12:40:55'],
    2: ['雨水', '19', '02:41:00'],
    3: ['春分', '21', '01:27:07'],
    4: ['谷雨', '20', '12:13:46'],
    5: ['小满', '21', '11:08:28'],
    6: ['夏至', '21', '18:57:42'],
    7: ['大暑', '23', '05:52:46'],
    8: ['处暑', '23', '13:09:06'],
    9: ['秋分', '23', '11:06:16'],
    10: ['霜降', '23', '20:46:09'],
    11: ['小雪', '22', '18:34:23'],
    12: ['冬至', '22', '08:00:33'],
  },
  2044: {
    1: ['大寒', '20', '18:36:44'],
    2: ['雨水', '19', '08:35:07'],
    3: ['春分', '20', '07:19:52'],
    4: ['谷雨', '19', '18:06:02'],
    5: ['小满', '20', '17:01:11'],
    6: ['夏至', '21', '00:50:26'],
    7: ['大暑', '22', '11:42:38'],
    8: ['处暑', '22', '18:53:58'],
    9: ['秋分', '22', '16:47:09'],
    10: ['霜降', '23', '02:25:35'],
    11: ['小雪', '22', '00:14:35'],
    12: ['冬至', '21', '13:42:53'],
  },
  2045: {
    1: ['大寒', '20', '00:21:30'],
    2: ['雨水', '18', '14:21:40'],
    3: ['春分', '20', '13:06:56'],
    4: ['谷雨', '19', '23:52:10'],
    5: ['小满', '20', '22:45:17'],
    6: ['夏至', '21', '06:33:11'],
    7: ['大暑', '22', '17:26:05'],
    8: ['处暑', '23', '00:38:27'],
    9: ['秋分', '22', '22:32:13'],
    10: ['霜降', '23', '08:11:48'],
    11: ['小雪', '22', '06:03:07'],
    12: ['冬至', '21', '19:34:23'],
  },
  2046: {
    1: ['大寒', '20', '06:15:09'],
    2: ['雨水', '18', '20:14:54'],
    3: ['春分', '20', '18:57:10'],
    4: ['谷雨', '20', '05:38:13'],
    5: ['小满', '21', '04:27:47'],
    6: ['夏至', '21', '12:13:55'],
    7: ['大暑', '22', '23:07:57'],
    8: ['处暑', '23', '06:23:47'],
    9: ['秋分', '23', '04:20:59'],
    10: ['霜降', '23', '14:02:49'],
    11: ['小雪', '22', '11:55:32'],
    12: ['冬至', '22', '01:27:45'],
  },
  2047: {
    1: ['大寒', '20', '12:09:13'],
    2: ['雨水', '19', '02:09:40'],
    3: ['春分', '21', '00:51:56'],
    4: ['谷雨', '20', '11:31:48'],
    5: ['小满', '21', '10:19:11'],
    6: ['夏至', '21', '18:02:45'],
    7: ['大暑', '23', '04:54:44'],
    8: ['处暑', '23', '12:10:08'],
    9: ['秋分', '23', '10:07:21'],
    10: ['霜降', '23', '19:47:50'],
    11: ['小雪', '22', '17:37:32'],
    12: ['冬至', '22', '07:06:29'],
  },
  2048: {
    1: ['大寒', '20', '17:46:21'],
    2: ['雨水', '19', '07:47:45'],
    3: ['春分', '20', '06:33:05'],
    4: ['谷雨', '19', '17:16:41'],
    5: ['小满', '20', '16:07:18'],
    6: ['夏至', '20', '23:53:10'],
    7: ['大暑', '22', '10:46:11'],
    8: ['处暑', '22', '18:01:44'],
    9: ['秋分', '22', '15:59:53'],
    10: ['霜降', '23', '01:41:58'],
    11: ['小雪', '21', '23:32:44'],
    12: ['冬至', '21', '13:01:30'],
  },
  2049: {
    1: ['大寒', '19', '23:40:27'],
    2: ['雨水', '18', '13:41:32'],
    3: ['春分', '20', '12:27:52'],
    4: ['谷雨', '19', '23:12:43'],
    5: ['小满', '20', '22:03:03'],
    6: ['夏至', '21', '05:46:32'],
    7: ['大暑', '22', '16:35:32'],
    8: ['处暑', '22', '23:46:35'],
    9: ['秋分', '22', '21:41:52'],
    10: ['霜降', '23', '07:24:26'],
    11: ['小雪', '22', '05:18:31'],
    12: ['冬至', '21', '18:51:23'],
  },
  2050: {
    1: ['大寒', '20', '05:33:01'],
    2: ['雨水', '18', '19:34:18'],
    3: ['春分', '20', '18:18:49'],
    4: ['谷雨', '20', '05:01:25'],
    5: ['小满', '21', '03:50:03'],
    6: ['夏至', '21', '11:32:14'],
    7: ['大暑', '22', '22:20:37'],
    8: ['处暑', '23', '05:31:51'],
    9: ['秋分', '23', '03:27:45'],
    10: ['霜降', '23', '13:11:03'],
    11: ['小雪', '22', '11:05:32'],
    12: ['冬至', '22', '00:37:55'],
  },
  2051: {
    1: ['大寒', '20', '11:18:00'],
    2: ['雨水', '19', '01:16:41'],
    3: ['春分', '20', '23:58:25'],
    4: ['谷雨', '20', '10:39:53'],
    5: ['小满', '21', '09:30:39'],
    6: ['夏至', '21', '17:17:53'],
    7: ['大暑', '23', '04:12:12'],
    8: ['处暑', '23', '11:28:23'],
    9: ['秋分', '23', '09:26:37'],
    10: ['霜降', '23', '19:09:20'],
    11: ['小雪', '22', '17:02:05'],
    12: ['冬至', '22', '06:33:21'],
  },
  2052: {
    1: ['大寒', '20', '17:13:26'],
    2: ['雨水', '19', '07:12:51'],
    3: ['春分', '20', '05:55:20'],
    4: ['谷雨', '19', '16:37:10'],
    5: ['小满', '20', '15:28:13'],
    6: ['夏至', '20', '23:15:27'],
    7: ['大暑', '22', '10:08:05'],
    8: ['处暑', '22', '17:20:43'],
    9: ['秋分', '22', '15:14:55'],
    10: ['霜降', '23', '00:54:24'],
    11: ['小雪', '21', '22:45:13'],
    12: ['冬至', '21', '12:16:26'],
  },
  2053: {
    1: ['大寒', '19', '22:58:28'],
    2: ['雨水', '18', '13:01:08'],
    3: ['春分', '20', '11:46:37'],
    4: ['谷雨', '19', '22:29:30'],
    5: ['小满', '20', '21:18:47'],
    6: ['夏至', '21', '05:03:22'],
    7: ['大暑', '22', '15:55:26'],
    8: ['处暑', '22', '23:09:29'],
    9: ['秋分', '22', '21:05:33'],
    10: ['霜降', '23', '06:46:29'],
    11: ['小雪', '22', '04:38:01'],
    12: ['冬至', '21', '18:09:11'],
  },
  2054: {
    1: ['大寒', '20', '04:50:14'],
    2: ['雨水', '18', '18:50:47'],
    3: ['春分', '20', '17:33:42'],
    4: ['谷雨', '20', '04:14:19'],
    5: ['小满', '21', '03:02:13'],
    6: ['夏至', '21', '10:46:25'],
    7: ['大暑', '22', '21:39:52'],
    8: ['处暑', '23', '04:57:41'],
    9: ['秋分', '23', '02:58:44'],
    10: ['霜降', '23', '12:44:04'],
    11: ['小雪', '22', '10:38:06'],
    12: ['冬至', '22', '00:09:11'],
  },
  2055: {
    1: ['大寒', '20', '10:48:15'],
    2: ['雨水', '19', '00:46:33'],
    3: ['春分', '20', '23:27:52'],
    4: ['谷雨', '20', '10:07:47'],
    5: ['小满', '21', '08:55:27'],
    6: ['夏至', '21', '16:39:08'],
    7: ['大暑', '23', '03:31:17'],
    8: ['处暑', '23', '10:47:48'],
    9: ['秋分', '23', '08:48:00'],
    10: ['霜降', '23', '18:32:33'],
    11: ['小雪', '22', '16:25:24'],
    12: ['冬至', '22', '05:54:51'],
  },
  2056: {
    1: ['大寒', '20', '16:32:10'],
    2: ['雨水', '19', '06:29:11'],
    3: ['春分', '20', '05:10:18'],
    4: ['谷雨', '19', '15:51:20'],
    5: ['小满', '20', '14:41:11'],
    6: ['夏至', '20', '22:27:29'],
    7: ['大暑', '22', '09:21:29'],
    8: ['处暑', '22', '16:38:18'],
    9: ['秋分', '22', '14:38:45'],
    10: ['霜降', '23', '00:24:36'],
    11: ['小雪', '21', '22:19:29'],
    12: ['冬至', '21', '11:50:53'],
  },
  2057: {
    1: ['大寒', '19', '22:29:25'],
    2: ['雨水', '18', '12:26:39'],
    3: ['春分', '20', '11:07:11'],
    4: ['谷雨', '19', '21:46:46'],
    5: ['小满', '20', '20:34:29'],
    6: ['夏至', '21', '04:18:20'],
    7: ['大暑', '22', '15:09:57'],
    8: ['处暑', '22', '22:24:16'],
    9: ['秋分', '22', '20:22:32'],
    10: ['霜降', '23', '06:08:15'],
    11: ['小雪', '22', '04:05:56'],
    12: ['冬至', '21', '17:42:07'],
  },
  2058: {
    1: ['大寒', '20', '04:25:16'],
    2: ['雨水', '18', '18:24:52'],
    3: ['春分', '20', '17:04:16'],
    4: ['谷雨', '20', '03:40:07'],
    5: ['小满', '21', '02:23:18'],
    6: ['夏至', '21', '10:03:19'],
    7: ['大暑', '22', '20:53:03'],
    8: ['处暑', '23', '04:07:59'],
    9: ['秋分', '23', '02:07:40'],
    10: ['霜降', '23', '11:53:39'],
    11: ['小雪', '22', '09:50:02'],
    12: ['冬至', '21', '23:24:13'],
  },
  2059: {
    1: ['大寒', '20', '10:05:47'],
    2: ['雨水', '19', '00:04:28'],
    3: ['春分', '20', '22:43:32'],
    4: ['谷雨', '20', '09:19:31'],
    5: ['小满', '21', '08:03:49'],
    6: ['夏至', '21', '15:46:32'],
    7: ['大暑', '23', '02:40:08'],
    8: ['处暑', '23', '09:59:25'],
    9: ['秋分', '23', '08:02:47'],
    10: ['霜降', '23', '17:50:02'],
    11: ['小雪', '22', '15:45:12'],
    12: ['冬至', '22', '05:17:13'],
  },
  2060: {
    1: ['大寒', '20', '15:57:22'],
    2: ['雨水', '19', '05:56:29'],
    3: ['春分', '20', '04:37:46'],
    4: ['谷雨', '19', '15:16:36'],
    5: ['小满', '20', '14:02:44'],
    6: ['夏至', '20', '21:44:53'],
    7: ['大暑', '22', '08:35:00'],
    8: ['处暑', '22', '15:48:48'],
    9: ['秋分', '22', '13:47:26'],
    10: ['霜降', '22', '23:32:39'],
    11: ['小雪', '21', '21:27:52'],
    12: ['冬至', '21', '11:00:41'],
  },
  2061: {
    1: ['大寒', '19', '21:41:52'],
    2: ['雨水', '18', '11:42:25'],
    3: ['春分', '20', '10:25:31'],
    4: ['谷雨', '19', '21:05:46'],
    5: ['小满', '20', '19:51:31'],
    6: ['夏至', '21', '03:31:29'],
    7: ['大暑', '22', '14:19:35'],
    8: ['处暑', '22', '21:32:22'],
    9: ['秋分', '22', '19:30:38'],
    10: ['霜降', '23', '05:16:28'],
    11: ['小雪', '22', '03:13:26'],
    12: ['冬至', '21', '16:48:06'],
  },
  2062: {
    1: ['大寒', '20', '03:29:25'],
    2: ['雨水', '18', '17:27:30'],
    3: ['春分', '20', '16:06:44'],
    4: ['谷雨', '20', '02:43:53'],
    5: ['小满', '21', '01:29:02'],
    6: ['夏至', '21', '09:10:39'],
    7: ['大暑', '22', '20:01:26'],
    8: ['处暑', '23', '03:17:33'],
    9: ['秋分', '23', '01:19:10'],
    10: ['霜降', '23', '11:07:37'],
    11: ['小雪', '22', '09:06:22'],
    12: ['冬至', '21', '22:41:55'],
  },
  2063: {
    1: ['大寒', '20', '09:23:13'],
    2: ['雨水', '18', '23:20:35'],
    3: ['春分', '20', '21:58:28'],
    4: ['谷雨', '20', '08:34:14'],
    5: ['小满', '21', '07:18:53'],
    6: ['夏至', '21', '15:01:10'],
    7: ['大暑', '23', '01:52:35'],
    8: ['处暑', '23', '09:08:04'],
    9: ['秋分', '23', '07:07:29'],
    10: ['霜降', '23', '16:52:34'],
    11: ['小雪', '22', '14:47:37'],
    12: ['冬至', '22', '04:20:21'],
  },
  2064: {
    1: ['大寒', '20', '15:00:37'],
    2: ['雨水', '19', '04:58:35'],
    3: ['春分', '20', '03:37:54'],
    4: ['谷雨', '19', '14:15:07'],
    5: ['小满', '20', '13:01:00'],
    6: ['夏至', '20', '20:44:55'],
    7: ['大暑', '22', '07:38:38'],
    8: ['处暑', '22', '14:55:56'],
    9: ['秋分', '22', '12:56:20'],
    10: ['霜降', '22', '22:41:32'],
    11: ['小雪', '21', '20:36:01'],
    12: ['冬至', '21', '10:08:02'],
  },
  2065: {
    1: ['大寒', '19', '20:48:07'],
    2: ['雨水', '18', '10:46:51'],
    3: ['春分', '20', '09:27:28'],
    4: ['谷雨', '19', '20:05:09'],
    5: ['小满', '20', '18:49:58'],
    6: ['夏至', '21', '02:31:45'],
    7: ['大暑', '22', '13:23:40'],
    8: ['处暑', '22', '20:40:37'],
    9: ['秋分', '22', '18:41:52'],
    10: ['霜降', '23', '04:28:56'],
    11: ['小雪', '22', '02:25:50'],
    12: ['冬至', '21', '16:00:02'],
  },
  2066: {
    1: ['大寒', '20', '02:41:21'],
    2: ['雨水', '18', '16:39:58'],
    3: ['春分', '20', '15:19:05'],
    4: ['谷雨', '20', '01:54:32'],
    5: ['小满', '21', '00:36:43'],
    6: ['夏至', '21', '08:15:40'],
    7: ['大暑', '22', '19:05:33'],
    8: ['处暑', '23', '02:22:45'],
    9: ['秋分', '23', '00:26:17'],
    10: ['霜降', '23', '10:15:39'],
    11: ['小雪', '22', '08:12:51'],
    12: ['冬至', '21', '21:44:47'],
  },
  2067: {
    1: ['大寒', '20', '08:22:09'],
    2: ['雨水', '18', '22:16:36'],
    3: ['春分', '20', '20:52:53'],
    4: ['谷雨', '20', '07:27:52'],
    5: ['小满', '21', '06:12:11'],
    6: ['夏至', '21', '13:55:16'],
    7: ['大暑', '23', '00:49:53'],
    8: ['处暑', '23', '08:11:30'],
    9: ['秋分', '23', '06:18:55'],
    10: ['霜降', '23', '16:11:03'],
    11: ['小雪', '22', '14:09:52'],
    12: ['冬至', '22', '03:42:22'],
  },
  2068: {
    1: ['大寒', '20', '14:19:14'],
    2: ['雨水', '19', '04:12:40'],
    3: ['春分', '20', '02:48:16'],
    4: ['谷雨', '19', '13:23:39'],
    5: ['小满', '20', '12:09:16'],
    6: ['夏至', '20', '19:53:02'],
    7: ['大暑', '22', '06:45:56'],
    8: ['处暑', '22', '14:03:12'],
    9: ['秋分', '22', '12:06:02'],
    10: ['霜降', '22', '21:56:13'],
    11: ['小雪', '21', '19:56:15'],
    12: ['冬至', '21', '09:31:56'],
  },
  2069: {
    1: ['大寒', '19', '20:12:23'],
    2: ['雨水', '18', '10:08:16'],
    3: ['春分', '20', '08:44:19'],
    4: ['谷雨', '19', '19:17:59'],
    5: ['小满', '20', '18:00:16'],
    6: ['夏至', '21', '01:40:33'],
    7: ['大暑', '22', '12:31:37'],
    8: ['处暑', '22', '19:48:32'],
    9: ['秋分', '22', '17:51:09'],
    10: ['霜降', '23', '03:41:25'],
    11: ['小雪', '22', '01:42:53'],
    12: ['冬至', '21', '15:21:19'],
  },
  2070: {
    1: ['大寒', '20', '02:04:15'],
    2: ['雨水', '18', '16:00:29'],
    3: ['春分', '20', '14:34:10'],
    4: ['谷雨', '20', '01:03:45'],
    5: ['小满', '20', '23:42:32'],
    6: ['夏至', '21', '07:21:51'],
    7: ['大暑', '22', '18:14:57'],
    8: ['处暑', '23', '01:36:25'],
    9: ['秋分', '22', '23:44:06'],
    10: ['霜降', '23', '09:37:38'],
    11: ['小雪', '22', '07:40:11'],
    12: ['冬至', '21', '21:18:35'],
  },
  2071: {
    1: ['大寒', '20', '08:01:40'],
    2: ['雨水', '18', '21:58:56'],
    3: ['春分', '20', '20:33:56'],
    4: ['谷雨', '20', '07:04:08'],
    5: ['小满', '21', '05:42:14'],
    6: ['夏至', '21', '13:20:05'],
    7: ['大暑', '23', '00:11:30'],
    8: ['处暑', '23', '07:31:08'],
    9: ['秋分', '23', '05:37:00'],
    10: ['霜降', '23', '15:28:25'],
    11: ['小雪', '22', '13:27:57'],
    12: ['冬至', '22', '03:03:07'],
  },
  2072: {
    1: ['大寒', '20', '13:44:25'],
    2: ['雨水', '19', '03:42:23'],
    3: ['春分', '20', '02:20:20'],
    4: ['谷雨', '19', '12:54:16'],
    5: ['小满', '20', '11:34:55'],
    6: ['夏至', '20', '19:13:03'],
    7: ['大暑', '22', '06:03:24'],
    8: ['处暑', '22', '13:21:45'],
    9: ['秋分', '22', '11:27:06'],
    10: ['霜降', '22', '21:19:07'],
    11: ['小雪', '21', '19:19:42'],
    12: ['冬至', '21', '08:55:17'],
  },
  2073: {
    1: ['大寒', '19', '19:36:14'],
    2: ['雨水', '18', '09:34:01'],
    3: ['春分', '20', '08:12:36'],
    4: ['谷雨', '19', '18:47:29'],
    5: ['小满', '20', '17:28:44'],
    6: ['夏至', '21', '01:06:16'],
    7: ['大暑', '22', '11:54:29'],
    8: ['处暑', '22', '19:10:30'],
    9: ['秋分', '22', '17:14:33'],
    10: ['霜降', '23', '03:07:18'],
    11: ['小雪', '22', '01:10:43'],
    12: ['冬至', '21', '14:49:58'],
  },
  2074: {
    1: ['大寒', '20', '01:33:25'],
    2: ['雨水', '18', '15:31:19'],
    3: ['春分', '20', '14:08:08'],
    4: ['谷雨', '20', '00:40:59'],
    5: ['小满', '20', '23:20:55'],
    6: ['夏至', '21', '06:57:43'],
    7: ['大暑', '22', '17:45:00'],
    8: ['处暑', '23', '00:59:50'],
    9: ['秋分', '22', '23:03:03'],
    10: ['霜降', '23', '08:55:05'],
    11: ['小雪', '22', '06:57:10'],
    12: ['冬至', '21', '20:34:31'],
  },
  2075: {
    1: ['大寒', '20', '07:15:47'],
    2: ['雨水', '18', '21:11:16'],
    3: ['春分', '20', '19:45:50'],
    4: ['谷雨', '20', '06:17:40'],
    5: ['小满', '21', '04:58:52'],
    6: ['夏至', '21', '12:39:43'],
    7: ['大暑', '22', '23:32:45'],
    8: ['处暑', '23', '06:52:30'],
    9: ['秋分', '23', '04:58:06'],
    10: ['霜降', '23', '14:49:53'],
    11: ['小雪', '22', '12:50:27'],
    12: ['冬至', '22', '02:26:21'],
  },
  2076: {
    1: ['大寒', '20', '13:06:57'],
    2: ['雨水', '19', '03:02:42'],
    3: ['春分', '20', '01:38:08'],
    4: ['谷雨', '19', '12:11:15'],
    5: ['小满', '20', '10:54:06'],
    6: ['夏至', '20', '18:36:04'],
    7: ['大暑', '22', '05:28:57'],
    8: ['处暑', '22', '12:46:59'],
    9: ['秋分', '22', '10:49:32'],
    10: ['霜降', '22', '20:38:17'],
    11: ['小雪', '21', '18:37:00'],
    12: ['冬至', '21', '08:12:40'],
  },
  2077: {
    1: ['大寒', '19', '18:54:40'],
    2: ['雨水', '18', '08:52:50'],
    3: ['春分', '20', '07:30:22'],
    4: ['谷雨', '19', '18:03:42'],
    5: ['小满', '20', '16:44:18'],
    6: ['夏至', '21', '00:22:45'],
    7: ['大暑', '22', '11:13:08'],
    8: ['处暑', '22', '18:31:05'],
    9: ['秋分', '22', '16:35:08'],
    10: ['霜降', '23', '02:25:17'],
    11: ['小雪', '22', '00:24:38'],
    12: ['冬至', '21', '14:00:06'],
  },
  2078: {
    1: ['大寒', '20', '00:40:41'],
    2: ['雨水', '18', '14:36:04'],
    3: ['春分', '20', '13:10:09'],
    4: ['谷雨', '19', '23:40:12'],
    5: ['小满', '2', '22:18:41'],
    6: ['夏至', '21', '05:57:15'],
    7: ['大暑', '22', '16:50:14'],
    8: ['处暑', '23', '00:13:12'],
    9: ['秋分', '22', '22:23:49'],
    10: ['霜降', '23', '08:19:49'],
    11: ['小雪', '22', '06:22:11'],
    12: ['冬至', '21', '19:57:16'],
  },
  2079: {
    1: ['大寒', '20', '06:35:13'],
    2: ['雨水', '18', '20:27:42'],
    3: ['春分', '20', '18:59:59'],
    4: ['谷雨', '20', '05:29:52'],
    5: ['小满', '21', '04:09:10'],
    6: ['夏至', '21', '11:48:37'],
    7: ['大暑', '22', '22:41:50'],
    8: ['处暑', '23', '06:03:39'],
    9: ['秋分', '23', '04:12:28'],
    10: ['霜降', '23', '14:07:16'],
    11: ['小雪', '22', '12:08:58'],
    12: ['冬至', '22', '01:43:19'],
  },
  2080: {
    1: ['大寒', '20', '12:20:17'],
    2: ['雨水', '19', '02:11:43'],
    3: ['春分', '20', '00:43:27'],
    4: ['谷雨', '19', '11:13:40'],
    5: ['小满', '20', '09:53:45'],
    6: ['夏至', '20', '17:33:25'],
    7: ['大暑', '22', '04:26:10'],
    8: ['处暑', '22', '11:47:18'],
    9: ['秋分', '22', '09:55:45'],
    10: ['霜降', '22', '19:51:21'],
    11: ['小雪', '21', '17:55:11'],
    12: ['冬至', '21', '07:32:08'],
  },
  2081: {
    1: ['大寒', '19', '18:11:03'],
    2: ['雨水', '18', '08:03:04'],
    3: ['春分', '20', '06:33:34'],
    4: ['谷雨', '19', '17:00:52'],
    5: ['小满', '20', '15:37:58'],
    6: ['夏至', '20', '23:15:43'],
    7: ['大暑', '22', '10:07:29'],
    8: ['处暑', '22', '17:28:24'],
    9: ['秋分', '22', '15:37:09'],
    10: ['霜降', '23', '01:33:52'],
    11: ['小雪', '21', '23:40:32'],
    12: ['冬至', '21', '13:21:51'],
  },
  2082: {
    1: ['大寒', '20', '00:05:08'],
    2: ['雨水', '18', '13:59:42'],
    3: ['春分', '20', '12:29:59'],
    4: ['谷雨', '19', '22:54:44'],
    5: ['小满', '20', '21:28:07'],
    6: ['夏至', '21', '05:02:38'],
    7: ['大暑', '22', '15:52:22'],
    8: ['处暑', '22', '23:12:47'],
    9: ['秋分', '22', '21:22:18'],
    10: ['霜降', '23', '07:19:25'],
    11: ['小雪', '22', '05:24:48'],
    12: ['冬至', '21', '19:04:00'],
  },
  2083: {
    1: ['大寒', '20', '05:45:40'],
    2: ['雨水', '18', '19:39:34'],
    3: ['春分', '20', '18:09:52'],
    4: ['谷雨', '20', '04:34:48'],
    5: ['小满', '21', '03:08:10'],
    6: ['夏至', '21', '10:43:14'],
    7: ['大暑', '22', '21:35:06'],
    8: ['处暑', '23', '04:58:35'],
    9: ['秋分', '23', '03:10:59'],
    10: ['霜降', '23', '13:09:42'],
    11: ['小雪', '22', '11:14:58'],
    12: ['冬至', '22', '00:52:43'],
  },
  2084: {
    1: ['大寒', '20', '11:32:57'],
    2: ['雨水', '19', '01:26:47'],
    3: ['春分', '19', '23:58:51'],
    4: ['谷雨', '19', '10:27:02'],
    5: ['小满', '20', '09:03:46'],
    6: ['夏至', '20', '16:39:56'],
    7: ['大暑', '22', '03:29:56'],
    8: ['处暑', '22', '10:49:49'],
    9: ['秋分', '22', '08:58:29'],
    10: ['霜降', '22', '18:55:18'],
    11: ['小雪', '21', '17:01:03'],
    12: ['冬至', '21', '06:40:38'],
  },
  2085: {
    1: ['大寒', '19', '11:32:57'],
    2: ['雨水', '18', '07:18:55'],
    3: ['春分', '20', '05:52:55'],
    4: ['谷雨', '19', '16:22:11'],
    5: ['小满', '20', '14:58:20'],
    6: ['夏至', '20', '22:32:12'],
    7: ['大暑', '22', '09:18:49'],
    8: ['处暑', '22', '16:35:48'],
    9: ['秋分', '22', '14:42:53'],
    10: ['霜降', '23', '00:39:33'],
    11: ['小雪', '21', '22:46:36'],
    12: ['冬至', '21', '12:28:07'],
  },
  2086: {
    1: ['大寒', '19', '23:10:59'],
    2: ['雨水', '18', '13:04:45'],
    3: ['春分', '20', '11:34:42'],
    4: ['谷雨', '19', '21:59:56'],
    5: ['小满', '20', '20:34:02'],
    6: ['夏至', '21', '04:08:59'],
    7: ['大暑', '22', '14:59:03'],
    8: ['处暑', '22', '22:20:17'],
    9: ['秋分', '22', '20:31:37'],
    10: ['霜降', '23', '06:31:33'],
    11: ['小雪', '22', '04:40:17'],
    12: ['冬至', '21', '18:22:03'],
  },
  2087: {
    1: ['大寒', '20', '05:04:38'],
    2: ['雨水', '18', '18:58:03'],
    3: ['春分', '20', '17:27:44'],
    4: ['谷雨', '20', '03:53:12'],
    5: ['小满', '21', '02:28:25'],
    6: ['夏至', '21', '10:05:23'],
    7: ['大暑', '22', '20:57:39'],
    8: ['处暑', '23', '04:19:05'],
    9: ['秋分', '23', '02:27:43'],
    10: ['霜降', '23', '12:23:38'],
    11: ['小雪', '22', '10:28:34'],
    12: ['冬至', '22', '00:07:54'],
  },
  2088: {
    1: ['大寒', '20', '10:50:03'],
    2: ['雨水', '19', '00:44:46'],
    3: ['春分', '19', '23:16:29'],
    4: ['谷雨', '19', '09:43:38'],
    5: ['小满', '20', '08:19:35'],
    6: ['夏至', '20', '15:56:07'],
    7: ['大暑', '22', '02:47:36'],
    8: ['处暑', '22', '10:08:56'],
    9: ['秋分', '22', '08:17:43'],
    10: ['霜降', '22', '18:13:09'],
    11: ['小雪', '21', '16:17:08'],
    12: ['冬至', '21', '05:55:38'],
  },
  2089: {
    1: ['大寒', '19', '16:37:38'],
    2: ['雨水', '18', '06:33:15'],
    3: ['春分', '20', '05:06:03'],
    4: ['谷雨', '19', '15:32:57'],
    5: ['小满', '20', '14:07:24'],
    6: ['夏至', '20', '21:42:24'],
    7: ['大暑', '22', '08:33:06'],
    8: ['处暑', '22', '15:55:13'],
    9: ['秋分', '22', '14:06:24'],
    10: ['霜降', '23', '00:04:48'],
    11: ['小雪', '21', '22:11:21'],
    12: ['冬至', '21', '11:51:30'],
  },
  2090: {
    1: ['大寒', '19', '22:34:04'],
    2: ['雨水', '18', '12:29:19'],
    3: ['春分', '20', '11:01:23'],
    4: ['谷雨', '19', '21:27:48'],
    5: ['小满', '20', '20:01:32'],
    6: ['夏至', '21', '03:35:22'],
    7: ['大暑', '22', '14:24:56'],
    8: ['处暑', '22', '21:46:37'],
    9: ['秋分', '22', '19:58:49'],
    10: ['霜降', '23', '05:58:47'],
    11: ['小雪', '22', '04:05:17'],
    12: ['冬至', '21', '17:43:02'],
  },
  2091: {
    1: ['大寒', '20', '04:21:33'],
    2: ['雨水', '18', '18:12:24'],
    3: ['春分', '20', '16:41:22'],
    4: ['谷雨', '20', '03:07:02'],
    5: ['小满', '21', '01:42:09'],
    6: ['夏至', '21', '09:18:26'],
    7: ['大暑', '22', '20:11:00'],
    8: ['处暑', '23', '03:35:45'],
    9: ['秋分', '23', '01:50:21'],
    10: ['霜降', '23', '11:51:59'],
    11: ['小雪', '22', '09:59:47'],
    12: ['冬至', '21', '23:38:02'],
  },
  2092: {
    1: ['大寒', '20', '10:15:57'],
    2: ['雨水', '19', '00:05:25'],
    3: ['春分', '19', '22:33:05'],
    4: ['谷雨', '19', '08:58:49'],
    5: ['小满', '20', '07:35:58'],
    6: ['夏至', '20', '15:14:29'],
    7: ['大暑', '22', '02:07:11'],
    8: ['处暑', '22', '09:29:46'],
    9: ['秋分', '22', '07:41:18'],
    10: ['霜降', '22', '17:41:13'],
    11: ['小雪', '21', '15:49:59'],
    12: ['冬至', '21', '05:31:25'],
  },
  2093: {
    1: ['大寒', '19', '16:13:11'],
    2: ['雨水', '18', '06:05:35'],
    3: ['春分', '20', '04:34:02'],
    4: ['谷雨', '19', '14:58:00'],
    5: ['小满', '20', '13:31:33'],
    6: ['夏至', '20', '21:06:34'],
    7: ['大暑', '22', '07:56:51'],
    8: ['处暑', '22', '15:17:54'],
    9: ['秋分', '22', '13:28:25'],
    10: ['霜降', '22', '23:27:47'],
    11: ['小雪', '21', '21:37:04'],
    12: ['冬至', '21', '11:20:15'],
  },
  2094: {
    1: ['大寒', '19', '22:03:29'],
    2: ['雨水', '18', '11:55:26'],
    3: ['春分', '20', '10:21:04'],
    4: ['谷雨', '19', '20:40:21'],
    5: ['小满', '20', '19:09:06'],
    6: ['夏至', '21', '02:41:49'],
    7: ['大暑', '22', '13:33:51'],
    8: ['处暑', '22', '20:59:44'],
    9: ['秋分', '22', '19:16:02'],
    10: ['霜降', '23', '05:19:40'],
    11: ['小雪', '22', '03:30:22'],
    12: ['冬至', '21', '17:12:48'],
  },
  2095: {
    1: ['大寒', '20', '03:55:13'],
    2: ['雨水', '18', '17:47:30'],
    3: ['春分', '20', '16:14:27'],
    4: ['谷雨', '20', '02:35:25'],
    5: ['小满', '21', '01:05:20'],
    6: ['夏至', '21', '08:38:21'],
    7: ['大暑', '22', '19:30:24'],
    8: ['处暑', '23', '02:55:49'],
    9: ['秋分', '23', '01:10:36'],
    10: ['霜降', '23', '11:12:14'],
    11: ['小雪', '22', '09:20:29'],
    12: ['冬至', '21', '23:00:18'],
  },
  2096: {
    1: ['大寒', '20', '09:40:59'],
    2: ['雨水', '18', '23:33:26'],
    3: ['春分', '19', '22:02:23'],
    4: ['谷雨', '19', '08:26:09'],
    5: ['小满', '20', '06:58:00'],
    6: ['夏至', '20', '14:30:16'],
    7: ['大暑', '22', '01:18:57'],
    8: ['处暑', '22', '08:41:01'],
    9: ['秋分', '22', '06:54:12'],
    10: ['霜降', '22', '16:55:45'],
    11: ['小雪', '21', '15:04:56'],
    12: ['冬至', '21', '04:45:41'],
  },
  2097: {
    1: ['大寒', '19', '15:26:41'],
    2: ['雨水', '18', '05:19:06'],
    3: ['春分', '20', '03:47:53'],
    4: ['谷雨', '19', '14:10:49'],
    5: ['小满', '20', '12:41:29'],
    6: ['夏至', '20', '20:12:51'],
    7: ['大暑', '22', '07:00:28'],
    8: ['处暑', '22', '14:21:36'],
    9: ['秋分', '22', '12:35:19'],
    10: ['霜降', '22', '22:39:16'],
    11: ['小雪', '21', '20:52:11'],
    12: ['冬至', '21', '10:36:53'],
  },
  2098: {
    1: ['大寒', '19', '21:20:24'],
    2: ['雨水', '18', '11:12:51'],
    3: ['春分', '20', '09:39:55'],
    4: ['谷雨', '19', '20:01:14'],
    5: ['小满', '20', '18:31:04'],
    6: ['夏至', '21', '02:02:26'],
    7: ['大暑', '22', '12:50:25'],
    8: ['处暑', '22', '20:11:05'],
    9: ['秋分', '22', '18:23:39'],
    10: ['霜降', '23', '04:26:21'],
    11: ['小雪', '22', '02:37:34'],
    12: ['冬至', '21', '16:20:16'],
  },
  2099: {
    1: ['大寒', '20', '03:01:46'],
    2: ['雨水', '18', '16:52:06'],
    3: ['春分', '20', '15:17:10'],
    4: ['谷雨', '20', '01:37:25'],
    5: ['小满', '21', '00:07:46'],
    6: ['夏至', '21', '07:41:05'],
    7: ['大暑', '22', '18:32:23'],
    8: ['处暑', '23', '01:56:34'],
    9: ['秋分', '23', '00:10:33'],
    10: ['霜降', '23', '10:12:22'],
    11: ['小雪', '22', '08:22:04'],
    12: ['冬至', '21', '22:03:47'],
  },
  2100: {
    1: ['大寒', '20', '08:45:20'],
    2: ['雨水', '18', '22:36:43'],
    3: ['春分', '20', '21:03:07'],
    4: ['谷雨', '20', '07:24:40'],
    5: ['小满', '21', '05:56:45'],
    6: ['夏至', '21', '13:31:39'],
    7: ['大暑', '23', '00:23:24'],
    8: ['处暑', '23', '07:47:06'],
    9: ['秋分', '23', '05:59:56'],
    10: ['霜降', '23', '16:00:09'],
    11: ['小雪', '22', '14:08:41'],
    12: ['冬至', '22', '03:50:20'],
  },
}

export const TimeArr = [
  '23:00',
  '01:00',
  '03:00',
  '05:00',
  '07:00',
  '09:00',
  '11:00',
  '13:00',
  '15:00',
  '17:00',
  '19:00',
  '21:00',
]

export const wx_wangshuai = [
  ['金', '木', '水', '火', '土'],
  /*金*/
  ['旺', '死', '相', '囚', '休'],
  /*木*/
  ['囚', '旺', '休', '相', '死'],
  /*水*/
  ['休', '相', '旺', '死', '囚'],
  /*火*/
  ['死', '休', '囚', '旺', '相'],
  /*土*/
  ['相', '囚', '死', '休', '旺'],
]

export const ylcode = [
  '子',
  '午',
  '卯',
  '酉',
  '寅',
  '申',
  '巳',
  '亥',
  '辰',
  '戌',
  '丑',
  '未',
]

export const animals = [
  '鼠',
  '牛',
  '虎',
  '兔',
  '龙',
  '蛇',
  '马',
  '羊',
  '猴',
  '鸡',
  '狗',
  '猪',
]

export const selectsX = [
  {
    data: '',
    items: '身旺,偏旺,平和,偏弱,身弱,从强,从弱,未知',
    name: '旺弱',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items:
      '建禄格,劫财格,食神格,伤官格,正财格,偏财格,正印格,偏印格,正官格,七杀格',
    name: '格局',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items:
      '建禄格,劫财格,食神格,伤官格,正财格,偏财格,正印格,偏印格,正官格,七杀格',
    name: '格局',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items:
      '建禄格,劫财格,食神格,伤官格,正财格,偏财格,正印格,偏印格,正官格,七杀格',
    name: '格局',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '木,火,土,金,水',
    name: '喜',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '木,火,土,金,水',
    name: '喜',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '木,火,土,金,水',
    name: '喜',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '木,火,土,金,水',
    name: '忌',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '木,火,土,金,水',
    name: '忌',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '木,火,土,金,水',
    name: '忌',
    show: 1,
    type: 1,
  },
]

export const feedbackStruct = [
  {
    data: '',
    items: '经商,从政,教师,职工,农民',
    name: '职业',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '小学,初中,高中,专科,本科,研究生,博士',
    name: '学历',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '20万以下,20-100万,100-1000万,1000-5000万,5000-10000万,1亿以上',
    name: '财富',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '未婚,已婚,二婚,三婚,离异,丧偶',
    name: '婚姻',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '',
    name: '健康状态',
    show: 1,
    type: 0,
  },
  {
    data: '',
    items: '',
    name: '六亲状况',
    show: 1,
    type: 0,
  },
  //如果需要兼容新字段，xml的渲染个数限制去掉即可
  {
    data: '',
    items: '',
    name: '性情描述',
    show: 1,
    type: 0,
  },
  {
    data: '',
    items: '',
    name: '事件内容',
    show: 1,
    type: 3,
  },
]

export const bzStruct = [
  {
    data: '',
    items: '身旺,偏旺,平和,偏弱,身弱,从强,从弱,假从强,假从弱,未知',
    name: '旺衰',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items:
      '建禄格,劫财格,食神格,伤官格,正财格,偏财格,正印格,偏印格,正官格,七杀格,曲直格,炎上格,稼穑格,从革格,润下格,从儿格,从财格,从杀格,从强格,从弱格',
    name: '格局',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items:
      '建禄格,劫财格,食神格,伤官格,正财格,偏财格,正印格,偏印格,正官格,七杀格',
    name: '格局',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items:
      '建禄格,劫财格,食神格,伤官格,正财格,偏财格,正印格,偏印格,正官格,七杀格',
    name: '格局',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '木,火,土,金,水',
    name: '喜',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '木,火,土,金,水',
    name: '喜',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '木,火,土,金,水',
    name: '喜',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '木,火,土,金,水',
    name: '忌',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '木,火,土,金,水',
    name: '忌',
    show: 1,
    type: 1,
  },
  {
    data: '',
    items: '木,火,土,金,水',
    name: '忌',
    show: 1,
    type: 1,
  },
]

/**
 * 干支关系 - 天干关系
 */
export const gzRelation_tg = [
  {
    id: 1,
    name: '天干相冲',
    lists: [
      {
        title: '条件',
        list: [
          {
            id: 1,
            name: '甲_庚相冲',
          },
          {
            id: 2,
            name: '乙_辛相冲',
          },
          {
            id: 3,
            name: '丙_壬相冲',
          },
          {
            id: 4,
            name: '丁_癸相冲',
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: '天干相克',
    lists: [
      {
        title: '条件',
        list: [
          {
            id: 5,
            name: '甲_戊相克',
          },
          {
            id: 6,
            name: '乙_己相克',
          },
          {
            id: 7,
            name: '丙_庚相克',
          },
          {
            id: 8,
            name: '丁_辛相克',
          },
          {
            id: 9,
            name: '戊_壬相克',
          },
          {
            id: 10,
            name: '己_癸相克',
          },
          {
            id: 11,
            name: '庚_甲相克',
          },
          {
            id: 12,
            name: '辛_乙相克',
          },
          {
            id: 13,
            name: '壬_丙相克',
          },
          {
            id: 14,
            name: '癸_丁相克',
          },
        ],
      },
    ],
  },
  {
    id: 3,
    name: '天干五合',
    lists: [
      {
        title: '条件',
        list: [
          {
            id: 15,
            name: '甲_己合化土',
          },
          {
            id: 16,
            name: '乙_庚合化金',
          },
          {
            id: 17,
            name: '丙_辛合化水',
          },
          {
            id: 18,
            name: '丁_壬合化木',
          },
          {
            id: 19,
            name: '戊_癸合化火',
          },
        ],
      },
    ],
  },
]

/**
 * 干支关系 - 地支关系
 */
export const gzRelation_dz = [
  {
    id: 4,
    name: '地支六合',
    lists: [
      {
        title: '条件',
        list: [
          {
            id: 20,
            name: '子_丑合化土',
          },
          {
            id: 21,
            name: '寅_亥合化木',
          },
          {
            id: 22,
            name: '卯_戌合化火',
          },
          {
            id: 23,
            name: '辰_酉合化金',
          },
          {
            id: 24,
            name: '巳_申合化水',
          },
          {
            id: 25,
            name: '午_未合化火',
          },
        ],
      },
    ],
  },
  {
    id: 5,
    name: '地支三合',
    lists: [
      {
        title: '条件：地支会三合局',
        list: [
          {
            id: 26,
            name: '申_子_辰三合水局',
          },
          {
            id: 27,
            name: '寅_午_戌三合火局',
          },
          {
            id: 28,
            name: '巳_酉_丑三合金局',
          },
          {
            id: 29,
            name: '亥_卯_未三合木局',
          },
        ],
      },
      {
        title: '条件：地支半合局',
        list: [
          {
            id: 30,
            name: '申_子半合水局',
          },
          {
            id: 31,
            name: '子_辰半合水局',
          },
          {
            id: 98,
            name: '寅_午半合火局',
          },
          {
            id: 32,
            name: '午_戌半合火局',
          },
          {
            id: 33,
            name: '巳_酉半合金局',
          },
          {
            id: 34,
            name: '酉_丑半合金局',
          },
          {
            id: 35,
            name: '亥_卯半合木局',
          },
          {
            id: 36,
            name: '卯_未半合木局',
          },
        ],
      },
      {
        title: '条件：地支暗合局',
        list: [
          {
            id: 37,
            name: '地支见申_辰，天干见癸',
          },
          {
            id: 38,
            name: '地支见亥_未，天干见乙',
          },
          {
            id: 39,
            name: '地支见寅_戌，天干见丁',
          },
          {
            id: 40,
            name: '地支见巳_丑，天干见辛',
          },
        ],
      },
      {
        title: '条件：地支拱合局',
        list: [
          {
            id: 41,
            name: '申_辰拱合子',
          },
          {
            id: 42,
            name: '亥_未拱合卯',
          },
          {
            id: 43,
            name: '寅_戌拱合午',
          },
          {
            id: 44,
            name: '巳_丑拱合酉',
          },
        ],
      },
    ],
  },
  {
    id: 6,
    name: '地支三会',
    lists: [
      {
        title: '条件：地支三会局',
        list: [
          {
            id: 45,
            name: '寅_卯_辰三会木局',
          },
          {
            id: 46,
            name: '巳_午_未三会火局',
          },
          {
            id: 47,
            name: '申_酉_戌三会金局',
          },
          {
            id: 48,
            name: '亥_子_丑三会水局',
          },
          {
            id: 49,
            name: '丑_辰_未_戌合土局',
          },
        ],
      },
      {
        title: '条件：地支暗三会局',
        list: [
          {
            id: 50,
            name: '地支见寅_辰，天干见乙',
          },
          {
            id: 51,
            name: '地支见巳_未，天干见丁',
          },
          {
            id: 52,
            name: '地支见申_戌，天干见辛',
          },
          {
            id: 53,
            name: '地支见亥_丑，天干见癸',
          },
        ],
      },
      {
        title: '条件：地支拱三会局',
        list: [
          {
            id: 54,
            name: '寅_辰拱会卯',
          },
          {
            id: 55,
            name: '巳_未拱会午',
          },
          {
            id: 56,
            name: '申_戌拱会酉',
          },
          {
            id: 57,
            name: '亥_丑拱会子',
          },
        ],
      },
    ],
  },
  {
    id: 7,
    name: '地支暗合',
    lists: [
      {
        title: '条件：地支暗合局',
        list: [
          {
            id: 58,
            name: '卯_申暗合',
          },
          {
            id: 59,
            name: '午_亥暗合',
          },
          {
            id: 60,
            name: '丑_寅暗合',
          },
          {
            id: 61,
            name: '寅_未暗合',
          },
          {
            id: 62,
            name: '子_戌暗合',
          },
          {
            id: 63,
            name: '子_辰暗合',
          },
          {
            id: 64,
            name: '巳_酉暗合',
          },
          {
            id: 65,
            name: '寅_午暗合',
          },
          {
            id: 66,
            name: '子_巳暗合',
          },
        ],
      },
    ],
  },
  {
    id: 8,
    name: '地支相刑',
    lists: [
      {
        title: '条件：地支三刑',
        list: [
          {
            id: 67,
            name: '寅_巳_申三刑',
          },
          {
            id: 68,
            name: '丑_戌_未三刑',
          },
        ],
      },
      {
        title: '条件：地支相刑',
        list: [
          {
            id: 69,
            name: '寅_巳相刑',
          },
          {
            id: 70,
            name: '巳_申相刑',
          },
          {
            id: 71,
            name: '申_寅相刑',
          },
          {
            id: 72,
            name: '丑_戌相刑',
          },
          {
            id: 73,
            name: '戌_未相刑',
          },
          {
            id: 74,
            name: '未_丑相刑',
          },
          {
            id: 75,
            name: '子_卯相刑',
          },
          {
            id: 76,
            name: '酉_酉相刑',
          },
          {
            id: 77,
            name: '亥_亥相刑',
          },
          {
            id: 78,
            name: '午_午相刑',
          },
          {
            id: 79,
            name: '辰_辰相刑',
          },
        ],
      },
    ],
  },
  {
    id: 9,
    name: '地支相冲',
    lists: [
      {
        title: '条件',
        list: [
          {
            id: 80,
            name: '子_午相冲',
          },
          {
            id: 81,
            name: '丑_未相冲',
          },
          {
            id: 82,
            name: '寅_申相冲',
          },
          {
            id: 83,
            name: '卯_酉相冲',
          },
          {
            id: 84,
            name: '辰_戌相冲',
          },
          {
            id: 85,
            name: '巳_亥相冲',
          },
        ],
      },
    ],
  },
  {
    id: 10,
    name: '地支相破',
    lists: [
      {
        title: '条件',
        list: [
          {
            id: 86,
            name: '子_酉相破',
          },
          {
            id: 87,
            name: '午_卯相破',
          },
          {
            id: 88,
            name: '巳_申相破',
          },
          {
            id: 89,
            name: '辰_丑相破',
          },
          {
            id: 90,
            name: '寅_亥相破',
          },
          {
            id: 91,
            name: '戌_未相破',
          },
        ],
      },
    ],
  },
  {
    id: 11,
    name: '地支相害',
    lists: [
      {
        title: '条件',
        list: [
          {
            id: 92,
            name: '子_未相害',
          },
          {
            id: 93,
            name: '丑_午相害',
          },
          {
            id: 94,
            name: '寅_巳相害',
          },
          {
            id: 95,
            name: '卯_辰相害',
          },
          {
            id: 96,
            name: '申_亥相害',
          },
          {
            id: 97,
            name: '酉_戌相害',
          },
        ],
      },
    ],
  },
]

/**
 * 干支关系默认值
 * @key tg: 天干关系
 * @key dz: 地支关系
 * @key switch: 开关
 * @key selected: 位置索引
 * @key datas: 条件数据
 */
export const setting_gzrelation_default = {
  tg: [
    {
      id: 1,
      switch: false,
      selected: 1,
      datas: ['1111'],
    },
    {
      id: 2,
      switch: true,
      selected: 1,
      datas: ['1111111111'],
    },
    {
      id: 3,
      switch: true,
      selected: 1,
      datas: ['11111'],
    },
  ],
  dz: [
    {
      id: 4,
      switch: true,
      selected: 1,
      datas: ['111111'],
    },
    {
      id: 5,
      switch: true,
      selected: 1,
      datas: ['1111', '11111111', '1111', '1111'],
    },
    {
      id: 6,
      switch: true,
      selected: 1,
      datas: ['11111', '1111', '1111'],
    },
    {
      id: 7,
      switch: true,
      selected: 1,
      datas: ['111111111'],
    },
    {
      id: 8,
      switch: true,
      selected: 1,
      datas: ['11', '11111111111'],
    },
    {
      id: 9,
      switch: true,
      selected: 1,
      datas: ['111111'],
    },
    {
      id: 10,
      switch: true,
      selected: 1,
      datas: ['111111'],
    },
    {
      id: 11,
      switch: true,
      selected: 1,
      datas: ['111111'],
    },
  ],
}

/**
 * 地支藏干默认值
 */
export const setting_dizhizg_default = [
  { id: 'CG_zi', value: '癸' },
  { id: 'CG_chou', value: '己 癸 辛' },
  { id: 'CG_yin', value: '甲 丙 戊' },
  { id: 'CG_mao', value: '乙' },
  { id: 'CG_chen', value: '戊 乙 癸' },
  { id: 'CG_si', value: '丙 庚 戊' },
  { id: 'CG_wu', value: '丁 己' },
  { id: 'CG_wei', value: '己 丁 乙' },
  { id: 'CG_shen', value: '庚 壬 戊' },
  { id: 'CG_you', value: '辛' },
  { id: 'CG_xu', value: '戊 辛 丁' },
  { id: 'CG_hai', value: '壬 甲' },
]

/**
 * 人员司令分野
 */
export const ryslList = [
  {
    id: 1,
    title: '《子平真诠》分日诀：',
    content:
      '寅：戊七日，丙七日，甲十六日。\n卯：甲十日，乙二十日。\n辰：乙九日，癸三日，戊十八日。\n巳：戊五日，庚九日，丙十六日。\n午：丙十日，己九日，丁十一日。\n未：丁九日，乙三日，己十八日。\n申：戊己十日，壬三日，庚十七日。\n酉：庚十日，辛二十日。\n戌：辛九日，丁三日，戊十八日。\n亥：戊七日，甲五日，壬十八日。\n子：壬十日，癸二十日。\n丑：癸九日，辛三日，己十八日。',
  },
  {
    id: 2,
    title: '《三命通会》分日诀：',
    content:
      '寅：己七日，丙五日，甲十八日。\n卯：甲九日，癸三日，乙十八日。\n辰：乙九日，癸三日，戊十八日。\n巳：戊七日，庚五日，丙十八日。\n午：丙九日，己三日，丁十八日。\n未：丁七日，乙五日，己十八日。\n申：己七日，戊三日，壬三日，庚十七日。\n酉：庚七日，丁三日，辛二十日。\n戌：辛七日，丁五日，戊十八日。\n亥：戊七日，甲五日，壬十八日。\n子：壬九日，辛三日，癸十八日。\n丑：癸七日，辛五日，己十八日。',
  },
  {
    id: 3,
    title: '《渊海子平》分日诀：',
    content:
      '寅：戊七日，丙七日，甲十六日。\n卯：甲十日，乙二十日。\n辰：乙九日，癸三日，戊十八日。\n巳：戊五日，庚九日，丙十六日。\n午：丙十日，己十日，丁十日。\n未：丁九日，乙三日，己十八日。\n申：己七日，戊三日，壬三日，庚十七日。\n酉：庚十日，辛二十日。\n戌：辛九日，丁三日，戊十八日。\n亥：戊七日，甲五日，壬十八日。\n子：壬十日，癸二十日。\n丑：癸九日，辛三日，己十八日。',
  },
  {
    id: 4,
    title: '《神峰通考》分日诀：',
    content:
      '寅：戊七日，丙七日，甲十六日。\n卯：甲十日，乙二十日。\n辰：乙九日，癸三日，戊十八日。\n巳：戊七日，庚七日，丙十六日。\n午：丙十日，己七日，丁十三日。\n未：丁九日，乙三日，己十八日。\n申：戊七日，壬七日，庚十六日。\n酉：庚十日，辛二十日。\n戌：辛九日，丁三日，戊十八日。\n亥：戊七日，甲七日，壬十六日。\n子：壬十日，癸二十日。\n丑：癸九日，辛三日，己十八日。',
  },
  {
    id: 5,
    title: '《星平会海》分日诀：',
    content:
      '寅：戊七日，丙七日，甲十六日。\n卯：甲十日，乙二十日。\n辰：乙九日，癸三日，戊十八日。\n巳：戊五日，庚九日，丙十六日。\n午：丙十日，己九日，丁十一日。\n未：丁九日，乙二日，己十八日。\n申：己七日，戊三日，壬三日，庚十七日。\n酉：庚十日，辛二十日。\n戌：辛九日，丁三日，戊十八日。\n亥：戊七日，甲五日，壬十八日。\n子：壬十日，癸二十日。\n丑：癸九日，辛三日，己十八日。',
  },
  {
    id: 6,
    title: '万育吾之法诀：',
    content:
      '寅：己五日，丙五日，甲二十日。\n卯：甲七日，乙二十三日。\n辰：乙七日，壬五日，戊十八日。\n巳：戊七日，庚五日，丙十八日。\n午：丙七日，丁二十三日。\n未：丁七日，甲五日，己十八日。\n申：己五日，壬五日，庚二十日。\n酉：庚七日，辛二十三日。\n戌：辛七日，丙五日，戊十八日。\n亥：戊五日，甲五日，壬二十日。\n子：壬七日，癸二十三日。\n丑：癸七日，庚五日，己十八日。',
  },
]

/**
 * 种类Type：(从0开始)
 */
export const sysSSTypes = [
  '干对干',
  '干对支',
  '干对干支',
  '支对干',
  '支对支',
  '支对干支',
  '干支对干',
  '干支对支',
  '干支对干支',
  '纳音对干',
  '纳音对支',
  '纳音对干支',
  '干支一柱',
]

/**
 * 纳音五行
 */
export const nayinWXArr = ['纳音金', '纳音木', '纳音火', '纳音水', '纳音土']

/**
 * 位置-坐对ID
 */
export const ssMainTags = {
  1: '年干',
  2: '月干',
  3: '日干',
  4: '时干',
  5: '大运干',
  6: '流年干',
  7: '年支',
  8: '月支',
  9: '日支',
  10: '时支',
  11: '大运支',
  12: '流年支',
  13: '年柱',
  14: '月柱',
  15: '日柱',
  16: '时柱',
  17: '年纳音',
  18: '天干',
  19: '大运柱',
  20: '月纳音',
  21: '日纳音',
  22: '时纳音',
  23: '年干支一柱',
  24: '月干支一柱',
  25: '日干支一柱',
  26: '时干支一柱',
}
export const ssMainTags2 = {
  年干: 1,
  月干: 2,
  日干: 3,
  时干: 4,
  大运干: 5,
  流年干: 6,
  年支: 7,
  月支: 8,
  日支: 9,
  时支: 10,
  大运支: 11,
  流年支: 12,
  年柱: 13,
  月柱: 14,
  日柱: 15,
  时柱: 16,
  年纳音: 17,
  天干: 18,
  大运柱: 19,
  月纳音: 20,
  日纳音: 21,
  时纳音: 22,
  年干支一柱: 23,
  月干支一柱: 24,
  日干支一柱: 25,
  时干支一柱: 26,
}

// 神煞顺序表
export const ssSequenceList = [
  '天乙贵人',
  '太极贵人',
  '文昌贵人',
  '天德贵人',
  '月德贵人',
  '三奇贵人',
  '福星贵人',
  '德秀贵人',
  '天厨贵人',
  '国印贵人',
  '天德合',
  '月德合',
  '天罗地网',
  '天罗',
  '地网',
  '十恶大败',
  '阴差阳错',
  '天赦日',
  '十灵日',
  '六秀日',
  '四废日',
  '孤鸾煞',
  '勾绞煞',
  '红艳煞',
  '童子煞',
  '华盖',
  '驿马',
  '禄神',
  '将星',
  '学堂',
  '正学堂',
  '词馆',
  '正词馆',
  '天医',
  '金舆',
  '桃花',
  '红鸾',
  '天喜',
  '金神',
  '拱禄',
  '天转日',
  '地转日',
  '丧门',
  '吊客',
  '披麻',
  '八专日',
  '九丑日',
  '元辰',
  '魁罡日',
  '孤辰',
  '寡宿',
  '流霞',
  '亡神',
  '劫煞',
  '灾煞',
  '血刃',
  '飞刃',
  '羊刃',
  '空亡',
]
export const sysSSList = [
  {
    id: 1,
    name: '天乙贵人',
    main: '1,3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '丑',
      乙: '子',
      丙: '亥',
      丁: '亥',
      戊: '丑',
      己: '子',
      庚: '丑',
      辛: '午',
      壬: '巳',
      癸: '巳',
    },
  },
  {
    id: 2,
    name: '天乙贵人',
    main: '1,3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '未',
      乙: '申',
      丙: '酉',
      丁: '酉',
      戊: '未',
      己: '申',
      庚: '未',
      辛: '寅',
      壬: '卯',
      癸: '卯',
    },
  },
  {
    id: 3,
    name: '太极贵人',
    main: '1,3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '子',
      乙: '子',
      丙: '卯',
      丁: '卯',
      戊: '辰',
      己: '辰',
      庚: '寅',
      辛: '寅',
      壬: '巳',
      癸: '巳',
    },
  },
  {
    id: 4,
    name: '太极贵人',
    main: '1,3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '午',
      乙: '午',
      丙: '酉',
      丁: '酉',
      戊: '丑',
      己: '丑',
      庚: '亥',
      辛: '亥',
      壬: '申',
      癸: '申',
    },
  },
  {
    id: 5,
    name: '太极贵人',
    main: '1,3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: { 戊: '戌', 己: '戌' },
  },
  {
    id: 6,
    name: '太极贵人',
    main: '1,3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: { 戊: '未', 己: '未' },
  },
  {
    id: 7,
    name: '文昌贵人',
    main: '1,3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '巳',
      乙: '午',
      丙: '申',
      丁: '酉',
      戊: '申',
      己: '酉',
      庚: '亥',
      辛: '子',
      壬: '寅',
      癸: '卯',
    },
  },
  {
    id: 8,
    name: '国印贵人',
    main: '1,3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '戌',
      乙: '亥',
      丙: '丑',
      丁: '寅',
      戊: '丑',
      己: '寅',
      庚: '辰',
      辛: '巳',
      壬: '未',
      癸: '申',
    },
  },
  {
    id: 9,
    name: '金舆',
    main: '1,3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '辰',
      乙: '巳',
      丙: '未',
      丁: '申',
      戊: '未',
      己: '申',
      庚: '戌',
      辛: '亥',
      壬: '丑',
      癸: '寅',
    },
  },
  {
    id: 12,
    name: '禄神',
    main: '3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '寅',
      乙: '卯',
      丙: '巳',
      丁: '午',
      戊: '巳',
      己: '午',
      庚: '申',
      辛: '酉',
      壬: '亥',
      癸: '子',
    },
  },
  {
    id: 13,
    name: '羊刃',
    main: '3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '卯',
      乙: '寅',
      丙: '午',
      丁: '巳',
      戊: '午',
      己: '巳',
      庚: '酉',
      辛: '申',
      壬: '子',
      癸: '亥',
    },
  },
  {
    id: 14,
    name: '飞刃',
    main: '3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '酉',
      乙: '申',
      丙: '子',
      丁: '亥',
      戊: '子',
      己: '亥',
      庚: '卯',
      辛: '寅',
      壬: '午',
      癸: '巳',
    },
  },
  {
    id: 15,
    name: '流霞',
    main: '3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '酉',
      乙: '戌',
      丙: '未',
      丁: '申',
      戊: '巳',
      己: '午',
      庚: '辰',
      辛: '卯',
      壬: '亥',
      癸: '寅',
    },
  },
  {
    id: 16,
    name: '红艳煞',
    main: '3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '午',
      乙: '午',
      丙: '寅',
      丁: '未',
      戊: '辰',
      己: '辰',
      庚: '戌',
      辛: '酉',
      壬: '子',
      癸: '申',
    },
  },
  {
    id: 17,
    name: '驿马',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '寅',
      丑: '亥',
      寅: '申',
      卯: '巳',
      辰: '寅',
      巳: '亥',
      午: '申',
      未: '巳',
      申: '寅',
      酉: '亥',
      戌: '申',
      亥: '巳',
    },
  },
  {
    id: 18,
    name: '驿马',
    main: '9',
    tags: '7,8,10,11,12',
    sex: '0',
    data: {
      子: '寅',
      丑: '亥',
      寅: '申',
      卯: '巳',
      辰: '寅',
      巳: '亥',
      午: '申',
      未: '巳',
      申: '寅',
      酉: '亥',
      戌: '申',
      亥: '巳',
    },
  },
  {
    id: 19,
    name: '将星',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '子',
      丑: '酉',
      寅: '午',
      卯: '卯',
      辰: '子',
      巳: '酉',
      午: '午',
      未: '卯',
      申: '子',
      酉: '酉',
      戌: '午',
      亥: '卯',
    },
  },
  {
    id: 20,
    name: '将星',
    main: '9',
    tags: '7,8,10,11,12',
    sex: '0',
    data: {
      子: '子',
      丑: '酉',
      寅: '午',
      卯: '卯',
      辰: '子',
      巳: '酉',
      午: '午',
      未: '卯',
      申: '子',
      酉: '酉',
      戌: '午',
      亥: '卯',
    },
  },
  {
    id: 21,
    name: '华盖',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '辰',
      丑: '丑',
      寅: '戌',
      卯: '未',
      辰: '辰',
      巳: '丑',
      午: '戌',
      未: '未',
      申: '辰',
      酉: '丑',
      戌: '戌',
      亥: '未',
    },
  },
  {
    id: 22,
    name: '华盖',
    main: '9',
    tags: '7,8,10,11,12',
    sex: '0',
    data: {
      子: '辰',
      丑: '丑',
      寅: '戌',
      卯: '未',
      辰: '辰',
      巳: '丑',
      午: '戌',
      未: '未',
      申: '辰',
      酉: '丑',
      戌: '戌',
      亥: '未',
    },
  },
  {
    id: 23,
    name: '劫煞',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '巳',
      丑: '寅',
      寅: '亥',
      卯: '申',
      辰: '巳',
      巳: '寅',
      午: '亥',
      未: '申',
      申: '巳',
      酉: '寅',
      戌: '亥',
      亥: '申',
    },
  },
  {
    id: 24,
    name: '劫煞',
    main: '9',
    tags: '7,8,10,11,12',
    sex: '0',
    data: {
      子: '巳',
      丑: '寅',
      寅: '亥',
      卯: '申',
      辰: '巳',
      巳: '寅',
      午: '亥',
      未: '申',
      申: '巳',
      酉: '寅',
      戌: '亥',
      亥: '申',
    },
  },
  {
    id: 25,
    name: '亡神',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '亥',
      丑: '申',
      寅: '巳',
      卯: '寅',
      辰: '亥',
      巳: '申',
      午: '巳',
      未: '寅',
      申: '亥',
      酉: '申',
      戌: '巳',
      亥: '寅',
    },
  },
  {
    id: 26,
    name: '亡神',
    main: '9',
    tags: '7,8,10,11,12',
    sex: '0',
    data: {
      子: '亥',
      丑: '申',
      寅: '巳',
      卯: '寅',
      辰: '亥',
      巳: '申',
      午: '巳',
      未: '寅',
      申: '亥',
      酉: '申',
      戌: '巳',
      亥: '寅',
    },
  },
  {
    id: 27,
    name: '天罗地网',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: { 辰: '巳', 巳: '辰', 戌: '亥', 亥: '戌' },
  },
  {
    id: 28,
    name: '天罗地网',
    main: '9',
    tags: '7,8,10,11,12',
    sex: '0',
    data: { 辰: '巳', 巳: '辰', 戌: '亥', 亥: '戌' },
  },
  {
    id: 29,
    name: '桃花',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '酉',
      丑: '午',
      寅: '卯',
      卯: '子',
      辰: '酉',
      巳: '午',
      午: '卯',
      未: '子',
      申: '酉',
      酉: '午',
      戌: '卯',
      亥: '子',
    },
  },
  {
    id: 30,
    name: '桃花',
    main: '9',
    tags: '7,8,10,11,12',
    sex: '0',
    data: {
      子: '酉',
      丑: '午',
      寅: '卯',
      卯: '子',
      辰: '酉',
      巳: '午',
      午: '卯',
      未: '子',
      申: '酉',
      酉: '午',
      戌: '卯',
      亥: '子',
    },
  },
  {
    id: 31,
    name: '灾煞',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '午',
      丑: '卯',
      寅: '子',
      卯: '酉',
      辰: '午',
      巳: '卯',
      午: '子',
      未: '酉',
      申: '午',
      酉: '卯',
      戌: '子',
      亥: '酉',
    },
  },
  {
    id: 32,
    name: '孤辰',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '寅',
      丑: '寅',
      寅: '巳',
      卯: '巳',
      辰: '巳',
      巳: '申',
      午: '申',
      未: '申',
      申: '亥',
      酉: '亥',
      戌: '亥',
      亥: '寅',
    },
  },
  {
    id: 33,
    name: '寡宿',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '戌',
      丑: '戌',
      寅: '丑',
      卯: '丑',
      辰: '丑',
      巳: '辰',
      午: '辰',
      未: '辰',
      申: '未',
      酉: '未',
      戌: '未',
      亥: '戌',
    },
  },
  {
    id: 34,
    name: '勾绞煞',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '卯',
      丑: '辰',
      寅: '巳',
      卯: '午',
      辰: '未',
      巳: '申',
      午: '酉',
      未: '戌',
      申: '亥',
      酉: '子',
      戌: '丑',
      亥: '寅',
    },
  },
  {
    id: 35,
    name: '天喜',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '酉',
      丑: '申',
      寅: '未',
      卯: '午',
      辰: '巳',
      巳: '辰',
      午: '卯',
      未: '寅',
      申: '丑',
      酉: '子',
      戌: '亥',
      亥: '戌',
    },
  },
  {
    id: 36,
    name: '红鸾',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '卯',
      丑: '寅',
      寅: '丑',
      卯: '子',
      辰: '亥',
      巳: '戌',
      午: '酉',
      未: '申',
      申: '未',
      酉: '午',
      戌: '巳',
      亥: '辰',
    },
  },
  {
    id: 37,
    name: '元辰',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '1',
    data: {
      子: '未',
      丑: '申',
      寅: '酉',
      卯: '戌',
      辰: '亥',
      巳: '子',
      午: '丑',
      未: '寅',
      申: '卯',
      酉: '辰',
      戌: '巳',
      亥: '午',
    },
  },
  {
    id: 38,
    name: '元辰',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '2',
    data: {
      子: '巳',
      丑: '午',
      寅: '未',
      卯: '申',
      辰: '酉',
      巳: '戌',
      午: '亥',
      未: '子',
      申: '丑',
      酉: '寅',
      戌: '卯',
      亥: '辰',
    },
  },
  {
    id: 39,
    name: '披麻',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '酉',
      丑: '戌',
      寅: '亥',
      卯: '子',
      辰: '丑',
      巳: '寅',
      午: '卯',
      未: '辰',
      申: '巳',
      酉: '午',
      戌: '未',
      亥: '申',
    },
  },
  {
    id: 40,
    name: '吊客',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '戌',
      丑: '亥',
      寅: '子',
      卯: '丑',
      辰: '寅',
      巳: '卯',
      午: '辰',
      未: '巳',
      申: '午',
      酉: '未',
      戌: '申',
      亥: '酉',
    },
  },
  {
    id: 41,
    name: '丧门',
    main: '7',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      子: '寅',
      丑: '卯',
      寅: '辰',
      卯: '巳',
      辰: '午',
      巳: '未',
      午: '申',
      未: '酉',
      申: '戌',
      酉: '亥',
      戌: '子',
      亥: '丑',
    },
  },
  {
    id: 42,
    name: '天德贵人',
    main: '8',
    tags: '1,2,3,4,5',
    sex: '0',
    data: {
      丑: '庚',
      寅: '丁',
      辰: '壬',
      巳: '辛',
      未: '甲',
      申: '癸',
      戌: '丙',
      亥: '乙',
    },
  },
  {
    id: 43,
    name: '月德贵人',
    main: '8',
    tags: '1,2,3,4,5,6,7,8,9,10,11,12',
    sex: '0',
    data: {
      子: '壬',
      丑: '庚',
      寅: '丙',
      卯: '甲',
      辰: '壬',
      巳: '庚',
      午: '丙',
      未: '甲',
      申: '壬',
      酉: '庚',
      戌: '丙',
      亥: '甲',
    },
  },
  {
    id: 44,
    name: '天德合',
    main: '8',
    tags: '1,2,3,4,5',
    sex: '0',
    data: {
      丑: '乙',
      寅: '壬',
      辰: '丁',
      巳: '丙',
      未: '己',
      申: '戊',
      戌: '辛',
      亥: '庚',
    },
  },
  {
    id: 45,
    name: '月德合',
    main: '8',
    tags: '1,2,3,4,5',
    sex: '0',
    data: {
      子: '丁',
      丑: '乙',
      寅: '辛',
      卯: '己',
      辰: '丁',
      巳: '乙',
      午: '辛',
      未: '己',
      申: '丁',
      酉: '乙',
      戌: '辛',
      亥: '己',
    },
  },
  {
    id: 46,
    name: '天医',
    main: '8',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      子: '亥',
      丑: '子',
      寅: '丑',
      卯: '寅',
      辰: '卯',
      巳: '辰',
      午: '巳',
      未: '午',
      申: '未',
      酉: '申',
      戌: '酉',
      亥: '戌',
    },
  },
  {
    id: 47,
    name: '血刃',
    main: '8',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      子: '午',
      丑: '子',
      寅: '丑',
      卯: '未',
      辰: '寅',
      巳: '申',
      午: '卯',
      未: '酉',
      申: '辰',
      酉: '戌',
      戌: '巳',
      亥: '亥',
    },
  },
  {
    id: 49,
    name: '金神',
    main: '25,26',
    tags: '0',
    sex: '0',
    data: { 乙丑: '', 癸酉: '', 己巳: '' },
  },
  {
    id: 50,
    name: '十恶大败',
    main: '25',
    tags: '0',
    sex: '0',
    data: {
      壬申: '',
      庚辰: '',
      辛巳: '',
      丁亥: '',
      己丑: '',
      丙申: '',
      戊戌: '',
      甲辰: '',
      乙巳: '',
      癸亥: '',
    },
  },
  {
    id: 52,
    name: '十灵日',
    main: '25',
    tags: '0',
    sex: '0',
    data: {
      乙亥: '',
      癸未: '',
      庚寅: '',
      丁酉: '',
      壬寅: '',
      甲辰: '',
      庚戌: '',
      辛亥: '',
      丙辰: '',
      戊午: '',
    },
  },
  {
    id: 53,
    name: '阴差阳错',
    main: '25',
    tags: '0',
    sex: '0',
    data: {
      丙子: '',
      丁丑: '',
      戊寅: '',
      辛卯: '',
      壬辰: '',
      丙午: '',
      丁未: '',
      戊申: '',
      辛酉: '',
      壬戌: '',
      癸亥: '',
      癸巳: '',
    },
  },
  {
    id: 57,
    name: '九丑日',
    main: '25',
    tags: '0',
    sex: '0',
    data: {
      己卯: '',
      壬午: '',
      戊子: '',
      辛卯: '',
      丁酉: '',
      己酉: '',
      壬子: '',
      戊午: '',
      辛酉: '',
    },
  },
  {
    id: 58,
    name: '魁罡日',
    main: '25',
    tags: '0',
    sex: '0',
    data: { 庚辰: '', 壬辰: '', 戊戌: '', 庚戌: '' },
  },
  {
    id: 65,
    name: '六秀日',
    main: '25',
    tags: '0',
    sex: '0',
    data: { 戊子: '', 己丑: '', 丙午: '', 丁未: '', 戊午: '', 己未: '' },
  },
  {
    id: 80,
    name: '八专日',
    main: '25',
    tags: '0',
    sex: '0',
    data: {
      戊戌: '',
      丁未: '',
      癸丑: '',
      甲寅: '',
      乙卯: '',
      己未: '',
      庚申: '',
      辛酉: '',
    },
  },
  {
    id: 81,
    name: '孤鸾煞',
    main: '25',
    tags: '0',
    sex: '0',
    data: {
      丁巳: '',
      乙巳: '',
      丙午: '',
      戊申: '',
      辛亥: '',
      壬子: '',
      甲寅: '',
      戊午: '',
    },
  },
  {
    id: 129,
    name: '学堂',
    main: '17',
    tags: '8,9,10,11,12',
    sex: '0',
    data: { 金: '巳', 木: '亥', 水: '申', 土: '申', 火: '寅' },
  },
  {
    id: 130,
    name: '三奇贵人',
    main: '18',
    tags: '0',
    sex: '0',
    data: { 甲戊庚: '', 乙丙丁: '', 壬癸辛: '' },
  },
  {
    id: 131,
    name: '空亡',
    main: '13',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      甲子: '戌',
      乙丑: '戌',
      丙寅: '戌',
      丁卯: '戌',
      戊辰: '戌',
      己巳: '戌',
      庚午: '戌',
      辛未: '戌',
      壬申: '戌',
      癸酉: '戌',
      甲戌: '申',
      乙亥: '申',
      丙子: '申',
      丁丑: '申',
      戊寅: '申',
      己卯: '申',
      庚辰: '申',
      辛巳: '申',
      壬午: '申',
      癸未: '申',
      甲申: '午',
      乙酉: '午',
      丙戌: '午',
      丁亥: '午',
      戊子: '午',
      己丑: '午',
      庚寅: '午',
      辛卯: '午',
      壬辰: '午',
      癸巳: '午',
      甲午: '辰',
      乙未: '辰',
      丙申: '辰',
      丁酉: '辰',
      戊戌: '辰',
      己亥: '辰',
      庚子: '辰',
      辛丑: '辰',
      壬寅: '辰',
      癸卯: '辰',
      甲辰: '寅',
      乙巳: '寅',
      丙午: '寅',
      丁未: '寅',
      戊申: '寅',
      己酉: '寅',
      庚戌: '寅',
      辛亥: '寅',
      壬子: '寅',
      癸丑: '寅',
      甲寅: '子',
      乙卯: '子',
      丙辰: '子',
      丁巳: '子',
      戊午: '子',
      己未: '子',
      庚申: '子',
      辛酉: '子',
      壬戌: '子',
      癸亥: '子',
    },
  },
  {
    id: 132,
    name: '空亡',
    main: '15',
    tags: '7,8,10,11,12',
    sex: '0',
    data: {
      甲子: '戌',
      乙丑: '戌',
      丙寅: '戌',
      丁卯: '戌',
      戊辰: '戌',
      己巳: '戌',
      庚午: '戌',
      辛未: '戌',
      壬申: '戌',
      癸酉: '戌',
      甲戌: '申',
      乙亥: '申',
      丙子: '申',
      丁丑: '申',
      戊寅: '申',
      己卯: '申',
      庚辰: '申',
      辛巳: '申',
      壬午: '申',
      癸未: '申',
      甲申: '午',
      乙酉: '午',
      丙戌: '午',
      丁亥: '午',
      戊子: '午',
      己丑: '午',
      庚寅: '午',
      辛卯: '午',
      壬辰: '午',
      癸巳: '午',
      甲午: '辰',
      乙未: '辰',
      丙申: '辰',
      丁酉: '辰',
      戊戌: '辰',
      己亥: '辰',
      庚子: '辰',
      辛丑: '辰',
      壬寅: '辰',
      癸卯: '辰',
      甲辰: '寅',
      乙巳: '寅',
      丙午: '寅',
      丁未: '寅',
      戊申: '寅',
      己酉: '寅',
      庚戌: '寅',
      辛亥: '寅',
      壬子: '寅',
      癸丑: '寅',
      甲寅: '子',
      乙卯: '子',
      丙辰: '子',
      丁巳: '子',
      戊午: '子',
      己未: '子',
      庚申: '子',
      辛酉: '子',
      壬戌: '子',
      癸亥: '子',
    },
  },
  {
    id: 133,
    name: '空亡',
    main: '13',
    tags: '8,9,10,11,12',
    sex: '0',
    data: {
      甲子: '亥',
      乙丑: '亥',
      丙寅: '亥',
      丁卯: '亥',
      戊辰: '亥',
      己巳: '亥',
      庚午: '亥',
      辛未: '亥',
      壬申: '亥',
      癸酉: '亥',
      甲戌: '酉',
      乙亥: '酉',
      丙子: '酉',
      丁丑: '酉',
      戊寅: '酉',
      己卯: '酉',
      庚辰: '酉',
      辛巳: '酉',
      壬午: '酉',
      癸未: '酉',
      甲申: '未',
      乙酉: '未',
      丙戌: '未',
      丁亥: '未',
      戊子: '未',
      己丑: '未',
      庚寅: '未',
      辛卯: '未',
      壬辰: '未',
      癸巳: '未',
      甲午: '巳',
      乙未: '巳',
      丙申: '巳',
      丁酉: '巳',
      戊戌: '巳',
      己亥: '巳',
      庚子: '巳',
      辛丑: '巳',
      壬寅: '巳',
      癸卯: '巳',
      甲辰: '卯',
      乙巳: '卯',
      丙午: '卯',
      丁未: '卯',
      戊申: '卯',
      己酉: '卯',
      庚戌: '卯',
      辛亥: '卯',
      壬子: '卯',
      癸丑: '卯',
      甲寅: '丑',
      乙卯: '丑',
      丙辰: '丑',
      丁巳: '丑',
      戊午: '丑',
      己未: '丑',
      庚申: '丑',
      辛酉: '丑',
      壬戌: '丑',
      癸亥: '丑',
    },
  },
  {
    id: 134,
    name: '空亡',
    main: '15',
    tags: '7,8,10,11,12',
    sex: '0',
    data: {
      甲子: '亥',
      乙丑: '亥',
      丙寅: '亥',
      丁卯: '亥',
      戊辰: '亥',
      己巳: '亥',
      庚午: '亥',
      辛未: '亥',
      壬申: '亥',
      癸酉: '亥',
      甲戌: '酉',
      乙亥: '酉',
      丙子: '酉',
      丁丑: '酉',
      戊寅: '酉',
      己卯: '酉',
      庚辰: '酉',
      辛巳: '酉',
      壬午: '酉',
      癸未: '酉',
      甲申: '未',
      乙酉: '未',
      丙戌: '未',
      丁亥: '未',
      戊子: '未',
      己丑: '未',
      庚寅: '未',
      辛卯: '未',
      壬辰: '未',
      癸巳: '未',
      甲午: '巳',
      乙未: '巳',
      丙申: '巳',
      丁酉: '巳',
      戊戌: '巳',
      己亥: '巳',
      庚子: '巳',
      辛丑: '巳',
      壬寅: '巳',
      癸卯: '巳',
      甲辰: '卯',
      乙巳: '卯',
      丙午: '卯',
      丁未: '卯',
      戊申: '卯',
      己酉: '卯',
      庚戌: '卯',
      辛亥: '卯',
      壬子: '卯',
      癸丑: '卯',
      甲寅: '丑',
      乙卯: '丑',
      丙辰: '丑',
      丁巳: '丑',
      戊午: '丑',
      己未: '丑',
      庚申: '丑',
      辛酉: '丑',
      壬戌: '丑',
      癸亥: '丑',
    },
  },
  {
    id: 135,
    name: '天罗',
    main: '17',
    tags: '9,11,12',
    sex: '0',
    data: { 火: '戌、亥' },
  },
  {
    id: 136,
    name: '地网',
    main: '17',
    tags: '9,11,12',
    sex: '0',
    data: { 水: '辰、巳', 土: '辰、巳' },
  },
  {
    id: 137,
    name: '天转日',
    main: '8',
    tags: '15',
    sex: '0',
    data: {
      寅: '乙卯',
      卯: '乙卯',
      辰: '乙卯',
      巳: '丙午',
      午: '丙午',
      未: '丙午',
      申: '辛酉',
      酉: '辛酉',
      戌: '辛酉',
      亥: '壬子',
      子: '壬子',
      丑: '壬子',
    },
  },
  {
    id: 138,
    name: '地转日',
    main: '8',
    tags: '15',
    sex: '0',
    data: {
      寅: '辛卯',
      卯: '辛卯',
      辰: '辛卯',
      巳: '戊午',
      午: '戊午',
      未: '戊午',
      申: '癸酉',
      酉: '癸酉',
      戌: '癸酉',
      亥: '丙子',
      子: '丙子',
      丑: '丙子',
    },
  },
  {
    id: 139,
    name: '词馆',
    main: '17',
    tags: '8,9,10,11,12',
    sex: '0',
    data: { 金: '申', 木: '寅', 水: '亥', 土: '亥', 火: '巳' },
  },
  {
    id: 140,
    name: '童子煞',
    main: '8',
    tags: '9,10',
    sex: '0',
    data: {
      子: '卯未辰',
      丑: '卯未辰',
      寅: '寅子',
      卯: '寅子',
      辰: '寅子',
      巳: '卯未辰',
      午: '卯未辰',
      未: '卯未辰',
      申: '寅子',
      酉: '寅子',
      戌: '寅子',
      亥: '卯未辰',
    },
  },
  {
    id: 143,
    name: '童子煞',
    main: '17',
    tags: '9,10',
    sex: '0',
    data: {
      金: '午、卯',
      木: '午、卯',
      水: '酉、戌',
      火: '酉、戌',
      土: '辰、巳',
    },
  },
  {
    id: 144,
    name: '天赦日',
    main: '8',
    tags: '15',
    sex: '0',
    data: {
      寅: '戊寅',
      卯: '戊寅',
      辰: '戊寅',
      巳: '甲午',
      午: '甲午',
      未: '甲午',
      申: '戊申',
      酉: '戊申',
      戌: '戊申',
      亥: '甲子',
      子: '甲子',
      丑: '甲子',
    },
  },
  {
    id: 146,
    name: '四废日',
    main: '8',
    tags: '15',
    sex: '0',
    data: {
      寅: '庚申',
      卯: '庚申',
      辰: '庚申',
      巳: '壬子',
      午: '壬子',
      未: '壬子',
      申: '甲寅',
      酉: '甲寅',
      戌: '甲寅',
      亥: '丙午',
      子: '丙午',
      丑: '丙午',
    },
  },
  {
    id: 147,
    name: '四废日',
    main: '8',
    tags: '15',
    sex: '0',
    data: {
      寅: '辛酉',
      卯: '辛酉',
      辰: '辛酉',
      巳: '癸亥',
      午: '癸亥',
      未: '癸亥',
      申: '乙卯',
      酉: '乙卯',
      戌: '乙卯',
      亥: '丁巳',
      子: '丁巳',
      丑: '丁巳',
    },
  },
  {
    id: 148,
    name: '天厨贵人',
    main: '1,3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '巳',
      乙: '午',
      丙: '巳',
      丁: '午',
      戊: '申',
      己: '酉',
      庚: '亥',
      辛: '子',
      壬: '寅',
      癸: '卯',
    },
  },
  {
    id: 149,
    name: '福星贵人',
    main: '1,3',
    tags: '7,8,9,10,11,12',
    sex: '0',
    data: {
      甲: '寅子',
      丙: '寅子',
      乙: '卯丑',
      癸: '卯丑',
      戊: '申',
      己: '未',
      丁: '亥',
      庚: '午',
      辛: '巳',
      壬: '辰',
    },
  },
  {
    id: 150,
    name: '德秀贵人',
    main: '8',
    tags: '1,2,3,4,5,6',
    sex: '0',
    data: {
      寅: '丙丁戊癸',
      午: '丙丁戊癸',
      戌: '丙丁戊癸',
      申: '壬癸戊己丙辛甲',
      子: '壬癸戊己丙辛甲',
      辰: '壬癸戊己丙辛甲',
      巳: '乙庚辛',
      酉: '乙庚辛',
      丑: '乙庚辛',
      亥: '甲乙丁壬',
      卯: '甲乙丁壬',
      未: '甲乙丁壬',
    },
  },
  {
    id: 151,
    name: '拱禄',
    main: '16',
    tags: '15',
    sex: '0',
    data: {
      癸丑: '癸亥',
      癸亥: '癸丑',
      丁未: '丁巳',
      己巳: '己未',
      戊午: '戊辰',
    },
  },
  {
    id: 153,
    name: '正学堂',
    main: '17',
    tags: '14,15,16,19',
    sex: '0',
    data: { 金: '辛巳', 木: '己亥', 水: '甲申', 土: '戊申', 火: '丙寅' },
  },
  {
    id: 154,
    name: '正词馆',
    main: '17',
    tags: '14,15,16,19',
    sex: '0',
    data: { 金: '壬申', 木: '庚寅', 水: '癸亥', 土: '丁亥', 火: '乙巳' },
  },
  {
    id: 155,
    name: '天德贵人',
    main: '8',
    tags: '7,8,9,10,11',
    sex: '0',
    data: { 子: '巳', 卯: '申', 午: '亥', 酉: '寅' },
  },
  {
    id: 156,
    name: '天德合',
    main: '8',
    tags: '7,8,9,10,11',
    sex: '0',
    data: { 子: '申', 卯: '巳', 午: '寅', 酉: '亥' },
  },
]

export const ylTitles = [
  {
    id: 0,
    title: '月令主气直接取格',
  },
  {
    id: 1,
    title: '论月令透干取格',
  },
]
/**
 * 格局取法默认值
 * @key ylValues: 十二月令
 * @key additionValues：附加规则
 * @key specialValues：特殊格
 * @key ylDatas：月令规则
 */
export const setting_geju_default = {
  ylValues: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1],
  additionValues: [true, true],
  specialValues: [true, true],
  ylDatas: [
    [0, 0, 1, 1],
    [0, 0, 1, 1],
    [0, 0, 1, 1],
    [0, 0, 1, 1],
    [0, 0, 1, 1],
    [0, 0, 1, 1],
    [0, 0, 1, 1],
    [0, 0, 1, 1],
    [0, 0, 1, 1, true],
    [0, 0, 1, 1, true],
    [0, 0, 1, 1, true],
    [0, 0, 1, 1, true],
  ],
}

export const ylData = {
  title:
    '取格原理以月令为核心，查询月令藏干是否透出,藏干的权重优先级为，藏干:本气>中气>余气。因此，月令透干取格法规则的优先级如下:',
  datas: [
    {
      titles: ['（一）月令的主气透出天干', '（一）月令主气直接取格'],
      contents: ['优先主气取格（如寅月透甲，申月透庚）'],
    },
    {
      title: '（二）月令的主气不透，只有一个中气或余气透出',
      contents: ['透出之物取格（如寅月只透丙或只透戊）'],
    },
    {
      title: '（三）月令的主气不透，同时透出中气和余气两藏干',
      contents: [
        '取中气定格局，因为中气＞余气',
        [
          '在两者之间，选择五行力量强者取格',
          '在两者之间，选中五行力量强者的月令藏干取格',
        ],
        '兼透则兼用，中余气两个都取格',
      ],
    },
    {
      title: '（四）月令的藏干都不透',
      contents: [
        ['取主气定格局', '月令主气直接取格'],
        '在三个藏干之间，选择五行力量强者取格',
      ],
    },
  ],
}

export const ylData4_content = '墓库透出，优先墓库取格（如辰月透壬）'

export const specialList = [
  [
    '1、“子午卯酉”和“寅申巳亥”八个月，若主气为比劫，且以主气取格，属于建禄格或羊刃格；若月令的中余气为比劫等同于不透出，不能取格，需另取他格；',
    '2、五行力量强者，数值取之于基本信息页的“五行能量”功能。\n',
  ],
  [
    '1、“辰戌丑未”月若取格之物为比劫，不能取格，需判断其他条件另取其他格；',
    '2、五行力量强者，数值取之于基本信息页的“五行能量”功能。',
  ],
]

export const ylData2 = [
  [
    '不考虑藏干透出的情况，只取月令的主气定格',
    '比如：甲木日元，生于子月，正印格；生于寅月，建禄格',
  ],
  [
    '不考虑藏干透出的情况，只取月令的主气定格',
    '比如：戊土日元，生于申月，食神格；生于亥月，偏财格',
    '特别说明：',
    '“辰戌丑未”四季土月比较特殊，若主气为比劫，不能以主气直接取格，需另取其它格。（比如戊土生于辰月，主气不能取格，需寻其它格）',
  ],
]

/**
 * 人元司令默认值
 */
export const setting_rysl_default = {
  switch: true,
  selected: 0,
}
